import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const resources = {
  de: {
    translation: {
      common: {
        all: 'Alle',
        back: 'Zurück',
        cancel: 'Abbrechen',
        changeLanguage: 'Sprache wechseln',
        languageGerman: 'Deutsch',
        languageEnglish: 'Englisch',
        languageFrench: 'Französisch',
        languageDutch: 'Niederländisch',
        languagePolish: 'Polnisch',
        languageItalian: 'Italienisch',
        languageSpanish: 'Spanisch',
        // P2.OPT17 — sr-only Screen-Reader label for shadcn Dialog/Sheet close button
        close: 'Schließen',
        confirmPassword: 'Passwort bestätigen',
        date: 'Datum',
        delete: 'Löschen',
        download: 'Download',
        edit: 'Bearbeiten',
        email: 'E-Mail',
        error: 'Fehler',
        errorLoadingCompany: 'Fehler beim Laden der Firmendaten',
        loading: 'Laden...',
        logout: 'Abmelden',
        name: 'Name',
        open: 'Öffnen',
        password: 'Passwort',
        refresh: 'Aktualisieren',
        actions: 'Aktionen',
        amount: 'Betrag',
        optional: 'Optional',
        saving: 'Speichert...',
        size: 'Größe',
        type: 'Typ',
        anonymous: 'Anonym',
        avgRating: 'Durchschnittliche Bewertung',
        backToHome: 'Zurück zur Startseite',
        capacity: 'Kapazität',
        customerReviews: 'Kundenbewertungen',
        loginRequired: 'Anmeldung erforderlich',
        pagination: 'Seitennavigation',
        pageLoading: 'Seite wird geladen',
        more: 'Mehr',
        pleaseLoginToRequest: 'Bitte melden Sie sich an, um eine Anfrage zu stellen',
        premium: 'Premium',
        requestQuoteNow: 'Jetzt Angebot anfordern',
        reviews: 'Bewertungen',
        serviceArea: 'Einsatzgebiet',
        verified: 'Verifiziert',
        // P2.068 — hardcoded aria-label in CompanyCard.tsx + CompanyCompare.tsx
        ratingOutOfFive: 'Bewertung {{rating}} von 5',
        // P2.078 — JSON-LD / breadcrumb names used by Landing-Pages
        // P2.081 — breadcrumb.moving<City> for 5 City-Landing-Pages (Hamburg/München/Köln/Frankfurt/Stuttgart)
        seo: {
          breadcrumb: {
            home: 'Startseite',
            cleaning: 'Reinigung',
            disposal: 'Entrümpelung & Entsorgung',
            moving: 'Umzug',
            berlin: 'Umzug Berlin',
            movingHamburg: 'Umzug Hamburg',
            movingMuenchen: 'Umzug München',
            movingKoeln: 'Umzug Köln',
            movingFrankfurt: 'Umzug Frankfurt',
            movingStuttgart: 'Umzug Stuttgart',
          },
          service: {
            cleaningGermany: 'Reinigungsservice Deutschland',
            disposalGermany: 'Entrümpelungs- und Entsorgungsservice Deutschland',
            movingBerlin: 'Umzugsservice Berlin',
            movingHamburg: 'Umzugsservice Hamburg',
            movingMuenchen: 'Umzugsservice München',
            movingKoeln: 'Umzugsservice Köln',
            movingFrankfurt: 'Umzugsservice Frankfurt',
            movingStuttgart: 'Umzugsservice Stuttgart',
            cleaningBerlin: 'Reinigungsservice Berlin',
            disposalBerlin: 'Entrümpelungs- und Entsorgungsservice Berlin',
            cleaningHamburg: 'Reinigungsservice Hamburg',
            disposalHamburg: 'Entrümpelungs- und Entsorgungsservice Hamburg',
            cleaningMuenchen: 'Reinigungsservice München',
            disposalMuenchen: 'Entrümpelungs- und Entsorgungsservice München',
            cleaningKoeln: 'Reinigungsservice Köln',
            disposalKoeln: 'Entrümpelungs- und Entsorgungsservice Köln',
            cleaningFrankfurt: 'Reinigungsservice Frankfurt',
            disposalFrankfurt: 'Entrümpelungs- und Entsorgungsservice Frankfurt',
            cleaningStuttgart: 'Reinigungsservice Stuttgart',
            disposalStuttgart: 'Entrümpelungs- und Entsorgungsservice Stuttgart',
          },
          area: {
            germany: 'Deutschland',
          },
        },
      },
      anonymous: 'Anonym',
      avgRating: 'Durchschnittliche Bewertung',
      backToHome: 'Zurück zur Startseite',
      capacity: 'Kapazität',
      customerReviews: 'Kundenbewertungen',
      error: 'Fehler',
      errorLoadingCompany: 'Fehler beim Laden der Firmendaten',
      loginRequired: 'Anmeldung erforderlich',
      more: 'Mehr',
      pleaseLoginToRequest: 'Bitte melden Sie sich an, um eine Anfrage zu stellen',
      premium: 'Premium',
      requestQuoteNow: 'Jetzt Angebot anfordern',
      reviews: 'Bewertungen',
      serviceArea: 'Einsatzgebiet',
      skipToContent: 'Zum Hauptinhalt springen',
      verified: 'Verifiziert',
      auth: {
        signIn: 'Anmelden',
        signUp: 'Registrieren',
        email: 'E-Mail',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        name: 'Name',
        phone: 'Telefon',
        emailPlaceholder: 'ihre@email.de',
        passwordPlaceholder: '••••••••',
        emailRequired: 'E-Mail ist erforderlich',
        invalidEmail: 'Ungültige E-Mail-Adresse',
        weakPassword: 'Passwort muss mindestens 8 Zeichen lang sein',
        passwordMinLength: 'Passwort muss mindestens 8 Zeichen lang sein',
        passwordMismatch: 'Passwörter stimmen nicht überein',
        passwordMismatchDesc: 'Die eingegebenen Passwörter stimmen nicht überein',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        changePasswordTitle: 'Passwort zuruecksetzen',
        changePasswordDescription:
          'Aendern Sie Ihr Passwort fuer dieses Benutzerkonto. Admin-Konten sind von dieser Selbstbedienungsfunktion ausgeschlossen.',
        changePasswordAction: 'Passwort speichern',
        passwordChangeSuccess: 'Passwort aktualisiert',
        passwordChangeSuccessDesc: 'Ihr Passwort wurde erfolgreich aktualisiert.',
        passwordChangeError: 'Das Passwort konnte nicht aktualisiert werden.',
        passwordChangeBlocked: 'Passwortaenderung nicht erlaubt',
        forgotPassword: 'Passwort vergessen',
        forgotPasswordTitle: 'Passwort vergessen',
        forgotPasswordDescription:
          'Geben Sie Ihre Login-E-Mail ein. Wenn ein passendes Kunden- oder Firmenkonto existiert, senden wir einen Reset-Link.',
        forgotPasswordAction: 'Reset-Link senden',
        forgotPasswordSuccess: 'Reset-Link versendet',
        forgotPasswordSuccessDesc:
          'Falls ein passendes Konto existiert, wurde eine E-Mail mit einem Reset-Link versendet.',
        resetPasswordTitle: 'Neues Passwort setzen',
        resetPasswordDescription:
          'Vergeben Sie ein neues Passwort fuer Ihr Kunden- oder Firmenkonto.',
        resetPasswordAction: 'Passwort zuruecksetzen',
        resetPasswordSuccess: 'Passwort erfolgreich zurueckgesetzt',
        resetPasswordSuccessDesc: 'Sie koennen sich jetzt mit dem neuen Passwort anmelden.',
        resetPasswordError: 'Das Passwort konnte nicht zurueckgesetzt werden.',
        resetPasswordInvalidToken: 'Der Reset-Link ist ungueltig oder abgelaufen.',
        backToLogin: 'Zurueck zur Anmeldung',
        loginSuccess: 'Erfolgreich angemeldet',
        loginSuccessDesc: 'Sie werden zu Ihrem Dashboard weitergeleitet.',
        loginError: 'Anmeldung fehlgeschlagen',
        registerSuccess: 'Erfolgreich registriert',
        registerSuccessDesc: 'Ihr Konto wurde erfolgreich erstellt.',
        registerError: 'Registrierung fehlgeschlagen',
        logoutSuccess: 'Erfolgreich abgemeldet',
        credentials: 'Anmeldedaten',
        pleaseLogin: 'Bitte melden Sie sich an',
        loginNow: 'Jetzt anmelden',
        loginRequired: 'Anmeldung erforderlich',
        pleaseLoginToRequest: 'Bitte melden Sie sich an, um eine Anfrage zu stellen',
        loginRequiredForRequest:
          'Sie müssen angemeldet sein, um ein Angebot von dieser Firma anzufordern',
        passwordChangeTitle: 'Passwort ändern',
        passwordChangeDescription: 'Ändern Sie Ihr Passwort, um Ihr Konto zu schützen.',
      },
      home: {
        title: 'Regional Umzug 24',
        subtitle: 'Ihr Partner für regionale Umzüge',
      },
      dashboard: {
        welcome: 'Willkommen',
        myRequests: 'Meine Anfragen',
        activeRequests: 'Aktive Anfragen',
        statistics: 'Statistiken',
      },
      nav: {
        dashboard: 'Dashboard',
        requests: 'Anfragen',
        profile: 'Profil',
        privacy: 'Datenschutz',
        imprint: 'Impressum',
        terms: 'AGB',
        home: 'Startseite',
        companies: 'Umzugsfirmen Berlin',
        howItWorks: "So funktioniert's",
        pricing: 'Preise',
        about: 'Über uns',
        requestCTA: 'Anfrage erstellen',
        openMenu: 'Menü öffnen',
        closeMenu: 'Menü schließen',
        login: 'Anmelden',
        companyLogin: 'Für Firmen',
      },
      favorite: {
        add: 'Zu Favoriten hinzufügen',
        remove: 'Aus Favoriten entfernen',
        added: 'Zu Favoriten hinzugefügt',
        removed: 'Aus Favoriten entfernt',
        tabTitle: 'Favoriten',
        empty: 'Sie haben noch keine Favoriten gespeichert.',
        emptyHint:
          'Markieren Sie interessante Firmen mit dem Herz-Symbol, um sie hier wiederzufinden.',
        count: '{{count}} Favoriten',
        error: 'Favoriten konnten nicht aktualisiert werden.',
        signInRequired: 'Bitte melden Sie sich an, um Favoriten zu speichern.',
        viewProfile: 'Profil ansehen',
        removedFromList: 'Firma aus den Favoriten entfernt',
      },
      legal: {
        contactPerson: 'Ansprechpartner',
        // P2.089 — hardcoded defaultContent in Impressum.tsx (lines 38-90)
        imprint: {
          providerHeading: 'Angaben gemäß § 5 TMG',
          providerCountry: 'Deutschland',
          contactHeading: 'Kontakt',
          contactEmailLabel: 'E-Mail:',
          contactEmailValue: 'info@regionalumzug24.de',
          contactPhoneLabel: 'Telefon:',
          contactPhoneValue: '+49 (0) 123 456789',
          editorialResponsibleHeading: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
          disputeResolutionHeading: 'EU-Streitschlichtung',
          disputeResolutionDescription:
            'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
          disputeResolutionLinkText: 'https://ec.europa.eu/consumers/odr',
          disclaimerHeading: 'Haftungsausschluss',
          disclaimerContentHeading: 'Haftung für Inhalte',
          disclaimerContentText:
            'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
          disclaimerLinksHeading: 'Haftung für Links',
          disclaimerLinksText:
            'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
        },
        // P2.089 — hardcoded defaultContent in Datenschutz.tsx (lines 39-70)
        privacy: {
          overviewHeading: '1. Datenschutz auf einen Blick',
          overviewGeneralHeading: 'Allgemeine Hinweise',
          overviewGeneralText:
            'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.',
          hostingHeading: '2. Hosting',
          hostingText: 'Wir hosten die Inhalte unserer Website bei einem externen Anbieter.',
          mandatoryInformationHeading: '3. Allgemeine Hinweise und Pflichtinformationen',
          dataProtectionHeading: 'Datenschutz',
          dataProtectionText:
            'Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.',
          lastUpdated: 'Stand: {{date}}',
        },
      },
      request: {
        caseProfile: {
          authorityNamePlaceholder: 'z. B. Sozialamt Musterstadt',
          notePlaceholder: 'z. B. Fristen, Rückfragen oder Hinweise zur Kostenübernahme',
          // P2.069 — hardcoded <Badge> label in AdminOperationsManagementWorkspace
          badgeLabel: 'Fallprofil',
        },
        new: 'Neue Anfrage',
        title: 'Anfrage',
        directCompanyDescription: 'Fordern Sie direkt ein Angebot von dieser Firma an',
        date: 'Datum',
        moveDate: 'Umzugsdatum',
        from: 'Von',
        to: 'Nach',
        fromTo: 'Von - Nach',
        fromAddress: 'Von Adresse',
        toAddress: 'Nach Adresse',
        fromPostalCode: 'Von PLZ',
        toPostalCode: 'Nach PLZ',
        squareMeters: 'Quadratmeter',
        type: 'Typ',
        createSuccess: 'Anfrage erfolgreich erstellt',
        createError: 'Fehler beim Erstellen der Anfrage',
        // P1.W2 v2 — Kunden-Hinweis nach Submit (Premium-Tier-Match)
        pricingMatchHint:
          'Ihre Anfrage wird bevorzugt an Firmen mit aktiven Vergütungsmodellen (Lead / Provision / Festpreis) zugestellt.',
        // P2.068 — hardcoded aria-label in AnfrageNeu.tsx branch badge
        branchBadgeAria: 'Branche: {{branch}}',
        addressPlaceholder: 'Straße, Hausnummer, Stadt',
        postalCodePlaceholder: 'z.B. 86551',
        descriptionPlaceholder:
          'Gibt es besondere Anforderungen? Z.B. enge Treppe, schwere Möbel, Halteverbotszone...',
        submitting: 'Wird gesendet...',
        submitButton: 'Kostenlos Angebote erhalten',
        photos: {
          title: 'Fotos der Wohnung',
          help: 'Laden Sie bis zu 5 Bilder hoch, damit Firmen Ihre Wohnung und Möbel besser einschätzen können.',
          upload: 'Fotos hochladen',
          dragDrop: 'Bilder hier ablegen oder klicken',
          maxSize: 'Maximal 5 MB pro Bild (JPEG, PNG oder WebP)',
          tooMany: 'Sie können maximal 5 Fotos hochladen.',
          error: 'Bilder konnten nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
        },
        newForm: {
          moveTypeTitle: 'Umzugsart',
          moveTypeLabel: 'Art des Umzugs',
          requestTypeLabel: 'Anfrage-Typ',
          requestTypeStandard: 'Standard (kostenlos)',
          requestTypePremium: 'Premium (kostenpflichtig)',
          requestTypePremiumPlus: 'Premium+ (kostenpflichtig)',
          paidServiceWarning: '⚠️ Kostenpflichtiger Service',
          addressesTitle: 'Adressen',
          startAddressLabel: 'Startadresse',
          startPostalCodeLabel: 'PLZ (Start)',
          endAddressLabel: 'Zieladresse',
          endPostalCodeLabel: 'PLZ (Ziel)',
          detailsTitle: 'Details',
          moveDateLabel: 'Umzugsdatum',
          moveDatePlaceholder: 'Datum wählen',
          volumeLabel: 'Umfang (m³)',
          volumePlaceholder: 'z.B. 30',
          volumeHelpText: 'Als Richtwert: 1-Zimmer ≈ 20m³, 2-Zimmer ≈ 35m³, 3-Zimmer ≈ 50m³',
          specialRequirementsTitle: 'Sonderwünsche',
          additionalInfoLabel: 'Zusätzliche Informationen',
          infoBoxFreeTitle: 'Kostenlos & unverbindlich',
          infoBoxFreeText: 'Ihre Anfrage ist komplett kostenfrei und verpflichtet Sie zu nichts',
          infoBoxGdprTitle: 'DSGVO-konform',
          infoBoxGdprText: 'Ihre Daten werden sicher und verschlüsselt übertragen',
          infoBoxFastTitle: 'Schnelle Antworten',
          infoBoxFastText: 'Erhalten Sie Angebote innerhalb von 24 Stunden',
          accountCreatedTitle: 'Konto wurde erstellt',
          accountCreatedDescription:
            'Für Sie wurde automatisch ein Konto angelegt. Bitte notieren Sie sich Ihr Passwort – es wird aus Sicherheitsgründen nur einmal angezeigt.',
          accountCreatedPasswordLabel: 'Ihr Passwort',
          accountCreatedEmailLabel: 'E-Mail',
          accountCreatedAcknowledgeCta: 'Verstanden – zum Login',
          // P2.069 — hardcoded branchMeta labels in AnfrageNeu.tsx
          branchLabels: {
            moving: 'Umzug',
            cleaning: 'Reinigung',
            disposal: 'Entrümpelung',
          },
        },
        blockedCreateAlert:
          'Ihr Kundenkonto ist aktuell gesperrt. Neue Anfragen koennen erst nach Pruefung oder Aufhebung der Sperre erstellt werden.',
        blockedCreateError:
          'Neue Anfragen sind waehrend einer aktiven Kundensperre nicht moeglich. Bitte pruefen Sie Ihren Sperrstatus im Dashboard.',
        blockedOpenDashboard: 'Zum Dashboard',
        blockedSubmitButton: 'Konto gesperrt',
        draft: {
          title: 'Entwurf wird lokal gespeichert',
          description:
            'Ihre Anfrage wird automatisch im Browser zwischengespeichert. Passwoerter werden dabei nicht gespeichert.',
          savedAt: 'Zuletzt lokal gespeichert: {{date}}',
          clearAction: 'Entwurf loeschen',
          cleared: 'Entwurf geloescht',
        },
        status: {
          label: 'Status',
          pending: 'Ausstehend',
          matched: 'Zugeordnet',
          accepted: 'Angenommen',
          declined: 'Abgelehnt',
          completed: 'Abgeschlossen',
          cancelled: 'Storniert',
        },
        detail: {
          title: 'Anfragedetails',
          confirmedCompany: 'Bestätigte Firma',
          timelineTitle: 'Zeitverlauf',
          timelineCreated: 'Anfrage erstellt',
          timelineFirstResponse: 'Erste Firmenrückmeldung',
          timelineCompanyConfirmed: 'Firma bestätigt',
          timelineCompanyConfirmedWithName: 'Firma bestätigt: {{company}}',
          timelineCompleted: 'Anfrage abgeschlossen',
          timelineCancelled: 'Anfrage storniert',
          noTimestamp: 'Zeitpunkt nicht verfügbar',
          communicationTitle: 'Kommunikation',
          communicationEmpty: 'Noch keine Nachrichten zu dieser Anfrage vorhanden.',
          communicationYou: 'Sie',
          activityTitle: 'Aktivitaet',
          activityEmpty: 'Noch keine Aktivitaet zu dieser Anfrage vorhanden.',
          activityStatusBadge: 'Status',
          activityMessageBadge: 'Nachricht',
          activityDocumentBadge: 'Dokument',
          activityMessageTitle: 'Nachricht von {{sender}}',
          activityDocumentTitle: 'Dokument hochgeladen: {{name}}',
          cancelAction: 'Anfrage stornieren',
          cancelConfirm: 'Möchten Sie diese Anfrage wirklich stornieren?',
          cancelledTitle: 'Anfrage storniert',
          cancelledDesc: 'Die Anfrage wurde storniert und offene Firmenzuordnungen wurden beendet.',
          cancelErrorDesc: 'Die Anfrage konnte nicht storniert werden.',
          completeAction: 'Abschließen',
          completeConfirm: 'Anfrage als abgeschlossen markieren?',
          completedTitle: 'Anfrage abgeschlossen',
          completedDesc: 'Die Anfrage wurde als abgeschlossen markiert.',
          completeErrorDesc: 'Die Anfrage konnte nicht abgeschlossen werden.',
          selectCompanyAction: 'Firma bestätigen',
          selectCompanyConfirm: 'Diese Firma als finalen Partner bestätigen?',
          companyConfirmedTitle: 'Firma bestätigt',
          companyConfirmedDesc:
            'Die Firma wurde als finaler Partner markiert. Andere offene Zuordnungen wurden geschlossen.',
          companyConfirmErrorDesc: 'Die Firma konnte nicht bestätigt werden.',
          selectBeforeComplete:
            'Bitte bestätigen Sie zuerst eine angenommene Firma, bevor Sie die Anfrage abschließen.',
          moveInfo: 'Umzugsinformationen',
          descriptionTitle: 'Beschreibung',
          specialRequirementsTitle: 'Besondere Anforderungen',
          moveDate: 'Umzugsdatum',
          volume: 'Volumen',
          fromPostalCode: 'PLZ',
          summaryTitle: 'Status-Übersicht',
          requested: 'Angefordert',
          accepted: 'Angenommen',
          open: 'Offen',
          rejected: 'Abgelehnt',
          remaining: 'Noch benötigt',
          noMatchingCompaniesTitle: 'Derzeit keine passende Firma gefunden',
          noMatchingCompaniesDesc:
            'Nach dem vollstaendigen Matching-Fenster konnte Ihrer Anfrage aktuell keine passende Firma zugeordnet werden. Sobald sich das aendert, informieren wir Sie automatisch.',
          acceptedCompaniesTitle: 'Matching bestaetigt',
          acceptedCompaniesDesc:
            'Diese Firmen haben das Matching bereits bestaetigt: {{companies}}.',
          offersTitle: 'Angebote',
          loadingOffers: 'Lädt...',
          noOffers: 'Noch keine Angebote erhalten',
          verifiedBadge: 'Verifiziert',
          respondedAt: 'Antwort erhalten',
          openChat: 'Chat öffnen',
          assigned: 'Beauftragt',
          reviewAction: 'Bewerten',
        },
      },
      timelinePanel: {
        empty: 'Noch keine Timeline-Eintraege vorhanden.',
        noTimestamp: 'Zeitpunkt nicht verfuegbar',
        fallbackCompany: 'eine Firma',
        fallbackActor: 'System',
        badges: {
          status: 'Status',
          billing: 'Billing',
          message: 'Nachricht',
          document: 'Dokument',
          review: 'Bewertung',
        },
        types: {
          request_created: 'Anfrage erstellt',
          request_completed: 'Anfrage abgeschlossen',
          request_cancelled: 'Anfrage storniert',
          company_selected: 'Firma bestaetigt: {{company}}',
          company_request_assigned: 'Anfrage an {{company}} zugewiesen',
          company_request_accepted: '{{company}} hat zugesagt',
          company_request_declined: '{{company}} hat abgelehnt',
          company_request_cancelled: 'Zuordnung zu {{company}} wurde beendet',
          company_request_cancellation_requested: '{{company}} hat ein Storno angefragt',
          company_request_cancellation_approved: 'Storno fuer {{company}} genehmigt',
          company_request_cancellation_rejected: 'Storno fuer {{company}} abgelehnt',
          payment_created: 'Payment fuer {{company}} angelegt',
          payment_paid: 'Payment fuer {{company}} bezahlt',
          payment_cancelled: 'Payment fuer {{company}} storniert',
          invoice_created: 'Rechnung {{invoice}} erstellt',
          invoice_paid: 'Rechnung {{invoice}} als bezahlt markiert',
          invoice_cancelled: 'Rechnung {{invoice}} storniert',
          review_created: 'Bewertung fuer {{company}} erstellt',
          chat_message_sent: 'Nachricht von {{actor}}',
          chat_escalation_pending: 'Rueckmeldung von {{actor}} ueberfaellig',
          document_uploaded: 'Dokument hochgeladen von {{actor}}',
        },
        details: {
          amount: 'Betrag: {{amount}} EUR',
          invoice: 'Rechnung: {{invoice}}',
          rating: 'Bewertung: {{rating}}/5',
          status: 'Status: {{status}}',
          reason: 'Hinweis: {{reason}}',
          document: 'Dokument: {{name}}',
          documentPurpose: 'Nachgefragtes Dokument: {{document}}',
          template: 'Vorlage: {{template}}',
          escalation: 'Eskalation: {{level}}',
          message: 'Nachricht: {{message}}',
        },
      },
      chatWorkflow: {
        loading: 'Nachrichten werden geladen...',
        loadError: 'Nachrichten konnten nicht geladen werden.',
        // P2.069 — hardcoded toast.description in ChatDialog/CustomerChatDialog
        sendError: 'Nachricht konnte nicht gesendet werden.',
        retryAction: 'Erneut laden',
        empty: 'Noch keine Nachrichten. Starten Sie die Konversation!',
        dialog: {
          customerTitle: 'Chat mit {{company}}',
          companyTitle: 'Chat mit {{customer}}',
          customerFallback: 'Kunde',
        },
        composer: {
          placeholder: 'Nachricht eingeben...',
          active: 'Aktiver Workflow:',
          clear: 'Zuruecksetzen',
          send: 'Nachricht senden',
        },
        escalationLevels: {
          follow_up: 'Nachfassen',
          urgent: 'Dringend',
        },
        documentPurposes: {
          customer_identity: 'Ausweis / Identitaetsnachweis',
          coverage_approval: 'Kostenuebernahme / Bewilligung',
          authority_reference: 'Behoerdennachweis / Aktenzeichen',
          care_level_proof: 'Pflegegradnachweis',
        },
        templates: {
          document_request: {
            label: 'Unterlage anfragen',
            message:
              'Bitte laden Sie noch {{document}} fuer diese Anfrage hoch oder bestaetigen Sie kurz den Status.',
          },
          document_uploaded_confirmation: {
            label: 'Unterlage nachgereicht',
            message:
              'Ich habe die angefragten Unterlagen soeben nachgereicht. Bitte pruefen Sie den Vorgang erneut.',
          },
          status_follow_up: {
            label: 'Status erfragen',
            message:
              'Koennen Sie bitte kurz den aktuellen Stand bestaetigen und mitteilen, was als naechstes benoetigt wird?',
          },
          move_details_request: {
            label: 'Umzugsdetails klaeren',
            message:
              'Ich habe noch eine Rueckfrage zu den Umzugsdetails und benoetige bitte eine kurze Rueckmeldung.',
          },
          availability_confirmation_request: {
            label: 'Termin bestaetigen',
            message:
              'Bitte bestaetigen Sie kurz, ob der geplante Termin und die aktuellen Rahmendaten weiterhin passen.',
          },
          urgent_response_needed: {
            label: 'Dringende Rueckmeldung',
            message:
              'Bitte melden Sie sich zeitnah zu dieser Anfrage zurueck, damit der Vorgang nicht ins Stocken geraet.',
          },
        },
      },
      company: {
        companyRegistration: 'Firmenregistrierung',
        becomePartner: 'Partner werden',
        registerNow: 'Jetzt registrieren',
        registering: 'Registrierung läuft...',
        companyData: 'Firmendaten',
        companyName: 'Firmenname',
        companyNamePlaceholder: 'Ihre Umzugsfirma GmbH',
        companyDescription: 'Firmenbeschreibung',
        companyDescriptionPlaceholder: 'Beschreiben Sie Ihre Dienstleistungen...',
        companyProfile: 'Firmenprofil',
        serviceAreas: 'Servicegebiete',
        postalCodeAreas: 'Postleitzahlengebiete',
        postalCodeAreasDesc: 'Geben Sie die Postleitzahlen ein, in denen Sie tätig sind',
        postalCodeAreasPlaceholder: 'z.B. 10115, 10117, 10119',
        specialServices: 'Spezialservices',
        verificationDocuments: 'Verifizierungsdokumente',
        uploadDocuments: 'Dokumente hochladen',
        uploadDocumentsDesc: 'Laden Sie Ihre Gewerbeanmeldung und andere relevante Dokumente hoch',
        documentsRequired: 'Dokumente erforderlich',
        documentsRequiredDesc:
          'Bitte laden Sie mindestens Ihre Gewerbeanmeldung hoch. Weitere Dokumente sind optional und werden erst bei der Auftragszuordnung beruecksichtigt.',
        documentsMissing: 'Dokumente fehlen',
        verificationProcess: 'Verifizierungsprozess',
        verificationProcessDesc: 'Ihre Dokumente werden geprüft',
        verificationPending: 'Verifizierung ausstehend',
        verificationPendingDesc: 'Ihre Dokumente werden derzeit geprüft',
        verified: 'Verifiziert',
        verifiedDesc: 'Ihr Unternehmen wurde erfolgreich verifiziert',
        verificationRejected: 'Verifizierung abgelehnt',
        verificationRejectedDesc: 'Ihre Verifizierung wurde abgelehnt',
        verificationActionRequired: 'Verifizierung erfordert Aktion',
        verificationActionRequiredDesc:
          'Mindestens ein Verifizierungsdokument muss ersetzt, korrigiert oder erneut eingereicht werden.',
        verificationFollowUpDue: 'Wiedervorlage faellig',
        verificationFollowUpDueDesc:
          'Fuer mindestens ein Verifizierungsdokument ist eine Wiedervorlage faellig. Bitte pruefen Sie den Dokumentenbereich.',
        verificationFollowUpOverdue: 'Wiedervorlage ueberfaellig',
        verificationFollowUpOverdueDesc:
          'Mindestens ein Verifizierungsdokument ist bei der Wiedervorlage ueberfaellig. Bitte reagieren Sie im Dokumentenbereich.',
        registrationSuccess: 'Registrierung erfolgreich',
        registrationSuccessDesc: 'Ihre Firma wurde erfolgreich registriert',
        registrationError: 'Registrierungsfehler',
        userCreationError: 'Fehler beim Erstellen des Benutzers',
        alreadyRegistered: 'Bereits registriert',
        companyProfileAlreadyExists:
          'Fuer dieses Benutzerkonto existiert bereits ein Firmenprofil.',
        registrationEmailMismatch:
          'Sie sind bereits mit einer anderen E-Mail-Adresse angemeldet. Bitte zuerst abmelden oder dieselbe E-Mail fuer die Firmenregistrierung verwenden.',
        requiresCompanyAccount: 'Erfordert Firmenkonto',
        nameMinLength: 'Name muss mindestens 3 Zeichen lang sein',
        phoneMinLength: 'Telefonnummer muss mindestens 10 Zeichen lang sein',
        regionRequired: 'Mindestens ein Servicegebiet ist erforderlich',
        movingRequests: 'Umzugsanfragen',
        qualifiedRequests: 'Qualifizierte Anfragen',
        qualifiedRequestsDesc: 'Anfragen, die Ihren Kriterien entsprechen',
        assignedRequestsOverview: 'Zugewiesene Anfragen Übersicht',
        openRequests: 'Offene Anfragen',
        noRequests: 'Keine Anfragen',
        noRequestsDesc: 'Derzeit sind keine Anfragen verfügbar',
        accept: 'Annehmen',
        decline: 'Ablehnen',
        accepted: 'Angenommen',
        declined: 'Abgelehnt',
        requestAccepted: 'Anfrage angenommen',
        requestDeclined: 'Anfrage abgelehnt',
        statusUpdated: 'Status aktualisiert',
        statusUpdateError: 'Fehler beim Aktualisieren des Status',
        requestAcceptBlockedTitle: 'Annahme derzeit gesperrt',
        requestAcceptBlockedError:
          'Ihre Firma kann diese Anfrage derzeit nicht annehmen, solange eine aktive Sperre besteht.',
        requestsBlockedAlertTitle: 'Offene Anfragen koennen derzeit nicht angenommen werden',
        requestsBlockedAlertDescPayment_one:
          '{{count}} offene Anfrage kann derzeit nicht angenommen werden, weil Rechnung {{invoice}} seit {{dueDate}} ueberfaellig ist.',
        requestsBlockedAlertDescPayment_other:
          '{{count}} offene Anfragen koennen derzeit nicht angenommen werden, weil Rechnung {{invoice}} seit {{dueDate}} ueberfaellig ist.',
        requestsBlockedAlertDescBlacklist_one:
          '{{count}} offene Anfrage kann derzeit nicht angenommen werden, weil Ihre Firma gesperrt ist ({{reason}}, gueltig bis {{validUntil}}).',
        requestsBlockedAlertDescBlacklist_other:
          '{{count}} offene Anfragen koennen derzeit nicht angenommen werden, weil Ihre Firma gesperrt ist ({{reason}}, gueltig bis {{validUntil}}).',
        requestsBlockedAlertDescGeneric_one:
          '{{count}} offene Anfrage kann derzeit aufgrund einer aktiven Sperre nicht angenommen werden.',
        requestsBlockedAlertDescGeneric_other:
          '{{count}} offene Anfragen koennen derzeit aufgrund einer aktiven Sperre nicht angenommen werden.',
        requestsBlockedBadge: 'Annahme gesperrt',
        requestsBlockedOpenOverview: 'Pruefstatus ansehen',
        loadError: 'Fehler beim Laden',
        match: 'Übereinstimmung',
        requestsReceived: 'Anfragen erhalten',
        totalReceived: 'Gesamt erhalten',
        totalRevenue: 'Gesamtumsatz',
        avgOrderValue: 'Durchschnittlicher Auftragswert',
        avgResponseTime: 'Durchschnittliche Antwortzeit',
        acceptanceRate: 'Annahmerate',
        declineRate: 'Ablehnungsrate',
        average: 'Durchschnitt',
        allOrders: 'Alle Aufträge',
        waitingForResponse: 'Warten auf Antwort',
        perOrder: 'pro Auftrag',
        noMatchingRequests: 'Keine passenden Anfragen',
        tryDifferentFilter: 'Versuchen Sie einen anderen Filter',
        standard: 'Standard',
        premium: 'Premium',
        requestCancellation: 'Stornierung anfordern',
        cancelRequest: 'Anfrage stornieren',
        cancelRequestDesc: 'Möchten Sie diese Anfrage wirklich stornieren?',
        cancellationReason: 'Stornierungsgrund',
        cancellationReasonPlaceholder: 'Bitte geben Sie einen Grund für die Stornierung an',
        reasonRequired: 'Grund erforderlich',
        reasonRequiredDesc: 'Bitte geben Sie einen Grund für die Stornierung an',
        cancellationSent: 'Stornierung gesendet',
        cancellationSentDesc: 'Ihre Stornierungsanfrage wurde gesendet',
        cancellationError: 'Stornierungsfehler',
        services: {
          packing: 'Verpackung',
          assembly: 'Montage',
          disposal: 'Entsorgung',
          storage: 'Lagerung',
          piano: 'Klaviertransport',
          international: 'International',
          renovation: 'Renovierung',
          cleaning: 'Reinigung',
          safe_transport: 'Tresortransport',
          server_transport: 'Servertransport',
          heavy_transport: 'Schwerlasttransporte',
          painting_service: 'Schilderservice',
        },
        priceTiers: {
          standard: 'Standard',
          premium: 'Premium',
          premiumPlus: 'Premium+',
          premiumDesc: 'Premium-Anfrage: Maximal 15 qualifizierte Angebote von geprüften Firmen.',
          premiumPlusDesc: 'Premium+ Anfrage: Maximal 5 exklusive Angebote von Top-Firmen.',
        },
        // P1.W2 v2 — Company-spezifische Pricing-Settings-Card
        pricingSettings: {
          heading: 'Vergütungsmodell',
          subheading:
            'Verwalten Sie Ihr Vergütungsmodell (Lead / Provision / Festpreis) und sehen Sie passende Statistiken.',
          currentTierLabel: 'Aktuelles Modell',
          noTierLabel: 'Noch kein Modell aktiviert',
          activeBadge: 'Aktiv',
          changeButton: 'Modell ändern',
          statsHeading: 'Statistik pro Modell',
          statsRequestsLabel: 'Anfragen',
          statsRevenueLabel: 'Umsatz',
          statsAvgLabel: 'Ø Preis',
          statsGrandTotalRequests: 'Anfragen gesamt',
          statsGrandTotalRevenue: 'Gesamtumsatz',
          statsNoData: 'Noch keine Auswertung verfügbar',
          dialogTitle: 'Vergütungsmodell wählen',
          dialogDescription:
            'Wählen Sie Lead-, Provisions- oder Festpreis-Modell und hinterlegen Sie die Werte.',
          closeButton: 'Schließen',
          loadError: 'Vergütungsmodell konnte nicht geladen werden.',
          loadErrorRetry: 'Erneut versuchen',
        },
        // P2.OPT121 — Company Pricing-Model-Switcher (Lead / Commission / Fixed)
        pricing: {
          tabTitle: 'Vergütungsmodell wählen',
          tabDescription: 'Wechseln Sie zwischen Lead-, Provisions- und Festpreis-Modell.',
          currentModelBadge: 'Aktuell aktiv',
          activate: 'Aktivieren',
          activating: 'Wird aktiviert...',
          saveChanges: 'Änderungen speichern',
          notesLabel: 'Hinweise',
          notesPlaceholder: 'Optionale Notizen zu Ihrem Vergütungsmodell',
          confirmTitle: 'Vergütungsmodell wechseln',
          confirmDescription: 'Möchten Sie wirklich zu {{model}} wechseln?',
          confirmModelLead: 'Lead-Modell',
          confirmModelCommission: 'Provisions-Modell',
          confirmModelFixedPrice: 'Festpreis-Modell',
          successTitle: 'Vergütungsmodell aktualisiert',
          successDescription: 'Ihr Vergütungsmodell wurde auf {{model}} gewechselt.',
          errorTitle: 'Fehler',
          errorBlocked: 'Das Vergütungsmodell kann nicht gewechselt werden.',
          errorGeneric: 'Das Vergütungsmodell konnte nicht aktualisiert werden.',
          leadTitle: 'Lead-Modell',
          leadSubtitle: 'Bezahlung pro qualifizierter Anfrage',
          leadDescription: 'Sie zahlen einen festen Betrag pro zugewiesener Anfrage.',
          leadTiers: 'Verfügbare Tarife',
          leadPros: '+ Planbare Einnahmen',
          leadCons: '- Keine Provision bei Erfolg',
          commissionTitle: 'Provisions-Modell',
          commissionSubtitle: 'Prozentuale Beteiligung am Auftragswert',
          commissionDescription: 'Sie zahlen eine Provision auf erfolgreich vermittelte Aufträge.',
          commissionExample: 'Beispiel',
          commissionRateLabel: 'Provisionssatz (%)',
          commissionRateHelp: 'Prozentuale Beteiligung am vermittelten Auftragswert',
          commissionPros: '+ Kein Risiko bei Absage',
          commissionCons: '- Einnahmen erst bei Erfolg',
          fixedPriceTitle: 'Festpreis-Modell',
          fixedPriceSubtitle: 'Pauschalpreis pro Auftrag',
          fixedPriceDescription:
            'Sie zahlen einen festen Betrag pro erfolgreich vermitteltem Auftrag.',
          fixedPriceExample: 'Beispiel',
          contractAmountLabel: 'Vertragswert (EUR)',
          contractAmountHelp: 'Pauschalpreis pro erfolgreich vermitteltem Auftrag',
          minContractValueLabel: 'Mindestauftragswert (EUR)',
          minContractValueHelp: 'Aufträge unter diesem Wert werden nicht vermittelt',
          fixedPricePros: '+ Hohe Planbarkeit',
          fixedPriceCons: '- Risiko bei Auftragsausfall',
          postRegisterTitle: 'Vergütungsmodell festlegen',
          postRegisterDescription:
            'Wählen Sie jetzt Ihr Vergütungsmodell. Sie können dies später jederzeit im Dashboard ändern.',
          continueToDashboard: 'Zum Dashboard',
          // OPT307-i18n — loadError + tierSelector (LEAD / COMMISSION / FIXED)
          loadError: 'Das Vergütungsmodell konnte nicht geladen werden.',
          tierSelector: {
            heading: 'Vergütungsstufe wählen',
            subheading:
              'Wählen Sie eines der drei Modelle und hinterlegen Sie die zugehörigen Werte.',
            leadTitle: 'Lead-Modell',
            leadHint: 'Fester Betrag pro zugewiesener Anfrage',
            leadFieldLabel: 'Preis pro Lead (€)',
            commissionTitle: 'Provisions-Modell',
            commissionHint: 'Prozentuale Beteiligung am Auftragswert',
            commissionFieldLabel: 'Provisionssatz (%)',
            minOrderValueLabel: 'Mindestauftragswert (€) (optional)',
            fixedTitle: 'Festpreis-Modell',
            fixedHint: 'Pauschalpreis pro abgeschlossenem Auftrag',
            fixedFieldLabel: 'Festpreis pro Auftrag (€)',
            validUntilLabel: 'Gültig bis (optional)',
            submit: 'Tarif aktivieren',
            submitting: 'Speichern...',
            successTitle: 'Tarif gespeichert',
            successDescription: 'Der neue Tarif wurde erfolgreich aktiviert.',
            errorTitle: 'Speichern fehlgeschlagen',
            invalidCommission: 'Provisionssatz muss zwischen 0 und 100 liegen.',
            invalidPrice: 'Bitte geben Sie einen gültigen Betrag > 0 ein.',
            invalidFixedPrice: 'Bitte geben Sie einen gültigen Festpreis > 0 ein.',
            modelLead: 'Lead',
            modelCommission: 'Provision',
            modelFixed: 'Festpreis',
          },
        },
        // P2.065 — Company Price-Tier-Settings-Card (Standard/Premium/Premium Plus)
        priceTierSettings: {
          heading: 'Tarif-Einstellungen',
          subheading:
            'Wählen Sie Ihren Tarif für die Anfragen-Zuordnung. Änderungen sind nur einmal täglich möglich und werden ab dem nächsten Tag um 00:00 Uhr aktiv.',
          currentTierLabel: 'Aktueller Tarif',
          noTierLabel: 'Noch kein Tarif festgelegt',
          perRequest: 'pro Anfrage',
          selectLabel: 'Neuen Tarif wählen',
          nextTierFrom: 'Ab {{date}} wechseln Sie zu',
          changeDailyWarning:
            'Sie haben heute bereits eine Tarifänderung vorgenommen. Eine weitere Änderung ist erst morgen möglich.',
          tierDisabledReason: 'Dieser Tarif ist aktuell im Admin-Menü für Firmen-User deaktiviert.',
          saving: 'Wird gespeichert...',
          saveButton: 'Tarif ändern (gültig ab morgen)',
          changeNotPossibleTitle: 'Änderung nicht möglich',
          changeNotPossibleDescription: 'Sie haben heute bereits eine Änderung vorgenommen.',
          successTitle: 'Tarif geändert',
          successDescription: 'Ihr neuer Tarif wird ab morgen ({{date}}) aktiv.',
          errorTitle: 'Fehler',
          errorDescription: 'Tarif konnte nicht geändert werden.',
          tierNames: {
            standard: 'Standard',
            premium: 'Premium',
            premium_plus: 'Premium Plus',
          },
          tierDescriptions: {
            standard: 'Basis-Sichtbarkeit für neue Anfragen',
            premium: 'Höhere Priorität bei der Zuordnung',
            premium_plus: 'Maximale Priorität und Sichtbarkeit',
          },
        },
        errorBoundary: {
          title: 'Etwas ist schiefgelaufen.',
          description:
            'Die Seite konnte nicht korrekt geladen werden. Bitte aktualisieren Sie die Seite oder versuchen Sie es später erneut.',
          reloadButton: 'Seite neu laden',
        },
        requestTypes: {
          private: 'Privatumzug',
          business: 'Firmenumzug',
          long_distance: 'Fernumzug',
          international: 'Auslandsumzug',
          special: 'Spezialumzug',
          official_relocation: 'Amtumzug',
          authority_relocation: 'Behoerdenumzug',
          assisted_move: 'Umzug mit Kostenuebernahme',
        },
        dashboard: {
          overviewTab: 'Übersicht',
          requestsTab: 'Anfragen',
          billingTab: 'Abrechnung',
          documentsTab: 'Dokumente',
          settingsTab: 'Einstellungen',
          notificationsTab: 'Benachrichtigungen',
          pricingTab: 'Vergütungsmodell',
          paymentsTab: 'Abrechnung',
          payNow: 'Jetzt bezahlen',
          customerFallback: 'Kunde',
          invoiceOpenError: 'Das Rechnungsdokument konnte nicht geöffnet werden.',
          requestDetailTitle: 'Anfrage Details',
          routeTitle: 'Umzugsroute',
          requestTypeTitle: 'Anfrageart',
          tierTitle: 'Preisstufe',
          customerContactTitle: 'Kundenkontakt',
          timelineTitle: 'Zeitverlauf',
          timelineAssigned: 'Anfrage zugewiesen',
          timelineMoveDate: 'Umzugstermin',
          timelineCurrentStatus: 'Aktueller Status: {{status}}',
          timelineNoTimestamp: 'Zeitpunkt nicht verfügbar',
          communicationTitle: 'Kommunikation',
          communicationEmpty: 'Noch keine Nachrichten zu dieser Anfrage vorhanden.',
          communicationCustomer: 'Kunde',
          communicationCompany: 'Ihre Firma',
          communicationLoadError: 'Nachrichten konnten nicht geladen werden.',
          activityTitle: 'Aktivitaet',
          activityEmpty: 'Noch keine Aktivitaet zu dieser Anfrage vorhanden.',
          activityStatusBadge: 'Status',
          activityMessageBadge: 'Nachricht',
          activityDocumentBadge: 'Dokument',
          activityMessageTitle: 'Nachricht von {{sender}}',
          activityDocumentTitle: 'Dokument hochgeladen: {{name}}',
          acceptAction: 'Anfrage annehmen',
          declineAction: 'Ablehnen',
          verificationRequiredForAccept: 'Verifizierung erforderlich, um Anfragen anzunehmen',
          rematchAssignment: 'Neuzuweisung',
          matchSuffix: 'Match',
          unlimited: 'Unbegrenzt',
          documentsCardTitle: 'Dokumentenstatus',
          documentsCardDesc: 'Verifizierungsunterlagen und Dateistand Ihrer Firma.',
          coverageCardTitle: 'Abdeckungsgebiet',
          coverageCardDesc: 'Aktuell konfigurierte Postleitzahlenbereiche für das Matching.',
          availabilityCardTitle: 'Verfuegbarkeit',
          availabilityCardDesc:
            'Aktive Wochentage, an denen Ihre Firma fuer neue Matches beruecksichtigt wird.',
          availabilityDaysLabel: 'aktive Tage',
          budgetCardTitle: 'Monatsbudget',
          budgetCardDesc: 'Operative Limits für Anfragen und Kosten pro Monat.',
          requestInsightsTitle: 'Anfragen-Insights',
          requestInsightsDesc: 'Schneller Überblick über Match-Qualität und Anfrage-Mix.',
          avgMatchScoreTitle: 'Ø Match-Score',
          responseRateTitle: 'Reaktionsquote',
          avgResponseHoursTitle: 'Ø Reaktionszeit',
          acceptanceRateRangeTitle: 'Annahmequote',
          completionRateTitle: 'Abschlussquote',
          assignedRequestsTitle: 'Zugewiesen',
          last30DaysTitle: 'Neue Anfragen 30 Tage',
          requestTypeMixTitle: 'Anfragearten',
          tierMixTitle: 'Preisstufen-Mix',
          tierMixDesc: 'Verteilung der eingehenden Anfragen nach Produktstufe.',
          performanceByTypeTitle: 'Leistung nach Anfrageart',
          performanceByTypeDesc:
            'Reaktion, Annahme und Abschluss nach Anfrageart im gewählten Zeitraum.',
          responseTargetTitle: 'Reaktionsziel',
          responseTargetOnTrack: 'Im Zielkorridor',
          responseTargetBehind: 'Der aktuelle Schnitt liegt ueber dem Ziel.',
          responseTargetUnset: 'Noch kein Ziel hinterlegt.',
          preferredRequestTypesTitle: 'Bevorzugte Anfragearten',
          noInsightData: 'Noch keine Daten vorhanden.',
          openInvoicesTitle: 'Offene Rechnungen',
          openInvoiceAmountTitle: 'Offener Betrag',
          paidPaymentsTitle: 'Bezahlt gesamt',
          pendingPaymentsTitle: 'Offene Payments',
          overdueInvoicesTitle: 'Ueberfaellige Rechnungen',
          latestDocumentTitle: 'Letzter Upload',
          documentTypesTitle: 'Dokumenttypen',
          reportFilterTitle: 'Zeitraum',
          reportFilterDesc: 'Filtert Insights, Billing und Dokumentenberichte nach Datum.',
          range30d: '30 Tage',
          range90d: '90 Tage',
          rangeAll: 'Gesamt',
          rangeCustom: 'Benutzerdefiniert',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          requestsInRangeTitle: 'Anfragen im Zeitraum',
          exportCsv: 'CSV Export',
          notificationSettingsTitle: 'E-Mail-Benachrichtigungen',
          notificationSettingsDescription:
            'Steuern Sie, welche E-Mail-Benachrichtigungen Ihre Firma erhalten soll.',
          matchingReadinessTitle: 'Matching-Bereitschaft',
          matchingReadinessDesc:
            'Zeigt, warum Ihre Firma aktuell gut fuer neue Anfragen sichtbar ist oder wo Konfiguration fehlt.',
          matchingReadinessReady: 'Bereit',
          matchingReadinessNeedsAction: 'Pruefen',
          matchingReadinessVerificationTitle: 'Verifizierung',
          matchingReadinessVerificationReady:
            'Ihre Firma ist verifiziert und kann regulär gematcht werden.',
          matchingReadinessVerificationPending:
            'Ohne abgeschlossene Verifizierung werden keine neuen Matches erzeugt.',
          matchingReadinessServiceAreaTitle: 'Einsatzgebiet',
          matchingReadinessServiceAreaReady: '{{count}} PLZ-Bereiche sind fuer das Matching aktiv.',
          matchingReadinessServiceAreaMissing:
            'Hinterlegen Sie mindestens einen PLZ-Bereich, damit Anfragen zur Route passen koennen.',
          matchingReadinessAvailabilityTitle: 'Verfuegbarkeit',
          matchingReadinessAvailabilityReady:
            '{{count}} Wochentage sind fuer neue Matches freigeschaltet.',
          matchingReadinessAvailabilityMissing:
            'Aktuell ist kein Wochentag freigegeben. So werden passende Anfragen ausgeschlossen.',
          matchingReadinessBudgetTitle: 'Budget und Sperren',
          matchingReadinessBudgetBlocked:
            'Aktuell blockiert eine Zahlungs- oder Blacklist-Sperre neue Zuordnungen.',
          matchingReadinessBudgetReached:
            '{{count}} von {{limit}} Monatsanfragen erreicht. Neue Matches bleiben bis zur Freigabe aus.',
          matchingReadinessBudgetReady:
            '{{count}} von {{limit}} Monatsanfragen genutzt. Budget ist noch verfuegbar.',
          matchingReadinessBudgetUnlimited:
            'Kein Anfragelimit gesetzt. Ihr Budget blockiert das Matching derzeit nicht.',
          matchingReadinessRequestTypesTitle: 'Anfragearten',
          matchingReadinessRequestTypesFocused:
            'Sie fokussieren aktuell {{count}} Anfragearten. Das reduziert das Match-Potenzial bewusst.',
          matchingReadinessRequestTypesOpen:
            'Es sind keine Anfragearten eingeschraenkt. Ihre Firma bleibt fuer alle Typen sichtbar.',
          matchingReadinessResponseTitle: 'Reaktionszeit',
          matchingReadinessResponseUnset:
            'Noch kein Reaktionsziel konfiguriert. Ein klares Ziel erleichtert die operative Steuerung.',
          matchingReadinessResponseNoData:
            'Noch keine belastbaren Reaktionsdaten fuer den gewaehlten Zeitraum vorhanden.',
          matchingReadinessResponseOnTrack:
            'Ø {{value}}h und damit innerhalb Ihres Ziels von {{target}}h.',
          matchingReadinessResponseBehind:
            'Ø {{value}}h und damit ueber Ihrem Ziel von {{target}}h.',
          tierReleaseStatus: {
            title: 'Tier-Freigabe',
            description:
              'Zeigt, wann neue Kundenanfragen fuer Ihr aktuelles Firmen-Tier freigeschaltet werden.',
            delayHint: 'Freigabe-Logik: {{minutes}} Minuten Vorlauf fuer neue Anfragen.',
            immediateTitle: 'Sofort im Matching',
            immediateDesc:
              'Mit Premium+ wird Ihre Firma fuer passende neue Anfragen ohne Vorlauf beruecksichtigt.',
            waitingTitle: 'Naechste Freigabe laeuft',
            waitingDesc_one:
              '{{count}} neue Anfrage befindet sich aktuell noch im Vorlauf. Danach kann Ihr Tier fuer passende Matches beruecksichtigt werden.',
            waitingDesc_other:
              '{{count}} neue Anfragen befinden sich aktuell noch im Vorlauf. Danach kann Ihr Tier fuer passende Matches beruecksichtigt werden.',
            countdownValue: '{{minutes}}m {{seconds}}s',
            nextReleaseAt: 'Naechste Freigabe um {{time}}.',
            readyTitle: 'Aktuell keine offene Wartezeit',
            readyDesc:
              'Derzeit wartet keine neue Anfrage mehr im {{minutes}}-Minuten-Fenster. Neue passende Anfragen werden nach diesem Vorlauf freigeschaltet.',
          },
          requestMatching: {
            title: 'Matching-Check fuer diese Anfrage',
            selectedTitle: 'Vom Kunden direkt bestaetigt',
            selectedDesc:
              'Diese Anfrage ist Ihrer Firma direkt ueber die Kundenauswahl bzw. bestehende Zuordnung zugeordnet.',
            eligibleTitle: 'Aktuell passend fuer Ihre Firma',
            eligibleDesc:
              'Nach Ihren aktuellen Einstellungen bleibt diese Anfrage fuer Ihr {{tier}}-Profil passend.',
            excludedTitle: 'Aktuell nicht mehr voll passend',
            excludedDesc:
              'Nach Ihren aktuellen Einstellungen wuerde diese Anfrage derzeit nicht mehr automatisch zugeordnet.',
            releaseTitle: 'Tier-Freigabe fuer diese Anfrage',
            releaseReadyDesc:
              'Das {{tier}}-Fenster mit {{minutes}} Minuten Vorlauf ist fuer diese Anfrage bereits erreicht.',
            releasePendingDesc:
              'Das {{tier}}-Fenster ist noch nicht offen. Voraussichtliche Freigabe in {{minutes}} Minuten.',
            releaseAt: 'Geplante Freigabe: {{time}}.',
            sourceLabel: 'Quelle',
            sourceSelected: 'Kundenauswahl',
            sourcePool: 'Automatisches Matching',
            tierLabel: 'Aktuelles Firmen-Tier',
            currentScoreLabel: 'Match-Score',
            noReasons: 'Fuer diese Anfrage liegen aktuell keine weiteren Matching-Hinweise vor.',
          },
          matchingInsights: {
            title: 'Matching-Potenzial',
            description:
              'Auswertung echter Nachfragemuster der letzten {{days}} Tage fuer Ihre Firma.',
            analyzedTitle: 'Gepruefte Anfragen',
            eligibleTitle: 'Direkt passend',
            excludedTitle: 'Mit Luecken',
            blockingReasonsTitle: 'Aktuelle Blocker',
            priorityHigh: 'Hoch',
            priorityMedium: 'Mittel',
            affectedRequests_one: '{{count}} Anfrage betroffen',
            affectedRequests_other: '{{count}} Anfragen betroffen',
            noRecommendations: 'Aktuell gibt es keine priorisierten Verbesserungsaufgaben.',
            marketTitle: 'Nachfrage-Snapshot',
            marketDesc:
              'Zeigt, wo im Markt zuletzt besonders viele passende oder verpasste Chancen lagen.',
            topRequestTypesTitle: 'Gefragte Anfragearten',
            topPostalAreasTitle: 'Starke PLZ-Gebiete',
            topSpecialServicesTitle: 'Gefragte Zusatzleistungen',
            topWeekdaysTitle: 'Hauefige Umzugstage',
            noSpecialServiceDemand:
              'Im gewaehlten Zeitraum wurden keine Zusatzleistungen angefragt.',
            marketHint:
              'Nutzen Sie diese Signale, um Einsatzgebiet, Leistungen und Verfuegbarkeit gezielt nachzuschaerfen.',
            clearAssignmentBlockTitle: 'Sperrgrund zuerst loesen',
            clearAssignmentBlockDesc:
              'Solange eine Billing- oder Blacklist-Sperre aktiv ist, erhalten Sie keine neuen Zuordnungen.',
            completeVerificationTitle: 'Verifizierung abschliessen',
            completeVerificationDesc:
              'Eine offene oder abgelehnte Verifizierung blockiert reguläres Matching vollstaendig.',
            expandServiceAreaTitle: 'Einsatzgebiet erweitern',
            expandServiceAreaDesc: 'Viele verpasste Chancen lagen zuletzt in {{areas}}.',
            expandRequestTypesTitle: 'Weitere Anfragearten freischalten',
            expandRequestTypesDesc:
              'Zusätzliche Sichtbarkeit ergibt sich vor allem bei {{requestTypes}}.',
            expandAvailabilityTitle: 'Verfuegbarkeit verbreitern',
            expandAvailabilityDesc: 'Besonders haeufig entgehen Anfragen an {{weekdays}}.',
            addSpecialServicesTitle: 'Weitere Zusatzleistungen anbieten',
            addSpecialServicesDesc:
              'Haeufig nachgefragt, bei Ihnen aber noch nicht hinterlegt: {{services}}.',
            increaseCapacityTitle: 'Kapazitaet erhoehen',
            increaseCapacityDesc:
              'Ein Teil der letzten Nachfrage lag ueber Ihrer aktuell hinterlegten Volumen-/Kapazitaetsgrenze.',
            increaseBudgetTitle: 'Monatsbudget pruefen',
            increaseBudgetDesc:
              'Ihr Anfragen-Budget war im Analysezeitraum ein wiederkehrender Ausschlussgrund.',
          },
          operationsAlertsTitle: 'Operations-Aktionscenter',
          operationsAlertsDesc:
            'Priorisiert offene Betriebsaufgaben fuer Dokumente, Wiedervorlagen, Einsatzgebiet und Verfuegbarkeit.',
          operationsAlertsEmpty: 'Aktuell sind keine operativen Nacharbeiten offen.',
          operationsAlertNeedsAction: 'Aktion noetig',
          operationsAlertMonitor: 'Im Blick behalten',
          operationsActionDocuments: 'Dokumente oeffnen',
          operationsActionSettings: 'Profil oeffnen',
          operationsAlertMissingDocsTitle: 'Fehlende Pflichtunterlagen',
          operationsAlertMissingDocsDesc_one:
            '{{count}} Verifizierungsdokument fehlt noch fuer eine vollstaendige Betriebsfreigabe.',
          operationsAlertMissingDocsDesc_other:
            '{{count}} Verifizierungsdokumente fehlen noch fuer eine vollstaendige Betriebsfreigabe.',
          operationsAlertRejectedDocsTitle: 'Reaktivierung nach Ablehnung noetig',
          operationsAlertRejectedDocsDesc_one:
            '{{count}} Dokument wurde abgelehnt. Laden Sie den Nachweis neu hoch, damit die Freigabe wieder aufgenommen werden kann.',
          operationsAlertRejectedDocsDesc_other:
            '{{count}} Dokumente wurden abgelehnt. Laden Sie neue Nachweise hoch, damit die Freigabe wieder aufgenommen werden kann.',
          operationsAlertPendingReviewTitle: 'Unterlagen in Pruefung',
          operationsAlertPendingReviewDesc_one: '{{count}} Dokument wartet auf Admin-Review.',
          operationsAlertPendingReviewDesc_other: '{{count}} Dokumente warten auf Admin-Review.',
          operationsAlertFollowUpDueTitle: 'Wiedervorlage heute faellig',
          operationsAlertFollowUpDueDesc_one:
            '{{count}} Dokumentenslot sollte heute erneut geprueft oder aktualisiert werden.',
          operationsAlertFollowUpDueDesc_other:
            '{{count}} Dokumentenslots sollten heute erneut geprueft oder aktualisiert werden.',
          operationsAlertFollowUpOverdueTitle: 'Wiedervorlage ueberfaellig',
          operationsAlertFollowUpOverdueDesc_one:
            '{{count}} Dokumentenslot hat eine ueberfaellige Wiedervorlage.',
          operationsAlertFollowUpOverdueDesc_other:
            '{{count}} Dokumentenslots haben ueberfaellige Wiedervorlagen.',
          operationsAlertServiceAreaMissingTitle: 'Einsatzgebiet fehlt',
          operationsAlertServiceAreaMissingDesc:
            'Ohne hinterlegte Postleitzahlenbereiche gehen passende Anfragen in der Vermittlung verloren.',
          operationsAlertServiceAreaNarrowTitle: 'Einsatzgebiet ist sehr eng',
          operationsAlertServiceAreaNarrowDesc:
            'Aktuell sind nur {{count}} PLZ-Bereiche hinterlegt. Mehr Reichweite erhoeht Ihre Sichtbarkeit.',
          operationsAlertAvailabilityMissingTitle: 'Verfuegbarkeit fehlt',
          operationsAlertAvailabilityMissingDesc:
            'Es ist kein aktiver Wochentag freigeschaltet. Neue Anfragen koennen so nicht zugeordnet werden.',
          operationsAlertAvailabilityLimitedTitle: 'Verfuegbarkeit ist eingeschraenkt',
          operationsAlertAvailabilityLimitedDesc:
            'Nur {{count}} aktive Tage sind freigeschaltet. Zusätzliche Tage verbessern die Reaktionsfaehigkeit.',
        },
        billing: {
          cardDesc: 'Verwalten und bezahlen Sie Zugangsgebühren für Anfragen.',
          invoicesTitle: 'Rechnungen',
          noInvoices: 'Noch keine Rechnungen vorhanden.',
          invoiceLabel: 'Rechnung',
          collectionsHeader: 'Mahnstufe',
          collectionStageTitle: 'Collections-Status',
          collectionStageCurrent: 'Im Zeitplan',
          collectionStageReminder1: 'Mahnstufe 1',
          collectionStageReminder2: 'Mahnstufe 2',
          collectionStageFinalNotice: 'Letzte Mahnung',
          collectionDays_one: '{{count}} Tag ueberfaellig',
          collectionDays_other: '{{count}} Tage ueberfaellig',
          collectionHealthy: 'Aktuell gibt es keine ueberfaelligen Rechnungen.',
          autoUnblockHint:
            'Nach erfolgreicher Zahlung und Statusabgleich werden Billing-Sperren automatisch aufgehoben.',
          historyTitle: 'Billing-Historie',
          historyEmpty: 'Noch keine Billing-Historie vorhanden.',
          historyKind: 'Typ',
          historyReference: 'Referenz',
          historyOccurredAt: 'Zeitpunkt',
          historyKindInvoice: 'Rechnung',
          historyKindPayment: 'Zahlung',
          dueDate: 'Fällig am',
          paymentsTitle: 'Zahlungen',
          noPayments: 'Keine Payment-Einträge für Ihre Firma vorhanden.',
          created: 'Erstellt',
          paidAt: 'Bezahlt am',
          redirectTitle: 'Weiterleitung zum Zahlungsanbieter…',
          redirectDesc: 'Bitte schließen Sie die Zahlung auf der geöffneten Seite ab.',
          missingCheckoutUrl: 'Der Server hat keine Checkout-URL zurückgegeben.',
          checkoutError: 'Checkout konnte nicht gestartet werden.',
          checkoutUnavailable:
            'Online-Zahlungen sind derzeit nicht konfiguriert. Bitte kontaktieren Sie den Support.',
          paymentPaid: 'Bezahlt',
          paymentPending: 'Offen',
          paymentFailed: 'Fehlgeschlagen',
          paymentCancelled: 'Storniert',
          paymentUnknown: 'Unbekannt',
          invoiceOverdue: 'Ueberfaellig',
        },
        assignmentBlockedPaymentTitle: 'Neue Zuordnungen sind blockiert',
        assignmentBlockedPaymentDesc:
          'Bitte begleichen Sie Rechnung {{invoice}} (faellig seit {{dueDate}}), damit Ihre Firma wieder neue Anfragen erhalten kann.',
        assignmentBlockedOpenBilling: 'Abrechnung oeffnen',
        assignmentBlockedOpenInvoice: 'Rechnung oeffnen',
        assignmentBlockedPaymentInlineTitle: 'Billing-Sperre aktiv',
        assignmentBlockedPaymentInlineDesc:
          'Rechnung {{invoice}} ist seit {{dueDate}} ueberfaellig. Nach Zahlung werden neue Zuordnungen wieder moeglich.',
        assignmentBlockedBlacklistTitle: 'Ihre Firma ist gesperrt',
        assignmentBlockedBlacklistDesc: 'Grund: {{reason}}. Gueltig bis: {{validUntil}}.',
        assignmentBlockedPermanent: 'permanent',
        assignmentBlockedStatusTitle: 'Sperrstatus',
        assignmentBlockedStatusDesc:
          'Neue Zuordnungen bleiben pausiert, bis alle aktiven Sperrgruende geklaert sind.',
        assignmentBlockedFactsTitle: 'Details',
        assignmentBlockedFactInvoice: 'Rechnung',
        assignmentBlockedFactDueDate: 'Faellig seit',
        assignmentBlockedFactCollectionStage: 'Mahnstufe',
        assignmentBlockedFactDaysOverdue: 'Ueberfaelligkeit',
        assignmentBlockedFactOverdueCount: 'Offene Rechnungen',
        assignmentBlockedFactReason: 'Sperrgrund',
        assignmentBlockedFactValidUntil: 'Gueltig bis',
        assignmentBlockedImpactTitle: 'Auswirkung',
        assignmentBlockedImpactDesc:
          'Ihre Firma erhaelt derzeit keine neuen Zuordnungen ueber den Marktplatz.',
        assignmentBlockedNextStepsTitle: 'Naechste Schritte',
        assignmentBlockedNextStepReviewBilling:
          'Pruefen Sie die offene Rechnung im Billing-Bereich.',
        assignmentBlockedNextStepPayInvoice:
          'Begleichen Sie die ueberfaellige Rechnung oder starten Sie direkt den Checkout.',
        assignmentBlockedNextStepAutoUnblock:
          'Nach Zahlung und Statusabgleich wird die Billing-Sperre automatisch aufgehoben.',
        assignmentBlockedNextStepReviewBlacklist:
          'Pruefen Sie den hinterlegten Sperrgrund und die Laufzeit der Sperre.',
        assignmentBlockedNextStepContactSupport:
          'Wenn die Sperre fachlich erledigt ist, kontaktieren Sie fuer die Entsperrung bitte das Admin-Team.',
        assignmentBlockedReasonPaymentLabel: 'Zahlungsverzug',
        assignmentBlockedReasonBlacklistLabel: 'Sperre',
        assignmentBlockedAdditionalReasonsTitle: 'Weitere aktive Sperrgruende',
        assignmentBlockedSecondaryReasonCount_one: '{{count}} weiterer Grund aktiv',
        assignmentBlockedSecondaryReasonCount_other: '{{count}} weitere Gruende aktiv',
        assignmentBlockedReasonPaymentSummary:
          'Rechnung {{invoice}} ist seit {{dueDate}} ueberfaellig.',
        assignmentBlockedReasonBlacklistSummary:
          'Sperrgrund: {{reason}}. Gueltig bis: {{validUntil}}.',
        recoveryAppeals: {
          title: 'Manuelle Pruefung & Entsperrung',
          description:
            'Reichen Sie eine Begruendung oder einen Nachweis ein, wenn eine Sperre geprueft werden soll.',
          verificationContextTitle: 'Offene Verifizierungspunkte fuer den Einspruch',
          verificationContextDesc:
            'Diese Dokument- und Wiedervorlage-Themen sollten Sie beim Entsperrungsantrag beruecksichtigen oder direkt im Dokumentenbereich aktualisieren.',
          empty: 'Noch keine Entsperrungsanfragen vorhanden.',
          historyTitle: 'Letzte Anfragen',
          openAction: 'Manuelle Pruefung anfragen',
          pendingAction: 'Anfrage in Pruefung',
          pendingTitle: 'Anfrage bereits offen',
          pendingDesc:
            'Es gibt bereits eine offene Entsperrungsanfrage. Bitte warten Sie auf die Rueckmeldung des Admin-Teams.',
          dialogTitle: 'Manuelle Entsperrungsanfrage',
          dialogDescription:
            'Beschreiben Sie den Sachverhalt und laden Sie optional einen Nachweis hoch.',
          reasonLabel: 'Begruendung',
          reasonPlaceholder:
            'Beschreiben Sie kurz, warum die Sperre geprueft oder aufgehoben werden soll.',
          reasonValidation: 'Bitte geben Sie mindestens 20 Zeichen fuer die Begruendung an.',
          proofLabel: 'Nachweis (optional)',
          proofHint: 'Optional koennen Sie einen Zahlungs- oder Klaerungsnachweis hochladen.',
          proofSelected: 'Ausgewaehlte Datei: {{filename}}',
          proofWorkspaceHint:
            'Dieser Nachweis gehoert nur zur Entsperrungsanfrage und erscheint nicht in der normalen Dokumentenliste.',
          openProof: 'Nachweis oeffnen',
          adminResponseLabel: 'Rueckmeldung',
          createdTitle: 'Anfrage eingereicht',
          createdDesc: 'Die Entsperrungsanfrage wurde an das Admin-Team weitergeleitet.',
          createError: 'Die Entsperrungsanfrage konnte nicht erstellt werden.',
          submit: 'Anfrage absenden',
          submitting: 'Anfrage wird gesendet...',
          status: {
            pending: 'In Pruefung',
            approved: 'Freigabe erteilt',
            rejected: 'Abgelehnt',
          },
        },
        documentsPanelTitle: 'Dokumentenverwaltung',
        documentsPanelDesc:
          'Laden Sie Verifizierungsunterlagen hoch und verwalten Sie bestehende Dokumente.',
        documentsListTitle: 'Dokumente',
        documentsListDesc: 'Alle derzeit hinterlegten Firmendokumente.',
        documentsCount_one: '{{count}} Dokument hinterlegt',
        documentsCount_other: '{{count}} Dokumente hinterlegt',
        documentsTotalTitle: 'Dokumente gesamt',
        documentsVerificationTitle: 'Verifizierungsdokumente',
        documentsOperationalTitle: 'Sonstige Dokumente',
        documentsPdfTitle: 'PDF Dateien',
        documentsUploadPurposeLabel: 'Upload Zweck',
        documentsAdditionalHint:
          'Zusatzdokumente sind fuer sonstige Firmenunterlagen gedacht. Nachweise fuer Entsperrungsanfragen laden Sie separat im Entsperrungsdialog hoch.',
        documentsPurposeLabel: 'Zweck',
        documentsCategoryLabel: 'Kategorie',
        documentsStatusLabel: 'Status',
        documentsStatusAvailable: 'Verfuegbar',
        documentsStatusVerified: 'Verifiziert',
        documentsStatusPending: 'In Pruefung',
        documentsStatusRejected: 'Abgelehnt',
        documentsCategoryPdf: 'PDF',
        documentsCategoryImage: 'Bild',
        documentsCategoryDocument: 'Dokument',
        documentsCategoryOther: 'Sonstiges',
        documentsEmpty: 'Noch keine Dokumente vorhanden.',
        documentsUploadedTitle: 'Dokumente hochgeladen',
        documentsUploadedDesc: 'Die Dokumente wurden gespeichert und zur Prüfung eingereicht.',
        additionalDocumentsUploadedDesc: 'Die zusätzlichen Firmendokumente wurden gespeichert.',
        documentsUploadError: 'Die Dokumente konnten nicht hochgeladen werden.',
        documentsDeletedTitle: 'Dokument gelöscht',
        documentsDeletedDesc: 'Das Dokument wurde entfernt.',
        documentsDeleteError: 'Das Dokument konnte nicht gelöscht werden.',
        documentsDownloadError: 'Das Dokument konnte nicht heruntergeladen werden.',
        documentsPurposeVerification: 'Verifizierung',
        documentsPurposeOther: 'Sonstige',
        documentsEmptyFiltered: 'Keine Dokumente für diesen Filter vorhanden.',
        documentTypes: {
          business_registration: 'Gewerbeanmeldung',
          liability_insurance: 'Haftpflicht - Firma',
          transport_liability_insurance: 'Transporthaftpflicht - Firma',
          other_or_eu_license: 'Sonstiges / Gueterkraftverkehrslizenz / EU-Lizenz',
        },
        documentUploadPerTypeDesc: 'Jede Dokumentenart wird separat hochgeladen und geprueft.',
        documentUploadRequiredDesc: 'Pflicht fuer die Firmenanmeldung.',
        documentUploadOptionalDesc:
          'Optional bei der Anmeldung, wird aber spaeter fuer die Auftragszuordnung beruecksichtigt.',
        documentReplacementQueued:
          'Das Dokument wurde hochgeladen und zur erneuten Pruefung eingereicht.',
        activeDocument: 'Aktives Dokument',
        pendingReplacement: 'Ersatzdokument in Pruefung',
        pendingReplacementKeepsActive:
          'Bis zur Freigabe bleibt das bisher genehmigte Dokument gueltig.',
        lastReviewTitle: 'Letzte Entscheidung',
        lastDecisionLabel: 'Status',
        lastReviewedAtLabel: 'Geprueft am',
        followUpTitle: 'Wiedervorlage',
        followUpDueAtValue: 'Faellig: {{date}}',
        followUpOverdueAtValue: 'Ueberfaellig seit {{date}}',
        followUpScheduledAtValue: 'Geplant: {{date}}',
        noReviewHistory: 'Noch keine Review-Historie vorhanden.',
        noFollowUp: 'Keine Wiedervorlage gesetzt.',
        noPendingReplacement: 'Kein Ersatzdokument hinterlegt.',
        noDocumentUploaded: 'Noch kein Dokument hochgeladen.',
        replaceDocument: 'Dokument ersetzen',
        uploadAdditionalDocuments: 'Weitere Dokumente hochladen',
        documentsOpenAction: 'Dokumentenbereich oeffnen',
        documentsLoadError:
          'Firmendokumente konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
        documentsRetryAction: 'Erneut laden',
        profile: {
          updatedTitle: 'Profil aktualisiert',
          updatedDesc: 'Ihre Änderungen wurden gespeichert.',
          updateError: 'Profil konnte nicht aktualisiert werden.',
          companyDataTitle: 'Firmendaten',
          companyDataDesc: 'Bearbeiten Sie Kontaktdaten, Einsatzgebiet und operative Grenzen.',
          descriptionPlaceholder: 'Beschreiben Sie Ihre Firma und Ihre Dienstleistungen...',
          capacityLabel: 'Kapazität (m³)',
          vehicleSizeLabel: 'Fahrzeuggröße',
          vehicleSizePlaceholder: 'z.B. 7.5t LKW',
          staffCountLabel: 'Anzahl Mitarbeiter',
          serviceAreaLabel: 'Handlungsgebiet (Postleitzahlen)',
          serviceAreaPlaceholder: 'z.B. 64291, 531, 40 (kommagetrennt)',
          serviceAreaHint:
            'Geben Sie Postleitzahlen oder Teile davon ein, z.B. 64291 für eine komplette PLZ oder 531 für alle PLZ, die mit 531 beginnen.',
          budgetTitle: 'Monatliches Anfragen-Budget',
          budgetCountLabel: 'Max. Anzahl Anfragen/Monat',
          budgetAmountLabel: 'Max. Betrag/Monat (€)',
          unlimitedPlaceholder: 'Unbegrenzt',
          budgetHint: 'Leer lassen für unbegrenztes Budget.',
          availabilityTitle: 'Verfuegbarkeit',
          availabilityDesc:
            'Steuern Sie, an welchen Wochentagen Ihre Firma fuer neue Anfragen gematcht werden darf.',
          availabilityHint: 'Deaktivierte Tage werden im Matching ausgeschlossen.',
          saveAction: 'Änderungen speichern',
          weekdays: {
            monday: 'Montag',
            tuesday: 'Dienstag',
            wednesday: 'Mittwoch',
            thursday: 'Donnerstag',
            friday: 'Freitag',
            saturday: 'Samstag',
            sunday: 'Sonntag',
          },
          serviceAreasTitle: 'Regionen',
          serviceAreasDesc: 'Ihre zusätzlich gepflegten regionalen Servicegebiete.',
          noRegions: 'Keine Regionen konfiguriert.',
          specialServicesTitle: 'Spezialservices',
          specialServicesDesc: 'Ihre angebotenen Zusatzleistungen.',
          specialServicesConfigTitle: 'Leistungen konfigurieren',
          specialServicesConfigDesc:
            'Waehlen Sie die Zusatzleistungen, mit denen Ihre Firma im Profil und operativ gefuehrt wird.',
          requestTypesTitle: 'Bevorzugte Anfragearten',
          requestTypesDesc:
            'Begrenzen Sie neue Matches auf die Anfragearten, die Ihre Firma aktiv bearbeiten moechte.',
          requestTypesHint:
            'Wenn nichts ausgewaehlt ist, erhaelt Ihre Firma weiterhin alle Anfragearten.',
          premiumPlusCriteriaTitle: 'Premium+ Matching-Kriterien',
          premiumPlusCriteriaDesc:
            'Definieren Sie optionale Filter, die nur fuer Premium+-Freigaben gelten.',
          premiumPlusMinVolumeLabel: 'Min. Umzugsvolumen (m³)',
          premiumPlusMaxVolumeLabel: 'Max. Umzugsvolumen (m³)',
          premiumPlusMinLeadTimeLabel: 'Min. Vorlaufzeit (Tage)',
          premiumPlusOptionalPlaceholder: 'Optional',
          premiumPlusCriteriaHint:
            'Leer gelassene Werte werden ignoriert. Premium+ Firmen koennen so exklusive Anfragen nach Volumen und Vorlaufzeit vorfiltern.',
          requestTypesSummaryTitle: 'Anfragearten',
          requestTypesSummaryDesc: 'Aktuell freigegebene Typen fuer neues Matching.',
          allRequestTypes: 'Alle Anfragearten aktiv.',
          responseTargetLabel: 'Reaktionsziel (Stunden)',
          responseTargetPlaceholder: 'z.B. 12',
          responseTargetHint: 'Optionales Ziel fuer Ihre interne Reaktionsgeschwindigkeit.',
          fleetTitle: 'Fahrzeugflotte',
          fleetDesc: 'Ihre hinterlegten Fahrzeuge fuer Einsatzplanung und Uebersicht.',
          fleetLabel: 'Fahrzeuge',
          fleetPlaceholder: 'z.B. 3.5t Transporter, 7.5t LKW, Moebellift',
          fleetHint: 'Mehrere Fahrzeuge kommagetrennt eingeben.',
          noFleet: 'Keine Fahrzeuge hinterlegt.',
          noSpecialServices: 'Keine Spezialservices hinterlegt.',
        },
        gallery: {
          title: 'Portfolio',
          empty: 'Diese Firma hat noch keine Portfolio-Bilder hinterlegt.',
          upload: 'Portfolio-Bilder hochladen',
          // P2.069 — hardcoded toast.description with count + pluralization
          uploadSuccessDesc_one: '{{count}} Bild hochgeladen',
          uploadSuccessDesc_other: '{{count}} Bilder hochgeladen',
          maxPhotos: 'Sie können bis zu 10 Portfolio-Bilder verwalten.',
          delete: 'Bild entfernen',
          edit: 'Portfolio bearbeiten',
          moveUp: 'Nach oben',
          moveDown: 'Nach unten',
        },
      },
      customer: {
        reviewDialog: {
          title: 'Firma bewerten: {{company}}',
          ratingLabel: 'Bewertung',
          ratingRequiredTitle: 'Bewertung erforderlich',
          ratingRequiredDesc: 'Bitte wählen Sie eine Sternebewertung aus.',
          tagsLabel: 'Tags (optional)',
          tags: {
            tagPunctual: 'Pünktlich',
            tagProfessional: 'Professionell',
            tagCareful: 'Sorgfältig',
            tagFriendly: 'Freundlich',
            tagFast: 'Schnell',
            tagGoodValue: 'Gutes Preis-Leistungs-Verhältnis',
          },
          commentLabel: 'Kommentar (optional)',
          commentPlaceholder: 'Teilen Sie Ihre Erfahrungen...',
          submit: 'Bewertung abgeben',
          submitting: 'Wird gespeichert...',
          successTitle: 'Bewertung abgegeben',
          successDesc: 'Vielen Dank für Ihr Feedback!',
          errorTitle: 'Fehler',
          errorDesc: 'Bewertung konnte nicht gespeichert werden.',
        },
        dashboard: {
          overviewTab: 'Übersicht',
          requestsTab: 'Anfragen',
          documentsTab: 'Dokumente',
          settingsTab: 'Einstellungen',
          notificationsTab: 'Benachrichtigungen',
          totalRequests: 'Gesamtanfragen',
          activeRequests: 'Aktive Anfragen',
          completedRequests: 'Abgeschlossene Anfragen',
          confirmedPartners: 'Bestätigte Firmen',
          newRequestDesc: 'Neue Umzugsanfrage anlegen und passende Firmen finden.',
          cancelledRequests: 'Stornierte Anfragen',
          archiveDesc: 'Archivierte Anfragen',
          profileDesc: 'Ihr Profil und Ihre Kontaktdaten.',
          requestsDesc: 'Verlauf, Status und Angebotsstand Ihrer Anfragen.',
          emptyRequestsDesc: 'Sie haben noch keine Anfragen erstellt.',
          requestInsightsTitle: 'Anfragen-Insights',
          requestInsightsDesc: 'Überblick über neue Anfragen, Angebotslage und Dokumente.',
          last30DaysTitle: 'Neue Anfragen 30 Tage',
          avgOffersTitle: 'Ø zugeordnete Angebote',
          documentsStoredTitle: 'Dokumente',
          tierMixTitle: 'Preisstufen-Mix',
          tierMixDesc: 'Verteilung Ihrer Anfragen nach Produktstufe.',
          activeSectionTitle: 'Aktive Anfragen',
          archiveSectionTitle: 'Archiv',
          noActiveRequests: 'Keine aktiven Anfragen vorhanden.',
          noArchivedRequests: 'Noch keine archivierten Anfragen vorhanden.',
          reportFilterTitle: 'Zeitraum',
          reportFilterDesc: 'Filtert Uebersicht, Verlauf und Dokumente nach Erstellungsdatum.',
          range30d: '30 Tage',
          range90d: '90 Tage',
          rangeAll: 'Gesamt',
          rangeCustom: 'Benutzerdefiniert',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          requestsInRangeTitle: 'Anfragen im Zeitraum',
          exportCsv: 'CSV Export',
          noDataInRange: 'Fuer diesen Zeitraum sind keine Daten vorhanden.',
          newRequestBlockedDesc: 'Neue Anfragen sind waehrend der aktiven Sperre deaktiviert.',
          requestsBlockedAlert:
            'Anfragen, Chat und neue Anfragen sind fuer dieses Kundenkonto aktuell blockiert. Reichen Sie bei Bedarf eine Entsperrungsanfrage ein.',
          missingDocsBadge: '{{count}} Nachweise fehlen noch',
        },
        blockStatus: {
          title: 'Konto gesperrt',
          description:
            'Ihr Kundenkonto ist derzeit fuer neue Anfragen und Anfragekommunikation gesperrt.',
          badge: 'Sperre aktiv',
          reasonTitle: 'Sperrgrund',
          reasonDescription: 'Grund: {{reason}}. Gueltig bis: {{validUntil}}.',
          permanent: 'Permanent',
          reasonLabel: 'Grund',
          validUntilLabel: 'Gueltig bis',
          factsTitle: 'Sperrdetails',
          impactTitle: 'Auswirkungen',
          impactDescription:
            'Sie koennen aktuell keine neuen Anfragen erstellen und keine bestehenden Anfragebereiche ueber die gesperrten APIs verwalten.',
          nextStepsTitle: 'Naechste Schritte',
          nextStepReviewReason: 'Pruefen Sie den hinterlegten Sperrgrund und offene Rueckfragen.',
          nextStepSubmitAppeal:
            'Reichen Sie eine Entsperrungsanfrage mit Begruendung oder Nachweis ein.',
          nextStepPendingReview:
            'Ihre Entsperrungsanfrage ist bereits in Pruefung. Warten Sie auf die Rueckmeldung des Admin-Teams.',
          nextStepContactSupport:
            'Kontaktieren Sie den Support, falls Sie weitere Kontextinformationen teilen moechten.',
        },
        recoveryAppeals: {
          title: 'Entsperrungsanfragen',
          description:
            'Verfolgen Sie den Status Ihrer manuellen Pruefanfragen und reichen Sie bei Bedarf neue Nachweise ein.',
          openAction: 'Entsperrung anfragen',
          pendingAction: 'Anfrage in Pruefung',
          dialogTitle: 'Entsperrungsanfrage einreichen',
          dialogDescription:
            'Beschreiben Sie den Hintergrund der Sperre und laden Sie optional einen Nachweis hoch.',
          reasonLabel: 'Begruendung',
          reasonPlaceholder:
            'Beschreiben Sie, warum Ihr Konto wieder freigeschaltet werden sollte und welche Aenderungen erfolgt sind.',
          reasonValidation: 'Bitte geben Sie mindestens 20 Zeichen fuer die Begruendung an.',
          proofLabel: 'Optionaler Nachweis',
          proofHint: 'Sie koennen optional einen PDF-, Bild- oder Office-Nachweis hochladen.',
          proofSelected: 'Ausgewaehlte Datei: {{filename}}',
          proofWorkspaceHint:
            'Dieser Nachweis gehoert nur zur Entsperrungsanfrage und erscheint nicht in Ihrer normalen Dokumentenliste.',
          submit: 'Anfrage senden',
          submitting: 'Wird gesendet...',
          createdTitle: 'Entsperrungsanfrage eingereicht',
          createdDesc: 'Ihre Anfrage wurde an das Admin-Team weitergeleitet.',
          createError: 'Die Entsperrungsanfrage konnte nicht erstellt werden.',
          pendingTitle: 'Anfrage bereits offen',
          pendingDesc: 'Es gibt bereits eine offene Entsperrungsanfrage fuer Ihr Konto.',
          empty: 'Es liegen noch keine Entsperrungsanfragen vor.',
          historyTitle: 'Letzte Anfragen',
          openProof: 'Nachweis oeffnen',
          adminResponseLabel: 'Admin-Rueckmeldung',
          status: {
            pending: 'In Pruefung',
            approved: 'Freigegeben',
            rejected: 'Abgelehnt',
          },
        },
        profile: {
          personalTitle: 'Persönliche Informationen',
          personalDesc: 'Verwalten Sie Ihre Kontaktdaten.',
          fullNameLabel: 'Vollständiger Name',
          fullNamePlaceholder: 'Max Mustermann',
          phonePlaceholder: '+49 30 1234567',
          addressTitle: 'Adresse',
          addressDesc: 'Ihre Wohnadresse für Rückfragen und Planung.',
          streetLabel: 'Straße und Hausnummer',
          streetPlaceholder: 'Musterstraße 123',
          postalCodeLabel: 'Postleitzahl',
          cityLabel: 'Stadt',
          cityPlaceholder: 'Berlin',
          countryLabel: 'Land',
          countryPlaceholder: 'Deutschland',
          notificationsTitle: 'Kommunikationspraeferenzen',
          notificationsDesc:
            'Steuern Sie, zu welchen Kundenereignissen Sie Benachrichtigungen erhalten moechten.',
          notifications: {
            emailNewRequests: 'Benachrichtigungen zu neuen oder aktualisierten Anfragen',
            emailMessages: 'Benachrichtigungen zu neuen Nachrichten',
            emailStatusUpdates: 'Benachrichtigungen zu Statusaenderungen',
            emailDocuments: 'Benachrichtigungen zu Dokumentenaktivitaet',
          },
          saveAction: 'Alle Änderungen speichern',
          updatedTitle: 'Profil aktualisiert',
          updatedDesc: 'Ihr Profil wurde gespeichert.',
          updateError: 'Profil konnte nicht gespeichert werden.',
          loadError: 'Profil konnte nicht geladen werden.',
        },
        documents: {
          title: 'Dokumente',
          desc: 'Verwalten Sie requestbezogene Dateien und Nachweise.',
          totalDocumentsTitle: 'Dokumente gesamt',
          activeDocumentsTitle: 'Aktive Anfragen',
          archivedDocumentsTitle: 'Archivierte Anfragen',
          pdfDocumentsTitle: 'PDF Dateien',
          statusActive: 'Aktiv',
          categoryLabel: 'Kategorie',
          categoryPdf: 'PDF',
          categoryImage: 'Bild',
          categoryDocument: 'Dokument',
          categoryOther: 'Sonstiges',
          uploadForRequest: 'Dokument für Anfrage hochladen',
          selectRequest: 'Anfrage auswählen',
          noUploadRequestTitle: 'Noch keine Anfrage für Dokument-Uploads vorhanden',
          noUploadRequestDesc:
            'Legen Sie zuerst eine Anfrage an. Danach wird sie hier automatisch für den Dokument-Upload auswählbar.',
          singleRequestHint:
            'Die einzige verfügbare Anfrage ist bereits vorausgewählt: {{request}}',
          uploadPurposeLabel: 'Dokumenttyp',
          uploadPurposePlaceholder: 'Dokumenttyp auswählen',
          uploadPurposeHint:
            'Normale Anfrage-Dokumente erscheinen hier. Nachweise fuer Entsperrungsanfragen werden separat im Entsperrungsdialog hochgeladen.',
          selectedPurposeHint: 'Ausgewaehlter Zweck: {{purpose}}',
          purposeOther: 'Sonstige Unterlage',
          purposeOtherHint:
            'Waehlen Sie diese Option fuer allgemeine anfragebezogene Dateien ohne festen Nachweistyp.',
          purposeCustomerIdentity: 'Ausweis / Identitaetsnachweis',
          purposeCoverageApproval: 'Kostenuebernahme / Bewilligung',
          purposeAuthorityReference: 'Behoerdenunterlage / Aktenzeichen',
          purposeCareLevelProof: 'Pflegegrad- / Pflegekassennachweis',
          uploadAction: 'Dokument hochladen',
          quickUploadTitle: 'Gezielte Nachweise fuer diese Anfrage',
          quickUploadDesc:
            'Fehlende Unterlagen koennen direkt mit dem passenden Zweck hochgeladen werden.',
          quickUploadComplete: 'Alle derzeit erwarteten Nachweise liegen vor',
          quickUploadMissing_one: '{{count}} Nachweis fehlt noch',
          quickUploadMissing_other: '{{count}} Nachweise fehlen noch',
          listTitle: 'Dateien',
          listDesc: 'Alle hochgeladenen Dokumente zu Ihren Anfragen.',
          empty: 'Noch keine Dokumente vorhanden.',
          emptyFiltered: 'Keine Dokumente für diesen Filter vorhanden.',
          uploadedTitle: 'Dokumente hochgeladen',
          uploadedDesc: 'Die Dateien wurden Ihrer Anfrage zugeordnet.',
          uploadError: 'Dokumente konnten nicht hochgeladen werden.',
          downloadError: 'Dokument konnte nicht heruntergeladen werden.',
          deletedTitle: 'Dokument gelöscht',
          deletedDesc: 'Das Dokument wurde entfernt.',
          deleteError: 'Dokument konnte nicht gelöscht werden.',
          noRequest: 'Keine Anfrage',
          loadError:
            'Nicht alle Dokumente konnten geladen werden. Einige Eintraege fehlen moeglicherweise voruebergehend.',
          retryAction: 'Erneut laden',
        },
      },
      notificationCenter: {
        title: 'Benachrichtigungscenter',
        description:
          'Alle ausgelieferten Systembenachrichtigungen in einer nachvollziehbaren Historie.',
        allFilter: 'Alle',
        unreadFilter: 'Ungelesen',
        typeFilterLabel: 'Benachrichtigungstyp',
        typeFilterAll: 'Alle Typen',
        refreshAction: 'Aktualisieren',
        emptyAll: 'Es liegen noch keine Benachrichtigungen vor.',
        emptyUnread: 'Es gibt aktuell keine ungelesenen Benachrichtigungen.',
        loadError: 'Benachrichtigungen konnten nicht geladen werden.',
        markReadError: 'Benachrichtigung konnte nicht als gelesen markiert werden.',
        markReadAction: 'Als gelesen markieren',
        markAllReadAction: 'Alle als gelesen markieren',
        markAllReadError: 'Benachrichtigungen konnten nicht gesammelt als gelesen markiert werden.',
        markAllReadSuccess: 'Benachrichtigungen aktualisiert',
        markAllReadSuccessDesc:
          'Alle Benachrichtigungen der aktuellen Auswahl wurden als gelesen markiert.',
        unreadBadge: 'Ungelesen',
        readBadge: 'Gelesen',
        receivedAt: 'Empfangen am {{date}}',
        pageSummary: 'Seite {{page}} von {{totalPages}}',
        previousAction: 'Zurueck',
        nextAction: 'Weiter',
        totalCount: '{{count}} gesamt',
        unreadCount: '{{count}} ungelesen',
        filteredUnreadCount: '{{count}} in Auswahl ungelesen',
        eventLabels: {
          company_new_request_assignment: 'Neue Anfrage fuer Firma',
          customer_company_response: 'Firmenantwort',
          customer_no_matching_companies: 'Keine passende Firma gefunden',
          customer_company_confirmed: 'Firmenbestaetigung',
          company_selected_confirmation: 'Kundenauswahl bestaetigt',
          customer_cancellation_review: 'Stornoentscheidung fuer Kunde',
          company_cancellation_review: 'Stornoentscheidung fuer Firma',
          company_verification_clarification_requested: 'Rueckfrage zu Verifizierungsdokumenten',
        },
      },
      pricing: {
        tabTitle: 'Vergütungsmodell',
        tabDescription:
          'Wählen Sie, wie Ihre Firma für Anfragen vergütet wird. Der Wechsel ist nur möglich, wenn keine offenen Rechnungen, Provisionsvereinbarungen oder Festpreisangebote existieren.',
        currentModelBadge: 'Aktuell aktiv',
        activate: 'Aktivieren',
        activating: 'Aktivierung läuft...',
        saveChanges: 'Änderungen speichern',
        notesLabel: 'Interne Notiz (optional)',
        notesPlaceholder: 'z.B. Sonderkonditionen für Großkunden',
        leadTitle: 'Lead-Vergütung',
        leadSubtitle: 'Klassische Provision pro zugewiesener Anfrage',
        leadDescription:
          'Sie zahlen einen festen Betrag pro qualifizierter Anfrage, die wir Ihnen zuweisen. Ideal für eine einfache, planbare Kostenstruktur.',
        leadTiers: 'Standard: 8 € · Premium: 12 € · Premium Plus: 15 €',
        leadPros: 'Einfache, vorhersehbare Kosten pro Anfrage',
        leadCons: 'Höhere Kosten bei Großaufträgen ohne Umsatzbeteiligung',
        commissionTitle: 'Provisionsvergütung',
        commissionSubtitle: 'Anteil am Auftragswert statt fixer Lead-Pauschale',
        commissionDescription:
          'Sie zahlen eine prozentuale Provision auf den tatsächlichen Auftragswert. Wir empfehlen eine Rate zwischen 5 % und 20 %. Standard sind 10 %, falls nicht überschrieben.',
        commissionRateLabel: 'Provisionssatz (%)',
        commissionRateHelp: 'Wert zwischen 0 und 100. Standard: 10 %.',
        commissionExample: 'Beispiel: 1.500 € Auftrag × 10 % = 150 € Provision',
        commissionPros: 'Faire Beteiligung am tatsächlichen Auftragswert',
        commissionCons: 'Aufwand bei Buchhaltung und Rechnungsstellung',
        fixedPriceTitle: 'Festpreisvergütung',
        fixedPriceSubtitle: 'Fester Betrag pro abgeschlossenem Auftrag',
        fixedPriceDescription:
          'Sie hinterlegen einen festen Betrag pro Auftrag. Der Mindestauftragswert sorgt dafür, dass sich das Modell nur für Aufträge ab einer definierten Größe lohnt.',
        contractAmountLabel: 'Festpreis pro Auftrag (€)',
        contractAmountHelp: 'Standard: 1,2-facher Lead-Preis, mindestens 200 €.',
        minContractValueLabel: 'Mindest-Auftragswert (€)',
        minContractValueHelp:
          'Wir empfehlen mindestens 200 €, damit das Modell wirtschaftlich bleibt.',
        fixedPriceExample: 'Beispiel: Festpreis 240 € × 12 Aufträge = 2.880 € / Monat',
        fixedPricePros: 'Planbare Einnahmen pro Auftrag, klare Kalkulation',
        fixedPriceCons: 'Risiko bei kleinen Aufträgen unter dem Mindestwert',
        confirmTitle: 'Vergütungsmodell wechseln',
        confirmDescription:
          'Möchten Sie wirklich zum Modell „{{model}}" wechseln? Diese Aktion wird mit einem Audit-Log-Eintrag dokumentiert und kann nur ohne offene Posten durchgeführt werden.',
        confirmModelLead: 'Lead-Vergütung',
        confirmModelCommission: 'Provisionsvergütung',
        confirmModelFixedPrice: 'Festpreisvergütung',
        successTitle: 'Vergütungsmodell aktualisiert',
        successDescription: 'Ihre Firma rechnet ab sofort nach dem Modell „{{model}}" ab.',
        errorTitle: 'Aktualisierung fehlgeschlagen',
        errorBlocked:
          'Das Vergütungsmodell kann nicht gewechselt werden, solange offene Rechnungen, Zahlungen, Provisionen oder Festpreisangebote existieren. Bitte schließen Sie diese zuerst ab.',
        errorGeneric:
          'Das Vergütungsmodell konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
        loadError: 'Das Vergütungsmodell konnte nicht geladen werden.',
        // P1.W2 v1 — 3-stufiges Pricing (LEAD / COMMISSION / FIXED)
        tierSelector: {
          heading: 'Vergütungsstufe wählen',
          subheading:
            'Wählen Sie eines der drei Modelle und hinterlegen Sie die zugehörigen Werte.',
          leadTitle: 'Lead-Modell',
          leadHint: 'Fester Betrag pro zugewiesener Anfrage',
          leadFieldLabel: 'Preis pro Lead (€)',
          commissionTitle: 'Provisions-Modell',
          commissionHint: 'Prozentualer Anteil am Auftragswert',
          commissionFieldLabel: 'Provisionssatz (%)',
          minOrderValueLabel: 'Mindest-Auftragswert (€) (optional)',
          fixedTitle: 'Festpreis-Modell',
          fixedHint: 'Pauschalpreis pro abgeschlossenem Auftrag',
          fixedFieldLabel: 'Festpreis pro Auftrag (€)',
          validUntilLabel: 'Gültig bis (optional)',
          submit: 'Tarif aktivieren',
          submitting: 'Wird gespeichert…',
          successTitle: 'Tarif gespeichert',
          successDescription: 'Der neue Tarif wurde erfolgreich aktiviert.',
          errorTitle: 'Speichern fehlgeschlagen',
          invalidCommission: 'Provisionssatz muss zwischen 0 und 100 liegen.',
          invalidPrice: 'Bitte geben Sie einen gültigen Betrag > 0 ein.',
          invalidFixedPrice: 'Bitte geben Sie einen gültigen Festpreis > 0 ein.',
          modelLead: 'Lead',
          modelCommission: 'Provision',
          modelFixed: 'Festpreis',
        },
      },
      // P2.068 — hardcoded aria-label in ProcessSteps.tsx (Schritt {{number}})
      process: {
        stepLabel: 'Schritt {{number}}',
      },
      // P2.068 — hardcoded German strings in CompanyCompare.tsx formatPrice()
      compare: {
        priceFree: 'kostenlos',
        priceFrom: 'ab {{amount}} €',
      },
      // P2.075 — hardcoded German placeholders in CompanyCompare bulk request
      bulkRequestPlaceholder: 'Vergleichsanfrage',
      // P2.075 — hardcoded German meta-description in PublicCompanyProfile.tsx
      publicProfile: {
        metaTitleWithName: '{{name}} - Umzugsfirma Profil',
        metaTitleDefault: 'Umzugsfirma Profil',
        metaDescriptionWithName:
          '{{name}} auf regionalumzug24: Bewertungen, Regionen und Leistungen für Ihren nächsten Umzug im Überblick.',
        metaDescriptionDefault:
          'Entdecken Sie geprüfte Umzugsfirmen mit Bewertungen, Leistungsprofil und regionalem Fokus auf regionalumzug24.',
      },
      admin: {
        common: {
          toggleOn: 'AN',
          toggleOff: 'AUS',
        },
        userDialog: {
          editTitle: 'Benutzer bearbeiten',
          createTitle: 'Neuer Benutzer',
          editDesc: 'Benutzerdaten aktualisieren',
          createDesc: 'Neuen Benutzer anlegen',
          emailLabel: 'E-Mail',
          nameLabel: 'Name',
          passwordLabel: 'Passwort',
          passwordOptionalHint: '(optional - nur bei Änderung)',
          passwordPlaceholder: 'Leer lassen für keine Änderung',
          roleLabel: 'Rolle',
          roleCustomer: 'Kunde',
          roleCompany: 'Firma',
          roleAdmin: 'Admin',
          cancel: 'Abbrechen',
          save: 'Speichern',
          saving: 'Speichern...',
          updatedTitle: 'Benutzer aktualisiert',
          updatedDesc: 'Die Änderungen wurden gespeichert.',
          createdTitle: 'Benutzer erstellt',
          createdDesc: 'Der neue Benutzer wurde erfolgreich angelegt.',
          errorTitle: 'Fehler',
          errorDesc: 'Benutzer konnte nicht gespeichert werden.',
        },
        invoiceDialog: {
          title: 'Rechnung erstellen',
          description: 'Manuelle Zahlungsanforderung für eine Firmenzuordnung anlegen',
          defaultTitle: 'Rechnung für {{request}}',
          successTitle: 'Rechnung erstellt',
          successDesc: 'Die Rechnung wurde als eigener Datensatz gespeichert.',
          errorTitle: 'Fehler',
          errorDesc: 'Rechnung konnte nicht erstellt werden.',
          companyLabel: 'Firma',
          requestLabel: 'Anfrage',
          amountLabel: 'Betrag (€)',
          titleLabel: 'Titel',
          titlePlaceholder: 'z.B. Vermittlungsrechnung',
          dueDateLabel: 'Fällig am (optional)',
          descriptionLabel: 'Beschreibung (optional)',
          descriptionPlaceholder: 'Interner Hinweis oder Leistungsbeschreibung',
          invoiceHint: 'Dies erzeugt eine Rechnung. Zahlungen bleiben davon fachlich getrennt.',
          cancel: 'Abbrechen',
          create: 'Erstellen',
          creating: 'Erstellen...',
        },
        dashboard: 'Admin Dashboard',
        dashboardDesc: 'Verwaltung und Übersicht',
        users: 'Benutzer',
        companies: 'Firmen',
        requests: 'Anfragen',
        cancellations: 'Stornierungen',
        legal: 'Rechtliches',
        userManagement: 'Benutzerverwaltung',
        userManagementDesc: 'Benutzer verwalten und erstellen',
        companyManagement: 'Firmenverwaltung',
        companyManagementDesc: 'Firmen verifizieren und verwalten',
        companyAssignmentStatus: 'Zuweisungsstatus',
        companyOperations: 'Operations',
        companyOperationsStable: 'Stabil',
        companyOperationsMore_one: '+{{count}} weiterer Hinweis',
        companyOperationsMore_other: '+{{count}} weitere Hinweise',
        companyAssignmentActive: 'Freigegeben',
        companyAssignmentActiveDesc: 'Keine aktive Sperre fuer neue Zuordnungen.',
        companyAssignmentBlockedDesc: 'Neue Zuordnungen sind derzeit blockiert.',
        companyAssignmentBlockedPayment: 'Durch Billing gesperrt',
        companyAssignmentBlockedPaymentDesc:
          'Rechnung {{invoice}} ist seit {{dueDate}} offen und blockiert neue Zuordnungen.',
        companyAssignmentBlockedBlacklist: 'Manuell gesperrt',
        companyAssignmentBlockedBlacklistDesc:
          'Sperrgrund: {{reason}}. Gueltig bis: {{validUntil}}.',
        requestManagement: 'Anfragenverwaltung',
        requestManagementDesc: 'Umzugsanfragen überwachen',
        cancellationRequests: 'Stornierungsanfragen',
        cancellationRequestsDesc: 'Stornierungsanfragen bearbeiten',
        legalContent: 'Rechtliche Inhalte',
        legalContentDesc: 'Impressum und Datenschutz verwalten',
        newUser: 'Neuer Benutzer',
        newCompany: 'Neue Firma',
        registeredUsers: 'Registrierte Benutzer',
        userList: {
          searchPlaceholder: 'Nach E-Mail oder Name suchen',
          roleAll: 'Alle Rollen',
          roleCustomer: 'Kunden',
          roleCompany: 'Firmen',
          roleAdmin: 'Admins',
          filteredCount: '{{count}} Benutzer',
          emptyState: 'Keine Benutzer fuer die aktuellen Filter gefunden.',
          export: 'Benutzer exportieren',
          exportError: 'Der Benutzerexport konnte nicht exportiert werden.',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Benutzer',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
        },
        companyList: {
          searchPlaceholder: 'Nach Firma, E-Mail oder Inhaber suchen',
          statusAll: 'Alle Stati',
          statusPending: 'Verifizierung ausstehend',
          statusVerified: 'Verifiziert',
          statusRejected: 'Abgelehnt',
          filteredCount: '{{count}} Firmen',
          emptyState: 'Keine Firmen fuer die aktuellen Filter gefunden.',
          export: 'Firmen exportieren',
          exportError: 'Der Firmenexport konnte nicht exportiert werden.',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Firmen',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
        },
        requestList: {
          searchPlaceholder: 'Nach Route, PLZ oder Kunde suchen',
          statusAll: 'Alle Stati',
          filteredCount: '{{count}} Anfragen',
          emptyState: 'Keine Anfragen fuer die aktuellen Filter gefunden.',
          export: 'Anfragen exportieren',
          exportError: 'Der Anfrageexport konnte nicht exportiert werden.',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Anfragen',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
        },
        total: 'Gesamt',
        roles: 'Rollen',
        registeredOn: 'Registriert am',
        verified: 'Verifiziert',
        verify: 'Verifizieren',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        company: 'Firma',
        request: 'Anfrage',
        requestedOn: 'Angefragt am',
        reason: 'Grund',
        noCancellationRequests: 'Keine Stornierungsanfragen',
        noAdminRights: 'Keine Admin-Rechte',
        dataLoadError: 'Fehler beim Laden der Daten',
        statusUpdated: 'Status aktualisiert',
        statusUpdateError: 'Fehler beim Aktualisieren des Status',
        companyVerified: 'Firma verifiziert',
        companyRejected: 'Firma abgelehnt',
        cancellationApproved: 'Stornierung genehmigt',
        cancellationApprovedDesc: 'Die Stornierungsanfrage wurde genehmigt',
        cancellationRejected: 'Stornierung abgelehnt',
        cancellationRejectedDesc: 'Die Stornierungsanfrage wurde abgelehnt',
        cancellationUpdateError: 'Fehler beim Aktualisieren der Stornierung',
        imprintDesc: 'Impressum bearbeiten',
        privacyDesc: 'Datenschutzerklärung bearbeiten',
        requestTimelineAction: 'Timeline',
        requestTimelineTitle: 'Anfrage-Timeline',
        requestTimelineDescription: 'Statusverlauf und Aktivitaeten zu dieser Anfrage.',
        requestTimelineLoadError: 'Die Anfrage-Timeline konnte nicht geladen werden.',
        operations: {
          summaryRematchTitle: 'Rematch-Queue',
          summaryRematchDesc: 'Anfragen mit offenen Matching-Slots.',
          summaryCancellationTitle: 'Storno-Queue',
          summaryCancellationDesc: 'Firmenstornos mit offener Entscheidung.',
          summaryBillingTitle: 'Billing-Issues',
          summaryBillingDesc: 'Faelle mit fehlender oder ueberfaelliger Abrechnung.',
          summaryVerificationTitle: 'Verifizierungs-Issues',
          summaryVerificationDesc: 'Offene Dokumentpruefungen und fehlende Nachweise.',
          queueTitle: 'Priorisierte Operations-Queue',
          queueDesc:
            'Alle offenen Problemfaelle in einer priorisierten Liste mit direkten Folgeaktionen.',
          queueEmpty: 'Keine offenen Operations-Faelle in diesem Filter.',
          exportQueue: 'Queue exportieren',
          exportError: 'Die Queue konnte nicht exportiert werden.',
          exportBillingIssues: 'Billing exportieren',
          exportVerificationIssues: 'Verifizierung exportieren',
          categoryColumn: 'Bereich',
          priorityColumn: 'Prioritaet',
          issueColumn: 'Problemfall',
          ageColumn: 'Alter',
          categoryRematch: 'Rematch',
          categoryCancellation: 'Storno',
          categoryBilling: 'Billing',
          categoryVerification: 'Verifizierung',
          severityAll: 'Alle Prioritaeten',
          severityHigh: 'Hoch',
          severityMedium: 'Mittel',
          searchPlaceholder: 'Suche nach Firma, Anfrage oder Referenz',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Eintraege',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
          ageToday: 'Heute',
          ageDays_one: '{{count}} Tag',
          ageDays_other: '{{count}} Tage',
          issueRematchDesc: '{{remaining}} von {{desired}} Slots sind noch offen.',
          issueMissingBillingSetup: 'Billing-Setup fehlt',
          issueMissingBillingSetupDesc:
            '{{company}} hat fuer {{request}} noch weder Payment noch Rechnung.',
          issueMissingInvoiceAfterPayment: 'Rechnung nach Zahlung fehlt',
          issueMissingInvoiceAfterPaymentDesc:
            '{{company}} hat fuer {{request}} bereits gezahlt, aber es gibt noch keine Rechnung.',
          issueDraftInvoiceStale: 'Rechnungsentwurf liegt zu lange offen',
          issueDraftInvoiceStaleDesc: 'Entwurf {{invoice}} wurde noch nicht weiterbearbeitet.',
          issueInvoiceOverdue: 'Rechnung ist ueberfaellig',
          issueInvoiceOverdueDesc: 'Rechnung {{invoice}} ist seit {{dueDate}} ueberfaellig.',
          issuePendingDocumentReview: 'Dokumentpruefung offen',
          issuePendingDocumentReviewDesc: '{{company}} wartet auf Pruefung von {{document}}.',
          issueMissingVerificationDocument: 'Verifizierungsnachweis fehlt',
          issueMissingVerificationDocumentDesc:
            '{{company}} ist pending, aber ohne Verifizierungsdokument.',
          issueRejectedVerificationDocument: 'Abgelehnte Verifizierungsdokumente',
          issueRejectedVerificationDocumentDesc:
            '{{company}} hat {{count}} abgelehnte Dokumentenslots und braucht neue Nachweise.',
          issueVerificationFollowUpDue: 'Wiedervorlage faellig',
          issueVerificationFollowUpDueDesc:
            '{{company}} hat {{count}} faellige Wiedervorlagen, davon {{overdueCount}} ueberfaellig.',
          issueServiceAreaMissing: 'Einsatzgebiet fehlt',
          issueServiceAreaMissingDesc: '{{company}} hat noch kein Einsatzgebiet hinterlegt.',
          issueAvailabilityMissing: 'Verfuegbarkeit fehlt',
          issueAvailabilityMissingDesc:
            '{{company}} hat aktuell keine aktiven Verfuegbarkeitstage.',
          openBilling: 'Billing oeffnen',
          reviewDocuments: 'Dokumente pruefen',
          openTimeline: 'Timeline',
          billingIssuesTitle: 'Billing-Qualitaetschecks',
          billingIssuesDesc: 'Die wichtigsten Billing-Faelle mit Handlungsbedarf.',
          billingIssuesEmpty: 'Keine offenen Billing-Issues.',
          verificationIssuesTitle: 'Verifizierungs-Qualitaetschecks',
          verificationIssuesDesc:
            'Offene Dokumentpruefungen und fehlende Nachweise fuer Pending-Firmen.',
          verificationIssuesEmpty: 'Keine offenen Verifizierungs-Issues.',
        },
        rematch: {
          title: 'Rematch ausführen',
          description: 'Es sind aktuell noch {{count}} Firmenzuordnungen offen.',
          summaryTitle: 'Matching-Überblick',
          summaryDesc: 'Aktueller Status für {{route}}.',
          summaryFallbackDesc: 'Aktueller Status für diese Anfrage.',
          confirmedLabel: 'Bestätigte Firmen',
          confirmedEmpty: 'Noch keine Firma hat das Matching bestätigt.',
          pendingLabel: 'Ausstehende Firmen',
          pendingEmpty: 'Aktuell keine offenen Firmenzuordnungen.',
          preselectedLabel: 'Vorausgewählte Firmen',
          preselectedEmpty: 'Für diese Anfrage wurden keine Firmen vorausgewählt.',
          releaseWaitingLabel: 'Wartefenster aktiv',
          releaseWaitingEmpty: 'Aktuell wartet keine passende Firma nur auf ihr Tier-Fenster.',
          releaseWaitingUnavailable: 'Freigabestatus konnte noch nicht geladen werden.',
          summaryAssignedBadge: '{{assigned}} von {{desired}} aktiv zugeordnet',
          summaryOpenBadge: '{{count}} Slots noch offen',
          cancellationRequestedBadge: '{{count}} Stornoanfragen offen',
          confirmedShort: 'Bestätigt {{count}}',
          pendingShort: 'Offen {{count}}',
          preselectedShort: 'Vorauswahl {{count}}',
          companyNamesWithMore: '{{names}} und {{count}} weitere',
          diagnosticsTitle: 'Matching-Diagnose',
          diagnosticsDescription:
            'Prüfe, welche Firmen aktuell berücksichtigt, ausgeschlossen oder direkt ausgewählt werden.',
          diagnosticsAction: 'Diagnose',
          diagnosticsSectionTitle: 'Diagnose',
          diagnosticsSectionDesc:
            'Serverseitige Auswahl- und Ausschlussgründe für den aktuellen Matching-Lauf.',
          refreshDiagnostics: 'Diagnose aktualisieren',
          diagnosticsLoadError: 'Matching-Diagnose konnte nicht geladen werden.',
          diagDesired: 'Ziel-Angebote',
          diagAssigned: 'Aktiv zugeordnet',
          diagNeedNow: 'Aktuell gesucht',
          diagEligible: 'Geeignete Firmen',
          stopReasonTitle: 'Matching gestoppt',
          noDiagnosticsCandidates:
            'Für diese Anfrage liegen aktuell keine Diagnose-Kandidaten vor.',
          noDiagnosticsData: 'Noch keine Diagnosedaten geladen.',
          decisionSelected: 'Wird zugeordnet',
          decisionEligible: 'Geeignet',
          decisionExcluded: 'Ausgeschlossen',
          summarySelected: 'Ausgewaehlt',
          summaryEligible: 'Weitere geeignet',
          summaryExcluded: 'Ausgeschlossen',
          // P2.069 — hardcoded <div> heading in AdminRematchDialog diagnostics panel
          topExclusionsTitle: 'Haeufigste Ausschlussgruende',
          sourceSelected: 'Vorausgewählt',
          sourcePool: 'Matching-Pool',
          scoreLabel: 'Score {{score}}',
          maxAdditional: 'Maximal zusätzlich zuordnen',
          // P2.069 — hardcoded toast.description in Admin.tsx rematch validation
          maxAdditionalRangeError: 'Bitte eine Zahl zwischen 1 und {{max}} eingeben.',
          helper: 'Leer lassen oder den offenen Bedarf eintragen, um alle freien Slots zu füllen.',
          runAction: 'Rematch starten',
          running: 'Wird ausgeführt...',
          successTitle: 'Rematch ausgeführt',
          successDesc: '{{created}} neue Firmen zugeordnet. Noch offen: {{remaining}}.',
          errorDesc: 'Rematch konnte nicht ausgeführt werden.',
          action: 'Rematch',
        },
        billing: {
          tab: 'Abrechnung',
          title: 'Abrechnung',
          desc: 'Rechnungen und Zahlungen getrennt pro Firmenzuordnung verfolgen.',
          companyHeader: 'Firma',
          requestHeader: 'Anfrage',
          invoiceHeader: 'Rechnung',
          collectionsHeader: 'Mahnstufe',
          collectionStageCurrent: 'Im Zeitplan',
          collectionStageReminder1: 'Mahnstufe 1',
          collectionStageReminder2: 'Mahnstufe 2',
          collectionStageFinalNotice: 'Letzte Mahnung',
          collectionDays_one: '{{count}} Tag ueberfaellig',
          collectionDays_other: '{{count}} Tage ueberfaellig',
          autoUnblockHint:
            'Nach Zahlung und Statusabgleich wird die Billing-Sperre automatisch aufgehoben.',
          exportCollections: 'Collections exportieren',
          exportError: 'Der Billing-Export konnte nicht exportiert werden.',
          filterAll: 'Alle',
          filterOverdue: 'Ueberfaellig',
          filterFinalNotice: 'Letzte Mahnung',
          filterBlocked: 'Gesperrt',
          paymentHeader: 'Payment',
          noInvoice: 'Keine Rechnung',
          noPayment: 'Kein Payment',
          invoiceDraft: 'Entwurf',
          invoiceSent: 'Versendet',
          invoicePaid: 'Bezahlt',
          invoiceCancelled: 'Storniert',
          paymentOpen: 'Offen',
          actionInvoice: 'Rechnung',
          actionSend: 'Versenden',
          actionMarkPaid: 'Als bezahlt',
          actionCancel: 'Stornieren',
          actionView: 'Ansicht',
          noRows: 'Keine Firmenzuordnungen für die Abrechnung vorhanden.',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Eintraege',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
          updatedTitle: 'Rechnungsstatus aktualisiert',
          updateError: 'Rechnungsstatus konnte nicht aktualisiert werden.',
          viewError: 'Rechnungsansicht konnte nicht geöffnet werden.',
        },
        documents: {
          title: 'Dokumentenaufsicht',
          desc: 'Alle Firmendokumente zentral pruefen, filtern und verwalten.',
          totalTitle: 'Dokumente gesamt',
          totalDesc: 'Alle derzeit im System hinterlegten Firmendateien.',
          verificationTitle: 'Verifizierungsdokumente',
          verificationDesc: 'Dateien, die fuer Firmenpruefungen relevant sind.',
          pendingTitle: 'In Pruefung',
          pendingDesc: 'Verifizierungsdokumente von Firmen mit offenem Status.',
          rejectedTitle: 'Abgelehnt',
          rejectedDesc: 'Dokumente von Firmen mit abgelehnter Verifizierung.',
          staleTitle: 'Ueberfaellig',
          staleDesc: 'Offene Verifizierungsdokumente, die seit mindestens 7 Tagen warten.',
          followUpDueTitle: 'Wiedervorlagen faellig',
          followUpDueDesc: 'Dokumentslots mit faelliger oder ueberfaelliger Wiedervorlage.',
          reviewQueueTitle: 'Pruefqueue',
          reviewQueueDesc: 'Direkte Freigabe oder Ablehnung aus der Dokumentensicht.',
          exportError: 'Der Dokumentenexport konnte nicht exportiert werden.',
          reviewQueueEmpty: 'Keine offenen Verifizierungsdokumente in der aktuellen Filterung.',
          followUpQueueTitle: 'Wiedervorlagenqueue',
          followUpQueueDesc: 'Priorisierte Slots mit sofortigem Bearbeitungsbedarf.',
          followUpQueueEmpty: 'Keine faelligen oder ueberfaelligen Wiedervorlagen vorhanden.',
          missingDocsTitle: 'Fehlende Unterlagen',
          missingDocsDesc: 'Pending Firmen ohne Verifizierungsdokumente.',
          missingDocsEmpty: 'Keine pending Firmen ohne Unterlagen vorhanden.',
          openCompany: 'Firma oeffnen',
          searchPlaceholder: 'Nach Firma, Dateiname oder Anfrage suchen',
          purposeHeader: 'Zweck',
          categoryHeader: 'Kategorie',
          reviewHeader: 'Pruefstatus',
          followUpHeader: 'Wiedervorlage',
          requestHeader: 'Anfrage',
          purposeChat: 'Chat Anhang',
          reviewPending: 'In Pruefung',
          reviewVerified: 'Verifiziert',
          reviewRejected: 'Abgelehnt',
          reviewAvailable: 'Verfuegbar',
          focusTitle: 'Fokus aus Verifizierungs-Queue',
          focusDescription: 'Die relevanten Dokumentenslots fuer diesen Fall sind hervorgehoben.',
          focusBadge: 'Im Fokus',
          slotHistoryTitle: 'Verlauf je Dokumentenslot',
          lastDecisionLabel: 'Letzte Entscheidung',
          lastReviewedAtLabel: 'Zuletzt geprueft',
          noReviewHistory: 'Noch keine dokumentierte Entscheidung.',
          reviewApproveTitle: 'Dokumente freigeben',
          reviewRejectTitle: 'Dokumente ablehnen',
          reviewDialogDesc: 'Review-Hinweis fuer {{company}} hinterlegen.',
          reviewApproveNoteLabel: 'Review-Hinweis (optional)',
          reviewRejectNoteLabel: 'Ablehnungsgrund',
          reviewApproveNotePlaceholder: 'Optionaler Hinweis fuer die Freigabe',
          reviewRejectNotePlaceholder: 'Grund fuer die Ablehnung festhalten',
          reviewNoteRequired: 'Bitte einen Ablehnungsgrund angeben.',
          adminNoteLabel: 'Interne Admin-Notiz',
          adminNotePlaceholder: 'Interne Notiz fuer den Verifizierungsprozess festhalten',
          followUpLabel: 'Wiedervorlage',
          followUpAtValue: 'Wiedervorlage: {{date}}',
          followUpDueAtValue: 'Faellig: {{date}}',
          followUpOverdueAtValue: 'Ueberfaellig seit {{date}}',
          followUpScheduledAtValue: 'Geplant: {{date}}',
          noFollowUp: 'Keine Wiedervorlage',
          followUpNoFile: 'Kein Dokument im Slot',
          saveSlotMetadata: 'Notiz speichern',
          followUpSavedTitle: 'Wiedervorlage gespeichert',
          followUpSavedDesc: 'Interne Notiz und Wiedervorlage wurden aktualisiert.',
          followUpSaveError: 'Interne Notiz oder Wiedervorlage konnte nicht gespeichert werden.',
          communication: {
            label: 'Firmen-Rueckfrage',
            placeholder: 'Rueckfrage an die Firma formulieren',
            sendAction: 'Rueckfrage senden',
            sentTitle: 'Rueckfrage gesendet',
            sentDesc:
              'Die Firma wurde ueber die fehlende oder zu aktualisierende Unterlage informiert.',
            sentError: 'Rueckfrage konnte nicht gesendet werden.',
            messageRequired: 'Bitte zuerst eine Rueckfrage formulieren.',
            templates: {
              document_missing: {
                label: 'Unterlage nachfordern',
                message:
                  'Bitte reichen Sie die Unterlage "{{document}}" fuer Ihre Firmenverifizierung nach.',
              },
              replacement_required: {
                label: 'Ersatzdokument anfordern',
                message:
                  'Bitte laden Sie fuer "{{document}}" ein aktualisiertes Ersatzdokument hoch, damit wir die Pruefung fortsetzen koennen.',
              },
              status_follow_up: {
                label: 'Status nachfassen',
                message:
                  'Bitte bestaetigen Sie kurz den aktuellen Stand zu "{{document}}" oder teilen Sie mit, wann die Unterlage nachgereicht wird.',
              },
            },
          },
          typeAll: 'Alle Dokumenttypen',
          ageAll: 'Alle Alter',
          followUpFilterAll: 'Alle Wiedervorlagen',
          followUpFilterAction: 'Faellig jetzt',
          followUpFilterOverdue: 'Ueberfaellig',
          followUpFilterScheduled: 'Geplant',
          followUpFilterNone: 'Ohne Wiedervorlage',
          ageFreshFilter: '0-2 Tage',
          ageAgingFilter: '3-6 Tage',
          ageStaleFilter: '7+ Tage',
          ageFresh_one: '{{count}} Tag offen',
          ageFresh_other: '{{count}} Tage offen',
          ageAging_one: '{{count}} Tag offen',
          ageAging_other: '{{count}} Tage offen',
          ageStale_one: '{{count}} Tag ueberfaellig',
          ageStale_other: '{{count}} Tage ueberfaellig',
          categoryPdf: 'PDF',
          categoryImage: 'Bild',
          categoryDocument: 'Dokument',
          categoryOther: 'Sonstiges',
          empty: 'Keine Dokumente fuer diesen Filter vorhanden.',
          deletedTitle: 'Dokument geloescht',
          deletedDesc: 'Das Dokument wurde entfernt.',
          deleteError: 'Das Dokument konnte nicht geloescht werden.',
          downloadError: 'Das Dokument konnte nicht heruntergeladen werden.',
          deleteConfirm: 'Dokument {{name}} wirklich loeschen?',
        },
        workspace: {
          overviewTab: 'Übersicht',
          healthTab: 'Monitoring',
          operationsTab: 'Betrieb',
          reportsTab: 'Reports',
          schedulesTab: 'Zeitpläne',
          errorsTab: 'Fehlerlog',
          companyTiersTab: 'Firmen-Tier',
          errorWatchTab: 'Fehler-Watch',
          documentsTab: 'Dokumente',
          auditTab: 'Audit',
          configTab: 'Konfiguration',
          pendingCompaniesTitle: 'Offene Firmenprüfungen',
          pendingCompaniesDesc: 'Firmen mit ausstehender Verifizierung.',
          rematchQueueTitle: 'Offene Rematches',
          rematchQueueDesc: 'Anfragen mit noch offenen Zuordnungsslots.',
          cancellationQueueTitle: 'Offene Stornos',
          cancellationQueueDesc: 'Zu prüfende Stornierungsanfragen von Firmen.',
          billingQueueTitle: 'Offene Rechnungen',
          billingQueueDesc: 'Entwürfe oder versendete Rechnungen ohne Abschluss.',
          blockedCompaniesTitle: 'Geblockte Firmen',
          blockedCompaniesDesc: 'Firmen, die aktuell keine neuen Zuweisungen erhalten.',
          operationsTitle: 'Betrieb',
          operationsDesc: 'User, Firmen, Anfragen und operative Eingriffe verwalten.',
          billingSummary: '{{invoices}} Rechnungen und {{payments}} Payments im System.',
          openBilling: 'Abrechnung öffnen',
          configTitle: 'Konfiguration',
          configDesc: 'Systemregeln, Blacklist und Verwaltungszugriffe bündeln.',
          blacklistSummary: '{{count}} aktive Blacklist-Einträge im System.',
          quickActionsTitle: 'Schnellaktionen',
          quickActionsDesc: 'Direkte administrative Eingriffe und Anlagemasken.',
          systemOverviewTitle: 'Systemübersicht',
          systemOverviewDesc: 'Zentrale Kennzahlen für Benutzer, Firmen und Governance.',
          requestStatusTitle: 'Anfragestatus',
          requestStatusDesc: 'Verteilung der aktuellen Kundenanfragen im System.',
          systemConfigTitle: 'Pricing Defaults',
          systemConfigDesc: 'Aktive Preis- und Angebotsdefaults für die Produktstufen.',
          pricingConfigTitle: 'Preis- und Angebotskonfiguration',
          pricingConfigDesc: 'Aktuell gesetzte Preise und Standard-Anzahl gewünschter Angebote.',
          defaultOffersLabel: 'Standard-Angebote',
          featureFlagsTitle: 'Feature-Konfiguration',
          featureFlagsDesc: 'Globale Features und Systemgrenzen aus der Admin-Konfiguration.',
          maxCompaniesPerRequest: 'Maximale Firmen pro Anfrage',
          requestExpirationDays: 'Gültigkeitsdauer von Anfragen (Tage)',
          premiumCustomerTitle: 'Premium fuer Kundenanfragen',
          premiumCustomerDesc:
            'Steuert, ob Kunden im Anfrageformular Premium und Premium+ buchen duerfen.',
          premiumCustomerPremiumLabel: 'Premium fuer Kunden aktivieren',
          premiumCustomerPremiumPlusLabel: 'Premium+ fuer Kunden aktivieren',
          premiumCompanyTitle: 'Premium fuer Firmen-User',
          premiumCompanyDesc:
            'Steuert, ob Firmen-User ihre Anfrage-Tarife auf Premium oder Premium+ umstellen duerfen.',
          premiumCompanyPremiumLabel: 'Premium fuer Firmen-User aktivieren',
          premiumCompanyPremiumPlusLabel: 'Premium+ fuer Firmen-User aktivieren',
          enabled: 'Aktiv',
          disabled: 'Inaktiv',
          savePricingAction: 'Pricing speichern',
          saveFeaturesAction: 'Features speichern',
          configSavedTitle: 'Konfiguration gespeichert',
          pricingSavedDesc: 'Preise und Default-Angebote wurden aktualisiert.',
          featuresSavedDesc: 'Feature-Konfiguration wurde aktualisiert.',
          configSaveError: 'Konfiguration konnte nicht gespeichert werden.',
          configValidationError: 'Bitte nur gueltige nicht-negative Zahlen eingeben.',
          legalStatusDesc: 'Status der veröffentlichten Inhalte.',
          published: 'Veröffentlicht',
          missing: 'Fehlt',
          legalChars: '{{count}} Zeichen hinterlegt',
          businessMetricsTitle: 'Business-Kennzahlen',
          businessMetricsDesc:
            'Verdichtete KPIs fuer Umsatz, Aktivitaet, Abschluss und Abrechnung.',
          businessMetricsPeriod: 'Letzte {{days}} Tage',
          paidRevenueTitle: 'Bezahlter Umsatz',
          paidRevenueDesc: 'Erfasste Zahlungen im betrachteten Zeitraum.',
          paidRevenueMeta: '{{count}} bezahlte Zahlungen',
          activeCompaniesTitle: 'Aktive Firmen',
          activeCompaniesDesc: 'Firmen mit Zuweisungen oder Zahlungen im Zeitraum.',
          activeCompaniesMeta: '{{assignments}} Zuweisungen, {{payments}} Zahlungen',
          completionRateTitle: 'Abschlussquote',
          completionRateDesc: 'Abgeschlossene Anfragen bezogen auf neu angelegte Anfragen.',
          completionRateMeta: '{{completed}} von {{total}} Anfragen abgeschlossen',
          collectionRateTitle: 'Inkassoquote',
          collectionRateDesc: 'Bezahlte Rechnungen bezogen auf neu erstellte Rechnungen.',
          collectionRateMeta: '{{paid}} von {{total}} Rechnungen bezahlt',
          reportsPaidVolumeTitle: 'Bezahltes Volumen',
          reportsVerifiedRatioTitle: 'Verifizierte Firmen',
          reportsAvgOffersTitle: 'Ø Wunsch-Angebote',
          reportsOpenInvoicesTitle: 'Offene Rechnungen',
          companyPerformanceTitle: 'Firmenleistung',
          companyPerformanceDesc: 'Annahmequote und bezahltes Volumen pro Firma.',
          requestDemandTitle: 'Nachfrage nach Anfrageart',
          requestDemandDesc: 'Verteilung und offene Last je Anfrageart.',
          invoiceAgingTitle: 'Rechnungsstatus',
          invoiceAgingDesc: 'Statusverteilung und Beträge über alle Rechnungen.',
          exportCsv: 'CSV Export',
          exportError: 'Der Report konnte nicht exportiert werden.',
          reportFilterTitle: 'Zeitraum',
          reportFilterDesc: 'Filtert alle Reports und CSV-Exporte nach Erstellungsdatum.',
          range30d: '30 Tage',
          range90d: '90 Tage',
          rangeAll: 'Gesamt',
          rangeCustom: 'Benutzerdefiniert',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
        },
        businessKpi: {
          title: 'Business-KPIs',
          desc: 'Conversion-Raten, SLA-Zeiten, Notification-Delivery und Health-Indikatoren im Zeitverlauf.',
          periodLabel: 'Zeitraum',
          trendsLabel: 'Trends anzeigen',
          trendsEnabled: 'Tägliche Trends aktiv',
          trendsDisabled: 'Tägliche Trends aus',
          period7d: '7 Tage',
          period30d: '30 Tage',
          period90d: '90 Tage',
          period180d: '180 Tage',
          conversionTitle: 'Conversion',
          conversionDesc: 'Vom Request bis zur bezahlten Zuweisung.',
          slaTitle: 'SLA-Zeiten',
          slaDesc: 'Median und 90. Perzentil in Stunden.',
          deliveryTitle: 'Notification-Delivery',
          deliveryDesc: 'Zustellraten und Retry/Stack-Status.',
          healthTitle: 'Health-Indikatoren',
          healthDesc: 'Liegengebliebene Anfragen und inaktive Firmen.',
          revenueTitle: 'Umsatz im Zeitraum',
          revenueDesc: 'Summe bezahlter Zuweisungen.',
          revenueMeta: '{{count}} bezahlte Zuweisungen',
          trendsTitle: 'Tagesverlauf',
          trendsDesc: 'Anfragen, Zahlungen und Notifications pro Tag.',
          rateRequestToAssignment: 'Request → Zuweisung',
          rateAssignmentToAccepted: 'Zuweisung → angenommen',
          rateAcceptedToPaid: 'Angenommen → bezahlt',
          slaRequestToFirstAssignment: 'Request → erste Zuweisung',
          slaRequestToFirstResponse: 'Request → erste Antwort',
          slaAssignmentToPaid: 'Zuweisung → bezahlt',
          slaMedian: 'Median {{value}}h',
          slaP90: 'P90 {{value}}h',
          slaSampleEmpty: 'Keine Daten im Zeitraum',
          deliverySent: 'Zugestellt',
          deliveryFailed: 'Fehlgeschlagen',
          deliveryRetry: 'Im Retry',
          deliveryDead: 'Endgültig fehlgeschlagen',
          deliveryRate: 'Zustellrate',
          retryRate: 'Retry-Quote',
          deadRate: 'Endgültig-fehl-Quote',
          healthStuck: 'Liegengebliebene Anfragen',
          healthStuckDesc: 'Status pending/matched seit >{{days}} Tagen.',
          healthInactive: 'Inaktive Firmen',
          healthInactiveDesc: 'Keine Aktivität in den letzten {{days}} Tagen.',
          trendsRequests: 'Anfragen',
          trendsCompleted: 'Davon abgeschlossen',
          trendsPayments: 'Zahlungen',
          trendsNotifications: 'Benachrichtigungen',
          reload: 'KPIs neu laden',
          loadError: 'KPIs konnten nicht geladen werden.',
          generatedAt: 'Erstellt: {{date}}',
          empty: 'Keine Daten im Zeitraum.',
        },
        domainEvents: {
          title: 'Domain-Events',
          desc: 'Vollständiger Audit-Stream aller Domain-Änderungen mit Filter und Detailansicht.',
          filterTitle: 'Filter',
          filterDesc: 'Eingrenzen nach Entity-Typ, Aktion, Akteur oder Zeitraum.',
          filterEntityType: 'Entity-Typ',
          filterEntityTypePlaceholder: 'z. B. request, payment, invoice',
          filterEntityId: 'Entity-ID',
          filterEntityIdPlaceholder: 'Optionale UUID',
          filterAction: 'Aktion',
          filterActionPlaceholder: 'z. B. request.created',
          filterActorUserId: 'Akteur-User-ID',
          filterActorUserIdPlaceholder: 'Optionale UUID',
          filterFromDate: 'Von',
          filterToDate: 'Bis',
          applyFilters: 'Filter anwenden',
          resetFilters: 'Filter zurücksetzen',
          totalEvents: 'Ereignisse',
          byEntityType: 'Nach Entity-Typ',
          byAction: 'Nach Aktion',
          listTitle: 'Ereignisliste',
          listEmpty: 'Keine Domain-Events im gewählten Zeitraum.',
          loadError: 'Domain-Events konnten nicht geladen werden.',
          paginationPrev: 'Zurück',
          paginationNext: 'Weiter',
          pageInfo: 'Seite {{page}} von {{totalPages}} ({{total}} Treffer)',
          detailTitle: 'Detail',
          detailMetadata: 'Metadaten',
          detailMetadataEmpty: 'Keine Metadaten',
          detailPreviousState: 'Vorheriger Status',
          detailResultingState: 'Neuer Status',
          detailActor: 'Akteur',
          detailActorSystem: 'System',
          detailEntity: 'Entity',
          detailCreatedAt: 'Zeitpunkt',
          entityTypes: {
            request: 'Anfrage',
            company_request: 'Firmenzuweisung',
            payment: 'Zahlung',
            review: 'Bewertung',
            company: 'Firma',
            document: 'Dokument',
            other: 'Sonstige',
          },
          actions: {
            'request.created': 'Anfrage erstellt',
            'request.cancelled': 'Anfrage storniert',
            'request.completed': 'Anfrage abgeschlossen',
            'request.needs_matches': 'Anfrage braucht Zuweisungen',
            'company_request.accepted': 'Zuweisung angenommen',
            'company_request.declined': 'Zuweisung abgelehnt',
            'company_request.cancellation_pending': 'Storno-Prüfung ausstehend',
            'payment.created': 'Zahlung angelegt',
            'payment.paid': 'Zahlung bezahlt',
            'payment.refunded': 'Zahlung erstattet',
            'payment.missing_billing': 'Billing-Daten fehlen',
            'payment.missing_invoice': 'Rechnung fehlt',
            'invoice.draft_stale': 'Rechnungsentwurf veraltet',
            'invoice.overdue': 'Rechnung überfällig',
            'invoice.paid': 'Rechnung bezahlt',
            'document.pending_review': 'Dokument in Prüfung',
            'document.missing_verification': 'Verifizierungsdokument fehlt',
            'document.rejected_verification': 'Verifizierung abgelehnt',
            'verification.follow_up_due': 'Verifizierungs-Wiedervorlage fällig',
            'company.service_area_missing': 'Service-Gebiet fehlt',
            'company.availability_missing': 'Verfügbarkeit fehlt',
            other: 'Sonstige Aktion',
          },
        },
        notificationHealth: {
          title: 'Notification-Health',
          desc: 'Live-Status der Notification-Pipeline: Zustellraten, Retries und Stuck-Logs mit Reset-Aktionen.',
          statsTitle: 'Live-Status',
          totalLogs: 'Logs gesamt',
          dueNow: 'Jetzt fällig',
          filterTitle: 'Filter',
          statusLabel: 'Status',
          eventTypeLabel: 'Event-Typ',
          eventTypePlaceholder: 'z. B. request.created',
          recipientTypeLabel: 'Empfänger-Typ',
          fromDateLabel: 'Von',
          toDateLabel: 'Bis',
          applyFilters: 'Filter anwenden',
          resetFilters: 'Filter zurücksetzen',
          listTitle: 'Logs',
          listEmpty: 'Keine Notification-Logs im gewählten Filter.',
          loadError: 'Notification-Health konnte nicht geladen werden.',
          actionsTitle: 'Aktionen',
          actionProcessTitle: 'Retries jetzt verarbeiten',
          actionProcessDesc: 'Manueller Trigger des Retry-Schedulers (max. 500).',
          actionProcessButton: 'Verarbeiten',
          actionResetTitle: 'Retry zurücksetzen',
          actionResetDesc: 'Setzt den Log auf status=retry, attempts=0, nextRetryAt=jetzt.',
          actionResetButton: 'Reset',
          actionMarkDeadTitle: 'Auf "dead" setzen',
          actionMarkDeadDesc: 'Markiert den Log manuell als endgültig fehlgeschlagen.',
          actionMarkDeadButton: 'Dead',
          actionConfirmReset: 'Soll dieser Log auf "retry" zurückgesetzt werden?',
          actionConfirmDead: 'Soll dieser Log als "dead" markiert werden?',
          paginationPrev: 'Zurück',
          paginationNext: 'Weiter',
          pageInfo: 'Seite {{page}} von {{totalPages}} ({{total}} Treffer)',
          resultProcessed: '{{processed}} verarbeitet, {{succeeded}} erfolgreich',
          resultFailed: '{{failed}} fehlgeschlagen',
          resultDead: '{{dead}} dead',
          columnStatus: 'Status',
          columnEvent: 'Event',
          columnRecipient: 'Empfänger',
          columnSubject: 'Betreff',
          columnAttempts: 'Versuche',
          columnLastError: 'Letzter Fehler',
          columnNextRetry: 'Nächster Retry',
          columnCreatedAt: 'Erstellt',
          columnActions: 'Aktionen',
          detailTitle: 'Details',
          detailChannel: 'Kanal',
          detailBody: 'Inhalt',
          detailEntityId: 'Entity-ID',
          eventTypeDistribution: 'Event-Typ Verteilung',
          attemptsLabel: '{{count}}x Versuche',
          statuses: {
            sent: 'Zugestellt',
            failed: 'Fehlgeschlagen',
            retry: 'Im Retry',
            dead: 'Endgültig fehlgeschlagen',
          },
        },
        schedules: {
          title: 'Berichts-Zeitplaene',
          description:
            'Zentrale Verwaltung der automatischen Berichtslaeufe (taeglich, woechentlich, monatlich).',
          newSchedule: 'Neuer Zeitplan',
          save: 'Speichern',
          saving: 'Speichert...',
          cancel: 'Abbrechen',
          reportType: 'Berichtstyp',
          cadence: 'Kadenz',
          cadenceOptions: {
            daily: 'Taeglich',
            weekly: 'Woechentlich',
            monthly: 'Monatlich',
          },
          weekday: 'Wochentag (UTC)',
          weekdayShort: 'Tag',
          dayOfMonth: 'Tag im Monat',
          dayShort: 'Tag',
          hourUtc: 'Stunde (UTC)',
          minuteUtc: 'Minute (UTC)',
          recipients: 'Empfaenger (kommasepariert)',
          recipientsHint: 'Eine oder mehrere E-Mail-Adressen, durch Komma getrennt.',
          recipientsPlaceholder: 'ops@example.com, lead@example.com',
          noRecipients: 'Keine Empfaenger konfiguriert',
          lastRun: 'Letzter Lauf',
          nextRun: 'Naechster Lauf',
          never: 'Noch nie',
          disabled: 'Deaktiviert',
          enable: 'Aktivieren',
          disable: 'Deaktivieren',
          delete: 'Loeschen',
          loading: 'Lade Zeitplaene...',
          empty: 'Noch keine Berichts-Zeitplaene vorhanden.',
          loadError: 'Zeitplaene konnten nicht geladen werden.',
          validationErrorTitle: 'Eingabe unvollstaendig',
          validationRecipients: 'Mindestens ein Empfaenger ist erforderlich.',
          createdTitle: 'Zeitplan angelegt',
          createdDescription: 'Der neue Berichts-Zeitplan ist aktiv.',
          createError: 'Zeitplan konnte nicht angelegt werden.',
          toggleError: 'Status konnte nicht geaendert werden.',
          deletedTitle: 'Zeitplan geloescht',
          deletedDescription: '{{label}} wurde entfernt.',
          deleteError: 'Zeitplan konnte nicht geloescht werden.',
        },
        errorLog: {
          title: 'Fehlerlog',
          description:
            'Zentrale Sicht auf Frontend- und Backend-Fehler. Filter, Resolve-Aktion, Export-faehig.',
          loading: 'Lade Fehlerlogs...',
          empty: 'Keine Fehler im gewaehlten Zeitraum.',
          loadError: 'Fehlerlogs konnten nicht geladen werden.',
          filterSource: 'Quelle',
          filterSeverity: 'Schweregrad',
          filterResolved: 'Status',
          filterSearch: 'Suche (Nachricht oder Pfad)',
          filterAllSources: 'Alle Quellen',
          sourceFrontend: 'Frontend',
          sourceBackend: 'Backend',
          filterAllSeverities: 'Alle Schweregrade',
          filterUnresolved: 'Ungeloest',
          filterAll: 'Alle',
          sinceHours: 'Zeitraum (Stunden)',
          since24h: '24h',
          since7d: '7 Tage',
          since30d: '30 Tage',
          statsTotal: 'Eintraege gesamt',
          statsUnresolved: 'Ungeloest',
          statsBySeverity: 'Nach Schweregrad',
          statsBySource: 'Nach Quelle',
          statsTopCategories: 'Top-Kategorien',
          columnSeverity: 'Schweregrad',
          columnCategory: 'Kategorie',
          columnSource: 'Quelle',
          columnCount: 'Anzahl',
          columnMessage: 'Nachricht',
          columnLastSeen: 'Zuletzt gesehen',
          columnPath: 'Pfad',
          columnActions: 'Aktionen',
          resolveAction: 'Als geloest markieren',
          reopenAction: 'Wieder oeffnen',
          deleteAction: 'Loeschen',
          notesLabel: 'Notiz (optional)',
          notesPlaceholder: 'Was wurde gemacht?',
          resolveSuccessTitle: 'Fehler als geloest markiert',
          reopenSuccessTitle: 'Fehler wieder geoeffnet',
          deleteSuccessTitle: 'Fehler geloescht',
          deleteConfirm: 'Diesen Eintrag wirklich loeschen?',
          detailTitle: 'Details',
          detailStack: 'Stacktrace',
          detailContext: 'Kontext',
          detailFirstSeen: 'Erstmals gesehen',
          detailResolvedBy: 'Geloest von',
          detailNotes: 'Notiz',
          noStack: 'Kein Stacktrace vorhanden',
          noContext: 'Kein Kontext vorhanden',
          refreshAction: 'Aktualisieren',
          paginationPrev: 'Zurueck',
          paginationNext: 'Weiter',
          pageInfo: 'Seite {{page}} von {{totalPages}} ({{total}} Treffer)',
          loadDetailError: 'Fehlerdetails konnten nicht geladen werden.',
          resolveError: 'Fehler konnte nicht als geloest markiert werden.',
          reopenError: 'Fehler konnte nicht wieder geoeffnet werden.',
          deleteError: 'Fehler konnte nicht geloescht werden.',
        },
        companyTiers: {
          title: 'Firmen-Tier Auto-Anpassung',
          description:
            'Performance-Score pro Firma berechnet aus Annahmequote, Antwortzeit, Reviews und Verifikation. Auto-Anpassung kann neue Tier-Empfehlungen auf CompanyPriceTierSetting schreiben.',
          loading: 'Lade Tier-Konfiguration...',
          configTitle: 'Schwellenwerte',
          configSaved: 'Tier-Konfiguration gespeichert.',
          configSaveError: 'Tier-Konfiguration konnte nicht gespeichert werden.',
          enabledLabel: 'Auto-Anpassung aktiv',
          runIntervalLabel: 'Intervall (Stunden)',
          minReviewsLabel: 'Min. Reviews fuer Premium+',
          minAcceptRateLabel: 'Min. Annahmequote fuer Premium (%)',
          minAcceptRatePremiumPlusLabel: 'Min. Annahmequote fuer Premium+ (%)',
          maxResponseMinutesLabel: 'Max. Antwortzeit fuer Premium+ (Min.)',
          minAcceptedLeadsLabel: 'Min. angenommene Leads 30d fuer Premium+',
          saveButton: 'Konfiguration speichern',
          candidatesTitle: 'Tier-Empfehlungen',
          candidatesDescription:
            'Aktuelle Tier-Einstufung vs. empfohlene Anpassung. Hoechster Score zuerst.',
          refreshButton: 'Kandidaten neu laden',
          runDryRunLabel: 'Trockenlauf (keine Aenderungen)',
          runButton: 'Auto-Anpassung jetzt ausfuehren',
          runResultLabel: 'Letzter Lauf',
          scannedLabel: 'Analysiert',
          updatedLabel: 'Geaendert',
          skippedLabel: 'Uebersprungen',
          changingLabel: 'Vorgeschlagene Aenderungen',
          scoreLabel: 'Score',
          currentTierLabel: 'Aktuelles Tier',
          recommendedTierLabel: 'Empfehlung',
          reasonLabel: 'Begruendung',
          verifiedLabel: 'Verifiziert',
          acceptRateLabel: 'Annahmequote',
          responseTimeLabel: 'Antwortzeit',
          reviewsLabel: 'Reviews',
          ratingLabel: 'Bewertung',
          runError: 'Auto-Anpassung konnte nicht gestartet werden.',
          loadCandidatesError: 'Tier-Empfehlungen konnten nicht geladen werden.',
          overrideTitle: 'Manuelles Tier-Override',
          overrideReasonLabel: 'Begruendung',
          overrideReasonPlaceholder: 'z.B. Sonderaktion 2024',
          overrideButton: 'Tier setzen',
          overrideError: 'Tier konnte nicht gesetzt werden.',
          tierLabels: {
            standard: 'Standard',
            premium: 'Premium',
            premium_plus: 'Premium+',
          },
          actionsTitle: 'Manuelle Uebersteuerung',
          actionsDescription:
            'Tier pro Firma direkt setzen. Es wird ein neuer CompanyPriceTierSetting-Eintrag mit effective_from = heute erzeugt.',
          companyIdLabel: 'Company-ID',
          companyIdPlaceholder: 'z.B. comp-uuid-...',
        },
        errorWatch: {
          title: 'Fehler-Watch-Service',
          description:
            'Erkennt Signatur-Spitzen in den letzten N Minuten, zeichnet DomainEvents auf und benachrichtigt Admins.',
          loading: 'Lade Watch-Konfiguration...',
          configTitle: 'Schwellenwerte',
          configSaved: 'Watch-Konfiguration gespeichert.',
          configSaveError: 'Watch-Konfiguration konnte nicht gespeichert werden.',
          enabledLabel: 'Watch aktiv',
          windowMinutesLabel: 'Fenster (Minuten)',
          thresholdCountLabel: 'Min. Anzahl pro Signatur',
          minDistinctUsersLabel: 'Min. unterschiedliche Nutzer',
          criticalOnlyLabel: 'Nur CRITICAL-Severities',
          runIntervalMinutesLabel: 'Intervall (Minuten)',
          saveButton: 'Konfiguration speichern',
          scanTitle: 'Spike-Scan',
          scanButton: 'Jetzt scannen',
          scanResultLabel: 'Scan-Ergebnis',
          scannedLabel: 'Geprueft',
          spikesDetectedLabel: 'Spikes erkannt',
          domainEventsLabel: 'DomainEvents',
          notificationsLabel: 'Admin-Benachrichtigungen',
          noSpikesLabel: 'Keine Spikes erkannt.',
          refreshButton: 'Aktualisieren',
          scanError: 'Scan konnte nicht ausgefuehrt werden.',
          loadError: 'Watch-Konfiguration konnte nicht geladen werden.',
          actionLabels: {
            open_p1_incident: 'P1-Incident eroeffnen',
            investigate_blast_radius: 'Blast-Radius pruefen',
            add_unit_test: 'Unit-Test ergaenzen',
          },
        },
        backup: {
          title: 'Backup-Workspace',
          description:
            'Status der taeglichen Datenbank-Backups inkl. Liste der vorhandenen Sicherungen und Off-Site-Sync.',
          loading: 'Lade Backup-Status...',
          loadError: 'Backup-Status konnte nicht geladen werden.',
          unavailable: 'Der Backup-Endpoint ist nicht erreichbar.',
          retry: 'Erneut versuchen',
          refreshButton: 'Aktualisieren',
          triggerButton: 'Backup anfordern',
          triggerAcceptedTitle: 'Backup-Trigger angenommen',
          triggerError: 'Backup konnte nicht angefordert werden.',
          unknownWarning: 'Backup-Status konnte nicht ermittelt werden.',
          lastBackupLabel: 'Letztes Backup',
          ageLabel: 'Alter',
          status: {
            healthy: 'Gesund',
            warning: 'Warnung',
            critical: 'Kritisch',
            unknown: 'Unbekannt',
          },
          localCount: 'Lokale Backups',
          localCountHint: 'Anzahl der gespeicherten Sicherungsdateien',
          offsiteTitle: 'Off-Site-Sync',
          offsiteConfigured: 'Konfiguriert',
          offsiteMissing: 'Nicht konfiguriert',
          offsiteCount: 'Off-Site Anzahl',
          checkedAtTitle: 'Letzte Pruefung',
          filesTitle: 'Sicherungsdateien',
          filesDescription: 'Liste der lokal vorhandenen Backup-Dateien (neueste zuerst).',
          filesEmpty: 'Aktuell sind keine Sicherungsdateien vorhanden.',
          columnName: 'Datei',
          columnSize: 'Groesse',
          columnAge: 'Alter',
          columnModified: 'Geaendert',
        },
        pricing: {
          title: 'Pricing-Konfiguration',
          description:
            'Provisionsmatrix pro Anfrage-Typ mit Modifier-System. Live-Preview fuer Standard-Szenarien.',
          loading: 'Lade Pricing-Konfiguration...',
          loadError: 'Pricing-Konfiguration konnte nicht geladen werden.',
          saveSuccessTitle: 'Konfiguration gespeichert',
          saveError: 'Konfiguration konnte nicht gespeichert werden.',
          matrixTitle: 'Provisionsmatrix (Basis-Provision pro Anfrage-Typ)',
          modifierTitle: 'Modifier-System',
          defaultsTitle: 'Standardwerte',
          previewTitle: 'Live-Preview',
          previewDescription:
            'Berechnet die effektive Provision fuer ein Szenario. Aenderungen sind erst nach "Speichern" aktiv.',
          columnRequestType: 'Anfrage-Typ',
          columnBaseRate: 'Basis %',
          columnAdjustment: 'Aufschlag %',
          columnEnabled: 'Aktiv',
          columnAction: 'Aktion',
          defaultsCommission: 'Standard-Provisionssatz (%)',
          defaultsMultiplier: 'Festpreis-Multiplikator',
          defaultsMinContract: 'Min. Vertragswert (EUR)',
          modifiers: {
            urgent: { label: 'Eilig (< 7 Tage)', description: 'Kurzfristige Anfrage' },
            weekend: { label: 'Wochenende', description: 'Umzug am Sa/So' },
            longDistance: { label: 'Fernumzug', description: '> 200 km' },
            packingService: { label: 'Verpackungs-Service', description: 'Zusatzleistung' },
          },
          requestTypes: {
            private: 'Privatumzug',
            business: 'Business-Umzug',
            long_distance: 'Fernumzug (DE)',
            international: 'Internationaler Umzug',
            special: 'Spezialtransport',
            official_relocation: 'Behoerdenumzug',
            authority_relocation: 'Amtsumzug',
            assisted_move: 'Begleiteter Umzug',
          },
          previewInput: {
            requestType: 'Anfrage-Typ',
            baseAmount: 'Basis-Betrag (EUR)',
            modifiers: 'Anwendbare Modifier',
          },
          previewModifierEmpty: 'Keine Modifier ausgewaehlt',
          previewResult: 'Effektive Provision: {{percent}}% ({{amount}} EUR)',
          // P2.068 — hardcoded aria-label in PricingConfigWorkspace.tsx (toggle {{key}})
          toggleEntryAria: 'Toggle {{key}}',
        },
        packingTiers: {
          title: 'Packing-Tiers (Cross-Sell)',
          description:
            'Konfigurierbare Preise fuer die drei Packing-Pakete (Basic/Standard/Premium). A/B-Test ermoeglicht 50/50-Split-Vergleiche.',
          loading: 'Lade Tier-Konfiguration...',
          loadError: 'Tier-Konfiguration konnte nicht geladen werden.',
          saveSuccessTitle: 'Tier-Konfiguration gespeichert',
          saveError: 'Tier-Konfiguration konnte nicht gespeichert werden.',
          tierSection: 'Tier-Pakete',
          abTestSection: 'A/B-Test',
          columnTier: 'Tier',
          columnPrice: 'Preis (EUR)',
          columnFeatures: 'Features',
          columnDescription: 'Beschreibung',
          columnEnabled: 'Aktiv',
          featureInputLabel: 'Feature (Enter zum Hinzufuegen)',
          featureAddAction: 'Hinzufuegen',
          featureRemoveAction: 'Entfernen',
          abTestEnabled: 'A/B-Test aktiv',
          abTestVariantPercent: 'Variant-Anteil (%)',
          abTestVariantTier: 'Variant-Tier',
          abTestResolveSaltLabel: 'Test-Salt',
          abTestResolveCustomerLabel: 'Customer-ID',
          abTestResolveAction: 'Tier aufloesen',
          abTestResolveResult: 'Aufgeloest: {{tier}} ({{variant}})',
          // P2.068 — hardcoded aria-label in PackingTierWorkspace.tsx (toggle {{id}})
          toggleTierAria: 'Tier {{id}} aktivieren',
          // P2.OPT118 — hardcoded English string in PackingTierWorkspace.tsx
          totalPotential: 'Gesamtpotenzial (aktivierte Tiers): {{amount}} EUR',
          tiers: {
            basic: { name: 'Basic', description: 'Einfaches Pack-Set fuer kleine Umzuege.' },
            standard: {
              name: 'Standard',
              description: 'Solides Standard-Pack fuer die meisten Umzuege.',
            },
            premium: {
              name: 'Premium',
              description: 'Profi-Pack inkl. Demontage fuer grosse Logistik.',
            },
          },
        },
        reminders: {
          title: 'Mahnwesen',
          description:
            'Automatische Mahnstufen basierend auf Tagen seit Faelligkeit. Manuelle Aktionen pro Rechnung moeglich.',
          loading: 'Lade Mahn-Kandidaten...',
          empty: 'Keine ueberfaelligen Rechnungen im gewaehlten Zeitraum.',
          loadError: 'Mahn-Kandidaten konnten nicht geladen werden.',
          sinceDays: 'Mindest-Tage ueberfaellig',
          sinceDays7: 'ab 7 Tage',
          sinceDays14: 'ab 14 Tage',
          sinceDays22: 'ab 22 Tage',
          refreshAction: 'Aktualisieren',
          runScanAction: 'Alle mahnen',
          scanStarted: 'Scan gestartet',
          scanResult: '{{sent}} gesendet, {{skipped}} uebersprungen',
          scanError: 'Scan fehlgeschlagen',
          sendAction: 'Mahnung senden',
          sendSuccess: 'Mahnung gesendet ({{stage}})',
          sendError: 'Mahnung konnte nicht gesendet werden',
          columnInvoice: 'Rechnung',
          columnCompany: 'Firma',
          columnAmount: 'Betrag',
          columnDueDate: 'Faelligkeit',
          columnDaysOverdue: 'Tage ueberfaellig',
          columnStage: 'Stufe',
          columnContact: 'Kontakt',
          columnActions: 'Aktionen',
          stageReminder1: '1. Mahnung',
          stageReminder2: '2. Mahnung',
          stageFinalNotice: 'Letzte Mahnung',
          statusSent: 'gesendet',
          statusSkipped: 'uebersprungen',
          skippedNoEmail: 'Keine E-Mail-Adresse',
          skippedNotFound: 'Rechnung nicht gefunden',
          skippedAlreadyRefunded: 'Bereits erstattet',
          skippedNoDueDate: 'Kein Faelligkeitsdatum',
          skippedNotOverdue: 'Noch nicht ueberfaellig',
        },
        refund: {
          title: 'Zahlung erstatten',
          description:
            'Stripe- oder PayPal-Refund ausfuehren. Manuelle Payments werden nur lokal storniert.',
          action: 'Erstatten',
          actionTitle: 'Zahlung erstatten',
          reasonLabel: 'Grund (optional)',
          reasonPlaceholder: 'z. B. Kundenanfrage, Storno',
          successTitle: 'Erstattung erfolgreich',
          successDescription: '{{provider}} Refund-ID: {{refundId}}',
          manualSuccess: 'Manuelle Zahlung lokal storniert.',
          alreadyRefunded: 'Zahlung ist bereits erstattet.',
          notFound: 'Zahlung nicht gefunden.',
          providerFailed: 'Provider-Fehler bei Refund: {{message}}',
          errorTitle: 'Erstattung fehlgeschlagen',
        },
        funnel: {
          title: 'Conversion-Funnel',
          description:
            'Stufen-Conversion von Anfrage-Erstellung bis Zahlung. Bottlenecks sichtbar in Echtzeit.',
          loading: 'Lade Funnel-Daten...',
          loadError: 'Funnel-Daten konnten nicht geladen werden.',
          refreshAction: 'Aktualisieren',
          since7d: '7 Tage',
          since30d: '30 Tage',
          since90d: '90 Tage',
          stepLabel: 'Stufe',
          countLabel: 'Anzahl',
          conversionFromPrevious: 'vs. vorherige Stufe',
          conversionFromFirst: 'vs. Anfragen',
          totalUnique: 'Eindeutige Entities',
          windowLabel: 'Zeitraum: {{since}} - {{until}}',
          dropOffBadge: 'Top Drop-Off',
          dropOffDelta: '{{delta}}% Verlust zur vorherigen Stufe',
          stepLabels: {
            'request.created': 'Anfrage erstellt',
            'request.matched': 'Anfrage gematcht',
            'company_request.dispatched': 'An Firmen gesendet',
            'company_request.accepted': 'Firma angenommen',
            'company_request.booked': 'Buchung bestaetigt',
            'payment.initiated': 'Zahlung gestartet',
            'payment.paid': 'Zahlung eingegangen',
            'company_request.declined': 'Firma abgelehnt',
            'payment.refunded': 'Zahlung erstattet',
          },
          noData: 'Keine Funnel-Daten im gewaehlten Zeitraum.',
          // P2.068 — hardcoded aria-label in FunnelLiveWidget.tsx ({{label}}: {{count}})
          // label is already a localized step name; we add a key to keep
          // the format consistent and translatable for non-DE/EN languages.
          stepBarAria: '{{label}}: {{count}}',
        },
        analyticsDeep: {
          title: 'Analytics Deep',
          description:
            'Cohort-Retention, Attribution-Modelle und Revenue-Zeitreihen fuer tiefergehende Insights.',
          loading: 'Lade Analytics-Daten...',
          loadError: 'Analytics-Daten konnten nicht geladen werden.',
          retryAction: 'Erneut versuchen',
          dateRangeLabel: 'Zeitraum',
          last7d: '7 Tage',
          last30d: '30 Tage',
          last90d: '90 Tage',
          customRange: 'Eigener Zeitraum',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          intervalDays: 'Intervall',
          intervalDay: 'Taeglich',
          intervalWeek: 'Wöchentlich',
          intervalMonth: 'Monatlich',
          intervalAuto: 'Standard',
          cohort: {
            title: 'Cohort-Retention',
            description:
              'Retention in Prozent pro Kohortenmonat. Zeilen sind Kohorten, Spalten sind Intervalle nach Request-Erstellung.',
            cohortColumn: 'Kohorte',
            sizeColumn: 'Größe',
            retentionColumns: 'Retention pro Intervall',
            empty: 'Keine Cohort-Daten fuer den Zeitraum.',
          },
          attribution: {
            title: 'Attribution',
            description:
              'Verteilung der Conversion-Credits je nach Modell (last-touch, first-touch, linear).',
            modelLabel: 'Modell',
            modelLastTouch: 'Last-Touch',
            modelFirstTouch: 'First-Touch',
            modelLinear: 'Linear',
            channelColumn: 'Channel',
            creditColumn: 'Anteil',
            requestsColumn: 'Requests',
            touchesColumn: 'Touches',
            totalLabel: 'Gesamt-Requests: {{count}}',
            totalTouchesLabel: 'Gesamt-Touches: {{count}}',
            note: 'Hinweis: {{note}}',
            empty: 'Keine Touchpoint-Daten verfuegbar.',
          },
          revenue: {
            title: 'Revenue-Zeitreihe',
            description: 'Bezahlte Payments und Rechnungen aggregiert nach Tag, Woche oder Monat.',
            groupByLabel: 'Granularität',
            groupByDay: 'Täglich',
            groupByWeek: 'Wöchentlich',
            groupByMonth: 'Monatlich',
            bucketColumn: 'Bucket',
            amountColumn: 'Betrag (EUR)',
            countColumn: 'Anzahl',
            totalLabel: 'Gesamt: {{amount}} EUR ({{count}} Payments)',
            empty: 'Keine Umsatzdaten fuer den Zeitraum.',
            // OPT373 — hardcoded English tooltip label in RevenueTimeSeries.tsx
            amountLabel: 'Betrag',
            // OPT460 — hardcoded English Button label ('Bar'/'Line') in chart-type toggle
            chartTypeLine: 'Linie',
            chartTypeBar: 'Balken',
          },
        },
        emailOpen: {
          title: 'Email-Open-Tracking',
          description:
            '1x1-Pixel-Tracking fuer versendete Emails. Zeigt Open-Rate je Template und je NotificationLog.',
          loading: 'Lade Open-Statistiken...',
          loadError: 'Open-Statistiken konnten nicht geladen werden.',
          retryAction: 'Erneut versuchen',
          dateRangeLabel: 'Zeitraum',
          last7d: '7 Tage',
          last30d: '30 Tage',
          last90d: '90 Tage',
          customRange: 'Anwenden',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          templateLabel: 'Template',
          templateAll: 'Alle Templates',
          kpiSent: 'Gesendet',
          kpiOpens: 'Opens',
          kpiUnique: 'Unique Opens',
          kpiOpenRate: 'Open-Rate',
          templateTableTitle: 'Open-Rate pro Template',
          recentTitle: 'Letzte versendete Emails',
          empty: 'Keine Daten im ausgewaehlten Zeitraum.',
          tableTemplate: 'Template',
          tableSent: 'Gesendet',
          tableOpens: 'Opens',
          tableRate: 'Rate',
          tableUnique: 'Unique',
          tableLastOpen: 'Letzter Open',
          tableSubject: 'Betreff',
        },
        pilotBerlin: {
          title: 'Pilot Berlin Stats',
          description:
            'Zentrales KPI-Dashboard fuer den Berlin-Pilot: Anfragen, Vermittlungen, Umsatz, Wachstum und Vergleich mit dem Rest von Deutschland.',
          dateRangeLabel: 'Zeitraum',
          last7d: '7 Tage',
          last30d: '30 Tage',
          last90d: '90 Tage',
          last180d: '180 Tage',
          customRange: 'Anwenden',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          loading: 'Lade Pilot-Berlin-Daten...',
          loadError: 'Pilot-Berlin-Daten konnten nicht geladen werden.',
          retryAction: 'Erneut versuchen',
          kpi: {
            totalRequests: 'Anfragen (Berlin)',
            totalCompanies: 'Registrierte Firmen',
            conversionRate: 'Conversion-Rate',
            avgMatchTime: 'Ø Match-Zeit',
            totalRevenue: 'Umsatz (EUR)',
            customerSatisfaction: 'Kundenzufriedenheit',
            monthlyGrowth: 'Wachstum Vormonat',
            activeCustomers: 'Aktive Kunden / Firmen',
            activeCustomersSubtitle: 'Letzte 30 Tage',
          },
          monthlyRevenue: {
            title: 'Monatlicher Umsatz (letzte 12 Monate)',
            description:
              'Aggregierter Umsatz aus CompanyRequestPayments im gewaehlten Zeitraum, verteilt auf Monats-Buckets.',
            amountLabel: 'Umsatz (EUR)',
            empty: 'Keine Umsatzdaten fuer den Zeitraum.',
          },
          topBranches: {
            title: 'Top-Leistungsarten',
            description:
              'Haeltigkeiten (special_services) der registrierten Berliner Firmen. n Firmen je Kategorie.',
            empty: 'Keine Branchen-Daten verfuegbar.',
          },
          topCompanies: {
            title: 'Top Berlin-Firmen',
            description:
              'Top {{limit}} Berliner Firmen sortiert nach bezahltem Umsatz (DESC), sekundaer nach Matches.',
            columnRank: '#',
            columnName: 'Firma',
            columnRevenue: 'Umsatz (EUR)',
            columnMatches: 'Matches',
            columnRating: 'Rating',
            columnVerified: 'Status',
            verified: 'Verifiziert',
            notVerified: 'Offen',
            empty: 'Keine Berliner Firmen mit Umsatz im Zeitraum.',
          },
          comparison: {
            title: 'Berlin vs. Rest von Deutschland',
            description:
              'Berlin-Anteil an Gesamt-Anfragen, Umsatz und Conversion-Differenz basierend auf den letzten 30 Tagen.',
            shareLabel:
              'Berlin macht {{percent}} aller Anfragen aus. Skalierungs-Empfehlung siehe Pilot-Berlin-Doku.',
            requestsShare: 'Anteil Anfragen',
            revenueShare: 'Anteil Umsatz',
            conversionDelta: 'Conversion-Delta (Berlin vs. Rest)',
            empty: 'Keine Vergleichsdaten verfuegbar.',
          },
        },
        health: {
          title: 'System-Monitoring',
          desc: 'Live-Status fuer API, Datenbank, Requests, Realtime und gemeldete Frontend-Fehler.',
          lastUpdated: 'Aktualisiert: {{date}}',
          overallStatusTitle: 'Systemstatus',
          overallStatusDesc: 'Aktueller Gesamtzustand des Backends.',
          databaseTitle: 'Datenbank',
          databaseDesc: 'Readiness-Status und Grundlast.',
          databaseOk: 'Datenbank ok',
          databaseError: 'Datenbank gestört',
          avgRequestTitle: 'Ø Request-Zeit',
          avgRequestDesc: 'Mittlere Latenz aller beobachteten Requests.',
          activeSocketsTitle: 'Aktive Sockets',
          activeSocketsDesc: 'Aktuell offene Realtime-Verbindungen.',
          frontendErrorsTitle: 'Frontend-Fehler',
          frontendErrorsDesc: 'Vom Frontend gemeldete Fehlerereignisse.',
          processTitle: 'Prozess',
          processDesc: 'Node-Prozess, Laufzeit und Speicherverbrauch.',
          requestStatusTitle: 'HTTP-Statusklassen',
          requestStatusDesc: 'Verteilung der beobachteten Antworten.',
          topRoutesTitle: 'Top Routen',
          topRoutesDesc: 'Am häufigsten beobachtete normalisierte API-Routen.',
          durationBucketsTitle: 'Latenz-Buckets',
          durationBucketsDesc: 'Anzahl Requests je Dauerklasse.',
          frontendBreakdownTitle: 'Frontend-Fehlerquellen',
          frontendBreakdownDesc: 'Aufschlüsselung nach Quelle und Schweregrad.',
          uptimeLabel: 'Laufzeit',
          uptimeValue: 'Laufzeit {{value}}',
          pidLabel: 'PID',
          nodeVersionLabel: 'Node-Version',
          memoryRssLabel: 'RSS Speicher',
          memoryHeapUsedLabel: 'Heap genutzt',
          memoryHeapTotalLabel: 'Heap gesamt',
          requestTotalMeta: '{{count}} Requests beobachtet',
          requestErrorsMeta: '{{errors4xx}}× 4xx • {{errors5xx}}× 5xx',
          totalSocketsMeta: '{{count}} Verbindungen insgesamt',
          frontendLastReported: 'Zuletzt gemeldet: {{date}}',
          frontendNeverReported: 'Bisher keine gemeldeten Fehler',
          statusOk: 'Ok',
          statusDegraded: 'Beeinträchtigt',
          statusError: 'Fehler',
          methodColumn: 'Methode',
          routeColumn: 'Route',
          countColumn: 'Anzahl',
          statusColumn: 'Status',
          bucketColumn: 'Bucket',
          sourceColumn: 'Quelle',
          severityColumn: 'Schweregrad',
          frontendSourceReportError: 'reportError Hook',
          frontendSourceWindowError: 'window.onerror',
          frontendSourceUnhandledRejection: 'Unhandled Rejection',
          frontendSourceErrorBoundary: 'Error Boundary',
          empty: 'Aktuell liegen noch keine Monitoring-Daten vor.',
        },
        compliance: {
          exportError: 'Der Compliance-Report konnte nicht exportiert werden.',
          summary: {
            highRiskCompanies: 'Risikofirmen',
            blockedCompanies: 'Gesperrte Firmen',
            overdueInvoices: 'Überfällige Rechnungen',
            auditEvents: 'Audit-Ereignisse',
          },
          verification: {
            title: 'Verifizierung & SLA',
            description:
              'Aktueller Zustand offener Prüfungen, fehlender Nachweise und Wiedervorlagen.',
            pendingCompanies: 'Firmen in Prüfung',
            rejectedCompanies: 'Abgelehnte Firmen',
            missingDocuments: 'Firmen mit fehlenden Dokumenten',
            pendingSlots: 'Dokumentslots in Prüfung',
            stalePendingSlots: 'Überalterte Prüfslots',
            followUpsDue: 'Fällige Wiedervorlagen',
            followUpsOverdue: 'Überfällige Wiedervorlagen',
            averagePendingAge: 'Ø Alter offener Prüfungen',
          },
          billing: {
            title: 'Billing & Inkasso',
            description: 'Zahlungsausfälle, Mahnstufen und assignment-relevante Billing-Risiken.',
            openInvoices: 'Offene Rechnungen',
            overdueInvoices: 'Überfällige Rechnungen',
            finalNoticeInvoices: 'Letzte Mahnung',
            blockedCompanies: 'Geblockte Firmen',
            overdueAmount: 'Überfälliger Betrag',
          },
          blacklist: {
            activeEntries: 'Aktive Sperren',
            companyEntries: 'Firmensperren',
            userEntries: 'Kundensperren',
            expiringSoon: 'Läuft bald ab',
          },
          audit: {
            title: 'Audit & Änderungen',
            description: 'Verdichtung sensibler Änderungen für Governance und Nachweisführung.',
            totalEvents: 'Ereignisse gesamt',
            configChanges: 'Konfigurationsänderungen',
            blacklistChanges: 'Blacklist-Änderungen',
            verificationActions: 'Verifizierungsaktionen',
            billingActions: 'Billing-Aktionen',
            storageActions: 'Dateiaktionen',
            topActions: 'Top Aktionen',
          },
          riskCompanies: {
            title: 'Auffällige Firmen',
            description: 'Firmen mit hohem aktuellem Compliance- oder Betriebsrisiko.',
            riskLevel: 'Risikostufe',
            score: 'Score',
            status: 'Status',
            reasons: 'Gründe',
            high: 'Hoch',
            medium: 'Mittel',
            empty: 'Im gewählten Zeitraum wurden keine auffälligen Firmen erkannt.',
          },
          riskReasons: {
            assignmentBlocked: 'Assignment blockiert',
            overdueInvoices: 'Überfällige Rechnungen',
            finalNoticeInvoice: 'Letzte Mahnung erreicht',
            overdueFollowUp: 'Überfällige Wiedervorlage',
            missingDocuments: 'Fehlende Dokumente',
            rejectedVerification: 'Verifizierung abgelehnt',
            stalePendingReview: 'Prüfung überfällig',
          },
        },
        weeklyReport: {
          title: 'Wochenreport',
          description:
            'Operativer 7-Tage-Bericht mit Vergleich zur Vorwoche, Prioritäten und Export.',
          exportCsv: 'Wochenreport exportieren',
          exportError: 'Der Wochenreport konnte nicht exportiert werden.',
          sendAction: 'Per E-Mail senden',
          sendingAction: 'Versende Bericht',
          sendSuccessTitle: 'Wochenreport versendet',
          sendSuccessDescription: '{{sent}} Admin-Empfänger informiert, {{skipped}} übersprungen.',
          sendError: 'Der Wochenreport konnte nicht versendet werden.',
          currentWindow: 'Aktuelle Woche',
          previousWindow: 'Vorwoche',
          vsPreviousWeek: 'vs. Vorwoche',
          recommendationsTitle: 'Empfohlene Maßnahmen',
          recommendationsDescription:
            'Priorisierte Themen, die das Team diese Woche aktiv angehen sollte.',
          communicationTitle: 'Kommunikationslage',
          communicationDescription:
            'Offene und überfällige Antwort-Workflows im aktuellen Bestand.',
          supplyGapsTitle: 'Versorgungslücken',
          supplyGapsDescription: 'Segmente mit Nachfrageüberhang und zu wenig aktiver Abdeckung.',
          riskCompaniesTitle: 'Risikofokus',
          riskCompaniesDescription:
            'Firmen, die im Wochenbericht sofortige Aufmerksamkeit brauchen.',
          noRecommendations: 'Aktuell keine priorisierten Maßnahmen erkannt.',
          noSupplyGaps: 'Keine wesentlichen Versorgungslücken im aktuellen Wochenbild.',
          noRiskCompanies: 'Keine auffälligen Risikofirmen im aktuellen Wochenbild.',
          affectedCount: '{{count}} betroffene Fälle',
          priorityHigh: 'Hoch',
          priorityMedium: 'Mittel',
          riskScore: 'Score {{score}}',
          metrics: {
            paidRevenue: 'Bezahlter Umsatz',
            requestsCreated: 'Neue Anfragen',
            completionRate: 'Abschlussquote',
            activeCompanies: 'Aktive Firmen',
            overdueInvoices: 'Überfällige Rechnungen',
            blockedCompanies: 'Geblockte Firmen',
            highRiskCompanies: 'Risikofirmen',
          },
          communication: {
            pendingTasks: 'Offene Antworten',
            overdueTasks: 'Überfällige Antworten',
            totalTasks: 'Alle offenen Fälle',
          },
          recommendationKeys: {
            reviewHighRiskCompanies: 'Risikofirmen priorisiert prüfen',
            clearOverdueInvoices: 'Überfällige Rechnungen und Mahnstufen nachfassen',
            resolveVerificationBacklog: 'Verifizierungs-Backlog und Wiedervorlagen abbauen',
            respondToOverdueCommunications: 'Überfällige Kommunikationsfälle beantworten',
            addressSupplyGaps: 'Angebotslücken in Nachfrage-Segmenten schließen',
          },
          weekdays: {
            0: 'Sonntag',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Samstag',
          },
          automation: {
            title: 'Automatischer Versand',
            description: 'Plane den Wochenreport für opt-in-Admins automatisch ein.',
            enabledLabel: 'Automatischen Wochenversand aktivieren',
            enabledDescription:
              'Nur Admins mit aktivierter Wochenreport-Benachrichtigung erhalten den Bericht.',
            weekdayLabel: 'Versandtag',
            hourLabel: 'Stunde (UTC)',
            minuteLabel: 'Minute (UTC)',
            timezoneHint:
              'Die Automatik verwendet UTC und schützt per Versandhistorie vor doppelten Wochenläufen.',
            saveAction: 'Automatik speichern',
            savedTitle: 'Wochenreport-Automatik gespeichert',
            savedDescription: 'Die Versandplanung für den Wochenreport wurde aktualisiert.',
            saveError: 'Die Wochenreport-Automatik konnte nicht gespeichert werden.',
            validationError:
              'Bitte geben Sie einen gültigen Wochentag sowie Stunde und Minute in UTC an.',
            nextRun: 'Nächster geplanter Lauf: {{localDate}} ({{utcDate}} UTC)',
            scheduleSummary: 'Wöchentlich am {{weekday}} um {{hour}}:{{minute}} UTC.',
            disabledHint: 'Die Wochenreport-Automatik ist derzeit deaktiviert.',
            lastRun: 'Letzter Lauf: {{date}} • {{status}} • {{source}}',
          },
          history: {
            title: 'Versandhistorie',
            description: 'Letzte manuelle und automatische Versandläufe des Wochenreports.',
            empty: 'Bisher gibt es noch keine Versandläufe.',
            statusSent: 'Versendet',
            statusSkipped: 'Übersprungen',
            statusFailed: 'Fehlgeschlagen',
            sourceScheduled: 'Automatisch',
            sourceManual: 'Manuell',
            sentMeta: '{{sent}} versendet, {{skipped}} übersprungen',
            scheduledFor: 'Geplanter Slot: {{date}}',
            anchorDate: 'Berichtsanker: {{date}}',
            recipients: 'Empfänger: {{recipients}}',
            rerunAction: 'Erneut senden',
            rerunningAction: 'Wird gesendet...',
            rerunSuccessTitle: 'Erneut gesendet',
            rerunSuccessDescription: 'Bericht wurde an {{sent}} Empfaenger gesendet',
            rerunError: 'Erneuter Versand fehlgeschlagen',
            sourceFilterLabel: 'Quelle',
            sourceFilterAll: 'Alle',
            sourceFilterManual: 'Manuell',
            sourceFilterScheduled: 'Geplant',
            sourceFilterApplied: 'Aktiv',
            emptyFiltered: 'Keine Eintraege fuer diesen Filter',
          },
        },
        matchingInsights: {
          title: 'Matching-Marktbild',
          description: 'Verdichtete Nachfrage- und Versorgungsluecken der letzten {{days}} Tage.',
          periodLabel: 'Zeitraum',
          period30: 'Letzte 30 Tage',
          period60: 'Letzte 60 Tage',
          period90: 'Letzte 90 Tage',
          period180: 'Letzte 180 Tage',
          refreshAction: 'Aktualisieren',
          exportAction: 'CSV exportieren',
          loadError: 'Die Matching-Insights konnten nicht geladen werden.',
          exportError: 'Die Matching-Insights konnten nicht exportiert werden.',
          emptyState: 'Fuer den gewaehlten Zeitraum sind aktuell keine Matching-Daten verfuegbar.',
          requestCount_one: '{{count}} Anfrage im Fokus',
          requestCount_other: '{{count}} Anfragen im Fokus',
          topRequestTypesTitle: 'Top Anfragearten',
          topPostalAreasTitle: 'Top PLZ-Gebiete',
          topSpecialServicesTitle: 'Top Zusatzleistungen',
          underservedRequestTypesTitle: 'Unterversorgte Anfragearten',
          underservedPostalAreasTitle: 'Unterversorgte PLZ-Gebiete',
          underservedSpecialServicesTitle: 'Unterversorgte Zusatzleistungen',
          coverageMeta: '{{demand}} Nachfrage / {{companies}} Firmen',
          noUnderservedSegments: 'Aktuell keine klar unterversorgten Segmente erkannt.',
        },
        aiInsights: {
          title: 'KI-Insights Dashboard',
          aiEnabled: 'KI-Erweiterung aktiv',
          aiDisabled: 'KI-Erweiterung deaktiviert (kein API-Key)',
          applyRange: 'Anwenden',
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          enhancementsToday: 'Verbesserungen heute',
          totalCost7d: 'Gesamtkosten (7T)',
          calls: 'Aufrufe',
          tokens: 'Tokens',
          totalCost: 'Gesamtkosten',
          avgCostPerCall: 'Ø Kosten / Aufruf (7T)',
          costTracking: 'Kosten-Tracking',
          costTrackingSubtitle:
            'Claude-API-Ausgaben über die letzten 7 Tage und konfigurierbarer Zeitraum.',
          totalTokens: 'Tokens verwendet (7T)',
          cachePanel: 'Cache-Übersicht',
          cachePanelSubtitle:
            'Der In-Process-LRU-Cache wird vom Endpoint /api/admin/ai/cache/stats abgefragt.',
          costUsdLabel: 'Kosten (USD)',
          callsLabel: 'Aufrufe',
          empty:
            'Noch keine KI-Insights aufgezeichnet. Erweitern Sie eine Anfrage, um diese Tabelle zu befüllen.',
          model: 'Modell',
          cost: 'Kosten',
          confidence: 'Konfidenz',
          costByModel: 'Kosten nach Modell',
          costOverTime: 'Kosten im Zeitverlauf (letzte 30 Tage)',
          averageConfidence: 'Ø Konfidenz (7T)',
          fallbackRate: 'Fallback-Rate (7T)',
          recentTitle: 'Aktuelle KI-Begründungen',
          recentSubtitle: 'Die letzten 20 KI-erweiterten Datensätze',
          noCostData: 'Noch keine Kostendaten verfügbar.',
          noModelData: 'Keine Modellkostendaten.',
          createdAt: 'Wann',
          company: 'Firma',
          request: 'Anfrage',
          reasoning: 'Begründung',
          baseScore: 'Basis',
          finalScore: 'Final',
        },
        mailSettings: {
          title: 'Mail-Konfiguration',
          description:
            'Verwalten Sie SMTP fuer den Versand und optionale IMAP-Zugangsdaten fuer spaetere Inbox-Workflows.',
          provider: 'Versandmodus',
          fromEmail: 'Absender-E-Mail',
          smtpTitle: 'SMTP-Versand',
          imapTitle: 'IMAP-Eingang',
          imapDescription:
            'Die IMAP-Konfiguration wird gespeichert und fuer spaetere Eingangs-/Reply-Workflows vorbereitet.',
          host: 'Host',
          port: 'Port',
          username: 'Benutzername',
          password: 'Passwort',
          mailbox: 'Postfach',
          secureConnection: 'Sichere Verbindung (TLS/SSL)',
          enableImap: 'IMAP aktivieren',
          passwordConfigured: 'Passwort ist hinterlegt',
          passwordMissing: 'Kein Passwort hinterlegt',
          passwordKeep: 'Leer lassen, um das bestehende Passwort zu behalten',
          saveAction: 'Mail-Konfiguration speichern',
          savedTitle: 'Mail-Konfiguration gespeichert',
          savedDescription: 'Die Mail-Server-Einstellungen wurden aktualisiert.',
          loadError: 'Die Mail-Konfiguration konnte nicht geladen werden.',
          saveError: 'Die Mail-Konfiguration konnte nicht gespeichert werden.',
          testRecipient: 'Empfänger der Test-E-Mail',
          testAction: 'Speichern & testen',
          testHint:
            'Die aktuellen SMTP-Einstellungen werden gespeichert, die Verbindung geprüft und anschließend eine Test-E-Mail versendet.',
          testSuccessTitle: 'SMTP-Test erfolgreich',
          testSuccessDescription: 'Die Test-E-Mail wurde an {{recipient}} übergeben.',
          testErrorTitle: 'SMTP-Test fehlgeschlagen',
          testErrorDescription:
            'Verbindung oder Versand fehlgeschlagen. Bitte Host, Port, TLS und Zugangsdaten prüfen.',
          notificationPreferencesTitle: 'Eigene Benachrichtigungen',
          notificationPreferencesDescription:
            'Legen Sie fest, welche System-E-Mails Sie als Admin erhalten moechten.',
          providers: {
            log: 'Nur protokollieren',
            noop: 'Nicht senden',
            smtp: 'Per SMTP senden',
          },
        },
        companyAccessRecovery: {
          title: 'Entsperrungsanfragen',
          description:
            'Offene Firmenanfragen fuer manuelle Pruefung von Billing- oder Sperrfaellen.',
          pendingCount_one: '{{count}} offen',
          pendingCount_other: '{{count}} offen',
          empty: 'Aktuell gibt es keine offenen Entsperrungsanfragen.',
          openProof: 'Nachweis oeffnen',
          markInvoicePaid: 'Rechnung als bezahlt markieren',
          removeBlacklist: 'Blacklist entfernen',
          approve: 'Freigabe senden',
          reject: 'Ablehnen',
          blockReasonPayment: 'Billing-Sperre',
          blockReasonBlacklist: 'Blacklist-Sperre',
          reviewApproveTitle: 'Entsperrung freigeben',
          reviewRejectTitle: 'Entsperrung ablehnen',
          reviewDialogDesc: 'Hinterlassen Sie eine Rueckmeldung fuer {{company}}.',
          reviewResponseLabel: 'Rueckmeldung an die Firma',
          reviewResponsePlaceholder:
            'Beschreiben Sie naechste Schritte oder den Grund der Entscheidung.',
          reviewResponseRequired: 'Bitte hinterlegen Sie eine Rueckmeldung fuer die Firma.',
          reviewSuccessTitle: 'Entscheidung gespeichert',
          reviewApprovedDesc: 'Die Entsperrungsanfrage wurde freigegeben.',
          reviewRejectedDesc: 'Die Entsperrungsanfrage wurde abgelehnt.',
          reviewError: 'Die Entsperrungsanfrage konnte nicht bearbeitet werden.',
          status: {
            pending: 'In Pruefung',
            approved: 'Freigegeben',
            rejected: 'Abgelehnt',
          },
        },
        userAccessRecovery: {
          title: 'Kunden-Entsperrungsanfragen',
          description: 'Offene Kundenanfragen fuer manuelle Pruefung von Sperrfaellen.',
          pendingCount_one: '{{count}} offen',
          pendingCount_other: '{{count}} offen',
          empty: 'Aktuell gibt es keine offenen Kunden-Entsperrungsanfragen.',
          openProof: 'Nachweis oeffnen',
          removeBlacklist: 'Sperre entfernen',
          approve: 'Freigabe senden',
          reject: 'Ablehnen',
          blockReasonBlacklist: 'Kundensperre',
          reviewApproveTitle: 'Kundenkonto freigeben',
          reviewRejectTitle: 'Entsperrung ablehnen',
          reviewDialogDesc: 'Hinterlassen Sie eine Rueckmeldung fuer {{user}}.',
          reviewResponseLabel: 'Rueckmeldung an den Kunden',
          reviewResponsePlaceholder:
            'Beschreiben Sie naechste Schritte oder den Grund der Entscheidung.',
          reviewResponseRequired: 'Bitte hinterlegen Sie eine Rueckmeldung fuer den Kunden.',
          reviewSuccessTitle: 'Entscheidung gespeichert',
          reviewApprovedDesc: 'Die Kunden-Entsperrungsanfrage wurde freigegeben.',
          reviewRejectedDesc: 'Die Kunden-Entsperrungsanfrage wurde abgelehnt.',
          reviewError: 'Die Kunden-Entsperrungsanfrage konnte nicht bearbeitet werden.',
          status: {
            pending: 'In Pruefung',
            approved: 'Freigegeben',
            rejected: 'Abgelehnt',
          },
        },
        blacklist: {
          title: 'Sperren',
          titleDesc: 'Benutzer- und Firmensperren verwalten',
          addEntry: 'Sperre hinzufügen',
          addEntryDesc: 'Neuen Eintrag zur Blacklist hinzufügen',
          searchPlaceholder: 'Nach Entitaet, Grund oder Ersteller suchen',
          entityType: 'Typ',
          entityTypeAll: 'Alle Typen',
          entityId: 'Entität ID',
          user: 'Benutzer',
          company: 'Firma',
          selectUser: 'Benutzer auswählen',
          selectUserPlaceholder: 'Wählen Sie einen Benutzer',
          selectCompany: 'Firma auswaehlen',
          selectCompanyPlaceholder: 'Waehlen Sie eine Firma',
          reason: 'Grund',
          reasonPlaceholder: 'Grund für die Sperre eingeben...',
          validUntil: 'Gültig bis',
          validUntilDesc: 'Leer lassen für permanente Sperre',
          createdBy: 'Erstellt von',
          fillRequired: 'Bitte füllen Sie alle erforderlichen Felder aus',
          created: 'Sperre erstellt',
          createdDesc: 'Die Sperre wurde erfolgreich erstellt',
          createError: 'Fehler beim Erstellen der Sperre',
          deleted: 'Sperre entfernt',
          deletedDesc: 'Die Sperre wurde erfolgreich entfernt',
          deleteError: 'Fehler beim Entfernen der Sperre',
          noEntries: 'Keine Sperren vorhanden',
          filteredCount: '{{count}} Sperren',
          statusAll: 'Alle Stati',
          statusActive: 'Aktiv',
          statusExpired: 'Abgelaufen',
          statusPermanent: 'Permanent',
          export: 'Sperren exportieren',
          exportError: 'Der Sperrenexport konnte nicht exportiert werden.',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Sperren',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
          permanent: 'Permanent',
          expired: 'Abgelaufen',
        },
        gdprHardDelete: {
          title: '{{entityType}} endgültig löschen (GDPR Art. 17)',
          description: 'Du löschst „{{label}}" dauerhaft aus der Datenbank.',
          hardDeleteCta: 'Hard-Delete (GDPR Art. 17)',
          warningTitle: 'Achtung: unwiderrufliche Hard-Delete-Aktion',
          warningBody:
            'Diese Aktion entfernt den Datensatz und alle abhängigen Zeilen endgültig. Es gibt keinen Papierkorb. Nur nutzen, wenn die rechtliche Prüfung dokumentiert ist.',
          emailLabel: 'E-Mail / Bezeichnung (zur Bestätigung)',
          tokenLabel: 'Sicherheits-Token',
          tokenHelp: 'Tippe genau PERMANENTLY-DELETE, um fortzufahren.',
          reasonLabel: 'Grund (optional, wird im Audit-Log gespeichert)',
          reasonPlaceholder: 'z. B. customer_request, legal_hold',
          dryRunCta: 'Dry-Run starten',
          dryRunSummaryTitle: 'Voraussichtliche Löschungen',
          dryRunSummaryDesc: 'Diese Zeilen würden entfernt werden:',
          dryRunNoCounts: 'Keine abhängigen Datensätze gefunden.',
          finalWarning:
            'Mit Klick auf „Endgültig löschen" wird die Transaktion unwiderruflich ausgeführt.',
          continueCta: 'Weiter zur Bestätigung',
          finalStepTitle: 'Letzte Bestätigung',
          finalStepBody:
            'Du löschst „{{label}}" jetzt permanent. Das Token „{{token}}" wurde erfolgreich eingegeben.',
          finalCta: 'Endgültig löschen',
          executing: 'Löschung läuft ...',
          completedTitle: 'Hard-Delete abgeschlossen',
          completedBody: '„{{label}}" und alle abhängigen Datensätze wurden entfernt.',
          successToastTitle: 'GDPR Hard-Delete erfolgreich',
          successToastDesc:
            '{{label}} wurde gemeinsam mit {{records}} abhängigen Datensätzen gelöscht.',
          closeCta: 'Schließen',
          errors: {
            dryRunFailed: 'Dry-Run fehlgeschlagen.',
            executeFailed: 'Hard-Delete fehlgeschlagen.',
          },
          entity: {
            user: 'Benutzer',
            company: 'Firma',
          },
        },
        audit: {
          title: 'Audit-Protokoll',
          desc: 'Nachvollziehbare Historie für Admin-, Dokumenten-, Billing- und Sperrentscheidungen.',
          searchLabel: 'Suche',
          searchPlaceholder: 'Nach Aktion, Entität, Actor oder Zusammenfassung suchen',
          actionFilter: 'Aktion',
          entityFilter: 'Entität',
          entityHeader: 'Entität',
          actorHeader: 'Ausgeführt von',
          summaryHeader: 'Zusammenfassung',
          export: 'CSV exportieren',
          exportError: 'Das Audit-Protokoll konnte nicht exportiert werden.',
          empty: 'Keine Audit-Einträge für den aktuellen Filter.',
          pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Eintraege',
          pageLabel: 'Seite',
          previousPage: 'Zurueck',
          nextPage: 'Weiter',
          systemActor: 'System',
          actions: {
            userCreated: 'Benutzer erstellt',
            userUpdated: 'Benutzer aktualisiert',
            invoiceCreated: 'Rechnung erstellt',
            invoiceStatusUpdated: 'Rechnungsstatus geändert',
            blacklistCreated: 'Sperre erstellt',
            blacklistRemoved: 'Sperre entfernt',
            companyAccessRecoveryRequested: 'Entsperrungsanfrage eingereicht',
            companyAccessRecoveryReviewed: 'Entsperrungsanfrage entschieden',
            userAccessRecoveryRequested: 'Kunden-Entsperrungsanfrage eingereicht',
            userAccessRecoveryReviewed: 'Kunden-Entsperrungsanfrage entschieden',
            companyVerificationReviewed: 'Firmenprüfung entschieden',
            companyVerificationMetadataUpdated: 'Verifizierungsnotiz aktualisiert',
            configUpdated: 'Konfiguration geändert',
            weeklyReportSent: 'Wochenreport versendet',
            requestCreated: 'Anfrage erstellt',
            requestUpdated: 'Anfrage aktualisiert',
            requestCancelled: 'Anfrage storniert',
            requestCompanySelected: 'Firma ausgewählt',
            requestCompleted: 'Anfrage abgeschlossen',
            requestPublicCompanyCreated: 'Öffentliche Firmenanfrage erstellt',
            fileDeleted: 'Datei gelöscht',
          },
          entities: {
            user: 'Benutzer',
            company: 'Firma',
            invoice: 'Rechnung',
            request: 'Anfrage',
            adminConfig: 'Konfiguration',
            adminReport: 'Admin-Report',
            companyDocument: 'Firmendokument',
            requestDocument: 'Anfragedokument',
            fileAsset: 'Datei',
          },
        },
      },
      chat: {
        noMessages: 'Keine Nachrichten',
      },
      errors: {
        error: 'Fehler',
        generic: 'Ein Fehler ist aufgetreten',
        validationError: 'Validierungsfehler',
        loadError: 'Fehler beim Laden',
        notFound: 'Nicht gefunden',
        accessDenied: 'Zugriff verweigert',
        invalidInput: 'Ungültige Eingabe',
      },
      notificationPreferences: {
        loadError: 'Benachrichtigungseinstellungen konnten nicht geladen werden.',
        saveError: 'Benachrichtigungseinstellungen konnten nicht gespeichert werden.',
        savedTitle: 'Benachrichtigungen gespeichert',
        savedDesc: 'Ihre E-Mail-Benachrichtigungen wurden aktualisiert.',
        saveAction: 'Benachrichtigungen speichern',
        labels: {
          emailNewRequests: 'Neue Anfragen per E-Mail',
          emailMessages: 'Neue Nachrichten per E-Mail',
          emailStatusUpdates: 'Statusaenderungen per E-Mail',
          emailDocuments: 'Dokumenten- und Pruefhinweise per E-Mail',
          emailWeeklyReports: 'Admin-Wochenreport per E-Mail',
        },
      },
      dataExport: {
        title: 'Daten-Export (DSGVO)',
        description:
          'Laden Sie eine vollstaendige Aufstellung aller zu Ihrer Person gespeicherten Daten gemaess DSGVO Art. 15 (Auskunft) und Art. 20 (Datenuebertragbarkeit) herunter.',
        legalNote:
          'Der Export enthaelt personenbezogene Daten. Bitte behandeln Sie die Datei vertraulich.',
        includeFilesLabel: 'Datei-Referenzen einschliessen',
        includeFilesHelp: 'Liste der hochgeladenen Dateien ohne Dateiinhalte.',
        formatLabel: 'Format',
        formatJson: 'JSON',
        formatJsonDescription: 'Maschinenlesbar, fuer Datenuebertragbarkeit.',
        formatPdf: 'PDF (Datenauskunft)',
        formatPdfDescription: 'Druckbar, mit Wasserzeichen und Seitenzahlen.',
        downloadButton: 'Daten-Export herunterladen',
        asyncButton: 'Per E-Mail erhalten',
        rateLimited:
          'Sie haben innerhalb der letzten Stunde bereits einen Export angefordert. Bitte versuchen Sie es spaeter erneut.',
        blocked: 'Der Daten-Export ist momentan nicht moeglich.',
        errorGeneric: 'Der Daten-Export konnte nicht erstellt werden.',
        successTitle: 'Daten-Export wird vorbereitet',
        successDesc: 'Ihr Download startet in Kuerze automatisch.',
        asyncSuccessTitle: 'Daten-Export angefordert',
        asyncSuccessDesc:
          'Wir senden Ihnen den Download-Link per E-Mail (gueltig fuer 24 Stunden).',
        downloadNow: 'Jetzt herunterladen',
        lastExportLabel: 'Letzter Export',
        lastExportNever: 'Noch kein Export durchgefuehrt',
        legalReference: 'Rechtsgrundlage: DSGVO Art. 15, Art. 20',
        delete: {
          title: 'Konto loeschen (DSGVO Art. 17)',
          description:
            'Loescht alle personenbezogenen Daten dieses Kontos unwiderruflich gemaess DSGVO Art. 17 (Recht auf Loeschung).',
          warning:
            'Diese Aktion ist endgueltig. Es gibt eine 30-taegige Wiederherstellungsfrist, in der wir die Loeschung auf Wunsch rueckgaengig machen koennen.',
          gracePeriod:
            'Innerhalb der 30-taegigen Frist koennen Sie die Loeschung per E-Mail an datenschutz@regionalumzug24.de widerrufen.',
          button: 'Konto loeschen',
          dialogTitle: 'Konto endgueltig loeschen?',
          dialogDescription:
            'Bitte bestaetigen Sie die Loeschung. Dies kann nicht rueckgaengig gemacht werden.',
          bulletProfile: 'Profil, Adresse und Kontaktdaten werden anonymisiert.',
          bulletEmail: 'Login und E-Mail-Zugang werden gesperrt.',
          bulletReviews:
            'Bewertungen werden zu "[deleted]" anonymisiert (Sterne bleiben erhalten).',
          bulletSessions: 'Alle aktiven Sitzungen und Reset-Token werden widerrufen.',
          confirmLabel: 'Tippen Sie {{word}} zur Bestaetigung',
          confirmWord: 'LOESCHEN',
          confirmButton: 'Endgueltig loeschen',
          confirmMismatch: 'Bitte tippen Sie das Wort exakt ein.',
          deleting: 'Loescht...',
          successTitle: 'Konto geloescht',
          successDesc:
            'Ihr Konto wurde anonymisiert. Sie werden in Kuerze zur Anmeldung weitergeleitet.',
          errorGeneric: 'Das Konto konnte nicht geloescht werden.',
        },
      },
      communicationTasks: {
        customerTitle: 'Offene Rueckmeldungen',
        customerDescription:
          'Antworten Sie auf offene Rueckfragen von Firmen, bevor Eskalationen faellig werden.',
        companyTitle: 'Offene Kundenrueckmeldungen',
        companyDescription:
          'Behalten Sie offene Rueckfragen an Kunden im Blick und reagieren Sie auf ueberfaellige Antworten.',
        adminTitle: 'Kommunikationsfaelle mit Antwortbedarf',
        adminDescription:
          'Zentrale Sicht auf offene oder ueberfaellige Chat-Rueckfragen zwischen Kunden und Firmen.',
        searchPlaceholder: 'Nach Route, Firma, Beteiligten oder Nachricht suchen',
        senderTypeFilter: 'Absender',
        senderTypeCustomer: 'Kunde',
        senderTypeCompany: 'Firma',
        senderTypeAdmin: 'Admin',
        export: 'CSV exportieren',
        exportError: 'Die Kommunikationsaufgaben konnten nicht exportiert werden.',
        pageSummary: 'Seite {{page}} von {{totalPages}} · {{total}} Aufgaben',
        previousPage: 'Zurueck',
        nextPage: 'Weiter',
        empty: 'Aktuell gibt es keine offenen Kommunikationsaufgaben.',
        statusPending: 'Antwort ausstehend',
        statusOverdue: 'Ueberfaellig',
        openAction: 'Chat oeffnen',
        openRequestAction: 'Anfrage oeffnen',
        createdAt: 'Angefragt: {{date}}',
        dueAtPending: 'Faellig: {{date}}',
        dueAtOverdue: 'Ueberfaellig seit {{date}}',
        summaryTotal: '{{count}} offen',
        summaryPending: '{{count}} geplant',
        summaryOverdue: '{{count}} ueberfaellig',
      },
      cookieConsent: {
        title: 'Cookies & Datenschutz',
        message:
          'Wir verwenden Cookies, um unsere Website bereitzustellen und — mit Ihrer Einwilligung — Reichweite zu messen. Sie koennen Ihre Auswahl jederzeit anpassen.',
        acceptAll: 'Alle akzeptieren',
        essentialOnly: 'Nur essenzielle',
        settings: 'Einstellungen',
        preferencesTitle: 'Cookie-Einstellungen',
        preferencesDescription:
          'Waehlen Sie, welche Kategorien Sie zulassen moechten. Essenzielle Cookies sind fuer den Betrieb der Seite erforderlich.',
        essentialTitle: 'Essenziell',
        essentialDescription:
          'Anmeldung, CSRF-Schutz, Session. Diese Cookies koennen nicht deaktiviert werden.',
        analyticsTitle: 'Statistik (Plausible)',
        analyticsDescription:
          'Anonyme Reichweitenmessung ueber Plausible Analytics (keine personenbezogenen Daten, keine Cookies).',
        analyticsUnavailable:
          'Plausible ist derzeit nicht konfiguriert (VITE_PLAUSIBLE_DOMAIN fehlt).',
        marketingTitle: 'Marketing',
        marketingDescription: 'Derzeit nicht aktiv. Wir nutzen kein Marketing-Tracking.',
        savePreferences: 'Auswahl speichern',
        close: 'Schliessen',
        cookiePolicyLink: 'Mehr in der Datenschutzerklaerung',
        footerLink: 'Cookie-Einstellungen',
      },
      // P2.072 — meta-title/description for city landing pages (Moving)
      frankfurtLanding: {
        metaTitle: 'Umzug Frankfurt | RegionalUmzug24',
        metaDescription:
          'Geprüfte Umzugsfirmen in Frankfurt am Main vergleichen. Kostenlose Angebote für Privat- und Büroumzüge in der Mainmetropole.',
      },
      hamburgLanding: {
        metaTitle: 'Umzug Hamburg | RegionalUmzug24',
        metaDescription:
          'Geprüfte Umzugsfirmen in Hamburg vergleichen. Kostenlose Angebote für Privat- und Büroumzüge in der Hansestadt.',
      },
      koelnLanding: {
        metaTitle: 'Umzug Köln | RegionalUmzug24',
        metaDescription:
          'Geprüfte Umzugsfirmen in Köln vergleichen. Kostenlose Angebote für Privat- und Büroumzüge in der Domstadt.',
      },
      muenchenLanding: {
        metaTitle: 'Umzug München | RegionalUmzug24',
        metaDescription:
          'Geprüfte Umzugsfirmen in München vergleichen. Kostenlose Angebote für Privat- und Büroumzüge in der bayerischen Landeshauptstadt.',
      },
      stuttgartLanding: {
        metaTitle: 'Umzug Stuttgart | RegionalUmzug24',
        metaDescription:
          'Geprüfte Umzugsfirmen in Stuttgart vergleichen. Kostenlose Angebote für Umzüge im Talkessel und im Schwabenland.',
      },
      frankfurtDirectory: {
        metaTitle: 'Umzugsfirmen Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Umzugsfirmen in Frankfurt am Main. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords:
          'Umzugsfirmen Frankfurt am Main, Umzug Frankfurt am Main, Umzugsunternehmen Frankfurt',
        pageTitle: 'Umzugsfirmen in Frankfurt am Main',
        pageSubtitle:
          'Entdecken Sie geprüfte Frankfurter Umzugsfirmen mit echten Bewertungen. Postleitzahlbereiche 60-65 - von Westend bis Höchst.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal60: 'PLZ 60 (Westend)',
        filterPostal65: 'PLZ 65 (Höchst)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Frankfurter Umzugsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Frankfurter Umzugsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Frankfurter Umzugsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      hamburgDirectory: {
        metaTitle: 'Umzugsfirmen Hamburg | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Umzugsfirmen in Hamburg. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Umzugsfirmen Hamburg, Umzug Hamburg, Umzugsunternehmen Hamburg',
        pageTitle: 'Umzugsfirmen in Hamburg',
        pageSubtitle:
          'Entdecken Sie geprüfte Hamburger Umzugsfirmen mit echten Bewertungen. Postleitzahlbereiche 20-22 - vom Stadtzentrum bis Bergedorf.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal20: 'PLZ 20 (Stadtzentrum)',
        filterPostal21: 'PLZ 21 (Nord)',
        filterPostal22: 'PLZ 22 (Ost)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Hamburger Umzugsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Hamburger Umzugsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Hamburger Umzugsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      koelnDirectory: {
        metaTitle: 'Umzugsfirmen Köln | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Umzugsfirmen in Köln. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Umzugsfirmen Köln, Umzug Köln, Umzugsunternehmen Köln',
        pageTitle: 'Umzugsfirmen in Köln',
        pageSubtitle:
          'Entdecken Sie geprüfte Kölner Umzugsfirmen mit echten Bewertungen. Postleitzahlbereiche 50-51 - links und rechts des Rheins.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal50: 'PLZ 50 (Stadtzentrum)',
        filterPostal51: 'PLZ 51 (rechtes Rheinufer)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Kölner Umzugsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Kölner Umzugsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Kölner Umzugsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      muenchenDirectory: {
        metaTitle: 'Umzugsfirmen München | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Umzugsfirmen in München. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Umzugsfirmen München, Umzug München, Umzugsunternehmen München',
        pageTitle: 'Umzugsfirmen in München',
        pageSubtitle:
          'Entdecken Sie geprüfte Münchner Umzugsfirmen mit echten Bewertungen. Postleitzahlbereiche 80-82 - von Schwabing bis zum Süden.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal80: 'PLZ 80 (Stadtzentrum)',
        filterPostal81: 'PLZ 81 (Süd/Ost)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Münchner Umzugsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Münchner Umzugsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Münchner Umzugsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      // OPT422-i18n — berlinDirectory (25 keys)
      berlinDirectory: {
        metaTitle: 'Umzugsfirmen Berlin | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Umzugsfirmen in Berlin. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Umzugsfirmen Berlin, Umzug Berlin, Umzugsunternehmen Berlin',
        pageTitle: 'Umzugsfirmen in Berlin',
        pageSubtitle:
          'Entdecken Sie geprüfte Berliner Umzugsfirmen mit echten Bewertungen. Postleitzahlbereiche 10-14 - inklusive Potsdam und Brandenburg.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Berliner Umzugsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Berliner Umzugsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Berliner Umzugsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        companyVerified: 'Verifiziert',
        companyPremium: 'Premium',
        companyReviews: 'Bewertungen',
        companySpecialties: 'Spezialisierungen',
        companyServiceArea: 'Einsatzgebiet',
        companyViewProfile: 'Profil ansehen',
        companyRequestQuote: 'Angebot anfragen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      // OPT422-i18n — berlinLanding (25 keys)
      berlinLanding: {
        metaTitle: 'Umzug Berlin | RegionalUmzug24',
        metaDescription:
          'Finden Sie die besten Umzugsfirmen in Berlin. Vergleichen Sie kostenlos Angebote von geprüften Berliner Umzugsunternehmen. Kontrolliert, bewertet, DSGVO-konform.',
        metaKeywords: 'Umzug Berlin, Umzugsfirmen Berlin, Umzugskosten Berlin',
        benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 in Berlin',
        benefitsSubtitle: 'Warum tausende Berliner unsere Matching-Plattform wählen',
        benefitFreeTitle: '100% kostenlos',
        benefitFreeDesc:
          'Das Erstellen einer Anfrage und der Vergleich von Angeboten ist vollständig kostenlos und unverbindlich.',
        benefitLocalTitle: 'Lokale Berliner Firmen',
        benefitLocalDesc:
          'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in Berlin und Umgebung (Postleitzahlen 10-14).',
        benefitReviewsTitle: 'Echte Bewertungen',
        benefitReviewsDesc:
          'Lesen Sie verifizierte Kundenbewertungen und entscheiden Sie auf Basis echter Erfahrungen.',
        statsTitle: 'Umziehen in Berlin in Zahlen',
        statsSubtitle: 'Berliner Kunden vertrauen RegionalUmzug24',
        statFirms: '200+',
        statFirmsLabel: 'Berliner Umzugsfirmen',
        statMoves: '500+',
        statMovesLabel: 'Vermittelte Umzüge',
        statSavings: '40%',
        statSavingsLabel: 'Durchschn. Ersparnis',
        statRating: '4,7/5',
        statRatingLabel: 'Kundenbewertung',
        ctaTitle: 'Bereit für Ihren Umzug in Berlin?',
        ctaSubtitle:
          'Erstellen Sie jetzt Ihre kostenlose Anfrage und erhalten Sie Angebote von geprüften Berliner Umzugsfirmen.',
        ctaPrimary: 'Jetzt Anfrage erstellen',
        ctaSecondary: 'Berliner Firmen ansehen',
      },
      stuttgartDirectory: {
        metaTitle: 'Umzugsfirmen Stuttgart | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Umzugsfirmen in Stuttgart. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Umzugsfirmen Stuttgart, Umzug Stuttgart, Umzugsunternehmen Stuttgart',
        pageTitle: 'Umzugsfirmen in Stuttgart',
        pageSubtitle:
          'Entdecken Sie geprüfte Stuttgarter Umzugsfirmen mit echten Bewertungen. Postleitzahlbereiche 70-71 - im Talkessel und in Schwaben.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal70: 'PLZ 70 (Stuttgart)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Stuttgarter Umzugsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Stuttgarter Umzugsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Stuttgarter Umzugsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      // P2.072 — meta-title/description for Cleaning city landing pages
      cleaningFrankfurtamMainLanding: {
        metaTitle: 'Reinigung Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Reinigungsfirmen in Frankfurt am Main. Kostenlose Angebote von verifizierten Anbietern.',
      },
      cleaningFrankfurtamMainDirectory: {
        metaTitle: 'Reinigungsfirmen Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Reinigungsfirmen in Frankfurt am Main. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords:
          'Reinigungsfirmen Frankfurt am Main, Reinigung Frankfurt am Main, Reinigungsunternehmen Frankfurt',
        pageTitle: 'Reinigungsfirmen in Frankfurt am Main',
        pageSubtitle:
          'Entdecken Sie geprüfte Reinigungsfirmen in Frankfurt am Main mit echten Bewertungen. Postleitzahlbereiche 60-65.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal60: 'PLZ 60 (Westend)',
        filterPostal65: 'PLZ 65 (Höchst)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Reinigungsfirma in Frankfurt am Main passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Reinigungsfirmen in Frankfurt am Main...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Reinigungsfirmen in Frankfurt am Main konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      cleaningHamburgLanding: {
        metaTitle: 'Reinigung Hamburg | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Reinigungsfirmen in Hamburg. Kostenlose Angebote von verifizierten Anbietern.',
      },
      cleaningHamburgDirectory: {
        metaTitle: 'Reinigungsfirmen Hamburg | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Reinigungsfirmen in Hamburg. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Reinigungsfirmen Hamburg, Reinigung Hamburg, Reinigungsunternehmen Hamburg',
        pageTitle: 'Reinigungsfirmen in Hamburg',
        pageSubtitle:
          'Entdecken Sie geprüfte Reinigungsfirmen in Hamburg mit echten Bewertungen. Postleitzahlbereiche 20-22.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal20: 'PLZ 20 (Stadtzentrum)',
        filterPostal21: 'PLZ 21 (Nord)',
        filterPostal22: 'PLZ 22 (Ost)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Reinigungsfirma in Hamburg passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Reinigungsfirmen in Hamburg...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Reinigungsfirmen in Hamburg konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      cleaningKolnLanding: {
        metaTitle: 'Reinigung Köln | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Reinigungsfirmen in Köln. Kostenlose Angebote von verifizierten Anbietern.',
      },
      cleaningKolnDirectory: {
        metaTitle: 'Reinigungsfirmen Köln | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Reinigungsfirmen in Köln. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Reinigungsfirmen Köln, Reinigung Köln, Reinigungsunternehmen Köln',
        pageTitle: 'Reinigungsfirmen in Köln',
        pageSubtitle:
          'Entdecken Sie geprüfte Reinigungsfirmen in Köln mit echten Bewertungen. Postleitzahlbereiche 50-51.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal50: 'PLZ 50 (Stadtzentrum)',
        filterPostal51: 'PLZ 51 (rechtes Rheinufer)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Reinigungsfirma in Köln passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Reinigungsfirmen in Köln...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Reinigungsfirmen in Köln konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      cleaningMunchenLanding: {
        metaTitle: 'Reinigung München | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Reinigungsfirmen in München. Kostenlose Angebote von verifizierten Anbietern.',
      },
      cleaningMunchenDirectory: {
        metaTitle: 'Reinigungsfirmen München | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Reinigungsfirmen in München. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Reinigungsfirmen München, Reinigung München, Reinigungsunternehmen München',
        pageTitle: 'Reinigungsfirmen in München',
        pageSubtitle:
          'Entdecken Sie geprüfte Reinigungsfirmen in München mit echten Bewertungen. Postleitzahlbereiche 80-82.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal80: 'PLZ 80 (Stadtzentrum)',
        filterPostal81: 'PLZ 81 (Süd/Ost)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Reinigungsfirma in München passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Reinigungsfirmen in München...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Reinigungsfirmen in München konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      cleaningStuttgartLanding: {
        metaTitle: 'Reinigung Stuttgart | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Reinigungsfirmen in Stuttgart. Kostenlose Angebote von verifizierten Anbietern.',
      },
      cleaningStuttgartDirectory: {
        metaTitle: 'Reinigungsfirmen Stuttgart | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Reinigungsfirmen in Stuttgart. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords:
          'Reinigungsfirmen Stuttgart, Reinigung Stuttgart, Reinigungsunternehmen Stuttgart',
        pageTitle: 'Reinigungsfirmen in Stuttgart',
        pageSubtitle:
          'Entdecken Sie geprüfte Reinigungsfirmen in Stuttgart mit echten Bewertungen. Postleitzahlbereiche 70-71.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal70: 'PLZ 70 (Stuttgart)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Reinigungsfirma in Stuttgart passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Reinigungsfirmen in Stuttgart...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Reinigungsfirmen in Stuttgart konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      // P2.072 — meta-title/description for Disposal city landing pages
      disposalFrankfurtamMainLanding: {
        metaTitle: 'Entrümpelung Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Entrümpelungsfirmen in Frankfurt am Main. Kostenlose Angebote von verifizierten Anbietern.',
      },
      disposalFrankfurtamMainDirectory: {
        metaTitle: 'Entrümpelungsfirmen Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Entrümpelungsfirmen in Frankfurt am Main. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords:
          'Entrümpelungsfirmen Frankfurt am Main, Entrümpelung Frankfurt am Main, Entsorgung Frankfurt',
        pageTitle: 'Entrümpelungsfirmen in Frankfurt am Main',
        pageSubtitle:
          'Entdecken Sie geprüfte Entrümpelungsfirmen in Frankfurt am Main mit echten Bewertungen. Postleitzahlbereiche 60-65.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal60: 'PLZ 60 (Westend)',
        filterPostal65: 'PLZ 65 (Höchst)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Entrümpelungsfirma in Frankfurt am Main passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Entrümpelungsfirmen in Frankfurt am Main...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Entrümpelungsfirmen in Frankfurt am Main konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      disposalHamburgLanding: {
        metaTitle: 'Entrümpelung Hamburg | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Entrümpelungsfirmen in Hamburg. Kostenlose Angebote von verifizierten Anbietern.',
      },
      disposalHamburgDirectory: {
        metaTitle: 'Entrümpelungsfirmen Hamburg | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Entrümpelungsfirmen in Hamburg. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Entrümpelungsfirmen Hamburg, Entrümpelung Hamburg, Entsorgung Hamburg',
        pageTitle: 'Entrümpelungsfirmen in Hamburg',
        pageSubtitle:
          'Entdecken Sie geprüfte Entrümpelungsfirmen in Hamburg mit echten Bewertungen. Postleitzahlbereiche 20-22.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal20: 'PLZ 20 (Stadtzentrum)',
        filterPostal21: 'PLZ 21 (Nord)',
        filterPostal22: 'PLZ 22 (Ost)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Entrümpelungsfirma in Hamburg passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Entrümpelungsfirmen in Hamburg...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Entrümpelungsfirmen in Hamburg konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      disposalKolnLanding: {
        metaTitle: 'Entrümpelung Köln | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Entrümpelungsfirmen in Köln. Kostenlose Angebote von verifizierten Anbietern.',
      },
      disposalKolnDirectory: {
        metaTitle: 'Entrümpelungsfirmen Köln | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Entrümpelungsfirmen in Köln. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Entrümpelungsfirmen Köln, Entrümpelung Köln, Entsorgung Köln',
        pageTitle: 'Entrümpelungsfirmen in Köln',
        pageSubtitle:
          'Entdecken Sie geprüfte Entrümpelungsfirmen in Köln mit echten Bewertungen. Postleitzahlbereiche 50-51.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal50: 'PLZ 50 (Stadtzentrum)',
        filterPostal51: 'PLZ 51 (rechtes Rheinufer)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Entrümpelungsfirma in Köln passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Entrümpelungsfirmen in Köln...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Entrümpelungsfirmen in Köln konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      disposalMunchenLanding: {
        metaTitle: 'Entrümpelung München | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Entrümpelungsfirmen in München. Kostenlose Angebote von verifizierten Anbietern.',
      },
      disposalMunchenDirectory: {
        metaTitle: 'Entrümpelungsfirmen München | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Entrümpelungsfirmen in München. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Entrümpelungsfirmen München, Entrümpelung München, Entsorgung München',
        pageTitle: 'Entrümpelungsfirmen in München',
        pageSubtitle:
          'Entdecken Sie geprüfte Entrümpelungsfirmen in München mit echten Bewertungen. Postleitzahlbereiche 80-82.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal80: 'PLZ 80 (Stadtzentrum)',
        filterPostal81: 'PLZ 81 (Süd/Ost)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Entrümpelungsfirma in München passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Entrümpelungsfirmen in München...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Entrümpelungsfirmen in München konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      disposalStuttgartLanding: {
        metaTitle: 'Entrümpelung Stuttgart | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Entrümpelungsfirmen in Stuttgart. Kostenlose Angebote von verifizierten Anbietern.',
      },
      disposalStuttgartDirectory: {
        metaTitle: 'Entrümpelungsfirmen Stuttgart | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Entrümpelungsfirmen in Stuttgart. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords: 'Entrümpelungsfirmen Stuttgart, Entrümpelung Stuttgart, Entsorgung Stuttgart',
        pageTitle: 'Entrümpelungsfirmen in Stuttgart',
        pageSubtitle:
          'Entdecken Sie geprüfte Entrümpelungsfirmen in Stuttgart mit echten Bewertungen. Postleitzahlbereiche 70-71.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        filterPostal70: 'PLZ 70 (Stuttgart)',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Entrümpelungsfirma in Stuttgart passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Entrümpelungsfirmen in Stuttgart...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Entrümpelungsfirmen in Stuttgart konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
      },
      // P2.074 — meta-title/description for main pages (Auth/Index/FirmaRegister/NotFound/AGB)
      authPage: {
        metaTitle: 'Anmelden oder registrieren | RegionalUmzug24',
        metaDescription:
          'Melden Sie sich bei regionalumzug24 an oder erstellen Sie ein neues Kundenkonto.',
      },
      indexPage: {
        metaTitle: 'Umzugsfirmen vergleichen | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie kostenlos professionelle Umzugsfirmen in Ihrer Region, erhalten Sie bis zu 15 Angebote und finden Sie den passenden Umzugspartner.',
      },
      companyRegisterPage: {
        metaTitle: 'Umzugsfirma registrieren | RegionalUmzug24',
        metaDescription:
          'Registrieren Sie Ihr Umzugsunternehmen bei regionalumzug24 und gewinnen Sie qualifizierte Anfragen aus Ihrer Region.',
      },
      notFoundPage: {
        metaTitle: 'Seite nicht gefunden | RegionalUmzug24',
        metaDescription: 'Die angeforderte Seite wurde auf regionalumzug24 nicht gefunden.',
      },
      termsPage: {
        metaTitle: 'AGB | RegionalUmzug24',
        metaDescription: 'Allgemeine Geschäftsbedingungen für die Nutzung von regionalumzug24.',
      },
      // P2.074 — meta-title/description for Berlin city pages (Cleaning/Disposal)
      disposalBerlinLanding: {
        metaTitle: 'Entrümpelung Berlin | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Entrümpelungsfirmen in Berlin. Kostenlose Angebote für Wohnungsauflösungen und Entsorgung.',
      },
      disposalBerlinDirectory: {
        metaTitle: 'Entrümpelungsfirmen Berlin | RegionalUmzug24',
        metaDescription:
          'Liste geprüfter Entrümpelungsfirmen in Berlin. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords:
          'Entrümpelungsfirmen Berlin, Entrümpelung Berlin, Entsorgung Berlin, Wohnungsauflösung Berlin, BSR Sperrmüll',
        pageTitle: 'Entrümpelungsfirmen in Berlin',
        pageSubtitle:
          'Entdecken Sie geprüfte Berliner Entrümpelungsfirmen mit echten Bewertungen. PLZ 10-14 - von Mitte bis Köpenick.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Berliner Entrümpelungsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Berliner Entrümpelungsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Berliner Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
        filterPostal10: 'PLZ 10 (Mitte, Charlottenburg)',
        filterPostal11: 'PLZ 11 (Tiergarten, Friedrichshain)',
        filterPostal12: 'PLZ 12 (Neukölln, Tempelhof, Steglitz)',
        filterPostal13: 'PLZ 13 (Pankow, Weißensee, Reinickendorf)',
        filterPostal14: 'PLZ 14 (Wilmersdorf, Zehlendorf, Köpenick)',
      },
      cleaningBerlinLanding: {
        metaTitle: 'Reinigung Berlin | RegionalUmzug24',
        metaDescription:
          'Vergleichen Sie geprüfte Reinigungsfirmen in Berlin. Kostenlose Angebote von verifizierten Anbietern.',
      },
      cleaningBerlinDirectory: {
        metaTitle: 'Reinigungsfirmen Berlin | RegionalUmzug24',
        metaDescription:
          'Finden Sie geprüfte Reinigungsfirmen in Berlin. Filtern Sie nach PLZ, Bewertung und Leistungen.',
        metaKeywords:
          'Reinigungsfirmen Berlin, Reinigung Berlin, Reinigungsunternehmen Berlin, Reinigung Mitte, Reinigung Charlottenburg',
        pageTitle: 'Reinigungsfirmen in Berlin',
        pageSubtitle:
          'Entdecken Sie geprüfte Berliner Reinigungsfirmen mit echten Bewertungen. PLZ 10-14 - von Mitte bis Köpenick.',
        filterTitle: 'Filter',
        filterPremium: 'Nur Premium-Firmen',
        filterVerified: 'Nur verifizierte Firmen',
        filterPostalTitle: 'Postleitzahlbereich',
        filterPostalAll: 'Alle Postleitzahlbereiche',
        sortTitle: 'Sortieren nach',
        sortRating: 'Beste Bewertung',
        sortOrders: 'Meiste Aufträge',
        sortNewest: 'Neueste',
        resultCount: '{{count}} Firmen gefunden',
        emptyTitle: 'Keine Firmen gefunden',
        emptyDescription:
          'Keine Berliner Reinigungsfirma passt zu den aktuellen Filtern. Versuchen Sie, die Filter anzupassen.',
        emptyReset: 'Filter zurücksetzen',
        loadingTitle: 'Lade Berliner Reinigungsfirmen...',
        errorTitle: 'Fehler beim Laden',
        errorDescription:
          'Die Liste der Berliner Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        errorRetry: 'Erneut versuchen',
        paginationPrev: 'Zurück',
        paginationNext: 'Weiter',
        paginationPage: 'Seite {{page}} von {{total}}',
        filterPostal10: 'PLZ 10 (Mitte, Charlottenburg)',
        filterPostal11: 'PLZ 11 (Tiergarten, Friedrichshain)',
        filterPostal12: 'PLZ 12 (Neukölln, Tempelhof, Steglitz)',
        filterPostal13: 'PLZ 13 (Pankow, Weißensee, Reinickendorf)',
        filterPostal14: 'PLZ 14 (Wilmersdorf, Zehlendorf, Köpenick)',
      },
      // OPT373 — hardcoded English fallback strings in SubscriptionTierCard.tsx
      subscription: {
        title: 'Subscription',
        subtitle: 'Choose a tier that fits your team. Cancel any time.',
        active: 'Aktive Subscription',
        activeTier: 'Tier',
        month: 'Monat',
        cancelCta: 'Cancel subscription',
        cancelTitle: 'Cancel subscription?',
        cancelDescription:
          'You can keep using the current plan until the end of the billing period.',
        cancelling: 'Cancelling…',
        redirecting: 'Redirecting…',
        subscribeCta: 'Subscribe',
        errors: {
          checkoutFailed: 'Checkout fehlgeschlagen. Bitte versuchen Sie es erneut.',
          cancelFailed: 'Kündigung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        },
      },
      // OPT373 — hardcoded German unit/hint strings in VolumeCalculator.tsx
      volumeCalculator: {
        title: 'Volumen-Rechner',
        apartmentType: 'Wohnungstyp',
        rooms: {
          '1': '1-Zi',
          '2': '2-Zi',
          '3': '3-Zi',
          '4': '4-Zi',
          '5plus': '5+-Zi',
        },
        livingArea: 'Wohnfläche',
        additionalFloors: 'Zusätzliche Etagen (Keller, Dachboden)',
        estimated: 'Geschätztes Umzugsvolumen:',
        applyToForm: 'In Anfrage übernehmen',
        livingAreaUnit: 'm²',
        floorSurchargeHint: '+5 m³ pro Etage',
        // OPT402 — hardcoded `m³` unit string replaced across 5 components
        volumeUnit: 'm³',
        // OPT419 — `toggleAuto`/`toggleManual` referenced from AnfrageNeu.tsx,
        // missing in DE/EN bundles caused fallback to FR strings for DE users.
        toggleAuto: 'Volumen automatisch berechnen',
        toggleManual: 'Manuell eingeben',
      },
      pwa: {
        installTitle: 'App installieren',
        installDescription:
          'Installieren Sie RegionalUmzug24 für schnellen Zugriff auf Umzugsfirmen in Ihrer Region.',
        installAction: 'Installieren',
        installLater: 'Spaeter',
        installAccepted: 'App wird installiert',
        installDismissed: 'Vorschlag ausgeblendet',
        offline: {
          title: 'Sie sind offline',
          description:
            'Bitte überpruefen Sie Ihre Internetverbindung. Einige Bereiche sind nur online verfuegbar.',
          retryAction: 'Erneut versuchen',
        },
        pushOptIn: {
          title: 'Push-Benachrichtigungen aktivieren',
          description: 'Erhalten Sie Updates zu neuen Anfragen und Statusaenderungen.',
          enable: 'Aktivieren',
          later: 'Spaeter',
          enabled: 'Push aktiviert',
          disabled: 'Push deaktiviert',
          error: 'Push konnte nicht aktiviert werden.',
        },
      },
    },
  },
  en: {
    translation: {
      common: {
        all: 'All',
        back: 'Back',
        cancel: 'Cancel',
        changeLanguage: 'Change language',
        languageGerman: 'German',
        languageEnglish: 'English',
        languageFrench: 'French',
        languageDutch: 'Dutch',
        languagePolish: 'Polish',
        languageItalian: 'Italian',
        languageSpanish: 'Spanish',
        confirmPassword: 'Confirm Password',
        date: 'Date',
        delete: 'Delete',
        download: 'Download',
        edit: 'Edit',
        email: 'Email',
        error: 'Error',
        loading: 'Loading...',
        logout: 'Logout',
        name: 'Name',
        open: 'Open',
        password: 'Password',
        refresh: 'Refresh',
        actions: 'Actions',
        amount: 'Amount',
        optional: 'Optional',
        saving: 'Saving...',
        size: 'Size',
        type: 'Type',
        errorLoadingCompany: 'Error loading company',
        anonymous: 'Anonymous',
        avgRating: 'Average rating',
        backToHome: 'Back to home',
        capacity: 'Capacity',
        customerReviews: 'Customer reviews',
        loginRequired: 'Login required',
        pagination: 'Pagination',
        pageLoading: 'Page is loading',
        // P2.OPT17 — sr-only label for shadcn Dialog/Sheet close button
        close: 'Close',
        more: 'More',
        pleaseLoginToRequest: 'Please log in to submit a request',
        premium: 'Premium',
        requestQuoteNow: 'Request quote now',
        reviews: 'Reviews',
        serviceArea: 'Service area',
        verified: 'Verified',
        // P2.068 — hardcoded aria-label in CompanyCard.tsx + CompanyCompare.tsx
        ratingOutOfFive: 'Rating {{rating}} of 5',
        // P2.081 — breadcrumb.moving<City> for 5 City-Landing-Pages JSON-LD output
        // OPT282 — extended to mirror DE-Block (26 Keys) for EN coverage 99.5% -> 100%
        seo: {
          breadcrumb: {
            home: 'Home',
            cleaning: 'Cleaning',
            disposal: 'Disposal & Clearance',
            moving: 'Moving',
            berlin: 'Moving Berlin',
            movingHamburg: 'Moving Hamburg',
            movingMuenchen: 'Moving Munich',
            movingKoeln: 'Moving Cologne',
            movingFrankfurt: 'Moving Frankfurt',
            movingStuttgart: 'Moving Stuttgart',
          },
          service: {
            cleaningGermany: 'Cleaning Service Germany',
            disposalGermany: 'Disposal & Clearance Service Germany',
            movingBerlin: 'Moving Service Berlin',
            movingHamburg: 'Moving Service Hamburg',
            movingMuenchen: 'Moving Service Munich',
            movingKoeln: 'Moving Service Cologne',
            movingFrankfurt: 'Moving Service Frankfurt',
            movingStuttgart: 'Moving Service Stuttgart',
            cleaningBerlin: 'Cleaning Service Berlin',
            disposalBerlin: 'Disposal & Clearance Service Berlin',
            cleaningHamburg: 'Cleaning Service Hamburg',
            disposalHamburg: 'Disposal & Clearance Service Hamburg',
            cleaningMuenchen: 'Cleaning Service Munich',
            disposalMuenchen: 'Disposal & Clearance Service Munich',
            cleaningKoeln: 'Cleaning Service Cologne',
            disposalKoeln: 'Disposal & Clearance Service Cologne',
            cleaningFrankfurt: 'Cleaning Service Frankfurt',
            disposalFrankfurt: 'Disposal & Clearance Service Frankfurt',
            cleaningStuttgart: 'Cleaning Service Stuttgart',
            disposalStuttgart: 'Disposal & Clearance Service Stuttgart',
          },
          area: {
            germany: 'Germany',
          },
        },
      },
      anonymous: 'Anonymous',
      avgRating: 'Average rating',
      backToHome: 'Back to home',
      capacity: 'Capacity',
      customerReviews: 'Customer reviews',
      error: 'Error',
      errorLoadingCompany: 'Error loading company',
      loginRequired: 'Login required',
      more: 'More',
      pleaseLoginToRequest: 'Please log in to submit a request',
      premium: 'Premium',
      requestQuoteNow: 'Request quote now',
      reviews: 'Reviews',
      serviceArea: 'Service area',
      skipToContent: 'Skip to main content',
      verified: 'Verified',
      auth: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        name: 'Name',
        phone: 'Phone',
        emailPlaceholder: 'your@email.com',
        passwordPlaceholder: '••••••••',
        emailRequired: 'Email is required',
        invalidEmail: 'Invalid email address',
        weakPassword: 'Password must be at least 8 characters',
        passwordMinLength: 'Password must be at least 8 characters',
        passwordMismatch: 'Passwords do not match',
        passwordMismatchDesc: 'The passwords you entered do not match',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        changePasswordTitle: 'Reset Password',
        changePasswordDescription:
          'Change the password for this account. Admin accounts are excluded from this self-service action.',
        changePasswordAction: 'Save Password',
        passwordChangeSuccess: 'Password updated',
        passwordChangeSuccessDesc: 'Your password was updated successfully.',
        passwordChangeError: 'The password could not be updated.',
        passwordChangeBlocked: 'Password change not allowed',
        forgotPassword: 'Forgot Password',
        forgotPasswordTitle: 'Forgot Password',
        forgotPasswordDescription:
          'Enter your login email. If a matching customer or company account exists, we will send a reset link.',
        forgotPasswordAction: 'Send reset link',
        forgotPasswordSuccess: 'Reset link sent',
        forgotPasswordSuccessDesc:
          'If a matching account exists, an email with a reset link has been sent.',
        resetPasswordTitle: 'Set New Password',
        resetPasswordDescription: 'Choose a new password for your customer or company account.',
        resetPasswordAction: 'Reset password',
        resetPasswordSuccess: 'Password reset successful',
        resetPasswordSuccessDesc: 'You can now sign in with your new password.',
        resetPasswordError: 'The password could not be reset.',
        resetPasswordInvalidToken: 'The reset link is invalid or has expired.',
        backToLogin: 'Back to sign in',
        loginSuccess: 'Successfully logged in',
        loginSuccessDesc: 'You will be redirected to your dashboard.',
        loginError: 'Login failed',
        registerSuccess: 'Successfully registered',
        registerSuccessDesc: 'Your account has been created successfully.',
        registerError: 'Registration failed',
        logoutSuccess: 'Successfully logged out',
        credentials: 'Credentials',
        pleaseLogin: 'Please log in',
        loginNow: 'Log in now',
        loginRequired: 'Login required',
        pleaseLoginToRequest: 'Please log in to submit a request',
        loginRequiredForRequest: 'Login required to request',
        passwordChangeTitle: 'Change password',
        passwordChangeDescription: 'Change your password to protect your account.',
      },
      home: {
        title: 'Regional Umzug 24',
        subtitle: 'Your partner for regional moves',
      },
      dashboard: {
        welcome: 'Welcome',
        myRequests: 'My Requests',
        activeRequests: 'Active Requests',
        statistics: 'Statistics',
      },
      nav: {
        dashboard: 'Dashboard',
        requests: 'Requests',
        profile: 'Profile',
        privacy: 'Privacy',
        imprint: 'Imprint',
        terms: 'Terms of Service',
        home: 'Home',
        companies: 'Berlin Movers',
        howItWorks: 'How it works',
        pricing: 'Pricing',
        about: 'About us',
        requestCTA: 'Get a Quote',
        openMenu: 'Open menu',
        closeMenu: 'Close menu',
        login: 'Sign in',
        companyLogin: 'For Companies',
      },
      favorite: {
        add: 'Add to favorites',
        remove: 'Remove from favorites',
        added: 'Added to favorites',
        removed: 'Removed from favorites',
        tabTitle: 'Favorites',
        empty: 'You have not saved any favorites yet.',
        emptyHint: 'Tap the heart icon on interesting companies to find them back here.',
        count: '{{count}} favorites',
        error: 'Favorites could not be updated.',
        signInRequired: 'Please sign in to save favorites.',
        viewProfile: 'View profile',
        removedFromList: 'Company removed from favorites',
      },
      legal: {
        contactPerson: 'Contact person',
        // P2.089 — Imprint fallback (Impressum.tsx lines 38-90)
        imprint: {
          providerHeading: 'Information pursuant to § 5 TMG',
          providerCountry: 'Germany',
          contactHeading: 'Contact',
          contactEmailLabel: 'Email:',
          contactEmailValue: 'info@regionalumzug24.de',
          contactPhoneLabel: 'Phone:',
          contactPhoneValue: '+49 (0) 123 456789',
          editorialResponsibleHeading: 'Responsible for content pursuant to § 55 (2) RStV',
          disputeResolutionHeading: 'EU Dispute Resolution',
          disputeResolutionDescription:
            'The European Commission provides an online dispute resolution (ODR) platform:',
          disputeResolutionLinkText: 'https://ec.europa.eu/consumers/odr',
          disclaimerHeading: 'Disclaimer',
          disclaimerContentHeading: 'Liability for Content',
          disclaimerContentText:
            'As a service provider, we are responsible for our own content on these pages in accordance with § 7 (1) TMG and general law. However, according to §§ 8 to 10 TMG, we are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.',
          disclaimerLinksHeading: 'Liability for Links',
          disclaimerLinksText:
            'Our website contains links to external third-party websites whose content is beyond our control. We therefore cannot accept any liability for such external content. The respective provider or operator is always responsible for the content of any linked pages.',
        },
        // P2.089 — Privacy fallback (Datenschutz.tsx lines 39-70)
        privacy: {
          overviewHeading: '1. Privacy at a Glance',
          overviewGeneralHeading: 'General Information',
          overviewGeneralText:
            'The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to identify you personally.',
          hostingHeading: '2. Hosting',
          hostingText: 'We host the content of our website with an external provider.',
          mandatoryInformationHeading: '3. General Information and Mandatory Disclosures',
          dataProtectionHeading: 'Data Protection',
          dataProtectionText:
            'The operators of these pages take the protection of your personal data very seriously.',
          lastUpdated: 'Last updated: {{date}}',
        },
      },
      request: {
        caseProfile: {
          authorityNamePlaceholder: 'e.g. social welfare office',
          notePlaceholder: 'e.g. deadlines, questions or notes on cost coverage',
          // P2.069 — hardcoded <Badge> label in AdminOperationsManagementWorkspace
          badgeLabel: 'Case profile',
        },
        directCompanyDescription: 'Request a quote directly from this company',
        new: 'New Request',
        title: 'Request',
        date: 'Date',
        moveDate: 'Move Date',
        from: 'From',
        to: 'To',
        fromTo: 'From - To',
        fromAddress: 'From Address',
        toAddress: 'To Address',
        fromPostalCode: 'From Postal Code',
        toPostalCode: 'To Postal Code',
        squareMeters: 'Square Meters',
        type: 'Type',
        createSuccess: 'Request created successfully',
        createError: 'Error creating request',
        // P1.W2 v2 — Customer hint after submit (premium-tier match)
        pricingMatchHint:
          'Your request will be prioritised for companies with active pricing models (Lead / Commission / Fixed).',
        // P2.068 — hardcoded aria-label in AnfrageNeu.tsx branch badge
        branchBadgeAria: 'Branch: {{branch}}',
        addressPlaceholder: 'Street, House Number, City',
        postalCodePlaceholder: 'e.g. 10115',
        descriptionPlaceholder:
          'Are there any special requirements? E.g. narrow stairs, heavy furniture, parking restrictions...',
        submitting: 'Submitting...',
        submitButton: 'Get Free Quotes',
        photos: {
          title: 'Apartment photos',
          help: 'Upload up to 5 images so companies can better assess your apartment and furniture.',
          upload: 'Upload photos',
          dragDrop: 'Drop images here or click',
          maxSize: 'Maximum 5 MB per image (JPEG, PNG or WebP)',
          tooMany: 'You can upload a maximum of 5 photos.',
          error: 'Images could not be uploaded. Please try again.',
        },
        newForm: {
          moveTypeTitle: 'Move Type',
          moveTypeLabel: 'Type of Move',
          requestTypeLabel: 'Request Type',
          requestTypeStandard: 'Standard (free)',
          requestTypePremium: 'Premium (paid)',
          requestTypePremiumPlus: 'Premium+ (paid)',
          paidServiceWarning: '⚠️ Paid service',
          addressesTitle: 'Addresses',
          startAddressLabel: 'Pickup Address',
          startPostalCodeLabel: 'Postal Code (Pickup)',
          endAddressLabel: 'Delivery Address',
          endPostalCodeLabel: 'Postal Code (Delivery)',
          detailsTitle: 'Details',
          moveDateLabel: 'Move Date',
          moveDatePlaceholder: 'Pick a date',
          volumeLabel: 'Volume (m³)',
          volumePlaceholder: 'e.g. 30',
          volumeHelpText: 'Rule of thumb: 1-room ≈ 20m³, 2-room ≈ 35m³, 3-room ≈ 50m³',
          specialRequirementsTitle: 'Special Requirements',
          additionalInfoLabel: 'Additional Information',
          infoBoxFreeTitle: 'Free & Non-Binding',
          infoBoxFreeText: 'Your request is completely free and does not commit you to anything',
          infoBoxGdprTitle: 'GDPR-compliant',
          infoBoxGdprText: 'Your data is transmitted securely and encrypted',
          infoBoxFastTitle: 'Quick Responses',
          infoBoxFastText: 'Receive offers within 24 hours',
          accountCreatedTitle: 'Account Created',
          accountCreatedDescription:
            'An account has been created automatically for you. Please note your password — for security reasons, it is only shown once.',
          accountCreatedPasswordLabel: 'Your Password',
          accountCreatedEmailLabel: 'Email',
          accountCreatedAcknowledgeCta: 'Got it — go to login',
          // P2.069 — hardcoded branchMeta labels in AnfrageNeu.tsx
          branchLabels: {
            moving: 'Moving',
            cleaning: 'Cleaning',
            disposal: 'Disposal',
          },
        },
        blockedCreateAlert:
          'Your customer account is currently blocked. New requests can only be created after the block has been reviewed or removed.',
        blockedCreateError:
          'New requests are not available while your customer account is blocked. Please review your block status in the dashboard.',
        blockedOpenDashboard: 'Open dashboard',
        blockedSubmitButton: 'Account blocked',
        draft: {
          title: 'Draft saved locally',
          description:
            'Your request is automatically saved in this browser. Passwords are never stored.',
          savedAt: 'Last saved locally: {{date}}',
          clearAction: 'Delete draft',
          cleared: 'Draft deleted',
        },
        status: {
          label: 'Status',
          pending: 'Pending',
          matched: 'Matched',
          accepted: 'Accepted',
          declined: 'Declined',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        detail: {
          title: 'Request details',
          confirmedCompany: 'Confirmed company',
          timelineTitle: 'Timeline',
          timelineCreated: 'Request created',
          timelineFirstResponse: 'First company response',
          timelineCompanyConfirmed: 'Company confirmed',
          timelineCompanyConfirmedWithName: 'Company confirmed: {{company}}',
          timelineCompleted: 'Request completed',
          timelineCancelled: 'Request cancelled',
          noTimestamp: 'Timestamp unavailable',
          communicationTitle: 'Communication',
          communicationEmpty: 'No messages available for this request yet.',
          communicationYou: 'You',
          activityTitle: 'Activity',
          activityEmpty: 'No activity available for this request yet.',
          activityStatusBadge: 'Status',
          activityMessageBadge: 'Message',
          activityDocumentBadge: 'Document',
          activityMessageTitle: 'Message from {{sender}}',
          activityDocumentTitle: 'Document uploaded: {{name}}',
          cancelAction: 'Cancel request',
          cancelConfirm: 'Do you really want to cancel this request?',
          cancelledTitle: 'Request cancelled',
          cancelledDesc: 'The request was cancelled and open company assignments were closed.',
          cancelErrorDesc: 'The request could not be cancelled.',
          completeAction: 'Complete',
          completeConfirm: 'Mark request as completed?',
          completedTitle: 'Request completed',
          completedDesc: 'The request has been marked as completed.',
          completeErrorDesc: 'The request could not be completed.',
          selectCompanyAction: 'Confirm company',
          selectCompanyConfirm: 'Confirm this company as the final partner?',
          companyConfirmedTitle: 'Company confirmed',
          companyConfirmedDesc:
            'The company was marked as the final partner. Other open assignments were closed.',
          companyConfirmErrorDesc: 'The company could not be confirmed.',
          selectBeforeComplete:
            'Please confirm one accepted company before completing the request.',
          moveInfo: 'Move details',
          descriptionTitle: 'Description',
          specialRequirementsTitle: 'Special requirements',
          moveDate: 'Move date',
          volume: 'Volume',
          fromPostalCode: 'Postal code',
          summaryTitle: 'Status overview',
          requested: 'Requested',
          accepted: 'Accepted',
          open: 'Open',
          rejected: 'Rejected',
          remaining: 'Remaining',
          noMatchingCompaniesTitle: 'No suitable company found yet',
          noMatchingCompaniesDesc:
            'After the full matching window, no suitable company could currently be assigned to your request. We will inform you automatically as soon as that changes.',
          acceptedCompaniesTitle: 'Matching confirmed',
          acceptedCompaniesDesc: 'These companies have already confirmed the match: {{companies}}.',
          offersTitle: 'Offers',
          loadingOffers: 'Loading...',
          noOffers: 'No offers received yet',
          verifiedBadge: 'Verified',
          respondedAt: 'Responded on',
          openChat: 'Open chat',
          assigned: 'Assigned',
          reviewAction: 'Review',
        },
      },
      timelinePanel: {
        empty: 'No timeline entries yet.',
        noTimestamp: 'Timestamp unavailable',
        fallbackCompany: 'a company',
        fallbackActor: 'System',
        badges: {
          status: 'Status',
          billing: 'Billing',
          message: 'Message',
          document: 'Document',
          review: 'Review',
        },
        types: {
          request_created: 'Request created',
          request_completed: 'Request completed',
          request_cancelled: 'Request cancelled',
          company_selected: 'Company confirmed: {{company}}',
          company_request_assigned: 'Request assigned to {{company}}',
          company_request_accepted: '{{company}} accepted',
          company_request_declined: '{{company}} declined',
          company_request_cancelled: 'Assignment for {{company}} was closed',
          company_request_cancellation_requested: '{{company}} requested a cancellation',
          company_request_cancellation_approved: 'Cancellation for {{company}} approved',
          company_request_cancellation_rejected: 'Cancellation for {{company}} rejected',
          payment_created: 'Payment created for {{company}}',
          payment_paid: 'Payment paid for {{company}}',
          payment_cancelled: 'Payment cancelled for {{company}}',
          invoice_created: 'Invoice {{invoice}} created',
          invoice_paid: 'Invoice {{invoice}} marked as paid',
          invoice_cancelled: 'Invoice {{invoice}} cancelled',
          review_created: 'Review created for {{company}}',
          chat_message_sent: 'Message from {{actor}}',
          chat_escalation_pending: 'Reply from {{actor}} overdue',
          document_uploaded: 'Document uploaded by {{actor}}',
        },
        details: {
          amount: 'Amount: {{amount}} EUR',
          invoice: 'Invoice: {{invoice}}',
          rating: 'Rating: {{rating}}/5',
          status: 'Status: {{status}}',
          reason: 'Note: {{reason}}',
          document: 'Document: {{name}}',
          documentPurpose: 'Requested document: {{document}}',
          template: 'Template: {{template}}',
          escalation: 'Escalation: {{level}}',
          message: 'Message: {{message}}',
        },
      },
      chatWorkflow: {
        loading: 'Loading messages...',
        loadError: 'Messages could not be loaded.',
        // P2.069 — hardcoded toast.description in ChatDialog/CustomerChatDialog
        sendError: 'Message could not be sent.',
        retryAction: 'Retry',
        empty: 'No messages yet. Start the conversation!',
        dialog: {
          customerTitle: 'Chat with {{company}}',
          companyTitle: 'Chat with {{customer}}',
          customerFallback: 'Customer',
        },
        composer: {
          placeholder: 'Type a message...',
          active: 'Active workflow:',
          clear: 'Clear',
          send: 'Send message',
        },
        escalationLevels: {
          follow_up: 'Follow-up',
          urgent: 'Urgent',
        },
        documentPurposes: {
          customer_identity: 'ID / proof of identity',
          coverage_approval: 'Coverage approval',
          authority_reference: 'Authority reference',
          care_level_proof: 'Care level proof',
        },
        templates: {
          document_request: {
            label: 'Request document',
            message: 'Please upload {{document}} for this request or confirm the current status.',
          },
          document_uploaded_confirmation: {
            label: 'Document uploaded',
            message: 'I have uploaded the requested documents. Please review the request again.',
          },
          status_follow_up: {
            label: 'Ask for status',
            message: 'Could you please confirm the current status and what is needed next?',
          },
          move_details_request: {
            label: 'Clarify move details',
            message:
              'I still have a question about the move details and would appreciate a short reply.',
          },
          availability_confirmation_request: {
            label: 'Confirm appointment',
            message:
              'Please confirm that the planned date and current request details still work for you.',
          },
          urgent_response_needed: {
            label: 'Urgent reply needed',
            message: 'Please reply as soon as possible so this request can keep moving.',
          },
        },
      },
      company: {
        companyRegistration: 'Company Registration',
        becomePartner: 'Become a Partner',
        registerNow: 'Register Now',
        registering: 'Registering...',
        companyData: 'Company Data',
        companyName: 'Company Name',
        companyNamePlaceholder: 'Your Moving Company Ltd',
        companyDescription: 'Company Description',
        companyDescriptionPlaceholder: 'Describe your services...',
        companyProfile: 'Company Profile',
        serviceAreas: 'Service Areas',
        postalCodeAreas: 'Postal Code Areas',
        postalCodeAreasDesc: 'Enter the postal codes where you operate',
        postalCodeAreasPlaceholder: 'e.g. 10115, 10117, 10119',
        specialServices: 'Special Services',
        verificationDocuments: 'Verification Documents',
        uploadDocuments: 'Upload Documents',
        uploadDocumentsDesc: 'Upload your business registration and other relevant documents',
        documentsRequired: 'Documents Required',
        documentsRequiredDesc:
          'Please upload at least your business registration. Additional documents are optional during signup and are only considered later for request assignment.',
        documentsMissing: 'Documents Missing',
        verificationProcess: 'Verification Process',
        verificationProcessDesc: 'Your documents are being reviewed',
        verificationPending: 'Verification Pending',
        verificationPendingDesc: 'Your documents are currently being reviewed',
        verified: 'Verified',
        verifiedDesc: 'Your company has been successfully verified',
        verificationRejected: 'Verification Rejected',
        verificationRejectedDesc: 'Your verification has been rejected',
        verificationActionRequired: 'Verification needs action',
        verificationActionRequiredDesc:
          'At least one verification document must be replaced, corrected, or submitted again.',
        verificationFollowUpDue: 'Follow-up due',
        verificationFollowUpDueDesc:
          'At least one verification document has a due follow-up. Please review the document workspace.',
        verificationFollowUpOverdue: 'Follow-up overdue',
        verificationFollowUpOverdueDesc:
          'At least one verification document has an overdue follow-up. Please act in the document workspace.',
        registrationSuccess: 'Registration Successful',
        registrationSuccessDesc: 'Your company has been successfully registered',
        registrationError: 'Registration Error',
        userCreationError: 'Error creating user',
        alreadyRegistered: 'Already Registered',
        companyProfileAlreadyExists: 'A company profile already exists for this user account.',
        registrationEmailMismatch:
          'You are currently signed in with a different email address. Please sign out first or use the same email for company registration.',
        requiresCompanyAccount: 'Requires Company Account',
        nameMinLength: 'Name must be at least 3 characters',
        phoneMinLength: 'Phone number must be at least 10 characters',
        regionRequired: 'At least one service area is required',
        movingRequests: 'Moving Requests',
        qualifiedRequests: 'Qualified Requests',
        qualifiedRequestsDesc: 'Requests matching your criteria',
        assignedRequestsOverview: 'Assigned Requests Overview',
        openRequests: 'Open Requests',
        noRequests: 'No Requests',
        noRequestsDesc: 'No requests available at the moment',
        accept: 'Accept',
        decline: 'Decline',
        accepted: 'Accepted',
        declined: 'Declined',
        requestAccepted: 'Request Accepted',
        requestDeclined: 'Request Declined',
        statusUpdated: 'Status Updated',
        statusUpdateError: 'Error updating status',
        requestAcceptBlockedTitle: 'Accepting is currently blocked',
        requestAcceptBlockedError:
          'Your company cannot accept this request while an active assignment block exists.',
        requestsBlockedAlertTitle: 'Open requests cannot currently be accepted',
        requestsBlockedAlertDescPayment_one:
          '{{count}} open request cannot be accepted right now because invoice {{invoice}} has been overdue since {{dueDate}}.',
        requestsBlockedAlertDescPayment_other:
          '{{count}} open requests cannot be accepted right now because invoice {{invoice}} has been overdue since {{dueDate}}.',
        requestsBlockedAlertDescBlacklist_one:
          '{{count}} open request cannot be accepted right now because your company is blocked ({{reason}}, valid until {{validUntil}}).',
        requestsBlockedAlertDescBlacklist_other:
          '{{count}} open requests cannot be accepted right now because your company is blocked ({{reason}}, valid until {{validUntil}}).',
        requestsBlockedAlertDescGeneric_one:
          '{{count}} open request cannot currently be accepted because of an active block.',
        requestsBlockedAlertDescGeneric_other:
          '{{count}} open requests cannot currently be accepted because of an active block.',
        requestsBlockedBadge: 'Accept blocked',
        requestsBlockedOpenOverview: 'View review status',
        loadError: 'Error loading',
        match: 'Match',
        requestsReceived: 'Requests Received',
        totalReceived: 'Total Received',
        totalRevenue: 'Total Revenue',
        avgOrderValue: 'Average Order Value',
        avgResponseTime: 'Average Response Time',
        acceptanceRate: 'Acceptance Rate',
        declineRate: 'Decline Rate',
        average: 'Average',
        allOrders: 'All Orders',
        waitingForResponse: 'Waiting for Response',
        perOrder: 'per Order',
        noMatchingRequests: 'No matching requests',
        tryDifferentFilter: 'Try a different filter',
        standard: 'Standard',
        premium: 'Premium',
        requestCancellation: 'Request Cancellation',
        cancelRequest: 'Cancel Request',
        cancelRequestDesc: 'Do you really want to cancel this request?',
        cancellationReason: 'Cancellation Reason',
        cancellationReasonPlaceholder: 'Please provide a reason for cancellation',
        reasonRequired: 'Reason Required',
        reasonRequiredDesc: 'Please provide a reason for cancellation',
        cancellationSent: 'Cancellation Sent',
        cancellationSentDesc: 'Your cancellation request has been sent',
        cancellationError: 'Cancellation Error',
        services: {
          packing: 'Packing',
          assembly: 'Assembly',
          disposal: 'Disposal',
          storage: 'Storage',
          piano: 'Piano Transport',
          international: 'International',
          renovation: 'Renovation',
          cleaning: 'Cleaning',
          safe_transport: 'Safe transport',
          server_transport: 'Server transport',
          heavy_transport: 'Heavy transport',
          painting_service: 'Painting service',
        },
        priceTiers: {
          standard: 'Standard',
          premium: 'Premium',
          premiumPlus: 'Premium+',
          premiumDesc: 'Premium Request: Up to 15 qualified offers from verified companies.',
          premiumPlusDesc: 'Premium+ Request: Up to 5 exclusive offers from top companies.',
        },
        // P1.W2 v2 — Company-spezifische Pricing-Settings-Card
        pricingSettings: {
          heading: 'Pricing model',
          subheading:
            'Manage your pricing model (Lead / Commission / Fixed) and see the matching statistics.',
          currentTierLabel: 'Active model',
          noTierLabel: 'No model activated yet',
          activeBadge: 'Active',
          changeButton: 'Change model',
          statsHeading: 'Statistics per model',
          statsRequestsLabel: 'Requests',
          statsRevenueLabel: 'Revenue',
          statsAvgLabel: 'Avg. price',
          statsGrandTotalRequests: 'Total requests',
          statsGrandTotalRevenue: 'Total revenue',
          statsNoData: 'No analytics available yet',
          dialogTitle: 'Choose pricing model',
          dialogDescription:
            'Pick Lead, Commission or Fixed model and provide the matching values.',
          closeButton: 'Close',
          loadError: 'The pricing model could not be loaded.',
          loadErrorRetry: 'Retry',
        },
        // P2.OPT121 — Company Pricing-Model-Switcher (Lead / Commission / Fixed)
        pricing: {
          tabTitle: 'Choose pricing model',
          tabDescription: 'Switch between Lead, Commission and Fixed-price model.',
          currentModelBadge: 'Currently active',
          activate: 'Activate',
          activating: 'Activating...',
          saveChanges: 'Save changes',
          notesLabel: 'Notes',
          notesPlaceholder: 'Optional notes about your pricing model',
          confirmTitle: 'Switch pricing model',
          confirmDescription: 'Do you really want to switch to {{model}}?',
          confirmModelLead: 'Lead model',
          confirmModelCommission: 'Commission model',
          confirmModelFixedPrice: 'Fixed-price model',
          successTitle: 'Pricing model updated',
          successDescription: 'Your pricing model has been switched to {{model}}.',
          errorTitle: 'Error',
          errorBlocked: 'The pricing model cannot be switched.',
          errorGeneric: 'The pricing model could not be updated.',
          leadTitle: 'Lead model',
          leadSubtitle: 'Payment per qualified inquiry',
          leadDescription: 'You pay a fixed amount per assigned inquiry.',
          leadTiers: 'Available tiers',
          leadPros: '+ Predictable revenue',
          leadCons: '- No commission on success',
          commissionTitle: 'Commission model',
          commissionSubtitle: 'Percentage share of the order value',
          commissionDescription: 'You pay a commission on successfully referred orders.',
          commissionExample: 'Example',
          commissionRateLabel: 'Commission rate (%)',
          commissionRateHelp: 'Percentage share of the referred order value',
          commissionPros: '+ No risk if cancelled',
          commissionCons: '- Revenue only on success',
          fixedPriceTitle: 'Fixed-price model',
          fixedPriceSubtitle: 'Flat fee per order',
          fixedPriceDescription: 'You pay a fixed amount per successfully referred order.',
          fixedPriceExample: 'Example',
          contractAmountLabel: 'Contract value (EUR)',
          contractAmountHelp: 'Flat fee per successfully referred order',
          minContractValueLabel: 'Minimum order value (EUR)',
          minContractValueHelp: 'Orders below this value will not be referred',
          fixedPricePros: '+ High predictability',
          fixedPriceCons: '- Risk if order falls through',
          postRegisterTitle: 'Choose your pricing model',
          postRegisterDescription:
            'Pick your pricing model now. You can change it anytime later from the dashboard.',
          continueToDashboard: 'Go to dashboard',
          // OPT307-i18n — loadError + tierSelector (LEAD / COMMISSION / FIXED)
          loadError: 'The pricing model could not be loaded.',
          tierSelector: {
            heading: 'Choose pricing tier',
            subheading: 'Pick one of the three models and provide the corresponding values.',
            leadTitle: 'Lead model',
            leadHint: 'Fixed amount per assigned request',
            leadFieldLabel: 'Price per lead (€)',
            commissionTitle: 'Commission model',
            commissionHint: 'Percentage share of order value',
            commissionFieldLabel: 'Commission rate (%)',
            minOrderValueLabel: 'Minimum order value (€) (optional)',
            fixedTitle: 'Fixed-price model',
            fixedHint: 'Flat fee per completed order',
            fixedFieldLabel: 'Fixed price per order (€)',
            validUntilLabel: 'Valid until (optional)',
            submit: 'Activate pricing',
            submitting: 'Saving...',
            successTitle: 'Pricing saved',
            successDescription: 'The new pricing has been activated successfully.',
            errorTitle: 'Save failed',
            invalidCommission: 'Commission rate must be between 0 and 100.',
            invalidPrice: 'Please enter a valid amount > 0.',
            invalidFixedPrice: 'Please enter a valid fixed price > 0.',
            modelLead: 'Lead',
            modelCommission: 'Commission',
            modelFixed: 'Fixed price',
          },
        },
        // P2.065 — Company Price-Tier-Settings-Card (Standard/Premium/Premium Plus)
        priceTierSettings: {
          heading: 'Price tier settings',
          subheading:
            'Choose your tier for request assignment. Changes are limited to once per day and take effect at 00:00 the next day.',
          currentTierLabel: 'Current tier',
          noTierLabel: 'No tier set yet',
          perRequest: 'per request',
          selectLabel: 'Choose a new tier',
          nextTierFrom: 'From {{date}} you will switch to',
          changeDailyWarning:
            'You have already changed your tier today. Another change is only possible tomorrow.',
          tierDisabledReason: 'This tier is currently disabled by the admin for company users.',
          saving: 'Saving...',
          saveButton: 'Change tier (effective from tomorrow)',
          changeNotPossibleTitle: 'Change not possible',
          changeNotPossibleDescription: 'You have already made a change today.',
          successTitle: 'Tier changed',
          successDescription: 'Your new tier will be active from tomorrow ({{date}}).',
          errorTitle: 'Error',
          errorDescription: 'The tier could not be changed.',
          tierNames: {
            standard: 'Standard',
            premium: 'Premium',
            premium_plus: 'Premium Plus',
          },
          tierDescriptions: {
            standard: 'Basic visibility for new requests',
            premium: 'Higher priority in assignment',
            premium_plus: 'Maximum priority and visibility',
          },
        },
        errorBoundary: {
          title: 'Something went wrong.',
          description:
            'The page could not be loaded correctly. Please reload the page or try again later.',
          reloadButton: 'Reload page',
        },
        requestTypes: {
          private: 'Private move',
          business: 'Business move',
          long_distance: 'Long-distance move',
          international: 'International move',
          special: 'Special move',
          official_relocation: 'Official relocation',
          authority_relocation: 'Authority relocation',
          assisted_move: 'Assisted move / covered costs',
        },
        dashboard: {
          overviewTab: 'Overview',
          requestsTab: 'Requests',
          billingTab: 'Billing',
          documentsTab: 'Documents',
          settingsTab: 'Settings',
          notificationsTab: 'Notifications',
          pricingTab: 'Pricing model',
          paymentsTab: 'Billing',
          payNow: 'Pay now',
          customerFallback: 'Customer',
          invoiceOpenError: 'The invoice document could not be opened.',
          requestDetailTitle: 'Request details',
          routeTitle: 'Move route',
          requestTypeTitle: 'Request type',
          tierTitle: 'Price tier',
          customerContactTitle: 'Customer contact',
          timelineTitle: 'Timeline',
          timelineAssigned: 'Request assigned',
          timelineMoveDate: 'Move date',
          timelineCurrentStatus: 'Current status: {{status}}',
          timelineNoTimestamp: 'Timestamp unavailable',
          communicationTitle: 'Communication',
          communicationEmpty: 'No messages available for this request yet.',
          communicationCustomer: 'Customer',
          communicationCompany: 'Your company',
          communicationLoadError: 'Messages could not be loaded.',
          activityTitle: 'Activity',
          activityEmpty: 'No activity available for this request yet.',
          activityStatusBadge: 'Status',
          activityMessageBadge: 'Message',
          activityDocumentBadge: 'Document',
          activityMessageTitle: 'Message from {{sender}}',
          activityDocumentTitle: 'Document uploaded: {{name}}',
          acceptAction: 'Accept request',
          declineAction: 'Decline',
          verificationRequiredForAccept: 'Verification required to accept requests',
          rematchAssignment: 'Reassignment',
          matchSuffix: 'match',
          unlimited: 'Unlimited',
          documentsCardTitle: 'Document status',
          documentsCardDesc: 'Verification files and current document state of your company.',
          coverageCardTitle: 'Coverage area',
          coverageCardDesc: 'Currently configured postal code ranges used for matching.',
          availabilityCardTitle: 'Availability',
          availabilityCardDesc:
            'Active weekdays on which your company is considered for new matches.',
          availabilityDaysLabel: 'active days',
          budgetCardTitle: 'Monthly budget',
          budgetCardDesc: 'Operational limits for requests and monthly spend.',
          requestInsightsTitle: 'Request insights',
          requestInsightsDesc: 'Quick view of match quality and request mix.',
          avgMatchScoreTitle: 'Avg match score',
          responseRateTitle: 'Response rate',
          avgResponseHoursTitle: 'Avg response time',
          acceptanceRateRangeTitle: 'Acceptance rate',
          completionRateTitle: 'Completion rate',
          assignedRequestsTitle: 'Assigned',
          last30DaysTitle: 'New requests 30 days',
          requestTypeMixTitle: 'Request types',
          tierMixTitle: 'Tier mix',
          tierMixDesc: 'Distribution of incoming requests by product tier.',
          performanceByTypeTitle: 'Performance by request type',
          performanceByTypeDesc:
            'Response, acceptance and completion by request type in the selected range.',
          responseTargetTitle: 'Response target',
          responseTargetOnTrack: 'Currently on target',
          responseTargetBehind: 'The current average is above the target.',
          responseTargetUnset: 'No target configured yet.',
          preferredRequestTypesTitle: 'Preferred request types',
          noInsightData: 'No data available yet.',
          openInvoicesTitle: 'Open invoices',
          openInvoiceAmountTitle: 'Outstanding amount',
          paidPaymentsTitle: 'Paid total',
          pendingPaymentsTitle: 'Pending payments',
          overdueInvoicesTitle: 'Overdue invoices',
          latestDocumentTitle: 'Latest upload',
          documentTypesTitle: 'Document types',
          reportFilterTitle: 'Date range',
          reportFilterDesc: 'Filters insights, billing and document reports by date.',
          range30d: '30 days',
          range90d: '90 days',
          rangeAll: 'All time',
          rangeCustom: 'Custom',
          startDate: 'Start date',
          endDate: 'End date',
          requestsInRangeTitle: 'Requests in range',
          exportCsv: 'CSV export',
          notificationSettingsTitle: 'Email notifications',
          notificationSettingsDescription:
            'Choose which email notifications your company should receive.',
          matchingReadinessTitle: 'Matching readiness',
          matchingReadinessDesc:
            'Shows why your company is currently visible for new requests and where configuration is still missing.',
          matchingReadinessReady: 'Ready',
          matchingReadinessNeedsAction: 'Review',
          matchingReadinessVerificationTitle: 'Verification',
          matchingReadinessVerificationReady:
            'Your company is verified and can participate in regular matching.',
          matchingReadinessVerificationPending:
            'Without completed verification no new matches will be created.',
          matchingReadinessServiceAreaTitle: 'Service area',
          matchingReadinessServiceAreaReady:
            '{{count}} postal code ranges are active for matching.',
          matchingReadinessServiceAreaMissing:
            'Add at least one postal code range so route-based matching can succeed.',
          matchingReadinessAvailabilityTitle: 'Availability',
          matchingReadinessAvailabilityReady: '{{count}} weekdays are enabled for new matches.',
          matchingReadinessAvailabilityMissing:
            'No weekday is currently enabled. Matching will exclude otherwise suitable requests.',
          matchingReadinessBudgetTitle: 'Budget and blocks',
          matchingReadinessBudgetBlocked:
            'A payment or blacklist block is currently preventing new assignments.',
          matchingReadinessBudgetReached:
            '{{count}} of {{limit}} monthly requests reached. New matches will pause until released.',
          matchingReadinessBudgetReady:
            '{{count}} of {{limit}} monthly requests used. Budget is still available.',
          matchingReadinessBudgetUnlimited:
            'No request cap configured. Budget does not currently block matching.',
          matchingReadinessRequestTypesTitle: 'Request types',
          matchingReadinessRequestTypesFocused:
            'You currently focus on {{count}} request types. This intentionally narrows match volume.',
          matchingReadinessRequestTypesOpen:
            'No request types are restricted. Your company stays visible for all types.',
          matchingReadinessResponseTitle: 'Response time',
          matchingReadinessResponseUnset:
            'No response target configured yet. A clear target helps operational steering.',
          matchingReadinessResponseNoData:
            'No reliable response-time data is available for the selected range yet.',
          matchingReadinessResponseOnTrack:
            'Avg {{value}}h and therefore within your target of {{target}}h.',
          matchingReadinessResponseBehind:
            'Avg {{value}}h and therefore above your target of {{target}}h.',
          tierReleaseStatus: {
            title: 'Tier release status',
            description:
              'Shows when new customer requests become available for your current company tier.',
            delayHint: 'Release logic: {{minutes}} minute lead time for new requests.',
            immediateTitle: 'Immediately in matching',
            immediateDesc:
              'With Premium+ your company is considered for suitable new requests without any waiting period.',
            waitingTitle: 'Next release is running',
            waitingDesc_one:
              '{{count}} new request is still inside the lead-time window. After that, your tier can be considered for suitable matches.',
            waitingDesc_other:
              '{{count}} new requests are still inside the lead-time window. After that, your tier can be considered for suitable matches.',
            countdownValue: '{{minutes}}m {{seconds}}s',
            nextReleaseAt: 'Next release at {{time}}.',
            readyTitle: 'No open waiting window right now',
            readyDesc:
              'There is currently no new request left inside the {{minutes}}-minute window. New suitable requests will be released after that lead time.',
          },
          requestMatching: {
            title: 'Matching check for this request',
            selectedTitle: 'Directly confirmed by the customer',
            selectedDesc:
              'This request is linked to your company directly through customer selection or an existing assignment.',
            eligibleTitle: 'Currently a fit for your company',
            eligibleDesc:
              'With your current settings, this request still fits your {{tier}} profile.',
            excludedTitle: 'Currently no longer a full fit',
            excludedDesc:
              'With your current settings, this request would currently no longer be assigned automatically.',
            releaseTitle: 'Tier release for this request',
            releaseReadyDesc:
              'The {{tier}} window with a {{minutes}} minute lead time has already opened for this request.',
            releasePendingDesc:
              'The {{tier}} window is not open yet. Estimated release in {{minutes}} minutes.',
            releaseAt: 'Planned release: {{time}}.',
            sourceLabel: 'Source',
            sourceSelected: 'Customer selection',
            sourcePool: 'Automatic matching',
            tierLabel: 'Current company tier',
            currentScoreLabel: 'Match score',
            noReasons: 'There are currently no further matching hints for this request.',
          },
          matchingInsights: {
            title: 'Matching potential',
            description:
              'Analysis of real demand patterns from the last {{days}} days for your company.',
            analyzedTitle: 'Requests analysed',
            eligibleTitle: 'Direct fit',
            excludedTitle: 'With gaps',
            blockingReasonsTitle: 'Current blockers',
            priorityHigh: 'High',
            priorityMedium: 'Medium',
            affectedRequests_one: '{{count}} request affected',
            affectedRequests_other: '{{count}} requests affected',
            noRecommendations: 'There are currently no prioritised improvement actions.',
            marketTitle: 'Demand snapshot',
            marketDesc:
              'Shows where the market recently produced the most fitting or missed opportunities.',
            topRequestTypesTitle: 'Demanded request types',
            topPostalAreasTitle: 'Strong postal areas',
            topSpecialServicesTitle: 'Demanded extra services',
            topWeekdaysTitle: 'Common move days',
            noSpecialServiceDemand: 'No extra services were requested in the selected period.',
            marketHint: 'Use these signals to sharpen service area, capabilities and availability.',
            clearAssignmentBlockTitle: 'Resolve assignment block first',
            clearAssignmentBlockDesc:
              'As long as a billing or blacklist block is active, no new assignments can be created.',
            completeVerificationTitle: 'Complete verification',
            completeVerificationDesc:
              'An open or rejected verification fully blocks regular matching.',
            expandServiceAreaTitle: 'Expand service area',
            expandServiceAreaDesc: 'Many missed opportunities recently came from {{areas}}.',
            expandRequestTypesTitle: 'Enable more request types',
            expandRequestTypesDesc:
              'Additional visibility is mainly available in {{requestTypes}}.',
            expandAvailabilityTitle: 'Widen availability',
            expandAvailabilityDesc: 'Requests are most often missed on {{weekdays}}.',
            addSpecialServicesTitle: 'Offer more extra services',
            addSpecialServicesDesc:
              'Frequently requested but not yet configured for your company: {{services}}.',
            increaseCapacityTitle: 'Increase capacity',
            increaseCapacityDesc:
              'Part of recent demand exceeded your currently configured volume/capacity limit.',
            increaseBudgetTitle: 'Review monthly budget',
            increaseBudgetDesc:
              'Your request budget repeatedly excluded you during the analysis period.',
          },
          operationsAlertsTitle: 'Operations action center',
          operationsAlertsDesc:
            'Prioritises open operational tasks for documents, follow-ups, service area and availability.',
          operationsAlertsEmpty: 'There is currently no operational follow-up required.',
          operationsAlertNeedsAction: 'Action needed',
          operationsAlertMonitor: 'Monitor',
          operationsActionDocuments: 'Open documents',
          operationsActionSettings: 'Open profile',
          operationsAlertMissingDocsTitle: 'Missing required documents',
          operationsAlertMissingDocsDesc_one:
            '{{count}} verification document is still missing for full operational approval.',
          operationsAlertMissingDocsDesc_other:
            '{{count}} verification documents are still missing for full operational approval.',
          operationsAlertRejectedDocsTitle: 'Reactivation needed after rejection',
          operationsAlertRejectedDocsDesc_one:
            '{{count}} document was rejected. Upload a new proof so approval can resume.',
          operationsAlertRejectedDocsDesc_other:
            '{{count}} documents were rejected. Upload new proofs so approval can resume.',
          operationsAlertPendingReviewTitle: 'Documents under review',
          operationsAlertPendingReviewDesc_one: '{{count}} document is waiting for admin review.',
          operationsAlertPendingReviewDesc_other:
            '{{count}} documents are waiting for admin review.',
          operationsAlertFollowUpDueTitle: 'Follow-up due today',
          operationsAlertFollowUpDueDesc_one:
            '{{count}} document slot should be checked or refreshed today.',
          operationsAlertFollowUpDueDesc_other:
            '{{count}} document slots should be checked or refreshed today.',
          operationsAlertFollowUpOverdueTitle: 'Follow-up overdue',
          operationsAlertFollowUpOverdueDesc_one:
            '{{count}} document slot has an overdue follow-up.',
          operationsAlertFollowUpOverdueDesc_other:
            '{{count}} document slots have overdue follow-ups.',
          operationsAlertServiceAreaMissingTitle: 'Service area missing',
          operationsAlertServiceAreaMissingDesc:
            'Without configured postal code ranges your company will miss relevant assignments.',
          operationsAlertServiceAreaNarrowTitle: 'Service area is very narrow',
          operationsAlertServiceAreaNarrowDesc:
            'Only {{count}} postal code ranges are configured right now. More coverage increases visibility.',
          operationsAlertAvailabilityMissingTitle: 'Availability missing',
          operationsAlertAvailabilityMissingDesc:
            'No active weekday is enabled. New requests cannot be assigned like this.',
          operationsAlertAvailabilityLimitedTitle: 'Availability is limited',
          operationsAlertAvailabilityLimitedDesc:
            'Only {{count}} active days are enabled. Additional days improve operational responsiveness.',
        },
        billing: {
          cardDesc: 'Manage and pay request access fees.',
          invoicesTitle: 'Invoices',
          noInvoices: 'No invoices available yet.',
          invoiceLabel: 'Invoice',
          collectionsHeader: 'Collection stage',
          collectionStageTitle: 'Collections status',
          collectionStageCurrent: 'On track',
          collectionStageReminder1: 'Dunning stage 1',
          collectionStageReminder2: 'Dunning stage 2',
          collectionStageFinalNotice: 'Final notice',
          collectionDays_one: '{{count}} day overdue',
          collectionDays_other: '{{count}} days overdue',
          collectionHealthy: 'There are currently no overdue invoices.',
          autoUnblockHint:
            'Billing blocks are removed automatically after successful payment reconciliation.',
          historyTitle: 'Billing history',
          historyEmpty: 'No billing history yet.',
          historyKind: 'Type',
          historyReference: 'Reference',
          historyOccurredAt: 'Occurred at',
          historyKindInvoice: 'Invoice',
          historyKindPayment: 'Payment',
          dueDate: 'Due date',
          paymentsTitle: 'Payments',
          noPayments: 'No payment records found for your company.',
          created: 'Created',
          paidAt: 'Paid at',
          redirectTitle: 'Redirecting to payment provider…',
          redirectDesc: 'Please complete the payment in the opened page.',
          missingCheckoutUrl: 'No checkout URL returned by server.',
          checkoutError: 'Failed to start checkout.',
          checkoutUnavailable:
            'Online payments are not configured right now. Please contact support.',
          paymentPaid: 'Paid',
          paymentPending: 'Pending',
          paymentFailed: 'Failed',
          paymentCancelled: 'Cancelled',
          paymentUnknown: 'Unknown',
          invoiceOverdue: 'Overdue',
        },
        assignmentBlockedPaymentTitle: 'New assignments are blocked',
        assignmentBlockedPaymentDesc:
          'Please settle invoice {{invoice}} (overdue since {{dueDate}}) so your company can receive new requests again.',
        assignmentBlockedOpenBilling: 'Open billing',
        assignmentBlockedOpenInvoice: 'Open invoice',
        assignmentBlockedPaymentInlineTitle: 'Billing block active',
        assignmentBlockedPaymentInlineDesc:
          'Invoice {{invoice}} has been overdue since {{dueDate}}. New assignments resume after payment.',
        assignmentBlockedBlacklistTitle: 'Your company is blocked',
        assignmentBlockedBlacklistDesc: 'Reason: {{reason}}. Valid until: {{validUntil}}.',
        assignmentBlockedPermanent: 'permanent',
        assignmentBlockedStatusTitle: 'Block status',
        assignmentBlockedStatusDesc:
          'New assignments stay paused until every active block reason has been resolved.',
        assignmentBlockedFactsTitle: 'Details',
        assignmentBlockedFactInvoice: 'Invoice',
        assignmentBlockedFactDueDate: 'Overdue since',
        assignmentBlockedFactCollectionStage: 'Collection stage',
        assignmentBlockedFactDaysOverdue: 'Overdue by',
        assignmentBlockedFactOverdueCount: 'Open invoices',
        assignmentBlockedFactReason: 'Block reason',
        assignmentBlockedFactValidUntil: 'Valid until',
        assignmentBlockedImpactTitle: 'Current impact',
        assignmentBlockedImpactDesc:
          'Your company is currently not receiving any new marketplace assignments.',
        assignmentBlockedNextStepsTitle: 'Next steps',
        assignmentBlockedNextStepReviewBilling: 'Review the open invoice in the billing section.',
        assignmentBlockedNextStepPayInvoice:
          'Settle the overdue invoice or start checkout directly.',
        assignmentBlockedNextStepAutoUnblock:
          'After payment and reconciliation, the billing block is removed automatically.',
        assignmentBlockedNextStepReviewBlacklist:
          'Review the stored block reason and the active validity period.',
        assignmentBlockedNextStepContactSupport:
          'If the block should already be resolved, please contact the admin team to restore access.',
        assignmentBlockedReasonPaymentLabel: 'Payment overdue',
        assignmentBlockedReasonBlacklistLabel: 'Block',
        assignmentBlockedAdditionalReasonsTitle: 'Additional active block reasons',
        assignmentBlockedSecondaryReasonCount_one: '{{count}} more reason active',
        assignmentBlockedSecondaryReasonCount_other: '{{count}} more reasons active',
        assignmentBlockedReasonPaymentSummary:
          'Invoice {{invoice}} has been overdue since {{dueDate}}.',
        assignmentBlockedReasonBlacklistSummary: 'Reason: {{reason}}. Valid until: {{validUntil}}.',
        recoveryAppeals: {
          title: 'Manual review & access recovery',
          description: 'Submit a reason or proof when an active company block needs manual review.',
          verificationContextTitle: 'Open verification items for this appeal',
          verificationContextDesc:
            'Consider these document and follow-up topics in your recovery appeal or update them directly in the document workspace.',
          empty: 'No access recovery requests have been submitted yet.',
          historyTitle: 'Recent requests',
          openAction: 'Request manual review',
          pendingAction: 'Request under review',
          pendingTitle: 'Request already pending',
          pendingDesc:
            'There is already an open access recovery request. Please wait for the admin team to respond.',
          dialogTitle: 'Manual access recovery request',
          dialogDescription: 'Describe the case and optionally upload supporting proof.',
          reasonLabel: 'Reason',
          reasonPlaceholder: 'Briefly explain why the block should be reviewed or removed.',
          reasonValidation: 'Please provide at least 20 characters describing the case.',
          proofLabel: 'Proof (optional)',
          proofHint: 'You can optionally upload payment confirmation or other supporting evidence.',
          proofSelected: 'Selected file: {{filename}}',
          proofWorkspaceHint:
            'This proof only belongs to the access recovery request and does not appear in the normal document workspace.',
          openProof: 'Open proof',
          adminResponseLabel: 'Admin response',
          createdTitle: 'Request submitted',
          createdDesc: 'Your access recovery request was forwarded to the admin team.',
          createError: 'The access recovery request could not be created.',
          submit: 'Submit request',
          submitting: 'Submitting request...',
          status: {
            pending: 'Under review',
            approved: 'Approved',
            rejected: 'Rejected',
          },
        },
        documentsPanelTitle: 'Document management',
        documentsPanelDesc: 'Upload verification files and manage existing company documents.',
        documentsListTitle: 'Documents',
        documentsListDesc: 'All company documents currently on file.',
        documentsCount_one: '{{count}} document on file',
        documentsCount_other: '{{count}} documents on file',
        documentsTotalTitle: 'Documents total',
        documentsVerificationTitle: 'Verification files',
        documentsOperationalTitle: 'Other files',
        documentsPdfTitle: 'PDF files',
        documentsUploadPurposeLabel: 'Upload purpose',
        documentsAdditionalHint:
          'Additional documents are meant for general company files. Proof for access recovery requests must be uploaded separately in the recovery dialog.',
        documentsPurposeLabel: 'Purpose',
        documentsCategoryLabel: 'Category',
        documentsStatusLabel: 'Status',
        documentsStatusAvailable: 'Available',
        documentsStatusVerified: 'Verified',
        documentsStatusPending: 'Under review',
        documentsStatusRejected: 'Rejected',
        documentsCategoryPdf: 'PDF',
        documentsCategoryImage: 'Image',
        documentsCategoryDocument: 'Document',
        documentsCategoryOther: 'Other',
        documentsEmpty: 'No documents uploaded yet.',
        documentsUploadedTitle: 'Documents uploaded',
        documentsUploadedDesc: 'The documents were saved and submitted for review.',
        additionalDocumentsUploadedDesc: 'The additional company documents were saved.',
        documentsUploadError: 'The documents could not be uploaded.',
        documentsDeletedTitle: 'Document deleted',
        documentsDeletedDesc: 'The document was removed.',
        documentsDeleteError: 'The document could not be deleted.',
        documentsDownloadError: 'The document could not be downloaded.',
        documentsPurposeVerification: 'Verification',
        documentsPurposeOther: 'Other',
        documentsEmptyFiltered: 'No documents available for this filter.',
        documentTypes: {
          business_registration: 'Business registration',
          liability_insurance: 'Company liability insurance',
          transport_liability_insurance: 'Transport liability insurance',
          other_or_eu_license: 'Other / road haulage licence / EU licence',
        },
        documentUploadPerTypeDesc: 'Each document type is uploaded and reviewed separately.',
        documentUploadRequiredDesc: 'Required for company signup.',
        documentUploadOptionalDesc:
          'Optional during signup, but considered later for request assignment.',
        documentReplacementQueued: 'The document was uploaded and submitted for renewed review.',
        activeDocument: 'Active document',
        pendingReplacement: 'Replacement under review',
        pendingReplacementKeepsActive:
          'The previously approved document remains valid until review is complete.',
        lastReviewTitle: 'Last decision',
        lastDecisionLabel: 'Status',
        lastReviewedAtLabel: 'Reviewed at',
        followUpTitle: 'Follow-up',
        followUpDueAtValue: 'Due: {{date}}',
        followUpOverdueAtValue: 'Overdue since {{date}}',
        followUpScheduledAtValue: 'Scheduled: {{date}}',
        noReviewHistory: 'No review history yet.',
        noFollowUp: 'No follow-up set.',
        noPendingReplacement: 'No replacement uploaded.',
        noDocumentUploaded: 'No document uploaded yet.',
        replaceDocument: 'Replace document',
        uploadAdditionalDocuments: 'Upload additional documents',
        documentsOpenAction: 'Open document workspace',
        documentsLoadError: 'Company documents could not be loaded. Please try again.',
        documentsRetryAction: 'Retry',
        profile: {
          updatedTitle: 'Profile updated',
          updatedDesc: 'Your changes have been saved.',
          updateError: 'Profile could not be updated.',
          companyDataTitle: 'Company details',
          companyDataDesc: 'Edit contact data, service area and operational limits.',
          descriptionPlaceholder: 'Describe your company and services...',
          capacityLabel: 'Capacity (m³)',
          vehicleSizeLabel: 'Vehicle size',
          vehicleSizePlaceholder: 'e.g. 7.5t truck',
          staffCountLabel: 'Staff count',
          serviceAreaLabel: 'Service area (postal codes)',
          serviceAreaPlaceholder: 'e.g. 64291, 531, 40 (comma separated)',
          serviceAreaHint:
            'Enter postal codes or prefixes, for example 64291 for one full code or 531 for all codes starting with 531.',
          budgetTitle: 'Monthly request budget',
          budgetCountLabel: 'Max requests/month',
          budgetAmountLabel: 'Max amount/month (€)',
          unlimitedPlaceholder: 'Unlimited',
          budgetHint: 'Leave empty for unlimited budget.',
          availabilityTitle: 'Availability',
          availabilityDesc:
            'Choose on which weekdays your company may receive new request matches.',
          availabilityHint: 'Disabled days are excluded from matching.',
          saveAction: 'Save changes',
          weekdays: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
          },
          serviceAreasTitle: 'Regions',
          serviceAreasDesc: 'Your additionally maintained regional service areas.',
          noRegions: 'No regions configured.',
          specialServicesTitle: 'Special services',
          specialServicesDesc: 'Additional services your company offers.',
          specialServicesConfigTitle: 'Configure services',
          specialServicesConfigDesc:
            'Choose the additional services your company should expose in profile and operations.',
          requestTypesTitle: 'Preferred request types',
          requestTypesDesc:
            'Limit new matches to the request types your company actively wants to handle.',
          requestTypesHint:
            'If nothing is selected, your company continues to receive all request types.',
          premiumPlusCriteriaTitle: 'Premium+ matching criteria',
          premiumPlusCriteriaDesc:
            'Define optional filters that only apply to Premium+ early access.',
          premiumPlusMinVolumeLabel: 'Min move volume (m³)',
          premiumPlusMaxVolumeLabel: 'Max move volume (m³)',
          premiumPlusMinLeadTimeLabel: 'Min lead time (days)',
          premiumPlusOptionalPlaceholder: 'Optional',
          premiumPlusCriteriaHint:
            'Blank values are ignored. Premium+ companies can pre-filter exclusive requests by volume and lead time.',
          requestTypesSummaryTitle: 'Request types',
          requestTypesSummaryDesc: 'Currently enabled types for new matching.',
          allRequestTypes: 'All request types active.',
          responseTargetLabel: 'Response target (hours)',
          responseTargetPlaceholder: 'e.g. 12',
          responseTargetHint: 'Optional target for your internal response speed.',
          fleetTitle: 'Fleet',
          fleetDesc: 'Stored vehicles for planning and dashboard overview.',
          fleetLabel: 'Vehicles',
          fleetPlaceholder: 'e.g. 3.5t van, 7.5t truck, furniture lift',
          fleetHint: 'Enter multiple vehicles separated by commas.',
          noFleet: 'No vehicles configured.',
          noSpecialServices: 'No special services configured.',
        },
        gallery: {
          title: 'Portfolio',
          empty: 'This company has not added any portfolio images yet.',
          upload: 'Upload portfolio images',
          // P2.069 — hardcoded toast.description with count + pluralization
          uploadSuccessDesc_one: '{{count}} image uploaded',
          uploadSuccessDesc_other: '{{count}} images uploaded',
          maxPhotos: 'You can manage up to 10 portfolio images.',
          delete: 'Remove image',
          edit: 'Edit portfolio',
          moveUp: 'Move up',
          moveDown: 'Move down',
        },
      },
      customer: {
        reviewDialog: {
          title: 'Rate company: {{company}}',
          ratingLabel: 'Rating',
          ratingRequiredTitle: 'Rating required',
          ratingRequiredDesc: 'Please select a star rating.',
          tagsLabel: 'Tags (optional)',
          tags: {
            tagPunctual: 'Punctual',
            tagProfessional: 'Professional',
            tagCareful: 'Careful',
            tagFriendly: 'Friendly',
            tagFast: 'Fast',
            tagGoodValue: 'Good value for money',
          },
          commentLabel: 'Comment (optional)',
          commentPlaceholder: 'Share your experience...',
          submit: 'Submit review',
          submitting: 'Saving...',
          successTitle: 'Review submitted',
          successDesc: 'Thank you for your feedback!',
          errorTitle: 'Error',
          errorDesc: 'The review could not be saved.',
        },
        dashboard: {
          overviewTab: 'Overview',
          requestsTab: 'Requests',
          documentsTab: 'Documents',
          settingsTab: 'Settings',
          notificationsTab: 'Notifications',
          totalRequests: 'Total requests',
          activeRequests: 'Active requests',
          completedRequests: 'Completed requests',
          confirmedPartners: 'Confirmed companies',
          newRequestDesc: 'Create a new moving request and find matching companies.',
          cancelledRequests: 'Cancelled requests',
          archiveDesc: 'Archived requests',
          profileDesc: 'Your profile and contact details.',
          requestsDesc: 'History, status and offer progress of your requests.',
          emptyRequestsDesc: 'You have not created any requests yet.',
          requestInsightsTitle: 'Request insights',
          requestInsightsDesc: 'Overview of recent requests, offers and documents.',
          last30DaysTitle: 'New requests 30 days',
          avgOffersTitle: 'Avg assigned offers',
          documentsStoredTitle: 'Documents',
          tierMixTitle: 'Tier mix',
          tierMixDesc: 'Distribution of your requests by product tier.',
          activeSectionTitle: 'Active requests',
          archiveSectionTitle: 'Archive',
          noActiveRequests: 'No active requests available.',
          noArchivedRequests: 'No archived requests available yet.',
          reportFilterTitle: 'Date range',
          reportFilterDesc: 'Filters overview, history and documents by creation date.',
          range30d: '30 days',
          range90d: '90 days',
          rangeAll: 'All time',
          rangeCustom: 'Custom',
          startDate: 'Start date',
          endDate: 'End date',
          requestsInRangeTitle: 'Requests in range',
          exportCsv: 'CSV export',
          noDataInRange: 'No data is available for this range.',
          newRequestBlockedDesc:
            'New requests are disabled while the active block remains in place.',
          requestsBlockedAlert:
            'Requests, chat, and new request creation are currently blocked for this customer account. Submit an access recovery request if you need a manual review.',
          missingDocsBadge: '{{count}} documents still missing',
        },
        blockStatus: {
          title: 'Account blocked',
          description:
            'Your customer account is currently blocked for new requests and request communication.',
          badge: 'Block active',
          reasonTitle: 'Block reason',
          reasonDescription: 'Reason: {{reason}}. Valid until: {{validUntil}}.',
          permanent: 'Permanent',
          reasonLabel: 'Reason',
          validUntilLabel: 'Valid until',
          factsTitle: 'Block details',
          impactTitle: 'Impact',
          impactDescription:
            'You currently cannot create new requests or manage existing request flows through the blocked APIs.',
          nextStepsTitle: 'Next steps',
          nextStepReviewReason: 'Review the stored block reason and any open follow-up items.',
          nextStepSubmitAppeal: 'Submit an access recovery request with context or proof.',
          nextStepPendingReview:
            'Your access recovery request is already under review. Wait for the admin team response.',
          nextStepContactSupport: 'Contact support if you need to share additional context.',
        },
        recoveryAppeals: {
          title: 'Access recovery requests',
          description:
            'Track manual review requests for your account and upload additional proof if needed.',
          openAction: 'Request access recovery',
          pendingAction: 'Request under review',
          dialogTitle: 'Submit access recovery request',
          dialogDescription: 'Describe the background of the block and optionally upload proof.',
          reasonLabel: 'Reason',
          reasonPlaceholder:
            'Explain why your account should be unblocked again and what has changed.',
          reasonValidation: 'Please provide at least 20 characters describing the request.',
          proofLabel: 'Optional proof',
          proofHint: 'You can optionally upload PDF, image, or Office proof files.',
          proofSelected: 'Selected file: {{filename}}',
          proofWorkspaceHint:
            'This proof only belongs to the access recovery request and does not appear in your normal document list.',
          submit: 'Send request',
          submitting: 'Submitting...',
          createdTitle: 'Access recovery request submitted',
          createdDesc: 'Your request was forwarded to the admin team.',
          createError: 'The access recovery request could not be created.',
          pendingTitle: 'Request already open',
          pendingDesc: 'There is already an open access recovery request for your account.',
          empty: 'No access recovery requests have been submitted yet.',
          historyTitle: 'Recent requests',
          openProof: 'Open proof',
          adminResponseLabel: 'Admin response',
          status: {
            pending: 'Under review',
            approved: 'Approved',
            rejected: 'Rejected',
          },
        },
        profile: {
          personalTitle: 'Personal information',
          personalDesc: 'Manage your contact details.',
          fullNameLabel: 'Full name',
          fullNamePlaceholder: 'John Doe',
          phonePlaceholder: '+49 30 1234567',
          addressTitle: 'Address',
          addressDesc: 'Your home address for planning and follow-up.',
          streetLabel: 'Street and house number',
          streetPlaceholder: 'Example Street 123',
          postalCodeLabel: 'Postal code',
          cityLabel: 'City',
          cityPlaceholder: 'Berlin',
          countryLabel: 'Country',
          countryPlaceholder: 'Germany',
          notificationsTitle: 'Communication preferences',
          notificationsDesc: 'Choose which customer events should trigger notifications for you.',
          notifications: {
            emailNewRequests: 'Notifications for new or updated requests',
            emailMessages: 'Notifications for new messages',
            emailStatusUpdates: 'Notifications for status changes',
            emailDocuments: 'Notifications for document activity',
          },
          saveAction: 'Save all changes',
          updatedTitle: 'Profile updated',
          updatedDesc: 'Your profile has been saved.',
          updateError: 'Profile could not be saved.',
          loadError: 'Profile could not be loaded.',
        },
        documents: {
          title: 'Documents',
          desc: 'Manage request-related files and supporting documents.',
          totalDocumentsTitle: 'Documents total',
          activeDocumentsTitle: 'Active requests',
          archivedDocumentsTitle: 'Archived requests',
          pdfDocumentsTitle: 'PDF files',
          statusActive: 'Active',
          categoryLabel: 'Category',
          categoryPdf: 'PDF',
          categoryImage: 'Image',
          categoryDocument: 'Document',
          categoryOther: 'Other',
          uploadForRequest: 'Upload document for request',
          selectRequest: 'Select request',
          noUploadRequestTitle: 'No request available for document uploads yet',
          noUploadRequestDesc:
            'Create a request first. It will then become available here automatically for document uploads.',
          singleRequestHint: 'The only available request is already preselected: {{request}}',
          uploadPurposeLabel: 'Document type',
          uploadPurposePlaceholder: 'Select document type',
          uploadPurposeHint:
            'Regular request documents appear here. Proof for access recovery requests is uploaded separately in the recovery dialog.',
          selectedPurposeHint: 'Selected purpose: {{purpose}}',
          purposeOther: 'General supporting file',
          purposeOtherHint:
            'Use this option for general request-related files without a specific proof type.',
          purposeCustomerIdentity: 'Identity document / ID proof',
          purposeCoverageApproval: 'Coverage approval / cost coverage',
          purposeAuthorityReference: 'Authority reference / case file',
          purposeCareLevelProof: 'Care level / care fund proof',
          uploadAction: 'Upload document',
          quickUploadTitle: 'Targeted proof for this request',
          quickUploadDesc:
            'Missing supporting files can be uploaded directly with the correct purpose.',
          quickUploadComplete: 'All currently expected proof files are available',
          quickUploadMissing_one: '{{count}} proof file still missing',
          quickUploadMissing_other: '{{count}} proof files still missing',
          listTitle: 'Files',
          listDesc: 'All uploaded documents linked to your requests.',
          empty: 'No documents uploaded yet.',
          emptyFiltered: 'No documents available for this filter.',
          uploadedTitle: 'Documents uploaded',
          uploadedDesc: 'The files were linked to your request.',
          uploadError: 'Documents could not be uploaded.',
          downloadError: 'Document could not be downloaded.',
          deletedTitle: 'Document deleted',
          deletedDesc: 'The document was removed.',
          deleteError: 'Document could not be deleted.',
          noRequest: 'No request',
          loadError: 'Not all documents could be loaded. Some entries may be temporarily missing.',
          retryAction: 'Retry',
        },
      },
      notificationCenter: {
        title: 'Notification center',
        description: 'A persistent history of delivered system notifications.',
        allFilter: 'All',
        unreadFilter: 'Unread',
        typeFilterLabel: 'Notification type',
        typeFilterAll: 'All types',
        refreshAction: 'Refresh',
        emptyAll: 'There are no notifications yet.',
        emptyUnread: 'There are no unread notifications right now.',
        loadError: 'Notifications could not be loaded.',
        markReadError: 'Notification could not be marked as read.',
        markReadAction: 'Mark as read',
        markAllReadAction: 'Mark all as read',
        markAllReadError: 'Notifications could not be marked as read in bulk.',
        markAllReadSuccess: 'Notifications updated',
        markAllReadSuccessDesc: 'All notifications in the current selection were marked as read.',
        unreadBadge: 'Unread',
        readBadge: 'Read',
        receivedAt: 'Received at {{date}}',
        pageSummary: 'Page {{page}} of {{totalPages}}',
        previousAction: 'Previous',
        nextAction: 'Next',
        totalCount: '{{count}} total',
        unreadCount: '{{count}} unread',
        filteredUnreadCount: '{{count}} unread in selection',
        eventLabels: {
          company_new_request_assignment: 'New request assigned to company',
          customer_company_response: 'Company response',
          customer_no_matching_companies: 'No suitable company found',
          customer_company_confirmed: 'Company confirmed',
          company_selected_confirmation: 'Customer confirmed your company',
          customer_cancellation_review: 'Cancellation decision for customer',
          company_cancellation_review: 'Cancellation decision for company',
          company_verification_clarification_requested: 'Verification document follow-up',
        },
      },
      pricing: {
        tabTitle: 'Pricing model',
        tabDescription:
          'Choose how your company is paid for matched requests. The switch is only possible when there are no open invoices, commissions or fixed-price offers.',
        currentModelBadge: 'Currently active',
        activate: 'Activate',
        activating: 'Activating...',
        saveChanges: 'Save changes',
        notesLabel: 'Internal note (optional)',
        notesPlaceholder: 'e.g. special terms for key accounts',
        leadTitle: 'Lead-based pricing',
        leadSubtitle: 'Classic fee per matched request',
        leadDescription:
          'You pay a fixed amount per qualified request we match to your company. Ideal for a simple, predictable cost structure.',
        leadTiers: 'Standard: €8 · Premium: €12 · Premium Plus: €15',
        leadPros: 'Simple, predictable cost per request',
        leadCons: 'Higher cost on large jobs without revenue share',
        commissionTitle: 'Commission pricing',
        commissionSubtitle: 'Share of contract value instead of a flat lead fee',
        commissionDescription:
          'You pay a percentage of the actual contract value. We recommend a rate between 5 % and 20 %. The default is 10 % if not overridden.',
        commissionRateLabel: 'Commission rate (%)',
        commissionRateHelp: 'Value between 0 and 100. Default: 10 %.',
        commissionExample: 'Example: €1,500 contract × 10 % = €150 commission',
        commissionPros: 'Fair share of the actual contract value',
        commissionCons: 'Additional bookkeeping and invoicing effort',
        fixedPriceTitle: 'Fixed-price pricing',
        fixedPriceSubtitle: 'Flat fee per completed contract',
        fixedPriceDescription:
          'You set a flat amount per contract. A minimum contract value makes sure the model only applies to jobs above a defined size.',
        contractAmountLabel: 'Fixed price per contract (€)',
        contractAmountHelp: 'Default: 1.2x lead price, minimum €200.',
        minContractValueLabel: 'Minimum contract value (€)',
        minContractValueHelp: 'We recommend at least €200 to keep the model profitable.',
        fixedPriceExample: 'Example: €240 fixed price × 12 contracts = €2,880 / month',
        fixedPricePros: 'Predictable revenue per contract, clear calculation',
        fixedPriceCons: 'Risk on small jobs below the minimum value',
        confirmTitle: 'Switch pricing model',
        confirmDescription:
          'Do you really want to switch to the "{{model}}" model? This action is logged in the audit trail and can only be performed when there are no open items.',
        confirmModelLead: 'Lead-based pricing',
        confirmModelCommission: 'Commission pricing',
        confirmModelFixedPrice: 'Fixed-price pricing',
        successTitle: 'Pricing model updated',
        successDescription: 'Your company now uses the "{{model}}" model.',
        errorTitle: 'Update failed',
        errorBlocked:
          'The pricing model cannot be switched while there are open invoices, payments, commissions or fixed-price offers. Please close those first.',
        errorGeneric: 'The pricing model could not be updated. Please try again.',
        loadError: 'The pricing model could not be loaded.',
        // P1.W2 v1 — 3-stufiges Pricing (LEAD / COMMISSION / FIXED)
        tierSelector: {
          heading: 'Choose your pricing tier',
          subheading: 'Pick one of the three models and provide the matching monetary values.',
          leadTitle: 'Lead model',
          leadHint: 'Fixed amount per matched request',
          leadFieldLabel: 'Lead price (€)',
          commissionTitle: 'Commission model',
          commissionHint: 'Percentage of the order value',
          commissionFieldLabel: 'Commission rate (%)',
          minOrderValueLabel: 'Minimum order value (€) (optional)',
          fixedTitle: 'Fixed-price model',
          fixedHint: 'Flat fee per completed order',
          fixedFieldLabel: 'Fixed price per order (€)',
          validUntilLabel: 'Valid until (optional)',
          submit: 'Activate tier',
          submitting: 'Saving…',
          successTitle: 'Tier saved',
          successDescription: 'The new tier was activated successfully.',
          errorTitle: 'Save failed',
          invalidCommission: 'Commission rate must be between 0 and 100.',
          invalidPrice: 'Please enter a valid amount greater than 0.',
          invalidFixedPrice: 'Please enter a valid fixed price greater than 0.',
          modelLead: 'Lead',
          modelCommission: 'Commission',
          modelFixed: 'Fixed',
        },
      },
      // P2.068 — hardcoded aria-label in ProcessSteps.tsx (Step {{number}})
      process: {
        stepLabel: 'Step {{number}}',
      },
      // P2.068 — hardcoded German strings in CompanyCompare.tsx formatPrice()
      compare: {
        priceFree: 'Free',
        priceFrom: 'from {{amount}} €',
      },
      // P2.075 — bulk request placeholder (EN)
      bulkRequestPlaceholder: 'Comparison request',
      // P2.075 — public profile meta (EN)
      publicProfile: {
        metaTitleWithName: '{{name}} - Moving company profile',
        metaTitleDefault: 'Moving company profile',
        metaDescriptionWithName:
          '{{name}} on regionalumzug24: reviews, regions and services for your next move at a glance.',
        metaDescriptionDefault:
          'Discover verified moving companies with reviews, service profiles and regional focus on regionalumzug24.',
      },
      admin: {
        common: {
          toggleOn: 'ON',
          toggleOff: 'OFF',
        },
        userDialog: {
          editTitle: 'Edit user',
          createTitle: 'New user',
          editDesc: 'Update user details',
          createDesc: 'Create a new user',
          emailLabel: 'Email',
          nameLabel: 'Name',
          passwordLabel: 'Password',
          passwordOptionalHint: '(optional - only when changing)',
          passwordPlaceholder: 'Leave empty to keep unchanged',
          roleLabel: 'Role',
          roleCustomer: 'Customer',
          roleCompany: 'Company',
          roleAdmin: 'Admin',
          cancel: 'Cancel',
          save: 'Save',
          saving: 'Saving...',
          updatedTitle: 'User updated',
          updatedDesc: 'The changes have been saved.',
          createdTitle: 'User created',
          createdDesc: 'The new user was created successfully.',
          errorTitle: 'Error',
          errorDesc: 'The user could not be saved.',
        },
        invoiceDialog: {
          title: 'Create invoice',
          description: 'Create a manual payment request for a company assignment',
          defaultTitle: 'Invoice for {{request}}',
          successTitle: 'Invoice created',
          successDesc: 'The invoice has been saved as a separate record.',
          errorTitle: 'Error',
          errorDesc: 'The invoice could not be created.',
          companyLabel: 'Company',
          requestLabel: 'Request',
          amountLabel: 'Amount (€)',
          titleLabel: 'Title',
          titlePlaceholder: 'e.g. brokerage invoice',
          dueDateLabel: 'Due date (optional)',
          descriptionLabel: 'Description (optional)',
          descriptionPlaceholder: 'Internal note or description of services',
          invoiceHint: 'This creates an invoice. Payments remain separate.',
          cancel: 'Cancel',
          create: 'Create',
          creating: 'Creating...',
        },
        dashboard: 'Admin Dashboard',
        dashboardDesc: 'Management and Overview',
        users: 'Users',
        companies: 'Companies',
        requests: 'Requests',
        cancellations: 'Cancellations',
        legal: 'Legal',
        userManagement: 'User Management',
        userManagementDesc: 'Manage and create users',
        companyManagement: 'Company Management',
        companyManagementDesc: 'Verify and manage companies',
        companyAssignmentStatus: 'Assignment status',
        companyOperations: 'Operations',
        companyOperationsStable: 'Stable',
        companyOperationsMore_one: '+{{count}} more item',
        companyOperationsMore_other: '+{{count}} more items',
        companyAssignmentActive: 'Eligible',
        companyAssignmentActiveDesc: 'No active block for new assignments.',
        companyAssignmentBlockedDesc: 'New assignments are currently blocked.',
        companyAssignmentBlockedPayment: 'Blocked by billing',
        companyAssignmentBlockedPaymentDesc:
          'Invoice {{invoice}} has been overdue since {{dueDate}} and blocks new assignments.',
        companyAssignmentBlockedBlacklist: 'Manually blocked',
        companyAssignmentBlockedBlacklistDesc:
          'Block reason: {{reason}}. Valid until: {{validUntil}}.',
        requestManagement: 'Request Management',
        requestManagementDesc: 'Monitor moving requests',
        cancellationRequests: 'Cancellation Requests',
        cancellationRequestsDesc: 'Process cancellation requests',
        legalContent: 'Legal Content',
        legalContentDesc: 'Manage imprint and privacy policy',
        newUser: 'New User',
        newCompany: 'New Company',
        registeredUsers: 'Registered Users',
        userList: {
          searchPlaceholder: 'Search by email or name',
          roleAll: 'All roles',
          roleCustomer: 'Customers',
          roleCompany: 'Companies',
          roleAdmin: 'Admins',
          filteredCount: '{{count}} users',
          emptyState: 'No users match the current filters.',
          export: 'Export users',
          exportError: 'The user export could not be exported.',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} users',
          previousPage: 'Previous',
          nextPage: 'Next',
        },
        companyList: {
          searchPlaceholder: 'Search by company, email or owner',
          statusAll: 'All statuses',
          statusPending: 'Verification pending',
          statusVerified: 'Verified',
          statusRejected: 'Rejected',
          filteredCount: '{{count}} companies',
          emptyState: 'No companies match the current filters.',
          export: 'Export companies',
          exportError: 'The company export could not be exported.',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} companies',
          previousPage: 'Previous',
          nextPage: 'Next',
        },
        requestList: {
          searchPlaceholder: 'Search by route, postal code or customer',
          statusAll: 'All statuses',
          filteredCount: '{{count}} requests',
          emptyState: 'No requests match the current filters.',
          export: 'Export requests',
          exportError: 'The request export could not be exported.',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} requests',
          previousPage: 'Previous',
          nextPage: 'Next',
        },
        total: 'Total',
        roles: 'Roles',
        registeredOn: 'Registered On',
        verified: 'Verified',
        verify: 'Verify',
        approve: 'Approve',
        reject: 'Reject',
        company: 'Company',
        request: 'Request',
        requestedOn: 'Requested On',
        reason: 'Reason',
        noCancellationRequests: 'No Cancellation Requests',
        noAdminRights: 'No Admin Rights',
        dataLoadError: 'Error loading data',
        statusUpdated: 'Status Updated',
        statusUpdateError: 'Error updating status',
        companyVerified: 'Company Verified',
        companyRejected: 'Company Rejected',
        cancellationApproved: 'Cancellation Approved',
        cancellationApprovedDesc: 'The cancellation request has been approved',
        cancellationRejected: 'Cancellation Rejected',
        cancellationRejectedDesc: 'The cancellation request has been rejected',
        cancellationUpdateError: 'Error updating cancellation',
        imprintDesc: 'Edit Imprint',
        privacyDesc: 'Edit Privacy Policy',
        requestTimelineAction: 'Timeline',
        requestTimelineTitle: 'Request timeline',
        requestTimelineDescription: 'Status history and activity for this request.',
        requestTimelineLoadError: 'The request timeline could not be loaded.',
        operations: {
          summaryRematchTitle: 'Rematch queue',
          summaryRematchDesc: 'Requests with open matching slots.',
          summaryCancellationTitle: 'Cancellation queue',
          summaryCancellationDesc: 'Company cancellations waiting for a decision.',
          summaryBillingTitle: 'Billing issues',
          summaryBillingDesc: 'Cases with missing or overdue billing follow-up.',
          summaryVerificationTitle: 'Verification issues',
          summaryVerificationDesc: 'Open document reviews and missing verification evidence.',
          queueTitle: 'Prioritized operations queue',
          queueDesc:
            'All open problem cases in one prioritized list with direct follow-up actions.',
          queueEmpty: 'No open operations cases for this filter.',
          exportQueue: 'Export queue',
          exportError: 'The queue could not be exported.',
          exportBillingIssues: 'Export billing',
          exportVerificationIssues: 'Export verification',
          categoryColumn: 'Area',
          priorityColumn: 'Priority',
          issueColumn: 'Issue',
          ageColumn: 'Age',
          categoryRematch: 'Rematch',
          categoryCancellation: 'Cancellation',
          categoryBilling: 'Billing',
          categoryVerification: 'Verification',
          severityAll: 'All priorities',
          severityHigh: 'High',
          severityMedium: 'Medium',
          searchPlaceholder: 'Search by company, request or reference',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} items',
          previousPage: 'Previous',
          nextPage: 'Next',
          ageToday: 'Today',
          ageDays_one: '{{count}} day',
          ageDays_other: '{{count}} days',
          issueRematchDesc: '{{remaining}} of {{desired}} slots are still open.',
          issueMissingBillingSetup: 'Missing billing setup',
          issueMissingBillingSetupDesc:
            '{{company}} has neither payment nor invoice for {{request}} yet.',
          issueMissingInvoiceAfterPayment: 'Invoice missing after payment',
          issueMissingInvoiceAfterPaymentDesc:
            '{{company}} already paid for {{request}}, but there is still no invoice.',
          issueDraftInvoiceStale: 'Draft invoice is stale',
          issueDraftInvoiceStaleDesc: 'Draft {{invoice}} has not been progressed yet.',
          issueInvoiceOverdue: 'Invoice is overdue',
          issueInvoiceOverdueDesc: 'Invoice {{invoice}} is overdue since {{dueDate}}.',
          issuePendingDocumentReview: 'Document review pending',
          issuePendingDocumentReviewDesc: '{{company}} is waiting for review of {{document}}.',
          issueMissingVerificationDocument: 'Verification document missing',
          issueMissingVerificationDocumentDesc:
            '{{company}} is pending without a verification document.',
          issueRejectedVerificationDocument: 'Rejected verification documents',
          issueRejectedVerificationDocumentDesc:
            '{{company}} has {{count}} rejected document slots and needs replacement evidence.',
          issueVerificationFollowUpDue: 'Follow-up due',
          issueVerificationFollowUpDueDesc:
            '{{company}} has {{count}} due follow-ups, {{overdueCount}} of them overdue.',
          issueServiceAreaMissing: 'Service area missing',
          issueServiceAreaMissingDesc: '{{company}} has not configured a service area yet.',
          issueAvailabilityMissing: 'Availability missing',
          issueAvailabilityMissingDesc: '{{company}} currently has no active availability days.',
          openBilling: 'Open billing',
          reviewDocuments: 'Review documents',
          openTimeline: 'Timeline',
          billingIssuesTitle: 'Billing quality checks',
          billingIssuesDesc: 'The most important billing cases that need action.',
          billingIssuesEmpty: 'No open billing issues.',
          verificationIssuesTitle: 'Verification quality checks',
          verificationIssuesDesc:
            'Open document reviews and missing evidence for pending companies.',
          verificationIssuesEmpty: 'No open verification issues.',
        },
        rematch: {
          title: 'Run rematch',
          description: 'There are currently {{count}} company assignments still open.',
          summaryTitle: 'Matching overview',
          summaryDesc: 'Current status for {{route}}.',
          summaryFallbackDesc: 'Current status for this request.',
          confirmedLabel: 'Confirmed companies',
          confirmedEmpty: 'No company has confirmed the match yet.',
          pendingLabel: 'Pending companies',
          pendingEmpty: 'There are currently no open company assignments.',
          preselectedLabel: 'Preselected companies',
          preselectedEmpty: 'No companies were preselected for this request.',
          releaseWaitingLabel: 'Release window pending',
          releaseWaitingEmpty: 'No eligible company is currently only waiting for its tier window.',
          releaseWaitingUnavailable: 'Release status could not be loaded yet.',
          summaryAssignedBadge: '{{assigned}} of {{desired}} actively assigned',
          summaryOpenBadge: '{{count}} slots still open',
          cancellationRequestedBadge: '{{count}} cancellation requests pending',
          confirmedShort: 'Confirmed {{count}}',
          pendingShort: 'Open {{count}}',
          preselectedShort: 'Preselected {{count}}',
          companyNamesWithMore: '{{names}} and {{count}} more',
          diagnosticsTitle: 'Matching diagnostics',
          diagnosticsDescription:
            'Inspect which companies are currently considered, excluded or directly selected.',
          diagnosticsAction: 'Diagnostics',
          diagnosticsSectionTitle: 'Diagnostics',
          diagnosticsSectionDesc:
            'Server-side selection and exclusion reasons for the current matching run.',
          refreshDiagnostics: 'Refresh diagnostics',
          diagnosticsLoadError: 'Matching diagnostics could not be loaded.',
          diagDesired: 'Target offers',
          diagAssigned: 'Active assignments',
          diagNeedNow: 'Needed now',
          diagEligible: 'Eligible companies',
          stopReasonTitle: 'Matching stopped',
          noDiagnosticsCandidates: 'There are currently no diagnostic candidates for this request.',
          noDiagnosticsData: 'No diagnostic data loaded yet.',
          decisionSelected: 'Will be assigned',
          decisionEligible: 'Eligible',
          decisionExcluded: 'Excluded',
          summarySelected: 'Selected',
          summaryEligible: 'Other eligible',
          summaryExcluded: 'Excluded',
          // P2.069 — hardcoded <div> heading in AdminRematchDialog diagnostics panel
          topExclusionsTitle: 'Most common exclusion reasons',
          sourceSelected: 'Preselected',
          sourcePool: 'Matching pool',
          scoreLabel: 'Score {{score}}',
          maxAdditional: 'Maximum additional assignments',
          // P2.069 — hardcoded toast.description in Admin.tsx rematch validation
          maxAdditionalRangeError: 'Please enter a number between 1 and {{max}}.',
          helper: 'Leave empty or enter the open demand to fill all free slots.',
          runAction: 'Start rematch',
          running: 'Running...',
          successTitle: 'Rematch completed',
          successDesc: '{{created}} new companies assigned. Remaining open: {{remaining}}.',
          errorDesc: 'Rematch could not be executed.',
          action: 'Rematch',
        },
        billing: {
          tab: 'Billing',
          title: 'Billing',
          desc: 'Track invoices and payments separately per company assignment.',
          companyHeader: 'Company',
          requestHeader: 'Request',
          invoiceHeader: 'Invoice',
          collectionsHeader: 'Collection stage',
          collectionStageCurrent: 'On track',
          collectionStageReminder1: 'Dunning stage 1',
          collectionStageReminder2: 'Dunning stage 2',
          collectionStageFinalNotice: 'Final notice',
          collectionDays_one: '{{count}} day overdue',
          collectionDays_other: '{{count}} days overdue',
          autoUnblockHint:
            'The billing block is removed automatically after payment and reconciliation.',
          exportCollections: 'Export collections',
          exportError: 'The billing export could not be exported.',
          filterAll: 'All',
          filterOverdue: 'Overdue',
          filterFinalNotice: 'Final notice',
          filterBlocked: 'Blocked',
          paymentHeader: 'Payment',
          noInvoice: 'No invoice',
          noPayment: 'No payment',
          invoiceDraft: 'Draft',
          invoiceSent: 'Sent',
          invoicePaid: 'Paid',
          invoiceCancelled: 'Cancelled',
          paymentOpen: 'Open',
          actionInvoice: 'Invoice',
          actionSend: 'Send',
          actionMarkPaid: 'Mark as paid',
          actionCancel: 'Cancel',
          actionView: 'View',
          noRows: 'No company assignments available for billing.',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} items',
          previousPage: 'Previous',
          nextPage: 'Next',
          updatedTitle: 'Invoice status updated',
          updateError: 'Invoice status could not be updated.',
          viewError: 'Invoice view could not be opened.',
        },
        documents: {
          title: 'Document oversight',
          desc: 'Review, filter and manage all company documents in one place.',
          totalTitle: 'Documents total',
          totalDesc: 'All company files currently stored in the system.',
          verificationTitle: 'Verification files',
          verificationDesc: 'Files relevant for company verification checks.',
          pendingTitle: 'Under review',
          pendingDesc: 'Verification files from companies with pending status.',
          rejectedTitle: 'Rejected',
          rejectedDesc: 'Files from companies with rejected verification.',
          staleTitle: 'Overdue',
          staleDesc: 'Open verification files waiting for at least 7 days.',
          followUpDueTitle: 'Follow-ups due',
          followUpDueDesc: 'Document slots with due or overdue follow-ups.',
          reviewQueueTitle: 'Review queue',
          reviewQueueDesc: 'Approve or reject directly from the document workspace.',
          exportError: 'The document export could not be exported.',
          reviewQueueEmpty: 'No open verification documents in the current filter.',
          followUpQueueTitle: 'Follow-up queue',
          followUpQueueDesc: 'Prioritized slots that need immediate attention.',
          followUpQueueEmpty: 'No due or overdue follow-ups right now.',
          missingDocsTitle: 'Missing files',
          missingDocsDesc: 'Pending companies without verification documents.',
          missingDocsEmpty: 'No pending companies without documents found.',
          openCompany: 'Open company',
          searchPlaceholder: 'Search by company, filename or request',
          purposeHeader: 'Purpose',
          categoryHeader: 'Category',
          reviewHeader: 'Review status',
          followUpHeader: 'Follow-up',
          requestHeader: 'Request',
          purposeChat: 'Chat attachment',
          reviewPending: 'Under review',
          reviewVerified: 'Verified',
          reviewRejected: 'Rejected',
          reviewAvailable: 'Available',
          focusTitle: 'Focused from verification queue',
          focusDescription: 'The relevant document slots for this case are highlighted.',
          focusBadge: 'Focused',
          slotHistoryTitle: 'History by document slot',
          lastDecisionLabel: 'Last decision',
          lastReviewedAtLabel: 'Last reviewed',
          noReviewHistory: 'No documented review yet.',
          reviewApproveTitle: 'Approve documents',
          reviewRejectTitle: 'Reject documents',
          reviewDialogDesc: 'Store a review note for {{company}}.',
          reviewApproveNoteLabel: 'Review note (optional)',
          reviewRejectNoteLabel: 'Rejection reason',
          reviewApproveNotePlaceholder: 'Optional note for the approval',
          reviewRejectNotePlaceholder: 'Record why the documents are rejected',
          reviewNoteRequired: 'Please enter a rejection reason.',
          adminNoteLabel: 'Internal admin note',
          adminNotePlaceholder: 'Store an internal note for the verification process',
          followUpLabel: 'Follow-up',
          followUpAtValue: 'Follow-up: {{date}}',
          followUpDueAtValue: 'Due: {{date}}',
          followUpOverdueAtValue: 'Overdue since {{date}}',
          followUpScheduledAtValue: 'Scheduled: {{date}}',
          noFollowUp: 'No follow-up',
          followUpNoFile: 'No document in this slot',
          saveSlotMetadata: 'Save note',
          followUpSavedTitle: 'Follow-up saved',
          followUpSavedDesc: 'Internal note and follow-up were updated.',
          followUpSaveError: 'Internal note or follow-up could not be saved.',
          communication: {
            label: 'Company follow-up',
            placeholder: 'Write a clarification message for the company',
            sendAction: 'Send follow-up',
            sentTitle: 'Follow-up sent',
            sentDesc: 'The company has been informed about the missing or outdated document.',
            sentError: 'The follow-up could not be sent.',
            messageRequired: 'Please enter a message first.',
            templates: {
              document_missing: {
                label: 'Request document',
                message:
                  'Please provide the document "{{document}}" for your company verification.',
              },
              replacement_required: {
                label: 'Request replacement',
                message:
                  'Please upload an updated replacement document for "{{document}}" so we can continue the review.',
              },
              status_follow_up: {
                label: 'Status follow-up',
                message:
                  'Please confirm the current status for "{{document}}" or let us know when you will upload it.',
              },
            },
          },
          typeAll: 'All document types',
          ageAll: 'All ages',
          followUpFilterAll: 'All follow-ups',
          followUpFilterAction: 'Due now',
          followUpFilterOverdue: 'Overdue',
          followUpFilterScheduled: 'Scheduled',
          followUpFilterNone: 'No follow-up',
          ageFreshFilter: '0-2 days',
          ageAgingFilter: '3-6 days',
          ageStaleFilter: '7+ days',
          ageFresh_one: '{{count}} day open',
          ageFresh_other: '{{count}} days open',
          ageAging_one: '{{count}} day open',
          ageAging_other: '{{count}} days open',
          ageStale_one: '{{count}} day overdue',
          ageStale_other: '{{count}} days overdue',
          categoryPdf: 'PDF',
          categoryImage: 'Image',
          categoryDocument: 'Document',
          categoryOther: 'Other',
          empty: 'No documents found for this filter.',
          deletedTitle: 'Document deleted',
          deletedDesc: 'The document was removed.',
          deleteError: 'The document could not be deleted.',
          downloadError: 'The document could not be downloaded.',
          deleteConfirm: 'Delete document {{name}}?',
        },
        workspace: {
          overviewTab: 'Overview',
          healthTab: 'Monitoring',
          operationsTab: 'Operations',
          reportsTab: 'Reports',
          schedulesTab: 'Schedules',
          errorsTab: 'Error Log',
          companyTiersTab: 'Company tier',
          errorWatchTab: 'Error watch',
          documentsTab: 'Documents',
          auditTab: 'Audit',
          configTab: 'Configuration',
          pendingCompaniesTitle: 'Pending company reviews',
          pendingCompaniesDesc: 'Companies waiting for verification.',
          rematchQueueTitle: 'Open rematches',
          rematchQueueDesc: 'Requests that still have open assignment slots.',
          cancellationQueueTitle: 'Open cancellations',
          cancellationQueueDesc: 'Company cancellation requests waiting for review.',
          billingQueueTitle: 'Open invoices',
          billingQueueDesc: 'Draft or sent invoices not completed yet.',
          blockedCompaniesTitle: 'Blocked companies',
          blockedCompaniesDesc: 'Companies currently blocked from receiving new assignments.',
          operationsTitle: 'Operations',
          operationsDesc: 'Manage users, companies, requests and operational interventions.',
          billingSummary: '{{invoices}} invoices and {{payments}} payments in the system.',
          openBilling: 'Open billing',
          configTitle: 'Configuration',
          configDesc: 'Bundle system rules, blacklist and administrative controls.',
          blacklistSummary: '{{count}} active blacklist entries in the system.',
          quickActionsTitle: 'Quick actions',
          quickActionsDesc: 'Direct administrative actions and creation flows.',
          systemOverviewTitle: 'System overview',
          systemOverviewDesc: 'Core metrics for users, companies and governance.',
          requestStatusTitle: 'Request status',
          requestStatusDesc: 'Distribution of current customer requests in the system.',
          systemConfigTitle: 'Pricing defaults',
          systemConfigDesc: 'Active pricing and default offer counts for product tiers.',
          pricingConfigTitle: 'Pricing and offer configuration',
          pricingConfigDesc: 'Currently configured prices and default requested offer counts.',
          defaultOffersLabel: 'Default offers',
          featureFlagsTitle: 'Feature configuration',
          featureFlagsDesc: 'Global features and system limits from admin config.',
          maxCompaniesPerRequest: 'Maximum companies per request',
          requestExpirationDays: 'Request expiration period (days)',
          premiumCustomerTitle: 'Premium for customer requests',
          premiumCustomerDesc:
            'Controls whether customers can book Premium and Premium+ in the request form.',
          premiumCustomerPremiumLabel: 'Enable Premium for customers',
          premiumCustomerPremiumPlusLabel: 'Enable Premium+ for customers',
          premiumCompanyTitle: 'Premium for company users',
          premiumCompanyDesc:
            'Controls whether company users can switch their request tier to Premium or Premium+.',
          premiumCompanyPremiumLabel: 'Enable Premium for company users',
          premiumCompanyPremiumPlusLabel: 'Enable Premium+ for company users',
          enabled: 'Enabled',
          disabled: 'Disabled',
          savePricingAction: 'Save pricing',
          saveFeaturesAction: 'Save features',
          configSavedTitle: 'Configuration saved',
          pricingSavedDesc: 'Prices and default offers were updated.',
          featuresSavedDesc: 'Feature configuration was updated.',
          configSaveError: 'Configuration could not be saved.',
          configValidationError: 'Please enter only valid non-negative numbers.',
          legalStatusDesc: 'Status of the published content.',
          published: 'Published',
          missing: 'Missing',
          legalChars: '{{count}} characters stored',
          businessMetricsTitle: 'Business metrics',
          businessMetricsDesc: 'Condensed KPIs for revenue, activity, completion and billing.',
          businessMetricsPeriod: 'Last {{days}} days',
          paidRevenueTitle: 'Paid revenue',
          paidRevenueDesc: 'Captured payments in the selected period.',
          paidRevenueMeta: '{{count}} paid payments',
          activeCompaniesTitle: 'Active companies',
          activeCompaniesDesc: 'Companies with assignments or payments in the period.',
          activeCompaniesMeta: '{{assignments}} assignments, {{payments}} payments',
          completionRateTitle: 'Completion rate',
          completionRateDesc: 'Completed requests relative to newly created requests.',
          completionRateMeta: '{{completed}} of {{total}} requests completed',
          collectionRateTitle: 'Collection rate',
          collectionRateDesc: 'Paid invoices relative to newly created invoices.',
          collectionRateMeta: '{{paid}} of {{total}} invoices paid',
          reportsPaidVolumeTitle: 'Paid volume',
          reportsVerifiedRatioTitle: 'Verified companies',
          reportsAvgOffersTitle: 'Avg desired offers',
          reportsOpenInvoicesTitle: 'Open invoices',
          companyPerformanceTitle: 'Company performance',
          companyPerformanceDesc: 'Acceptance and paid volume per company.',
          requestDemandTitle: 'Demand by request type',
          requestDemandDesc: 'Distribution and open load by request type.',
          invoiceAgingTitle: 'Invoice status',
          invoiceAgingDesc: 'Status distribution and amounts across all invoices.',
          exportCsv: 'CSV export',
          exportError: 'The report could not be exported.',
          reportFilterTitle: 'Date range',
          reportFilterDesc: 'Filters all reports and CSV exports by creation date.',
          range30d: '30 days',
          range90d: '90 days',
          rangeAll: 'All time',
          rangeCustom: 'Custom',
          startDate: 'Start date',
          endDate: 'End date',
        },
        businessKpi: {
          title: 'Business KPIs',
          desc: 'Conversion rates, SLA times, notification delivery, and health indicators over time.',
          periodLabel: 'Period',
          trendsLabel: 'Show trends',
          trendsEnabled: 'Daily trends on',
          trendsDisabled: 'Daily trends off',
          period7d: '7 days',
          period30d: '30 days',
          period90d: '90 days',
          period180d: '180 days',
          conversionTitle: 'Conversion',
          conversionDesc: 'From request through to paid assignment.',
          slaTitle: 'SLA times',
          slaDesc: 'Median and 90th percentile in hours.',
          deliveryTitle: 'Notification delivery',
          deliveryDesc: 'Delivery, retry and dead-letter rates.',
          healthTitle: 'Health indicators',
          healthDesc: 'Stuck requests and inactive companies.',
          revenueTitle: 'Revenue in period',
          revenueDesc: 'Sum of paid assignments.',
          revenueMeta: '{{count}} paid assignments',
          trendsTitle: 'Daily trends',
          trendsDesc: 'Requests, payments and notifications per day.',
          rateRequestToAssignment: 'Request → assignment',
          rateAssignmentToAccepted: 'Assignment → accepted',
          rateAcceptedToPaid: 'Accepted → paid',
          slaRequestToFirstAssignment: 'Request → first assignment',
          slaRequestToFirstResponse: 'Request → first response',
          slaAssignmentToPaid: 'Assignment → paid',
          slaMedian: 'Median {{value}}h',
          slaP90: 'P90 {{value}}h',
          slaSampleEmpty: 'No data in range',
          deliverySent: 'Sent',
          deliveryFailed: 'Failed',
          deliveryRetry: 'Retrying',
          deliveryDead: 'Dead',
          deliveryRate: 'Delivery rate',
          retryRate: 'Retry rate',
          deadRate: 'Dead rate',
          healthStuck: 'Stuck requests',
          healthStuckDesc: 'Status pending/matched for >{{days}} days.',
          healthInactive: 'Inactive companies',
          healthInactiveDesc: 'No activity in the last {{days}} days.',
          trendsRequests: 'Requests',
          trendsCompleted: 'Of which completed',
          trendsPayments: 'Payments',
          trendsNotifications: 'Notifications',
          reload: 'Reload KPIs',
          loadError: 'KPIs could not be loaded.',
          generatedAt: 'Generated: {{date}}',
          empty: 'No data in this period.',
        },
        domainEvents: {
          title: 'Domain events',
          desc: 'Full audit stream of all domain changes with filtering and detail view.',
          filterTitle: 'Filters',
          filterDesc: 'Narrow by entity type, action, actor or time range.',
          filterEntityType: 'Entity type',
          filterEntityTypePlaceholder: 'e.g. request, payment, invoice',
          filterEntityId: 'Entity ID',
          filterEntityIdPlaceholder: 'Optional UUID',
          filterAction: 'Action',
          filterActionPlaceholder: 'e.g. request.created',
          filterActorUserId: 'Actor user ID',
          filterActorUserIdPlaceholder: 'Optional UUID',
          filterFromDate: 'From',
          filterToDate: 'To',
          applyFilters: 'Apply filters',
          resetFilters: 'Reset filters',
          totalEvents: 'events',
          byEntityType: 'By entity type',
          byAction: 'By action',
          listTitle: 'Event list',
          listEmpty: 'No domain events in the selected range.',
          loadError: 'Domain events could not be loaded.',
          paginationPrev: 'Previous',
          paginationNext: 'Next',
          pageInfo: 'Page {{page}} of {{totalPages}} ({{total}} hits)',
          detailTitle: 'Detail',
          detailMetadata: 'Metadata',
          detailMetadataEmpty: 'No metadata',
          detailPreviousState: 'Previous state',
          detailResultingState: 'New state',
          detailActor: 'Actor',
          detailActorSystem: 'System',
          detailEntity: 'Entity',
          detailCreatedAt: 'Timestamp',
          entityTypes: {
            request: 'Request',
            company_request: 'Company assignment',
            payment: 'Payment',
            review: 'Review',
            company: 'Company',
            document: 'Document',
            other: 'Other',
          },
          actions: {
            'request.created': 'Request created',
            'request.cancelled': 'Request cancelled',
            'request.completed': 'Request completed',
            'request.needs_matches': 'Request needs matches',
            'company_request.accepted': 'Assignment accepted',
            'company_request.declined': 'Assignment declined',
            'company_request.cancellation_pending': 'Cancellation review pending',
            'payment.created': 'Payment created',
            'payment.paid': 'Payment paid',
            'payment.refunded': 'Payment refunded',
            'payment.missing_billing': 'Missing billing data',
            'payment.missing_invoice': 'Missing invoice',
            'invoice.draft_stale': 'Draft invoice stale',
            'invoice.overdue': 'Invoice overdue',
            'invoice.paid': 'Invoice paid',
            'document.pending_review': 'Document pending review',
            'document.missing_verification': 'Missing verification document',
            'document.rejected_verification': 'Verification rejected',
            'verification.follow_up_due': 'Verification follow-up due',
            'company.service_area_missing': 'Service area missing',
            'company.availability_missing': 'Availability missing',
            other: 'Other action',
          },
        },
        notificationHealth: {
          title: 'Notification health',
          desc: 'Live status of the notification pipeline: delivery rates, retries and stuck logs with reset actions.',
          statsTitle: 'Live status',
          totalLogs: 'Total logs',
          dueNow: 'Due now',
          filterTitle: 'Filters',
          statusLabel: 'Status',
          eventTypeLabel: 'Event type',
          eventTypePlaceholder: 'e.g. request.created',
          recipientTypeLabel: 'Recipient type',
          fromDateLabel: 'From',
          toDateLabel: 'To',
          applyFilters: 'Apply filters',
          resetFilters: 'Reset filters',
          listTitle: 'Logs',
          listEmpty: 'No notification logs in the selected filter.',
          loadError: 'Notification health could not be loaded.',
          actionsTitle: 'Actions',
          actionProcessTitle: 'Process retries now',
          actionProcessDesc: 'Manual trigger of the retry scheduler (max 500).',
          actionProcessButton: 'Process',
          actionResetTitle: 'Reset to retry',
          actionResetDesc: 'Sets status=retry, attempts=0, nextRetryAt=now.',
          actionResetButton: 'Reset',
          actionMarkDeadTitle: 'Mark as dead',
          actionMarkDeadDesc: 'Manually marks the log as permanently failed.',
          actionMarkDeadButton: 'Dead',
          actionConfirmReset: 'Reset this log to "retry"?',
          actionConfirmDead: 'Mark this log as "dead"?',
          paginationPrev: 'Previous',
          paginationNext: 'Next',
          pageInfo: 'Page {{page}} of {{totalPages}} ({{total}} hits)',
          resultProcessed: '{{processed}} processed, {{succeeded}} succeeded',
          resultFailed: '{{failed}} failed',
          resultDead: '{{dead}} dead',
          columnStatus: 'Status',
          columnEvent: 'Event',
          columnRecipient: 'Recipient',
          columnSubject: 'Subject',
          columnAttempts: 'Attempts',
          columnLastError: 'Last error',
          columnNextRetry: 'Next retry',
          columnCreatedAt: 'Created',
          columnActions: 'Actions',
          detailTitle: 'Details',
          detailChannel: 'Channel',
          detailBody: 'Body',
          detailEntityId: 'Entity ID',
          eventTypeDistribution: 'Event type distribution',
          attemptsLabel: '{{count}}x attempts',
          statuses: {
            sent: 'Sent',
            failed: 'Failed',
            retry: 'Retrying',
            dead: 'Dead',
          },
        },
        schedules: {
          title: 'Report schedules',
          description: 'Centralised management of automated report runs (daily, weekly, monthly).',
          newSchedule: 'New schedule',
          save: 'Save',
          saving: 'Saving...',
          cancel: 'Cancel',
          reportType: 'Report type',
          cadence: 'Cadence',
          cadenceOptions: {
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
          },
          weekday: 'Weekday (UTC)',
          weekdayShort: 'Day',
          dayOfMonth: 'Day of month',
          dayShort: 'Day',
          hourUtc: 'Hour (UTC)',
          minuteUtc: 'Minute (UTC)',
          recipients: 'Recipients (comma-separated)',
          recipientsHint: 'One or more email addresses, comma-separated.',
          recipientsPlaceholder: 'ops@example.com, lead@example.com',
          noRecipients: 'No recipients configured',
          lastRun: 'Last run',
          nextRun: 'Next run',
          never: 'Never',
          disabled: 'Disabled',
          enable: 'Enable',
          disable: 'Disable',
          delete: 'Delete',
          loading: 'Loading schedules...',
          empty: 'No report schedules configured yet.',
          loadError: 'Could not load schedules.',
          validationErrorTitle: 'Validation failed',
          validationRecipients: 'At least one recipient is required.',
          createdTitle: 'Schedule created',
          createdDescription: 'The new schedule is active.',
          createError: 'Could not create the schedule.',
          toggleError: 'Could not toggle the schedule.',
          deletedTitle: 'Schedule deleted',
          deletedDescription: '{{label}} has been removed.',
          deleteError: 'Could not delete the schedule.',
        },
        errorLog: {
          title: 'Error log',
          description:
            'Centralised view of frontend and backend errors. Filter, resolve, export-ready.',
          loading: 'Loading error logs...',
          empty: 'No errors in the selected window.',
          loadError: 'Could not load error logs.',
          filterSource: 'Source',
          filterSeverity: 'Severity',
          filterResolved: 'Status',
          filterSearch: 'Search (message or path)',
          filterAllSources: 'All sources',
          sourceFrontend: 'Frontend',
          sourceBackend: 'Backend',
          filterAllSeverities: 'All severities',
          filterUnresolved: 'Unresolved',
          filterAll: 'All',
          sinceHours: 'Time window (hours)',
          since24h: '24h',
          since7d: '7 days',
          since30d: '30 days',
          statsTotal: 'Total entries',
          statsUnresolved: 'Unresolved',
          statsBySeverity: 'By severity',
          statsBySource: 'By source',
          statsTopCategories: 'Top categories',
          columnSeverity: 'Severity',
          columnCategory: 'Category',
          columnSource: 'Source',
          columnCount: 'Count',
          columnMessage: 'Message',
          columnLastSeen: 'Last seen',
          columnPath: 'Path',
          columnActions: 'Actions',
          resolveAction: 'Mark as resolved',
          reopenAction: 'Re-open',
          deleteAction: 'Delete',
          notesLabel: 'Notes (optional)',
          notesPlaceholder: 'What was done?',
          resolveSuccessTitle: 'Error marked as resolved',
          reopenSuccessTitle: 'Error re-opened',
          deleteSuccessTitle: 'Error deleted',
          deleteConfirm: 'Really delete this entry?',
          detailTitle: 'Details',
          detailStack: 'Stacktrace',
          detailContext: 'Context',
          detailFirstSeen: 'First seen',
          detailResolvedBy: 'Resolved by',
          detailNotes: 'Notes',
          noStack: 'No stacktrace available',
          noContext: 'No context available',
          refreshAction: 'Refresh',
          paginationPrev: 'Previous',
          paginationNext: 'Next',
          pageInfo: 'Page {{page}} of {{totalPages}} ({{total}} matches)',
          loadDetailError: 'Could not load error details.',
          resolveError: 'Could not mark error as resolved.',
          reopenError: 'Could not re-open error.',
          deleteError: 'Could not delete error.',
        },
        companyTiers: {
          title: 'Company tier auto-adjustment',
          description:
            'Performance score per company computed from acceptance rate, response time, reviews, and verification. Auto-adjustment can write new tier recommendations into CompanyPriceTierSetting.',
          loading: 'Loading tier configuration...',
          configTitle: 'Thresholds',
          configSaved: 'Tier configuration saved.',
          configSaveError: 'Could not save tier configuration.',
          enabledLabel: 'Auto-adjustment enabled',
          runIntervalLabel: 'Interval (hours)',
          minReviewsLabel: 'Min. reviews for Premium+',
          minAcceptRateLabel: 'Min. acceptance rate for Premium (%)',
          minAcceptRatePremiumPlusLabel: 'Min. acceptance rate for Premium+ (%)',
          maxResponseMinutesLabel: 'Max. response time for Premium+ (min)',
          minAcceptedLeadsLabel: 'Min. accepted leads 30d for Premium+',
          saveButton: 'Save configuration',
          candidatesTitle: 'Tier recommendations',
          candidatesDescription: 'Current tier vs. recommended adjustment. Highest score first.',
          refreshButton: 'Reload candidates',
          runDryRunLabel: 'Dry run (no changes)',
          runButton: 'Run auto-adjustment now',
          runResultLabel: 'Last run',
          scannedLabel: 'Scanned',
          updatedLabel: 'Updated',
          skippedLabel: 'Skipped',
          changingLabel: 'Suggested changes',
          scoreLabel: 'Score',
          currentTierLabel: 'Current tier',
          recommendedTierLabel: 'Recommendation',
          reasonLabel: 'Reasoning',
          verifiedLabel: 'Verified',
          acceptRateLabel: 'Acceptance rate',
          responseTimeLabel: 'Response time',
          reviewsLabel: 'Reviews',
          ratingLabel: 'Rating',
          runError: 'Could not run auto-adjustment.',
          loadCandidatesError: 'Could not load tier recommendations.',
          overrideTitle: 'Manual tier override',
          overrideReasonLabel: 'Reason',
          overrideReasonPlaceholder: 'e.g. promo 2024',
          overrideButton: 'Set tier',
          overrideError: 'Could not set tier.',
          tierLabels: {
            standard: 'Standard',
            premium: 'Premium',
            premium_plus: 'Premium+',
          },
          actionsTitle: 'Manual override',
          actionsDescription:
            'Set a company tier directly. A new CompanyPriceTierSetting entry with effective_from = today will be created.',
          companyIdLabel: 'Company ID',
          companyIdPlaceholder: 'e.g. comp-uuid-...',
        },
        errorWatch: {
          title: 'Error watch service',
          description:
            'Detects signature spikes in the last N minutes, records domain events, and notifies admins.',
          loading: 'Loading watch configuration...',
          configTitle: 'Thresholds',
          configSaved: 'Watch configuration saved.',
          configSaveError: 'Could not save watch configuration.',
          enabledLabel: 'Watch enabled',
          windowMinutesLabel: 'Window (minutes)',
          thresholdCountLabel: 'Min. count per signature',
          minDistinctUsersLabel: 'Min. distinct users',
          criticalOnlyLabel: 'CRITICAL severities only',
          runIntervalMinutesLabel: 'Interval (minutes)',
          saveButton: 'Save configuration',
          scanTitle: 'Spike scan',
          scanButton: 'Run scan now',
          scanResultLabel: 'Scan result',
          scannedLabel: 'Scanned',
          spikesDetectedLabel: 'Spikes detected',
          domainEventsLabel: 'Domain events',
          notificationsLabel: 'Admin notifications',
          noSpikesLabel: 'No spikes detected.',
          refreshButton: 'Refresh',
          scanError: 'Scan could not be executed.',
          loadError: 'Watch configuration could not be loaded.',
          actionLabels: {
            open_p1_incident: 'Open P1 incident',
            investigate_blast_radius: 'Investigate blast radius',
            add_unit_test: 'Add unit test',
          },
        },
        backup: {
          title: 'Backup workspace',
          description:
            'Status of the daily database backups, including the list of stored snapshots and the off-site sync.',
          loading: 'Loading backup status...',
          loadError: 'Could not load backup status.',
          unavailable: 'The backup endpoint is unreachable.',
          retry: 'Retry',
          refreshButton: 'Refresh',
          triggerButton: 'Trigger backup',
          triggerAcceptedTitle: 'Backup trigger accepted',
          triggerError: 'Could not trigger a backup.',
          unknownWarning: 'Backup status could not be determined.',
          lastBackupLabel: 'Last backup',
          ageLabel: 'Age',
          status: {
            healthy: 'Healthy',
            warning: 'Warning',
            critical: 'Critical',
            unknown: 'Unknown',
          },
          localCount: 'Local backups',
          localCountHint: 'Number of stored snapshot files',
          offsiteTitle: 'Off-site sync',
          offsiteConfigured: 'Configured',
          offsiteMissing: 'Not configured',
          offsiteCount: 'Off-site count',
          checkedAtTitle: 'Last check',
          filesTitle: 'Backup files',
          filesDescription: 'List of local backup files (newest first).',
          filesEmpty: 'No backup files are currently available.',
          columnName: 'File',
          columnSize: 'Size',
          columnAge: 'Age',
          columnModified: 'Modified',
        },
        pricing: {
          title: 'Pricing configuration',
          description:
            'Commission matrix per request type with modifier system. Live preview for standard scenarios.',
          loading: 'Loading pricing configuration...',
          loadError: 'Could not load pricing configuration.',
          saveSuccessTitle: 'Configuration saved',
          saveError: 'Could not save configuration.',
          matrixTitle: 'Commission matrix (base commission per request type)',
          modifierTitle: 'Modifier system',
          defaultsTitle: 'Defaults',
          previewTitle: 'Live preview',
          previewDescription:
            'Calculates the effective commission for a scenario. Changes only apply after "Save".',
          columnRequestType: 'Request type',
          columnBaseRate: 'Base %',
          columnAdjustment: 'Adjustment %',
          columnEnabled: 'Enabled',
          columnAction: 'Action',
          defaultsCommission: 'Default commission rate (%)',
          defaultsMultiplier: 'Fixed-price multiplier',
          defaultsMinContract: 'Min. contract value (EUR)',
          modifiers: {
            urgent: { label: 'Urgent (< 7 days)', description: 'Short-notice request' },
            weekend: { label: 'Weekend', description: 'Move on Sat/Sun' },
            longDistance: { label: 'Long distance', description: '> 200 km' },
            packingService: { label: 'Packing service', description: 'Add-on' },
          },
          requestTypes: {
            private: 'Private move',
            business: 'Business move',
            long_distance: 'Long distance (DE)',
            international: 'International move',
            special: 'Special transport',
            official_relocation: 'Official relocation',
            authority_relocation: 'Authority relocation',
            assisted_move: 'Assisted move',
          },
          previewInput: {
            requestType: 'Request type',
            baseAmount: 'Base amount (EUR)',
            modifiers: 'Applicable modifiers',
          },
          previewModifierEmpty: 'No modifiers selected',
          previewResult: 'Effective commission: {{percent}}% ({{amount}} EUR)',
          // P2.068 — hardcoded aria-label in PricingConfigWorkspace.tsx (toggle {{key}})
          toggleEntryAria: 'Toggle {{key}}',
        },
        packingTiers: {
          title: 'Packing tiers (cross-sell)',
          description:
            'Configurable prices for the three packing bundles (Basic/Standard/Premium). A/B testing supports 50/50 split comparisons.',
          loading: 'Loading tier configuration...',
          loadError: 'Could not load tier configuration.',
          saveSuccessTitle: 'Tier configuration saved',
          saveError: 'Could not save tier configuration.',
          tierSection: 'Tier bundles',
          abTestSection: 'A/B test',
          columnTier: 'Tier',
          columnPrice: 'Price (EUR)',
          columnFeatures: 'Features',
          columnDescription: 'Description',
          columnEnabled: 'Enabled',
          featureInputLabel: 'Feature (Enter to add)',
          featureAddAction: 'Add',
          featureRemoveAction: 'Remove',
          abTestEnabled: 'A/B test enabled',
          abTestVariantPercent: 'Variant share (%)',
          abTestVariantTier: 'Variant tier',
          abTestResolveSaltLabel: 'Test salt',
          abTestResolveCustomerLabel: 'Customer ID',
          abTestResolveAction: 'Resolve tier',
          abTestResolveResult: 'Resolved: {{tier}} ({{variant}})',
          // P2.068 — hardcoded aria-label in PackingTierWorkspace.tsx (toggle {{id}})
          toggleTierAria: 'Toggle tier {{id}}',
          // P2.OPT118 — hardcoded English string in PackingTierWorkspace.tsx
          totalPotential: 'Total potential (enabled tiers): {{amount}} EUR',
          tiers: {
            basic: { name: 'Basic', description: 'Simple pack set for small moves.' },
            standard: {
              name: 'Standard',
              description: 'Solid standard pack for most moves.',
            },
            premium: {
              name: 'Premium',
              description: 'Pro pack incl. disassembly for large logistics.',
            },
          },
        },
        reminders: {
          title: 'Dunning',
          description:
            'Automatic reminder stages based on days past due. Manual actions per invoice available.',
          loading: 'Loading dunning candidates...',
          empty: 'No overdue invoices in the selected window.',
          loadError: 'Could not load dunning candidates.',
          sinceDays: 'Minimum days overdue',
          sinceDays7: 'from 7 days',
          sinceDays14: 'from 14 days',
          sinceDays22: 'from 22 days',
          refreshAction: 'Refresh',
          runScanAction: 'Run full scan',
          scanStarted: 'Scan started',
          scanResult: '{{sent}} sent, {{skipped}} skipped',
          scanError: 'Scan failed',
          sendAction: 'Send reminder',
          sendSuccess: 'Reminder sent ({{stage}})',
          sendError: 'Could not send reminder',
          columnInvoice: 'Invoice',
          columnCompany: 'Company',
          columnAmount: 'Amount',
          columnDueDate: 'Due date',
          columnDaysOverdue: 'Days overdue',
          columnStage: 'Stage',
          columnContact: 'Contact',
          columnActions: 'Actions',
          stageReminder1: '1st reminder',
          stageReminder2: '2nd reminder',
          stageFinalNotice: 'Final notice',
          statusSent: 'sent',
          statusSkipped: 'skipped',
          skippedNoEmail: 'No email address',
          skippedNotFound: 'Invoice not found',
          skippedAlreadyRefunded: 'Already refunded',
          skippedNoDueDate: 'No due date',
          skippedNotOverdue: 'Not yet overdue',
        },
        refund: {
          title: 'Refund payment',
          description:
            'Issue a Stripe or PayPal refund. Manual payments are only cancelled locally.',
          action: 'Refund',
          actionTitle: 'Refund payment',
          reasonLabel: 'Reason (optional)',
          reasonPlaceholder: 'e.g. customer request, cancellation',
          successTitle: 'Refund succeeded',
          successDescription: '{{provider}} refund ID: {{refundId}}',
          manualSuccess: 'Manual payment cancelled locally.',
          alreadyRefunded: 'Payment is already refunded.',
          notFound: 'Payment not found.',
          providerFailed: 'Provider error during refund: {{message}}',
          errorTitle: 'Refund failed',
        },
        funnel: {
          title: 'Conversion funnel',
          description:
            'Stage-by-stage conversion from request creation to payment. Bottlenecks visible in real time.',
          loading: 'Loading funnel data...',
          loadError: 'Could not load funnel data.',
          refreshAction: 'Refresh',
          since7d: '7 days',
          since30d: '30 days',
          since90d: '90 days',
          stepLabel: 'Stage',
          countLabel: 'Count',
          conversionFromPrevious: 'vs. previous stage',
          conversionFromFirst: 'vs. requests',
          totalUnique: 'Unique entities',
          windowLabel: 'Window: {{since}} - {{until}}',
          dropOffBadge: 'Top drop-off',
          dropOffDelta: '{{delta}}% loss vs. previous stage',
          stepLabels: {
            'request.created': 'Request created',
            'request.matched': 'Request matched',
            'company_request.dispatched': 'Dispatched to companies',
            'company_request.accepted': 'Company accepted',
            'company_request.booked': 'Booking confirmed',
            'payment.initiated': 'Payment initiated',
            'payment.paid': 'Payment received',
            'company_request.declined': 'Company declined',
            'payment.refunded': 'Payment refunded',
          },
          noData: 'No funnel data in the selected window.',
          // P2.068 — hardcoded aria-label in FunnelLiveWidget.tsx ({{label}}: {{count}})
          // label is already a localized step name; we add a key to keep
          // the format consistent and translatable for non-DE/EN languages.
          stepBarAria: '{{label}}: {{count}}',
        },
        analyticsDeep: {
          title: 'Analytics deep dive',
          description:
            'Cohort retention, attribution models and revenue time-series for deeper insight.',
          loading: 'Loading analytics data...',
          loadError: 'Could not load analytics data.',
          retryAction: 'Retry',
          dateRangeLabel: 'Date range',
          last7d: 'Last 7 days',
          last30d: 'Last 30 days',
          last90d: 'Last 90 days',
          customRange: 'Custom range',
          startDate: 'Start date',
          endDate: 'End date',
          intervalDays: 'Interval',
          intervalDay: 'Daily',
          intervalWeek: 'Weekly',
          intervalMonth: 'Monthly',
          intervalAuto: 'Default',
          cohort: {
            title: 'Cohort retention',
            description:
              'Retention percentage per cohort month. Rows are cohorts, columns are intervals after request creation.',
            cohortColumn: 'Cohort',
            sizeColumn: 'Size',
            retentionColumns: 'Retention per interval',
            empty: 'No cohort data for the selected window.',
          },
          attribution: {
            title: 'Attribution',
            description: 'Conversion credit split per model (last-touch, first-touch, linear).',
            modelLabel: 'Model',
            modelLastTouch: 'Last-touch',
            modelFirstTouch: 'First-touch',
            modelLinear: 'Linear',
            channelColumn: 'Channel',
            creditColumn: 'Credit',
            requestsColumn: 'Requests',
            touchesColumn: 'Touches',
            totalLabel: 'Total requests: {{count}}',
            totalTouchesLabel: 'Total touches: {{count}}',
            note: 'Note: {{note}}',
            empty: 'No touchpoint data available.',
          },
          revenue: {
            title: 'Revenue time-series',
            description: 'Paid payments and invoices aggregated by day, week or month.',
            groupByLabel: 'Granularity',
            groupByDay: 'Daily',
            groupByWeek: 'Weekly',
            groupByMonth: 'Monthly',
            bucketColumn: 'Bucket',
            amountColumn: 'Amount (EUR)',
            countColumn: 'Count',
            totalLabel: 'Total: EUR {{amount}} ({{count}} payments)',
            empty: 'No revenue data for the selected window.',
            // OPT373 — hardcoded English tooltip label in RevenueTimeSeries.tsx
            amountLabel: 'Amount',
            // OPT460 — hardcoded English Button label ('Bar'/'Line') in chart-type toggle
            chartTypeLine: 'Line',
            chartTypeBar: 'Bar',
          },
        },
        emailOpen: {
          title: 'Email open tracking',
          description:
            '1x1 pixel tracking for sent emails. Shows open rate per template and per notification log.',
          loading: 'Loading open stats...',
          loadError: 'Could not load open stats.',
          retryAction: 'Retry',
          dateRangeLabel: 'Date range',
          last7d: 'Last 7 days',
          last30d: 'Last 30 days',
          last90d: 'Last 90 days',
          customRange: 'Apply',
          startDate: 'Start date',
          endDate: 'End date',
          templateLabel: 'Template',
          templateAll: 'All templates',
          kpiSent: 'Sent',
          kpiOpens: 'Opens',
          kpiUnique: 'Unique opens',
          kpiOpenRate: 'Open rate',
          templateTableTitle: 'Open rate per template',
          recentTitle: 'Recent sent emails',
          empty: 'No data for the selected window.',
          tableTemplate: 'Template',
          tableSent: 'Sent',
          tableOpens: 'Opens',
          tableRate: 'Rate',
          tableUnique: 'Unique',
          tableLastOpen: 'Last open',
          tableSubject: 'Subject',
        },
        pilotBerlin: {
          title: 'Pilot Berlin stats',
          description:
            'Centralised KPI dashboard for the Berlin pilot: requests, matches, revenue, growth, and comparison with the rest of Germany.',
          dateRangeLabel: 'Date range',
          last7d: '7 days',
          last30d: '30 days',
          last90d: '90 days',
          last180d: '180 days',
          customRange: 'Apply',
          startDate: 'Start date',
          endDate: 'End date',
          loading: 'Loading pilot Berlin data...',
          loadError: 'Could not load pilot Berlin data.',
          retryAction: 'Retry',
          kpi: {
            totalRequests: 'Berlin requests',
            totalCompanies: 'Registered companies',
            conversionRate: 'Conversion rate',
            avgMatchTime: 'Avg. match time',
            totalRevenue: 'Revenue (EUR)',
            customerSatisfaction: 'Customer satisfaction',
            monthlyGrowth: 'Month-over-month growth',
            activeCustomers: 'Active customers / companies',
            activeCustomersSubtitle: 'Last 30 days',
          },
          monthlyRevenue: {
            title: 'Monthly revenue (last 12 months)',
            description:
              'Aggregated revenue from CompanyRequestPayments in the selected window, distributed across monthly buckets.',
            amountLabel: 'Revenue (EUR)',
            empty: 'No revenue data for the selected window.',
          },
          topBranches: {
            title: 'Top service branches',
            description:
              'Special services (special_services) of registered Berlin companies. n companies per category.',
            empty: 'No branch data available.',
          },
          topCompanies: {
            title: 'Top Berlin companies',
            description:
              'Top {{limit}} Berlin companies sorted by paid revenue DESC, secondary by matches.',
            columnRank: '#',
            columnName: 'Company',
            columnRevenue: 'Revenue (EUR)',
            columnMatches: 'Matches',
            columnRating: 'Rating',
            columnVerified: 'Status',
            verified: 'Verified',
            notVerified: 'Pending',
            empty: 'No Berlin companies with revenue in the selected window.',
          },
          comparison: {
            title: 'Berlin vs. rest of Germany',
            description:
              'Berlin share of total requests, revenue, and conversion delta based on the last 30 days.',
            shareLabel:
              'Berlin accounts for {{percent}} of all requests. See the pilot Berlin docs for scale-up criteria.',
            requestsShare: 'Request share',
            revenueShare: 'Revenue share',
            conversionDelta: 'Conversion delta (Berlin vs. rest)',
            empty: 'No comparison data available.',
          },
        },
        health: {
          title: 'System monitoring',
          desc: 'Live status for API, database, requests, realtime connections, and reported frontend errors.',
          lastUpdated: 'Updated: {{date}}',
          overallStatusTitle: 'System status',
          overallStatusDesc: 'Current overall backend state.',
          databaseTitle: 'Database',
          databaseDesc: 'Readiness state and baseline load.',
          databaseOk: 'Database ok',
          databaseError: 'Database degraded',
          avgRequestTitle: 'Avg request time',
          avgRequestDesc: 'Average latency across all observed requests.',
          activeSocketsTitle: 'Active sockets',
          activeSocketsDesc: 'Currently open realtime connections.',
          frontendErrorsTitle: 'Frontend errors',
          frontendErrorsDesc: 'Error events reported by the frontend.',
          processTitle: 'Process',
          processDesc: 'Node process, uptime, and memory footprint.',
          requestStatusTitle: 'HTTP status classes',
          requestStatusDesc: 'Distribution of observed responses.',
          topRoutesTitle: 'Top routes',
          topRoutesDesc: 'Most frequently observed normalized API routes.',
          durationBucketsTitle: 'Latency buckets',
          durationBucketsDesc: 'Observed requests grouped by duration class.',
          frontendBreakdownTitle: 'Frontend error sources',
          frontendBreakdownDesc: 'Breakdown by source and severity.',
          uptimeLabel: 'Uptime',
          uptimeValue: 'Uptime {{value}}',
          pidLabel: 'PID',
          nodeVersionLabel: 'Node version',
          memoryRssLabel: 'RSS memory',
          memoryHeapUsedLabel: 'Heap used',
          memoryHeapTotalLabel: 'Heap total',
          requestTotalMeta: '{{count}} requests observed',
          requestErrorsMeta: '{{errors4xx}}× 4xx • {{errors5xx}}× 5xx',
          totalSocketsMeta: '{{count}} total connections',
          frontendLastReported: 'Last reported: {{date}}',
          frontendNeverReported: 'No reported errors yet',
          statusOk: 'Ok',
          statusDegraded: 'Degraded',
          statusError: 'Error',
          methodColumn: 'Method',
          routeColumn: 'Route',
          countColumn: 'Count',
          statusColumn: 'Status',
          bucketColumn: 'Bucket',
          sourceColumn: 'Source',
          severityColumn: 'Severity',
          frontendSourceReportError: 'reportError hook',
          frontendSourceWindowError: 'window.onerror',
          frontendSourceUnhandledRejection: 'Unhandled rejection',
          frontendSourceErrorBoundary: 'Error boundary',
          empty: 'No monitoring data is available yet.',
        },
        compliance: {
          exportError: 'The compliance report could not be exported.',
          summary: {
            highRiskCompanies: 'High-risk companies',
            blockedCompanies: 'Blocked companies',
            overdueInvoices: 'Overdue invoices',
            auditEvents: 'Audit events',
          },
          verification: {
            title: 'Verification & SLA',
            description: 'Current state of pending reviews, missing evidence and follow-up items.',
            pendingCompanies: 'Companies under review',
            rejectedCompanies: 'Rejected companies',
            missingDocuments: 'Companies missing documents',
            pendingSlots: 'Document slots under review',
            stalePendingSlots: 'Stale pending slots',
            followUpsDue: 'Follow-ups due',
            followUpsOverdue: 'Overdue follow-ups',
            averagePendingAge: 'Avg pending age',
          },
          billing: {
            title: 'Billing & collections',
            description: 'Payment defaults, dunning stages and assignment-relevant billing risks.',
            openInvoices: 'Open invoices',
            overdueInvoices: 'Overdue invoices',
            finalNoticeInvoices: 'Final notices',
            blockedCompanies: 'Blocked companies',
            overdueAmount: 'Overdue amount',
          },
          blacklist: {
            activeEntries: 'Active blocks',
            companyEntries: 'Company blocks',
            userEntries: 'Customer blocks',
            expiringSoon: 'Expiring soon',
          },
          audit: {
            title: 'Audit & changes',
            description: 'Condensed view of sensitive changes for governance and evidence.',
            totalEvents: 'Total events',
            configChanges: 'Config changes',
            blacklistChanges: 'Blacklist changes',
            verificationActions: 'Verification actions',
            billingActions: 'Billing actions',
            storageActions: 'File actions',
            topActions: 'Top actions',
          },
          riskCompanies: {
            title: 'Flagged companies',
            description: 'Companies with elevated current compliance or operating risk.',
            riskLevel: 'Risk level',
            score: 'Score',
            status: 'Status',
            reasons: 'Reasons',
            high: 'High',
            medium: 'Medium',
            empty: 'No flagged companies were detected in the selected range.',
          },
          riskReasons: {
            assignmentBlocked: 'Assignment blocked',
            overdueInvoices: 'Overdue invoices',
            finalNoticeInvoice: 'Final notice reached',
            overdueFollowUp: 'Overdue follow-up',
            missingDocuments: 'Missing documents',
            rejectedVerification: 'Verification rejected',
            stalePendingReview: 'Review overdue',
          },
        },
        weeklyReport: {
          title: 'Weekly report',
          description:
            'Operational 7-day digest with previous-week comparison, priorities, and export.',
          exportCsv: 'Export weekly report',
          exportError: 'The weekly report could not be exported.',
          sendAction: 'Send by email',
          sendingAction: 'Sending report',
          sendSuccessTitle: 'Weekly report sent',
          sendSuccessDescription: '{{sent}} admin recipients notified, {{skipped}} skipped.',
          sendError: 'The weekly report could not be sent.',
          currentWindow: 'Current week',
          previousWindow: 'Previous week',
          vsPreviousWeek: 'vs previous week',
          recommendationsTitle: 'Recommended actions',
          recommendationsDescription:
            'Prioritized topics the team should actively work through this week.',
          communicationTitle: 'Communication status',
          communicationDescription: 'Open and overdue reply workflows in the current queue.',
          supplyGapsTitle: 'Supply gaps',
          supplyGapsDescription: 'Segments with excess demand and not enough active coverage.',
          riskCompaniesTitle: 'Risk focus',
          riskCompaniesDescription:
            'Companies that need immediate attention in this weekly digest.',
          noRecommendations: 'No prioritized actions detected right now.',
          noSupplyGaps: 'No material supply gaps in the current weekly picture.',
          noRiskCompanies: 'No flagged risk companies in the current weekly picture.',
          affectedCount: '{{count}} affected cases',
          priorityHigh: 'High',
          priorityMedium: 'Medium',
          riskScore: 'Score {{score}}',
          metrics: {
            paidRevenue: 'Paid revenue',
            requestsCreated: 'New requests',
            completionRate: 'Completion rate',
            activeCompanies: 'Active companies',
            overdueInvoices: 'Overdue invoices',
            blockedCompanies: 'Blocked companies',
            highRiskCompanies: 'High-risk companies',
          },
          communication: {
            pendingTasks: 'Pending replies',
            overdueTasks: 'Overdue replies',
            totalTasks: 'All open cases',
          },
          recommendationKeys: {
            reviewHighRiskCompanies: 'Review high-risk companies first',
            clearOverdueInvoices: 'Follow up overdue invoices and dunning stages',
            resolveVerificationBacklog: 'Reduce verification backlog and follow-ups',
            respondToOverdueCommunications: 'Respond to overdue communication cases',
            addressSupplyGaps: 'Close supply gaps in high-demand segments',
          },
          weekdays: {
            0: 'Sunday',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
          },
          automation: {
            title: 'Automatic delivery',
            description: 'Schedule the weekly report automatically for opted-in admins.',
            enabledLabel: 'Enable automatic weekly delivery',
            enabledDescription:
              'Only admins with the weekly report preference enabled will receive the report.',
            weekdayLabel: 'Delivery day',
            hourLabel: 'Hour (UTC)',
            minuteLabel: 'Minute (UTC)',
            timezoneHint:
              'Automation uses UTC and prevents duplicate weekly runs through delivery history.',
            saveAction: 'Save automation',
            savedTitle: 'Weekly report automation saved',
            savedDescription: 'The delivery schedule for the weekly report was updated.',
            saveError: 'The weekly report automation could not be saved.',
            validationError: 'Please enter a valid weekday as well as hour and minute in UTC.',
            nextRun: 'Next scheduled run: {{localDate}} ({{utcDate}} UTC)',
            scheduleSummary: 'Runs every {{weekday}} at {{hour}}:{{minute}} UTC.',
            disabledHint: 'Weekly report automation is currently disabled.',
            lastRun: 'Last run: {{date}} • {{status}} • {{source}}',
          },
          history: {
            title: 'Delivery history',
            description: 'Recent manual and automatic weekly report delivery runs.',
            empty: 'There are no delivery runs yet.',
            statusSent: 'Sent',
            statusSkipped: 'Skipped',
            statusFailed: 'Failed',
            sourceScheduled: 'Scheduled',
            sourceManual: 'Manual',
            sentMeta: '{{sent}} sent, {{skipped}} skipped',
            scheduledFor: 'Scheduled slot: {{date}}',
            anchorDate: 'Report anchor: {{date}}',
            recipients: 'Recipients: {{recipients}}',
            rerunAction: 'Send again',
            rerunningAction: 'Sending...',
            rerunSuccessTitle: 'Resent',
            rerunSuccessDescription: 'Report sent to {{sent}} recipients',
            rerunError: 'Resend failed',
            sourceFilterLabel: 'Source',
            sourceFilterAll: 'All',
            sourceFilterManual: 'Manual',
            sourceFilterScheduled: 'Scheduled',
            sourceFilterApplied: 'Active',
            emptyFiltered: 'No entries for this filter',
          },
        },
        matchingInsights: {
          title: 'Matching market view',
          description: 'Condensed demand and supply gaps from the last {{days}} days.',
          periodLabel: 'Period',
          period30: 'Last 30 days',
          period60: 'Last 60 days',
          period90: 'Last 90 days',
          period180: 'Last 180 days',
          refreshAction: 'Refresh',
          exportAction: 'Export CSV',
          loadError: 'Matching insights could not be loaded.',
          exportError: 'Matching insights could not be exported.',
          emptyState: 'There is currently no matching data for the selected period.',
          requestCount_one: '{{count}} request in focus',
          requestCount_other: '{{count}} requests in focus',
          topRequestTypesTitle: 'Top request types',
          topPostalAreasTitle: 'Top postal areas',
          topSpecialServicesTitle: 'Top extra services',
          underservedRequestTypesTitle: 'Underserved request types',
          underservedPostalAreasTitle: 'Underserved postal areas',
          underservedSpecialServicesTitle: 'Underserved extra services',
          coverageMeta: '{{demand}} demand / {{companies}} companies',
          noUnderservedSegments: 'No clearly underserved segments detected right now.',
        },
        aiInsights: {
          title: 'AI Insights Dashboard',
          aiEnabled: 'AI enhancement enabled',
          aiDisabled: 'AI enhancement disabled (no API key)',
          applyRange: 'Apply',
          startDate: 'Start date',
          endDate: 'End date',
          enhancementsToday: 'Enhancements today',
          totalCost7d: 'Total cost (7d)',
          calls: 'Calls',
          tokens: 'Tokens',
          totalCost: 'Total cost',
          avgCostPerCall: 'Avg cost / call (7d)',
          costTracking: 'Cost Tracking',
          costTrackingSubtitle:
            'Claude API spend over the last 7 days and configurable date range.',
          totalTokens: 'Tokens used (7d)',
          cachePanel: 'Cache panel',
          cachePanelSubtitle:
            'In-process LRU cache is queried by the /api/admin/ai/cache/stats endpoint.',
          costUsdLabel: 'Cost (USD)',
          callsLabel: 'Calls',
          empty: 'No AI insights recorded yet. Enhance a request to populate this table.',
          model: 'Model',
          cost: 'Cost',
          confidence: 'Confidence',
          costByModel: 'Cost by model',
          costOverTime: 'Cost over time (last 30 days)',
          averageConfidence: 'Avg confidence (7d)',
          fallbackRate: 'Fallback rate (7d)',
          recentTitle: 'Recent AI reasonings',
          recentSubtitle: 'Latest 20 AI-enhanced matching records',
          noCostData: 'No cost data yet.',
          noModelData: 'No model cost data.',
          createdAt: 'When',
          company: 'Company',
          request: 'Request',
          reasoning: 'Reasoning',
          baseScore: 'Base',
          finalScore: 'Final',
        },
        mailSettings: {
          title: 'Mail configuration',
          description:
            'Manage SMTP for outbound delivery and optional IMAP credentials for later inbox workflows.',
          provider: 'Delivery mode',
          fromEmail: 'From email',
          smtpTitle: 'SMTP delivery',
          imapTitle: 'IMAP inbox',
          imapDescription:
            'The IMAP configuration is stored now and prepared for future inbound/reply workflows.',
          host: 'Host',
          port: 'Port',
          username: 'Username',
          password: 'Password',
          mailbox: 'Mailbox',
          secureConnection: 'Secure connection (TLS/SSL)',
          enableImap: 'Enable IMAP',
          passwordConfigured: 'Password is configured',
          passwordMissing: 'No password configured',
          passwordKeep: 'Leave empty to keep the current password',
          saveAction: 'Save mail configuration',
          savedTitle: 'Mail configuration saved',
          savedDescription: 'Mail server settings were updated.',
          loadError: 'Mail configuration could not be loaded.',
          saveError: 'Mail configuration could not be saved.',
          testRecipient: 'Test email recipient',
          testAction: 'Save & test',
          testHint:
            'The current SMTP settings are saved, the connection is verified, and then a test email is sent.',
          testSuccessTitle: 'SMTP test successful',
          testSuccessDescription: 'The test email was accepted for {{recipient}}.',
          testErrorTitle: 'SMTP test failed',
          testErrorDescription:
            'Connection or delivery failed. Check host, port, TLS, and credentials.',
          notificationPreferencesTitle: 'Your own notifications',
          notificationPreferencesDescription:
            'Choose which system emails you want to receive as admin.',
          providers: {
            log: 'Log only',
            noop: 'Do not send',
            smtp: 'Send via SMTP',
          },
        },
        companyAccessRecovery: {
          title: 'Access recovery requests',
          description: 'Open company requests for manual review of billing or blocking issues.',
          pendingCount_one: '{{count}} open',
          pendingCount_other: '{{count}} open',
          empty: 'There are no open access recovery requests right now.',
          openProof: 'Open proof',
          markInvoicePaid: 'Mark invoice as paid',
          removeBlacklist: 'Remove blacklist',
          approve: 'Send approval',
          reject: 'Reject',
          blockReasonPayment: 'Billing block',
          blockReasonBlacklist: 'Blacklist block',
          reviewApproveTitle: 'Approve access recovery',
          reviewRejectTitle: 'Reject access recovery',
          reviewDialogDesc: 'Leave a response for {{company}}.',
          reviewResponseLabel: 'Response to company',
          reviewResponsePlaceholder: 'Describe the next steps or the reason for your decision.',
          reviewResponseRequired: 'Please provide a response for the company.',
          reviewSuccessTitle: 'Decision saved',
          reviewApprovedDesc: 'The access recovery request was approved.',
          reviewRejectedDesc: 'The access recovery request was rejected.',
          reviewError: 'The access recovery request could not be processed.',
          status: {
            pending: 'Under review',
            approved: 'Approved',
            rejected: 'Rejected',
          },
        },
        userAccessRecovery: {
          title: 'Customer access recovery requests',
          description: 'Open customer requests for manual review of blocked account cases.',
          pendingCount_one: '{{count}} open',
          pendingCount_other: '{{count}} open',
          empty: 'There are no open customer access recovery requests right now.',
          openProof: 'Open proof',
          removeBlacklist: 'Remove block',
          approve: 'Send approval',
          reject: 'Reject',
          blockReasonBlacklist: 'Customer block',
          reviewApproveTitle: 'Approve customer access',
          reviewRejectTitle: 'Reject access recovery',
          reviewDialogDesc: 'Leave a response for {{user}}.',
          reviewResponseLabel: 'Response to customer',
          reviewResponsePlaceholder: 'Describe the next steps or the reason for your decision.',
          reviewResponseRequired: 'Please provide a response for the customer.',
          reviewSuccessTitle: 'Decision saved',
          reviewApprovedDesc: 'The customer access recovery request was approved.',
          reviewRejectedDesc: 'The customer access recovery request was rejected.',
          reviewError: 'The customer access recovery request could not be processed.',
          status: {
            pending: 'Under review',
            approved: 'Approved',
            rejected: 'Rejected',
          },
        },
        blacklist: {
          title: 'Blacklist',
          titleDesc: 'Manage user and company blacklists',
          addEntry: 'Add Blacklist Entry',
          addEntryDesc: 'Add a new entry to the blacklist',
          searchPlaceholder: 'Search by entity, reason or creator',
          entityType: 'Type',
          entityTypeAll: 'All types',
          entityId: 'Entity ID',
          user: 'User',
          company: 'Company',
          selectUser: 'Select User',
          selectUserPlaceholder: 'Choose a user',
          selectCompany: 'Select company',
          selectCompanyPlaceholder: 'Choose a company',
          reason: 'Reason',
          reasonPlaceholder: 'Enter reason for blacklist...',
          validUntil: 'Valid Until',
          validUntilDesc: 'Leave empty for permanent blacklist',
          createdBy: 'Created By',
          fillRequired: 'Please fill all required fields',
          created: 'Blacklist Entry Created',
          createdDesc: 'The blacklist entry has been created successfully',
          createError: 'Error creating blacklist entry',
          deleted: 'Blacklist Entry Removed',
          deletedDesc: 'The blacklist entry has been removed successfully',
          deleteError: 'Error removing blacklist entry',
          noEntries: 'No blacklist entries',
          filteredCount: '{{count}} entries',
          statusAll: 'All statuses',
          statusActive: 'Active',
          statusExpired: 'Expired',
          statusPermanent: 'Permanent',
          export: 'Export blacklist',
          exportError: 'The blacklist export could not be exported.',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} entries',
          previousPage: 'Previous',
          nextPage: 'Next',
          permanent: 'Permanent',
          expired: 'Expired',
        },
        gdprHardDelete: {
          title: 'Permanently delete {{entityType}} (GDPR Art. 17)',
          description: 'You are about to permanently remove "{{label}}" from the database.',
          hardDeleteCta: 'Hard-Delete (GDPR Art. 17)',
          warningTitle: 'Warning: irreversible hard-delete action',
          warningBody:
            'This action removes the record and all dependent rows forever. There is no recycle bin. Use only after the legal review has been documented.',
          emailLabel: 'Email / label (for confirmation)',
          tokenLabel: 'Safety token',
          tokenHelp: 'Type exactly PERMANENTLY-DELETE to continue.',
          reasonLabel: 'Reason (optional, saved to audit log)',
          reasonPlaceholder: 'e.g. customer_request, legal_hold',
          dryRunCta: 'Run dry-run',
          dryRunSummaryTitle: 'Predicted deletions',
          dryRunSummaryDesc: 'These rows would be removed:',
          dryRunNoCounts: 'No dependent rows found.',
          finalWarning: 'Clicking "Delete permanently" executes the transaction with no rollback.',
          continueCta: 'Continue to confirmation',
          finalStepTitle: 'Final confirmation',
          finalStepBody:
            'You are permanently deleting "{{label}}". The token "{{token}}" was entered correctly.',
          finalCta: 'Delete permanently',
          executing: 'Deletion in progress...',
          completedTitle: 'Hard-delete completed',
          completedBody: '"{{label}}" and all dependent rows were removed.',
          successToastTitle: 'GDPR hard-delete succeeded',
          successToastDesc: '{{label}} was deleted together with {{records}} dependent records.',
          closeCta: 'Close',
          errors: {
            dryRunFailed: 'Dry-run failed.',
            executeFailed: 'Hard-delete failed.',
          },
          entity: {
            user: 'user',
            company: 'company',
          },
        },
        audit: {
          title: 'Audit log',
          desc: 'Traceable history for admin, document, billing, and blocking decisions.',
          searchLabel: 'Search',
          searchPlaceholder: 'Search by action, entity, actor or summary',
          actionFilter: 'Action',
          entityFilter: 'Entity',
          entityHeader: 'Entity',
          actorHeader: 'Actor',
          summaryHeader: 'Summary',
          export: 'Export CSV',
          exportError: 'The audit log could not be exported.',
          empty: 'No audit entries for the current filter.',
          pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} items',
          pageLabel: 'Page',
          previousPage: 'Previous',
          nextPage: 'Next',
          systemActor: 'System',
          actions: {
            userCreated: 'User created',
            userUpdated: 'User updated',
            invoiceCreated: 'Invoice created',
            invoiceStatusUpdated: 'Invoice status updated',
            blacklistCreated: 'Blacklist created',
            blacklistRemoved: 'Blacklist removed',
            companyAccessRecoveryRequested: 'Access recovery requested',
            companyAccessRecoveryReviewed: 'Access recovery reviewed',
            userAccessRecoveryRequested: 'Customer access recovery requested',
            userAccessRecoveryReviewed: 'Customer access recovery reviewed',
            companyVerificationReviewed: 'Company verification reviewed',
            companyVerificationMetadataUpdated: 'Verification note updated',
            configUpdated: 'Configuration updated',
            weeklyReportSent: 'Weekly report sent',
            requestCreated: 'Request created',
            requestUpdated: 'Request updated',
            requestCancelled: 'Request cancelled',
            requestCompanySelected: 'Company selected',
            requestCompleted: 'Request completed',
            requestPublicCompanyCreated: 'Public company request created',
            fileDeleted: 'File deleted',
          },
          entities: {
            user: 'User',
            company: 'Company',
            invoice: 'Invoice',
            request: 'Request',
            adminConfig: 'Configuration',
            adminReport: 'Admin report',
            companyDocument: 'Company document',
            requestDocument: 'Request document',
            fileAsset: 'File',
          },
        },
      },
      chat: {
        noMessages: 'No Messages',
      },
      errors: {
        error: 'Error',
        generic: 'An error occurred',
        validationError: 'Validation Error',
        loadError: 'Error loading',
        notFound: 'Not Found',
        accessDenied: 'Access Denied',
        invalidInput: 'Invalid Input',
      },
      notificationPreferences: {
        loadError: 'Notification settings could not be loaded.',
        saveError: 'Notification settings could not be saved.',
        savedTitle: 'Notifications saved',
        savedDesc: 'Your email notifications were updated.',
        saveAction: 'Save notifications',
        labels: {
          emailNewRequests: 'New requests by email',
          emailMessages: 'New messages by email',
          emailStatusUpdates: 'Status updates by email',
          emailDocuments: 'Document and verification updates by email',
          emailWeeklyReports: 'Admin weekly report by email',
        },
      },
      dataExport: {
        title: 'Data Export (GDPR)',
        description:
          'Download a complete summary of all personal data stored about you in accordance with GDPR Art. 15 (right of access) and Art. 20 (right to data portability).',
        legalNote: 'The export contains personal data. Please treat the file as confidential.',
        includeFilesLabel: 'Include file references',
        includeFilesHelp: 'List of uploaded files without file contents.',
        formatLabel: 'Format',
        formatJson: 'JSON',
        formatJsonDescription: 'Machine-readable, for data portability.',
        formatPdf: 'PDF (data disclosure)',
        formatPdfDescription: 'Printable, with watermark and page numbers.',
        downloadButton: 'Download data export',
        asyncButton: 'Receive by email',
        rateLimited:
          'You have already requested an export within the last hour. Please try again later.',
        blocked: 'The data export is currently not available.',
        errorGeneric: 'The data export could not be generated.',
        successTitle: 'Data export is being prepared',
        successDesc: 'Your download will start shortly.',
        asyncSuccessTitle: 'Data export requested',
        asyncSuccessDesc: 'We will email you the download link (valid for 24 hours).',
        downloadNow: 'Download now',
        lastExportLabel: 'Last export',
        lastExportNever: 'No export has been performed yet',
        legalReference: 'Legal basis: GDPR Art. 15, Art. 20',
        delete: {
          title: 'Delete account (GDPR Art. 17)',
          description:
            'Permanently removes all personal data associated with this account per GDPR Art. 17 (right to erasure).',
          warning:
            'This action is final. A 30-day grace period applies during which we can reverse the deletion on request.',
          gracePeriod:
            'Within the 30-day grace period you can revoke the deletion by emailing privacy@regionalumzug24.de.',
          button: 'Delete account',
          dialogTitle: 'Permanently delete your account?',
          dialogDescription: 'Please confirm the deletion. This cannot be undone.',
          bulletProfile: 'Profile, address and contact details will be anonymized.',
          bulletEmail: 'Login and email access will be revoked.',
          bulletReviews:
            'Reviews will be anonymized to "[deleted]" (stars are preserved for aggregate stats).',
          bulletSessions: 'All active sessions and reset tokens will be revoked.',
          confirmLabel: 'Type {{word}} to confirm',
          confirmWord: 'DELETE',
          confirmButton: 'Delete permanently',
          confirmMismatch: 'Please type the word exactly.',
          deleting: 'Deleting...',
          successTitle: 'Account deleted',
          successDesc:
            'Your account has been anonymized. You will be redirected to the login shortly.',
          errorGeneric: 'The account could not be deleted.',
        },
      },
      communicationTasks: {
        customerTitle: 'Open replies',
        customerDescription: 'Respond to company follow-ups before escalations become due.',
        companyTitle: 'Open customer follow-ups',
        companyDescription: 'Keep customer follow-ups in view and react to overdue replies.',
        adminTitle: 'Communication cases needing a reply',
        adminDescription:
          'Central view of open or overdue chat follow-ups between customers and companies.',
        searchPlaceholder: 'Search by route, company, participants or message',
        senderTypeFilter: 'Sender',
        senderTypeCustomer: 'Customer',
        senderTypeCompany: 'Company',
        senderTypeAdmin: 'Admin',
        export: 'Export CSV',
        exportError: 'Communication tasks could not be exported.',
        pageSummary: 'Page {{page}} of {{totalPages}} · {{total}} tasks',
        previousPage: 'Previous',
        nextPage: 'Next',
        empty: 'There are currently no open communication tasks.',
        statusPending: 'Reply pending',
        statusOverdue: 'Overdue',
        openAction: 'Open chat',
        openRequestAction: 'Open request',
        createdAt: 'Requested: {{date}}',
        dueAtPending: 'Due: {{date}}',
        dueAtOverdue: 'Overdue since {{date}}',
        summaryTotal: '{{count}} open',
        summaryPending: '{{count}} pending',
        summaryOverdue: '{{count}} overdue',
      },
      cookieConsent: {
        title: 'Cookies & privacy',
        message:
          'We use cookies to operate this site and — with your consent — to measure reach. You can change your selection at any time.',
        acceptAll: 'Accept all',
        essentialOnly: 'Essential only',
        settings: 'Settings',
        preferencesTitle: 'Cookie preferences',
        preferencesDescription:
          'Choose which categories you want to allow. Essential cookies are required to operate the site.',
        essentialTitle: 'Essential',
        essentialDescription:
          'Sign-in, CSRF protection, session. These cookies cannot be disabled.',
        analyticsTitle: 'Analytics (Plausible)',
        analyticsDescription:
          'Anonymous reach measurement via Plausible Analytics (no personal data, no cookies).',
        analyticsUnavailable: 'Plausible is not configured (VITE_PLAUSIBLE_DOMAIN missing).',
        marketingTitle: 'Marketing',
        marketingDescription: 'Currently inactive. We do not use marketing tracking.',
        savePreferences: 'Save preferences',
        close: 'Close',
        cookiePolicyLink: 'More in the privacy policy',
        footerLink: 'Cookie preferences',
      },
      // P2.072 — meta-title/description for city landing pages (Moving)
      frankfurtLanding: {
        metaTitle: 'Moving Frankfurt | RegionalUmzug24',
        metaDescription:
          'Compare verified moving companies in Frankfurt am Main. Free quotes for private and office moves in the Main metropolis.',
      },
      hamburgLanding: {
        metaTitle: 'Moving Hamburg | RegionalUmzug24',
        metaDescription:
          'Compare verified moving companies in Hamburg. Free quotes for private and office moves in the Hanseatic city.',
      },
      koelnLanding: {
        metaTitle: 'Moving Cologne | RegionalUmzug24',
        metaDescription:
          'Compare verified moving companies in Cologne. Free quotes for private and office moves in the cathedral city.',
      },
      muenchenLanding: {
        metaTitle: 'Moving Munich | RegionalUmzug24',
        metaDescription:
          'Compare verified moving companies in Munich. Free quotes for private and office moves in the Bavarian state capital.',
      },
      stuttgartLanding: {
        metaTitle: 'Moving Stuttgart | RegionalUmzug24',
        metaDescription:
          'Compare verified moving companies in Stuttgart. Free quotes for moves in the basin and across the Swabian region.',
      },
      // OPT422-i18n — berlinDirectory (25 keys) — EN
      berlinDirectory: {
        metaTitle: 'Moving Companies in Berlin | RegionalUmzug24',
        metaDescription:
          'Browse verified moving companies in Berlin. Filter by postal code, rating and services.',
        metaKeywords: 'Moving Companies Berlin, Moving Berlin, Movers Berlin',
        pageTitle: 'Moving Companies in Berlin',
        pageSubtitle:
          'Discover verified Berlin movers with real reviews. Postal-code areas 10-14 - including Potsdam and Brandenburg.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Berlin movers match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Berlin movers...',
        errorTitle: 'Loading error',
        errorDescription: 'The list of Berlin movers could not be loaded. Please try again.',
        errorRetry: 'Retry',
        companyVerified: 'Verified',
        companyPremium: 'Premium',
        companyReviews: 'Reviews',
        companySpecialties: 'Specialties',
        companyServiceArea: 'Service area',
        companyViewProfile: 'View profile',
        companyRequestQuote: 'Request quote',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      // OPT422-i18n — berlinLanding (25 keys) — EN
      berlinLanding: {
        metaTitle: 'Moving Berlin | RegionalUmzug24',
        metaDescription:
          'Find the best moving companies in Berlin. Compare free quotes from verified Berlin movers. Checked, rated, GDPR-compliant.',
        metaKeywords: 'Moving Berlin, Moving Companies Berlin, Moving costs Berlin',
        benefitsTitle: 'Your benefits with RegionalUmzug24 in Berlin',
        benefitsSubtitle: 'Why thousands of Berliners choose our matching platform',
        benefitFreeTitle: '100% free',
        benefitFreeDesc:
          'Submitting a request and comparing quotes is completely free and without obligation.',
        benefitLocalTitle: 'Local Berlin companies',
        benefitLocalDesc:
          'We only connect you with verified movers operating in Berlin and surroundings (postal codes 10-14).',
        benefitReviewsTitle: 'Genuine reviews',
        benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
        statsTitle: 'Moving in Berlin in numbers',
        statsSubtitle: 'Berlin customers trust RegionalUmzug24',
        statFirms: '200+',
        statFirmsLabel: 'Berlin moving companies',
        statMoves: '500+',
        statMovesLabel: 'Matched moves',
        statSavings: '40%',
        statSavingsLabel: 'Avg. savings',
        statRating: '4.7/5',
        statRatingLabel: 'Customer rating',
        ctaTitle: 'Ready for your move in Berlin?',
        ctaSubtitle: 'Create your free request now and receive quotes from verified Berlin movers.',
        ctaPrimary: 'Create request now',
        ctaSecondary: 'View Berlin companies',
      },
      frankfurtDirectory: {
        metaTitle: 'Moving Companies in Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Browse verified moving companies in Frankfurt am Main. Filter by postal code, rating and services.',
        metaKeywords:
          'Moving Companies Frankfurt am Main, Moving Frankfurt am Main, Movers Frankfurt',
        pageTitle: 'Moving Companies in Frankfurt am Main',
        pageSubtitle:
          'Discover verified Frankfurt movers with real reviews. Postal-code areas 60-65 - from Westend to Höchst.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal60: 'Postal 60 (Westend)',
        filterPostal65: 'Postal 65 (Höchst)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Frankfurt movers match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Frankfurt movers...',
        errorTitle: 'Loading error',
        errorDescription: 'The list of Frankfurt movers could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      hamburgDirectory: {
        metaTitle: 'Moving Companies in Hamburg | RegionalUmzug24',
        metaDescription:
          'Browse verified moving companies in Hamburg. Filter by postal code, rating and services.',
        metaKeywords: 'Moving Companies Hamburg, Moving Hamburg, Movers Hamburg',
        pageTitle: 'Moving Companies in Hamburg',
        pageSubtitle:
          'Discover verified Hamburg movers with real reviews. Postal-code areas 20-22 - from the city centre to Bergedorf.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal20: 'Postal 20 (city centre)',
        filterPostal21: 'Postal 21 (north)',
        filterPostal22: 'Postal 22 (east)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Hamburg movers match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Hamburg movers...',
        errorTitle: 'Loading error',
        errorDescription: 'The list of Hamburg movers could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      koelnDirectory: {
        metaTitle: 'Moving Companies in Cologne | RegionalUmzug24',
        metaDescription:
          'Browse verified moving companies in Cologne. Filter by postal code, rating and services.',
        metaKeywords: 'Moving Companies Cologne, Moving Cologne, Movers Cologne',
        pageTitle: 'Moving Companies in Cologne',
        pageSubtitle:
          'Discover verified Cologne movers with real reviews. Postal-code areas 50-51 - on both sides of the Rhine.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal50: 'Postal 50 (city centre)',
        filterPostal51: 'Postal 51 (right Rhine bank)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Cologne movers match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Cologne movers...',
        errorTitle: 'Loading error',
        errorDescription: 'The list of Cologne movers could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      muenchenDirectory: {
        metaTitle: 'Moving Companies in Munich | RegionalUmzug24',
        metaDescription:
          'Browse verified moving companies in Munich. Filter by postal code, rating and services.',
        metaKeywords: 'Moving Companies Munich, Moving Munich, Movers Munich',
        pageTitle: 'Moving Companies in Munich',
        pageSubtitle:
          'Discover verified Munich movers with real reviews. Postal-code areas 80-82 - from Schwabing to the south.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal80: 'Postal 80 (city centre)',
        filterPostal81: 'Postal 81 (south/east)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Munich movers match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Munich movers...',
        errorTitle: 'Loading error',
        errorDescription: 'The list of Munich movers could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      stuttgartDirectory: {
        metaTitle: 'Moving Companies in Stuttgart | RegionalUmzug24',
        metaDescription:
          'Browse verified moving companies in Stuttgart. Filter by postal code, rating and services.',
      },
      // P2.072 — meta-title/description for Cleaning city landing pages
      cleaningFrankfurtamMainLanding: {
        metaTitle: 'Cleaning Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Compare verified cleaning companies in Frankfurt am Main. Free quotes from verified providers.',
      },
      cleaningFrankfurtamMainDirectory: {
        metaTitle: 'Cleaning Companies in Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Find verified cleaning companies in Frankfurt am Main. Filter by postal code, rating and services.',
        metaKeywords:
          'Cleaning Companies Frankfurt am Main, Cleaning Frankfurt am Main, Cleaners Frankfurt',
        pageTitle: 'Cleaning Companies in Frankfurt am Main',
        pageSubtitle:
          'Discover verified cleaning companies in Frankfurt am Main with real reviews. Postal-code areas 60-65.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal60: 'Postal 60 (Westend)',
        filterPostal65: 'Postal 65 (Höchst)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Frankfurt am Main cleaning companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading cleaning companies in Frankfurt am Main...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of cleaning companies in Frankfurt am Main could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      cleaningHamburgLanding: {
        metaTitle: 'Cleaning Hamburg | RegionalUmzug24',
        metaDescription:
          'Compare verified cleaning companies in Hamburg. Free quotes from verified providers.',
      },
      cleaningHamburgDirectory: {
        metaTitle: 'Cleaning Companies in Hamburg | RegionalUmzug24',
        metaDescription:
          'Find verified cleaning companies in Hamburg. Filter by postal code, rating and services.',
        metaKeywords: 'Cleaning Companies Hamburg, Cleaning Hamburg, Cleaners Hamburg',
        pageTitle: 'Cleaning Companies in Hamburg',
        pageSubtitle:
          'Discover verified cleaning companies in Hamburg with real reviews. Postal-code areas 20-22.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal20: 'Postal 20 (city centre)',
        filterPostal21: 'Postal 21 (north)',
        filterPostal22: 'Postal 22 (east)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Hamburg cleaning companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading cleaning companies in Hamburg...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of cleaning companies in Hamburg could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      cleaningKolnLanding: {
        metaTitle: 'Cleaning Cologne | RegionalUmzug24',
        metaDescription:
          'Compare verified cleaning companies in Cologne. Free quotes from verified providers.',
      },
      cleaningKolnDirectory: {
        metaTitle: 'Cleaning Companies in Cologne | RegionalUmzug24',
        metaDescription:
          'Find verified cleaning companies in Cologne. Filter by postal code, rating and services.',
        metaKeywords: 'Cleaning Companies Cologne, Cleaning Cologne, Cleaners Cologne',
        pageTitle: 'Cleaning Companies in Cologne',
        pageSubtitle:
          'Discover verified cleaning companies in Cologne with real reviews. Postal-code areas 50-51.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal50: 'Postal 50 (city centre)',
        filterPostal51: 'Postal 51 (right Rhine bank)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Cologne cleaning companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading cleaning companies in Cologne...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of cleaning companies in Cologne could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      cleaningMunchenLanding: {
        metaTitle: 'Cleaning Munich | RegionalUmzug24',
        metaDescription:
          'Compare verified cleaning companies in Munich. Free quotes from verified providers.',
      },
      cleaningMunchenDirectory: {
        metaTitle: 'Cleaning Companies in Munich | RegionalUmzug24',
        metaDescription:
          'Find verified cleaning companies in Munich. Filter by postal code, rating and services.',
        metaKeywords: 'Cleaning Companies Munich, Cleaning Munich, Cleaners Munich',
        pageTitle: 'Cleaning Companies in Munich',
        pageSubtitle:
          'Discover verified cleaning companies in Munich with real reviews. Postal-code areas 80-82.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal80: 'Postal 80 (city centre)',
        filterPostal81: 'Postal 81 (south/east)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Munich cleaning companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading cleaning companies in Munich...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of cleaning companies in Munich could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      cleaningStuttgartLanding: {
        metaTitle: 'Cleaning Stuttgart | RegionalUmzug24',
        metaDescription:
          'Compare verified cleaning companies in Stuttgart. Free quotes from verified providers.',
      },
      cleaningStuttgartDirectory: {
        metaTitle: 'Cleaning Companies in Stuttgart | RegionalUmzug24',
        metaDescription:
          'Find verified cleaning companies in Stuttgart. Filter by postal code, rating and services.',
        metaKeywords: 'Cleaning Companies Stuttgart, Cleaning Stuttgart, Cleaners Stuttgart',
        pageTitle: 'Cleaning Companies in Stuttgart',
        pageSubtitle:
          'Discover verified cleaning companies in Stuttgart with real reviews. Postal-code areas 70-71.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal70: 'Postal 70 (Stuttgart)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Stuttgart cleaning companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading cleaning companies in Stuttgart...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of cleaning companies in Stuttgart could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      // P2.072 — meta-title/description for Disposal city landing pages
      disposalFrankfurtamMainLanding: {
        metaTitle: 'Clearance Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Compare verified clearance companies in Frankfurt am Main. Free quotes from verified providers.',
      },
      disposalFrankfurtamMainDirectory: {
        metaTitle: 'Clearance Companies in Frankfurt am Main | RegionalUmzug24',
        metaDescription:
          'Find verified clearance companies in Frankfurt am Main. Filter by postal code, rating and services.',
        metaKeywords:
          'Clearance Companies Frankfurt am Main, Clearance Frankfurt am Main, Disposal Frankfurt',
        pageTitle: 'Clearance Companies in Frankfurt am Main',
        pageSubtitle:
          'Discover verified clearance companies in Frankfurt am Main with real reviews. Postal-code areas 60-65.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal60: 'Postal 60 (Westend)',
        filterPostal65: 'Postal 65 (Höchst)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Frankfurt am Main clearance companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading clearance companies in Frankfurt am Main...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of clearance companies in Frankfurt am Main could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      disposalHamburgLanding: {
        metaTitle: 'Clearance Hamburg | RegionalUmzug24',
        metaDescription:
          'Compare verified clearance companies in Hamburg. Free quotes from verified providers.',
      },
      disposalHamburgDirectory: {
        metaTitle: 'Clearance Companies in Hamburg | RegionalUmzug24',
        metaDescription:
          'Find verified clearance companies in Hamburg. Filter by postal code, rating and services.',
        metaKeywords: 'Clearance Companies Hamburg, Clearance Hamburg, Disposal Hamburg',
        pageTitle: 'Clearance Companies in Hamburg',
        pageSubtitle:
          'Discover verified clearance companies in Hamburg with real reviews. Postal-code areas 20-22.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal20: 'Postal 20 (city centre)',
        filterPostal21: 'Postal 21 (north)',
        filterPostal22: 'Postal 22 (east)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Hamburg clearance companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading clearance companies in Hamburg...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of clearance companies in Hamburg could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      disposalKolnLanding: {
        metaTitle: 'Clearance Cologne | RegionalUmzug24',
        metaDescription:
          'Compare verified clearance companies in Cologne. Free quotes from verified providers.',
      },
      disposalKolnDirectory: {
        metaTitle: 'Clearance Companies in Cologne | RegionalUmzug24',
        metaDescription:
          'Find verified clearance companies in Cologne. Filter by postal code, rating and services.',
        metaKeywords: 'Clearance Companies Cologne, Clearance Cologne, Disposal Cologne',
        pageTitle: 'Clearance Companies in Cologne',
        pageSubtitle:
          'Discover verified clearance companies in Cologne with real reviews. Postal-code areas 50-51.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal50: 'Postal 50 (city centre)',
        filterPostal51: 'Postal 51 (right Rhine bank)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Cologne clearance companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading clearance companies in Cologne...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of clearance companies in Cologne could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      disposalMunchenLanding: {
        metaTitle: 'Clearance Munich | RegionalUmzug24',
        metaDescription:
          'Compare verified clearance companies in Munich. Free quotes from verified providers.',
      },
      disposalMunchenDirectory: {
        metaTitle: 'Clearance Companies in Munich | RegionalUmzug24',
        metaDescription:
          'Find verified clearance companies in Munich. Filter by postal code, rating and services.',
        metaKeywords: 'Clearance Companies Munich, Clearance Munich, Disposal Munich',
        pageTitle: 'Clearance Companies in Munich',
        pageSubtitle:
          'Discover verified clearance companies in Munich with real reviews. Postal-code areas 80-82.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal80: 'Postal 80 (city centre)',
        filterPostal81: 'Postal 81 (south/east)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Munich clearance companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading clearance companies in Munich...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of clearance companies in Munich could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      disposalStuttgartLanding: {
        metaTitle: 'Clearance Stuttgart | RegionalUmzug24',
        metaDescription:
          'Compare verified clearance companies in Stuttgart. Free quotes from verified providers.',
      },
      disposalStuttgartDirectory: {
        metaTitle: 'Clearance Companies in Stuttgart | RegionalUmzug24',
        metaDescription:
          'Find verified clearance companies in Stuttgart. Filter by postal code, rating and services.',
        metaKeywords: 'Clearance Companies Stuttgart, Clearance Stuttgart, Disposal Stuttgart',
        pageTitle: 'Clearance Companies in Stuttgart',
        pageSubtitle:
          'Discover verified clearance companies in Stuttgart with real reviews. Postal-code areas 70-71.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        filterPostal70: 'Postal 70 (Stuttgart)',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Stuttgart clearance companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading clearance companies in Stuttgart...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of clearance companies in Stuttgart could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
      },
      // P2.074 — meta-title/description for main pages (EN)
      authPage: {
        metaTitle: 'Sign in or register | RegionalUmzug24',
        metaDescription: 'Sign in to regionalumzug24 or create a new customer account.',
      },
      indexPage: {
        metaTitle: 'Compare moving companies | RegionalUmzug24',
        metaDescription:
          'Compare professional moving companies in your region for free, receive up to 15 offers and find the right moving partner.',
      },
      companyRegisterPage: {
        metaTitle: 'Register moving company | RegionalUmzug24',
        metaDescription:
          'Register your moving company with regionalumzug24 and receive qualified requests from your region.',
      },
      notFoundPage: {
        metaTitle: 'Page not found | RegionalUmzug24',
        metaDescription: 'The requested page was not found on regionalumzug24.',
      },
      termsPage: {
        metaTitle: 'Terms of Service | RegionalUmzug24',
        metaDescription: 'Terms and conditions for using regionalumzug24.',
      },
      // P2.074 — meta-title/description for Berlin city pages (EN)
      disposalBerlinLanding: {
        metaTitle: 'Clearance Berlin | RegionalUmzug24',
        metaDescription:
          'Compare verified clearance companies in Berlin. Free offers for apartment clearances and disposal.',
      },
      disposalBerlinDirectory: {
        metaTitle: 'Clearance Companies in Berlin | RegionalUmzug24',
        metaDescription:
          'List of verified clearance companies in Berlin. Filter by postal code, rating and services.',
        metaKeywords:
          'Clearance Companies Berlin, Berlin clearance company, Clearance Berlin companies, Flat clearance Berlin, BSR bulky waste',
        pageTitle: 'Clearance Companies in Berlin',
        pageSubtitle:
          'Discover verified Berlin clearance companies with real reviews. Postal 10-14 - from Mitte to Köpenick.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Berlin clearance companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Berlin clearance companies...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of Berlin clearance companies could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
        filterPostal10: 'Postal 10 (Mitte, Charlottenburg)',
        filterPostal11: 'Postal 11 (Tiergarten, Friedrichshain)',
        filterPostal12: 'Postal 12 (Neukölln, Tempelhof, Steglitz)',
        filterPostal13: 'Postal 13 (Pankow, Weißensee, Reinickendorf)',
        filterPostal14: 'Postal 14 (Wilmersdorf, Zehlendorf, Köpenick)',
      },
      cleaningBerlinLanding: {
        metaTitle: 'Cleaning Berlin | RegionalUmzug24',
        metaDescription:
          'Compare verified cleaning companies in Berlin. Free offers from verified providers.',
      },
      cleaningBerlinDirectory: {
        metaTitle: 'Cleaning Companies in Berlin | RegionalUmzug24',
        metaDescription:
          'Find verified cleaning companies in Berlin. Filter by postal code, rating and services.',
        metaKeywords:
          'Cleaning Companies Berlin, Berlin cleaning company, Cleaning Berlin companies, Cleaning Mitte, Cleaning Charlottenburg',
        pageTitle: 'Cleaning Companies in Berlin',
        pageSubtitle:
          'Discover verified Berlin cleaning companies with real reviews. Postal 10-14 - from Mitte to Köpenick.',
        filterTitle: 'Filters',
        filterPremium: 'Premium companies only',
        filterVerified: 'Verified companies only',
        filterPostalTitle: 'Postal-code area',
        filterPostalAll: 'All postal-code areas',
        sortTitle: 'Sort by',
        sortRating: 'Best rating',
        sortOrders: 'Most orders',
        sortNewest: 'Newest',
        resultCount: '{{count}} companies found',
        emptyTitle: 'No companies found',
        emptyDescription:
          'No Berlin cleaning companies match the current filters. Try adjusting your filter selection.',
        emptyReset: 'Reset filters',
        loadingTitle: 'Loading Berlin cleaning companies...',
        errorTitle: 'Loading error',
        errorDescription:
          'The list of Berlin cleaning companies could not be loaded. Please try again.',
        errorRetry: 'Retry',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {{page}} of {{total}}',
        filterPostal10: 'Postal 10 (Mitte, Charlottenburg)',
        filterPostal11: 'Postal 11 (Tiergarten, Friedrichshain)',
        filterPostal12: 'Postal 12 (Neukölln, Tempelhof, Steglitz)',
        filterPostal13: 'Postal 13 (Pankow, Weißensee, Reinickendorf)',
        filterPostal14: 'Postal 14 (Wilmersdorf, Zehlendorf, Köpenick)',
      },
      pwa: {
        installTitle: 'Install App',
        installDescription:
          'Install RegionalUmzug24 for quick access to moving companies in your region.',
        installAction: 'Install',
        installLater: 'Later',
        installAccepted: 'App is being installed',
        installDismissed: 'Suggestion dismissed',
        offline: {
          title: 'You are offline',
          description:
            'Please check your internet connection. Some sections are only available online.',
          retryAction: 'Retry',
        },
        pushOptIn: {
          title: 'Enable push notifications',
          description: 'Receive updates for new requests and status changes.',
          enable: 'Enable',
          later: 'Later',
          enabled: 'Push enabled',
          disabled: 'Push disabled',
          error: 'Push could not be enabled.',
        },
      },
      // OPT373 — hardcoded English fallback strings in SubscriptionTierCard.tsx
      subscription: {
        title: 'Subscription',
        subtitle: 'Choose a tier that fits your team. Cancel any time.',
        active: 'Active subscription',
        activeTier: 'Tier',
        month: 'Month',
        cancelCta: 'Cancel subscription',
        cancelTitle: 'Cancel subscription?',
        cancelDescription:
          'You can keep using the current plan until the end of the billing period.',
        cancelling: 'Cancelling…',
        redirecting: 'Redirecting…',
        subscribeCta: 'Subscribe',
        errors: {
          checkoutFailed: 'Checkout failed. Please try again.',
          cancelFailed: 'Cancellation failed. Please try again.',
        },
      },
      // OPT373 — hardcoded unit/hint strings in VolumeCalculator.tsx (EN anchor)
      volumeCalculator: {
        title: 'Volume Calculator',
        apartmentType: 'Apartment type',
        rooms: {
          '1': '1-room',
          '2': '2-room',
          '3': '3-room',
          '4': '4-room',
          '5plus': '5+-room',
        },
        livingArea: 'Living area',
        additionalFloors: 'Additional floors (cellar, attic)',
        estimated: 'Estimated moving volume:',
        applyToForm: 'Apply to request',
        livingAreaUnit: 'm²',
        floorSurchargeHint: '+5 m³ per floor',
        volumeUnit: 'm³',
        toggleAuto: 'Calculate volume automatically',
        toggleManual: 'Enter manually',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    resources,
    partialBundledLanguages: true,
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    // OPT451-FE: DE/EN are bundled inline via `resources` (zero first-paint
    // cost). For FR/NL/PL/IT/ES i18next-http-backend lazy-fetches the JSON
    // when `changeLanguage` is called; the LanguageDetector-detected language
    // is loaded immediately during init so first paint already shows correct
    // strings for that language. `load: 'currentOnly'` prevents eager
    // downloads of every supported locale.
    load: 'currentOnly',
    fallbackLng: ['de', 'en'],
    supportedLngs: ['de', 'en', 'fr', 'nl', 'pl', 'it', 'es'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
